export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * A type that can store integers, strings, floats, and nulls without any validation.
   * This is used for flexible data storage in reports, and is not intended for general use.
   * Please avoid using this for anything outside of reports. We may hopefully be able to remove this type in the future.
   */
  Any: { input: any; output: any; }
  /**
   * The `Date` scalar type represents a date. The Date appears in a JSON
   * response as an ISO8601 formatted string, without a time component.
   */
  Date: { input: any; output: any; }
  /**
   * The `DateTime` scalar type represents a date and time in the UTC
   * timezone. The DateTime appears in a JSON response as an ISO8601 formatted
   * string, including UTC timezone ("Z"). The parsed date and time string will
   * be converted to UTC if there is an offset.
   */
  DateTime: { input: any; output: any; }
  /**
   * The `Decimal` scalar type represents signed double-precision fractional
   * values parsed by the `Decimal` library. The Decimal appears in a JSON
   * response as a string to preserve precision.
   */
  Decimal: { input: any; output: any; }
  /**
   * The `Json` scalar type represents arbitrary json string data, represented as UTF-8
   * character sequences. The Json type is most often used to represent a free-form
   * human-readable json string.
   */
  Json: { input: any; output: any; }
  /**
   * The `Json` scalar type represents arbitrary json string data, represented as UTF-8
   * character sequences. The Json type is most often used to represent a free-form
   * human-readable json string.
   */
  JsonString: { input: any; output: any; }
};

export type AbQuestionCountEntry = {
  __typename?: 'AbQuestionCountEntry';
  count: Scalars['Int']['output'];
  key: Scalars['String']['output'];
};

export type AbQuestionCountOptsInput = {
  filterByUserAccess?: InputMaybe<Scalars['Boolean']['input']>;
  guideLevels?: InputMaybe<Array<Scalars['ID']['input']>>;
  hideAssessmentQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  hidePreviouslyAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  negateStandardsFilter?: InputMaybe<Scalars['Boolean']['input']>;
  questionDifficulties?: InputMaybe<Array<Scalars['Int']['input']>>;
  questionTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  standardSets?: InputMaybe<Array<Scalars['ID']['input']>>;
  standards?: InputMaybe<Array<Scalars['ID']['input']>>;
  subjects?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AbQuestionSearchResult = {
  __typename?: 'AbQuestionSearchResult';
  questionIds: Array<Scalars['ID']['output']>;
  total: Scalars['Int']['output'];
};

export enum AbQuestionSort {
  DefaultPosition = 'DEFAULT_POSITION',
  DifficultyAsc = 'DIFFICULTY_ASC',
  DifficultyDesc = 'DIFFICULTY_DESC',
  Random = 'RANDOM'
}

export type AdaptivePractice = {
  __typename?: 'AdaptivePractice';
  advanceThreshold?: Maybe<Scalars['Int']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  currentQuestion?: Maybe<Question>;
  currentQuestionId?: Maybe<Scalars['ID']['output']>;
  fallbackThreshold?: Maybe<Scalars['Int']['output']>;
  guesses: Array<Guess>;
  guideLevel?: Maybe<GuideLevel>;
  guideLevelId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  level: Scalars['Int']['output'];
  levelAt?: Maybe<Scalars['Int']['output']>;
  levelChangedAt: Scalars['DateTime']['output'];
  /** Whether this practice counts toward some but not all of the active settings for this skill on the student's skill path. */
  partialSkillPathConflict?: Maybe<Scalars['Boolean']['output']>;
  proficiencyLevelChanges: Array<ProficiencyLevelChange>;
  range?: Maybe<Scalars['Int']['output']>;
  rollingAccuracy?: Maybe<Scalars['Float']['output']>;
  rollingCorrectCount?: Maybe<Scalars['Int']['output']>;
  rollingGuessCount?: Maybe<Scalars['Int']['output']>;
  rollingIncorrectCount?: Maybe<Scalars['Int']['output']>;
  student: User;
  studentId: Scalars['ID']['output'];
  /** Whether this practice won't count toward any of the active settings for this skill on the student's skill path. */
  totalSkillPathConflict?: Maybe<Scalars['Boolean']['output']>;
  unfilteredGuideLevel: GuideLevel;
  updatedAt: Scalars['DateTime']['output'];
};


export type AdaptivePracticeGuessesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GuessSortInput>>>;
};


export type AdaptivePracticeLevelAtArgs = {
  at: Scalars['DateTime']['input'];
};


export type AdaptivePracticeProficiencyLevelChangesArgs = {
  filter?: InputMaybe<ProficiencyLevelChangeFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ProficiencyLevelChangeSortInput>>>;
};

export type AdaptivePracticeFilterAdvanceThreshold = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type AdaptivePracticeFilterCompletedAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AdaptivePracticeFilterCurrentQuestionId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type AdaptivePracticeFilterFallbackThreshold = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type AdaptivePracticeFilterGuideLevelId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type AdaptivePracticeFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type AdaptivePracticeFilterInput = {
  advanceThreshold?: InputMaybe<AdaptivePracticeFilterAdvanceThreshold>;
  and?: InputMaybe<Array<AdaptivePracticeFilterInput>>;
  completedAt?: InputMaybe<AdaptivePracticeFilterCompletedAt>;
  currentQuestion?: InputMaybe<QuestionFilterInput>;
  currentQuestionId?: InputMaybe<AdaptivePracticeFilterCurrentQuestionId>;
  fallbackThreshold?: InputMaybe<AdaptivePracticeFilterFallbackThreshold>;
  guideLevel?: InputMaybe<GuideLevelFilterInput>;
  guideLevelId?: InputMaybe<AdaptivePracticeFilterGuideLevelId>;
  id?: InputMaybe<AdaptivePracticeFilterId>;
  insertedAt?: InputMaybe<AdaptivePracticeFilterInsertedAt>;
  level?: InputMaybe<AdaptivePracticeFilterLevel>;
  levelAt?: InputMaybe<AdaptivePracticeFilterLevelAt>;
  levelChangedAt?: InputMaybe<AdaptivePracticeFilterLevelChangedAt>;
  not?: InputMaybe<Array<AdaptivePracticeFilterInput>>;
  or?: InputMaybe<Array<AdaptivePracticeFilterInput>>;
  /** Whether this practice counts toward some but not all of the active settings for this skill on the student's skill path. */
  partialSkillPathConflict?: InputMaybe<AdaptivePracticeFilterPartialSkillPathConflict>;
  proficiencyLevelChanges?: InputMaybe<ProficiencyLevelChangeFilterInput>;
  range?: InputMaybe<AdaptivePracticeFilterRange>;
  rollingAccuracy?: InputMaybe<AdaptivePracticeFilterRollingAccuracy>;
  student?: InputMaybe<UserFilterInput>;
  studentId?: InputMaybe<AdaptivePracticeFilterStudentId>;
  /** Whether this practice won't count toward any of the active settings for this skill on the student's skill path. */
  totalSkillPathConflict?: InputMaybe<AdaptivePracticeFilterTotalSkillPathConflict>;
  unfilteredGuideLevel?: InputMaybe<GuideLevelFilterInput>;
  updatedAt?: InputMaybe<AdaptivePracticeFilterUpdatedAt>;
};

export type AdaptivePracticeFilterInsertedAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AdaptivePracticeFilterLevel = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type AdaptivePracticeFilterLevelAt = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  input?: InputMaybe<AdaptivePracticeLevelAtFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type AdaptivePracticeFilterLevelChangedAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AdaptivePracticeFilterPartialSkillPathConflict = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdaptivePracticeFilterRange = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type AdaptivePracticeFilterRollingAccuracy = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Float']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Float']['input']>;
  lessThan?: InputMaybe<Scalars['Float']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Float']['input']>;
  notEq?: InputMaybe<Scalars['Float']['input']>;
};

export type AdaptivePracticeFilterStudentId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type AdaptivePracticeFilterTotalSkillPathConflict = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdaptivePracticeFilterUpdatedAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AdaptivePracticeLevelAtFieldInput = {
  at: Scalars['DateTime']['input'];
};

export enum AdaptivePracticeSortField {
  AdvanceThreshold = 'ADVANCE_THRESHOLD',
  CompletedAt = 'COMPLETED_AT',
  CurrentQuestionId = 'CURRENT_QUESTION_ID',
  FallbackThreshold = 'FALLBACK_THRESHOLD',
  GuideLevelId = 'GUIDE_LEVEL_ID',
  Id = 'ID',
  InsertedAt = 'INSERTED_AT',
  Level = 'LEVEL',
  LevelAt = 'LEVEL_AT',
  LevelChangedAt = 'LEVEL_CHANGED_AT',
  PartialSkillPathConflict = 'PARTIAL_SKILL_PATH_CONFLICT',
  Range = 'RANGE',
  RollingAccuracy = 'ROLLING_ACCURACY',
  StudentId = 'STUDENT_ID',
  TotalSkillPathConflict = 'TOTAL_SKILL_PATH_CONFLICT',
  UpdatedAt = 'UPDATED_AT'
}

export type AdaptivePracticeSortInput = {
  field: AdaptivePracticeSortField;
  levelAtInput?: InputMaybe<AdaptivePracticeLevelAtFieldInput>;
  order?: InputMaybe<SortOrder>;
};

export type AiGradingFeedbackStyle = {
  __typename?: 'AiGradingFeedbackStyle';
  label: Scalars['String']['output'];
  style: Scalars['String']['output'];
};

export type AnalyticsClassroomAssignment = {
  __typename?: 'AnalyticsClassroomAssignment';
  assignment: AnalyticsReportAssignment;
  assignmentId: Scalars['ID']['output'];
  classroom: AnalyticsReportClassroom;
  classroomId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  settings: Scalars['Json']['output'];
};

export type AnalyticsClassroomAssignmentFilterAssignmentId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type AnalyticsClassroomAssignmentFilterClassroomId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type AnalyticsClassroomAssignmentFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type AnalyticsClassroomAssignmentFilterInput = {
  and?: InputMaybe<Array<AnalyticsClassroomAssignmentFilterInput>>;
  assignment?: InputMaybe<AnalyticsReportAssignmentFilterInput>;
  assignmentId?: InputMaybe<AnalyticsClassroomAssignmentFilterAssignmentId>;
  classroom?: InputMaybe<AnalyticsReportClassroomFilterInput>;
  classroomId?: InputMaybe<AnalyticsClassroomAssignmentFilterClassroomId>;
  id?: InputMaybe<AnalyticsClassroomAssignmentFilterId>;
  not?: InputMaybe<Array<AnalyticsClassroomAssignmentFilterInput>>;
  or?: InputMaybe<Array<AnalyticsClassroomAssignmentFilterInput>>;
  settings?: InputMaybe<AnalyticsClassroomAssignmentFilterSettings>;
};

export type AnalyticsClassroomAssignmentFilterSettings = {
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum AnalyticsClassroomAssignmentSortField {
  AssignmentId = 'ASSIGNMENT_ID',
  ClassroomId = 'CLASSROOM_ID',
  Id = 'ID',
  Settings = 'SETTINGS'
}

export type AnalyticsClassroomAssignmentSortInput = {
  field: AnalyticsClassroomAssignmentSortField;
  order?: InputMaybe<SortOrder>;
};

export type AnalyticsQuestionSet = {
  __typename?: 'AnalyticsQuestionSet';
  id: Scalars['ID']['output'];
  subject: AnalyticsSubject;
  subjectId: Scalars['ID']['output'];
};

export type AnalyticsReport = {
  __typename?: 'AnalyticsReport';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  countPrimaryDimension?: Maybe<Scalars['Int']['output']>;
  countSecondaryDimension?: Maybe<Scalars['Int']['output']>;
  dimensions: Array<Scalars['String']['output']>;
  filters?: Maybe<Array<ReportFilter>>;
  hash: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  metricInputs?: Maybe<Array<MetricInput>>;
  metrics?: Maybe<Array<Scalars['String']['output']>>;
  persist: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


export type AnalyticsReportCountPrimaryDimensionArgs = {
  excludeUnlicensedClassrooms?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AnalyticsReportCountSecondaryDimensionArgs = {
  excludeUnlicensedClassrooms?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AnalyticsReportAssignment = {
  __typename?: 'AnalyticsReportAssignment';
  classroomAssignments: Array<AnalyticsClassroomAssignment>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  settings: Scalars['Json']['output'];
  studentAssignments: Array<AnalyticsStudentAssignment>;
  students: Array<AnalyticsStudent>;
};


export type AnalyticsReportAssignmentClassroomAssignmentsArgs = {
  filter?: InputMaybe<AnalyticsClassroomAssignmentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AnalyticsClassroomAssignmentSortInput>>>;
};


export type AnalyticsReportAssignmentStudentAssignmentsArgs = {
  filter?: InputMaybe<AnalyticsStudentAssignmentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AnalyticsStudentAssignmentSortInput>>>;
};


export type AnalyticsReportAssignmentStudentsArgs = {
  filter?: InputMaybe<AnalyticsStudentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AnalyticsStudentSortInput>>>;
};

export type AnalyticsReportAssignmentFilterDueDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnalyticsReportAssignmentFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type AnalyticsReportAssignmentFilterInput = {
  and?: InputMaybe<Array<AnalyticsReportAssignmentFilterInput>>;
  classroomAssignments?: InputMaybe<AnalyticsClassroomAssignmentFilterInput>;
  dueDate?: InputMaybe<AnalyticsReportAssignmentFilterDueDate>;
  id?: InputMaybe<AnalyticsReportAssignmentFilterId>;
  name?: InputMaybe<AnalyticsReportAssignmentFilterName>;
  not?: InputMaybe<Array<AnalyticsReportAssignmentFilterInput>>;
  or?: InputMaybe<Array<AnalyticsReportAssignmentFilterInput>>;
  settings?: InputMaybe<AnalyticsReportAssignmentFilterSettings>;
  studentAssignments?: InputMaybe<AnalyticsStudentAssignmentFilterInput>;
  students?: InputMaybe<AnalyticsStudentFilterInput>;
};

export type AnalyticsReportAssignmentFilterName = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type AnalyticsReportAssignmentFilterSettings = {
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum AnalyticsReportAssignmentSortField {
  DueDate = 'DUE_DATE',
  Id = 'ID',
  Name = 'NAME',
  Settings = 'SETTINGS'
}

export type AnalyticsReportAssignmentSortInput = {
  field: AnalyticsReportAssignmentSortField;
  order?: InputMaybe<SortOrder>;
};

export type AnalyticsReportClassroom = {
  __typename?: 'AnalyticsReportClassroom';
  applyStudentsToSchoolLicense: Scalars['Boolean']['output'];
  autoArchiveDate?: Maybe<Scalars['DateTime']['output']>;
  classroomAssignments: Array<AnalyticsClassroomAssignment>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};


export type AnalyticsReportClassroomClassroomAssignmentsArgs = {
  filter?: InputMaybe<AnalyticsClassroomAssignmentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AnalyticsClassroomAssignmentSortInput>>>;
};

export type AnalyticsReportClassroomFilterApplyStudentsToSchoolLicense = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AnalyticsReportClassroomFilterAutoArchiveDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnalyticsReportClassroomFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type AnalyticsReportClassroomFilterInput = {
  and?: InputMaybe<Array<AnalyticsReportClassroomFilterInput>>;
  applyStudentsToSchoolLicense?: InputMaybe<AnalyticsReportClassroomFilterApplyStudentsToSchoolLicense>;
  autoArchiveDate?: InputMaybe<AnalyticsReportClassroomFilterAutoArchiveDate>;
  classroomAssignments?: InputMaybe<AnalyticsClassroomAssignmentFilterInput>;
  id?: InputMaybe<AnalyticsReportClassroomFilterId>;
  name?: InputMaybe<AnalyticsReportClassroomFilterName>;
  not?: InputMaybe<Array<AnalyticsReportClassroomFilterInput>>;
  or?: InputMaybe<Array<AnalyticsReportClassroomFilterInput>>;
  status?: InputMaybe<AnalyticsReportClassroomFilterStatus>;
};

export type AnalyticsReportClassroomFilterName = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type AnalyticsReportClassroomFilterStatus = {
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type AnalyticsReportDiagnostic = {
  __typename?: 'AnalyticsReportDiagnostic';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type AnalyticsReportFiltersInput = {
  field?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<Scalars['Any']['input']>>;
};

export type AnalyticsReportGuide = {
  __typename?: 'AnalyticsReportGuide';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  published: Scalars['Boolean']['output'];
  subject: AnalyticsSubject;
  subjectId: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export type AnalyticsReportGuideLevel = {
  __typename?: 'AnalyticsReportGuideLevel';
  code: Scalars['String']['output'];
  countChildren: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  guide: AnalyticsReportGuide;
  guideId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  level: Scalars['Json']['output'];
  name: Scalars['String']['output'];
  nlevel?: Maybe<Scalars['Int']['output']>;
  parent?: Maybe<AnalyticsReportGuideLevel>;
  position: Scalars['Int']['output'];
  published: Scalars['Boolean']['output'];
  subject: AnalyticsSubject;
  subjectId: Scalars['ID']['output'];
};

export type AnalyticsReportQuestion = {
  __typename?: 'AnalyticsReportQuestion';
  difficulty?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isAdaptive?: Maybe<Scalars['Boolean']['output']>;
  questionSet?: Maybe<AnalyticsQuestionSet>;
  questionSetId: Scalars['ID']['output'];
  slugId?: Maybe<Scalars['String']['output']>;
  standards: Array<AnalyticsStandard>;
  title?: Maybe<Scalars['String']['output']>;
};


export type AnalyticsReportQuestionStandardsArgs = {
  filter?: InputMaybe<AnalyticsStandardFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AnalyticsStandardSortInput>>>;
};

export type AnalyticsSchool = {
  __typename?: 'AnalyticsSchool';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type AnalyticsStandard = {
  __typename?: 'AnalyticsStandard';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  standardSet: AnalyticsStandardSet;
  standardSetId: Scalars['ID']['output'];
  statusEndDate?: Maybe<Scalars['DateTime']['output']>;
  statusStartDate?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
};

export type AnalyticsStandardFilterDescription = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type AnalyticsStandardFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type AnalyticsStandardFilterInput = {
  and?: InputMaybe<Array<AnalyticsStandardFilterInput>>;
  description?: InputMaybe<AnalyticsStandardFilterDescription>;
  id?: InputMaybe<AnalyticsStandardFilterId>;
  not?: InputMaybe<Array<AnalyticsStandardFilterInput>>;
  or?: InputMaybe<Array<AnalyticsStandardFilterInput>>;
  standardSet?: InputMaybe<AnalyticsStandardSetFilterInput>;
  standardSetId?: InputMaybe<AnalyticsStandardFilterStandardSetId>;
  statusEndDate?: InputMaybe<AnalyticsStandardFilterStatusEndDate>;
  statusStartDate?: InputMaybe<AnalyticsStandardFilterStatusStartDate>;
  title?: InputMaybe<AnalyticsStandardFilterTitle>;
};

export type AnalyticsStandardFilterStandardSetId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type AnalyticsStandardFilterStatusEndDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnalyticsStandardFilterStatusStartDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnalyticsStandardFilterTitle = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type AnalyticsStandardSet = {
  __typename?: 'AnalyticsStandardSet';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type AnalyticsStandardSetFilterDescription = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type AnalyticsStandardSetFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type AnalyticsStandardSetFilterInput = {
  and?: InputMaybe<Array<AnalyticsStandardSetFilterInput>>;
  description?: InputMaybe<AnalyticsStandardSetFilterDescription>;
  id?: InputMaybe<AnalyticsStandardSetFilterId>;
  not?: InputMaybe<Array<AnalyticsStandardSetFilterInput>>;
  or?: InputMaybe<Array<AnalyticsStandardSetFilterInput>>;
  title?: InputMaybe<AnalyticsStandardSetFilterTitle>;
};

export type AnalyticsStandardSetFilterTitle = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export enum AnalyticsStandardSortField {
  Description = 'DESCRIPTION',
  Id = 'ID',
  StandardSetId = 'STANDARD_SET_ID',
  StatusEndDate = 'STATUS_END_DATE',
  StatusStartDate = 'STATUS_START_DATE',
  Title = 'TITLE'
}

export type AnalyticsStandardSortInput = {
  field: AnalyticsStandardSortField;
  order?: InputMaybe<SortOrder>;
};

export type AnalyticsStudent = {
  __typename?: 'AnalyticsStudent';
  assignments: Array<AnalyticsReportAssignment>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  studentAssignments: Array<AnalyticsStudentAssignment>;
  username: Scalars['String']['output'];
};


export type AnalyticsStudentAssignmentsArgs = {
  filter?: InputMaybe<AnalyticsReportAssignmentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AnalyticsReportAssignmentSortInput>>>;
};


export type AnalyticsStudentStudentAssignmentsArgs = {
  filter?: InputMaybe<AnalyticsStudentAssignmentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AnalyticsStudentAssignmentSortInput>>>;
};

export type AnalyticsStudentAssignment = {
  __typename?: 'AnalyticsStudentAssignment';
  assignment: AnalyticsReportAssignment;
  assignmentId: Scalars['ID']['output'];
  classroomAssignments: Array<AnalyticsClassroomAssignment>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  lockdownAutoSubmitReason?: Maybe<StudentAssignmentLockdownAutoSubmitReason>;
  lockdownViolations: Scalars['Json']['output'];
  settings?: Maybe<Scalars['Json']['output']>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
  student: AnalyticsStudent;
  studentId: Scalars['ID']['output'];
  submitted?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


export type AnalyticsStudentAssignmentClassroomAssignmentsArgs = {
  filter?: InputMaybe<AnalyticsClassroomAssignmentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AnalyticsClassroomAssignmentSortInput>>>;
};

export type AnalyticsStudentAssignmentFilterAssignmentId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type AnalyticsStudentAssignmentFilterDeletedAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnalyticsStudentAssignmentFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type AnalyticsStudentAssignmentFilterInput = {
  and?: InputMaybe<Array<AnalyticsStudentAssignmentFilterInput>>;
  assignment?: InputMaybe<AnalyticsReportAssignmentFilterInput>;
  assignmentId?: InputMaybe<AnalyticsStudentAssignmentFilterAssignmentId>;
  classroomAssignments?: InputMaybe<AnalyticsClassroomAssignmentFilterInput>;
  deletedAt?: InputMaybe<AnalyticsStudentAssignmentFilterDeletedAt>;
  id?: InputMaybe<AnalyticsStudentAssignmentFilterId>;
  insertedAt?: InputMaybe<AnalyticsStudentAssignmentFilterInsertedAt>;
  lockdownAutoSubmitReason?: InputMaybe<AnalyticsStudentAssignmentFilterLockdownAutoSubmitReason>;
  lockdownViolations?: InputMaybe<AnalyticsStudentAssignmentFilterLockdownViolations>;
  not?: InputMaybe<Array<AnalyticsStudentAssignmentFilterInput>>;
  or?: InputMaybe<Array<AnalyticsStudentAssignmentFilterInput>>;
  settings?: InputMaybe<AnalyticsStudentAssignmentFilterSettings>;
  startTime?: InputMaybe<AnalyticsStudentAssignmentFilterStartTime>;
  student?: InputMaybe<AnalyticsStudentFilterInput>;
  studentId?: InputMaybe<AnalyticsStudentAssignmentFilterStudentId>;
  submitted?: InputMaybe<AnalyticsStudentAssignmentFilterSubmitted>;
  updatedAt?: InputMaybe<AnalyticsStudentAssignmentFilterUpdatedAt>;
};

export type AnalyticsStudentAssignmentFilterInsertedAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnalyticsStudentAssignmentFilterLockdownAutoSubmitReason = {
  eq?: InputMaybe<StudentAssignmentLockdownAutoSubmitReason>;
  greaterThan?: InputMaybe<StudentAssignmentLockdownAutoSubmitReason>;
  greaterThanOrEqual?: InputMaybe<StudentAssignmentLockdownAutoSubmitReason>;
  in?: InputMaybe<Array<InputMaybe<StudentAssignmentLockdownAutoSubmitReason>>>;
  isDistinctFrom?: InputMaybe<StudentAssignmentLockdownAutoSubmitReason>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<StudentAssignmentLockdownAutoSubmitReason>;
  lessThan?: InputMaybe<StudentAssignmentLockdownAutoSubmitReason>;
  lessThanOrEqual?: InputMaybe<StudentAssignmentLockdownAutoSubmitReason>;
  notEq?: InputMaybe<StudentAssignmentLockdownAutoSubmitReason>;
};

export type AnalyticsStudentAssignmentFilterLockdownViolations = {
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AnalyticsStudentAssignmentFilterSettings = {
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AnalyticsStudentAssignmentFilterStartTime = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnalyticsStudentAssignmentFilterStudentId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type AnalyticsStudentAssignmentFilterSubmitted = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnalyticsStudentAssignmentFilterUpdatedAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum AnalyticsStudentAssignmentSortField {
  AssignmentId = 'ASSIGNMENT_ID',
  DeletedAt = 'DELETED_AT',
  Id = 'ID',
  InsertedAt = 'INSERTED_AT',
  LockdownAutoSubmitReason = 'LOCKDOWN_AUTO_SUBMIT_REASON',
  LockdownViolations = 'LOCKDOWN_VIOLATIONS',
  Settings = 'SETTINGS',
  StartTime = 'START_TIME',
  StudentId = 'STUDENT_ID',
  Submitted = 'SUBMITTED',
  UpdatedAt = 'UPDATED_AT'
}

export type AnalyticsStudentAssignmentSortInput = {
  field: AnalyticsStudentAssignmentSortField;
  order?: InputMaybe<SortOrder>;
};

export type AnalyticsStudentFilterEmail = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type AnalyticsStudentFilterFirstName = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type AnalyticsStudentFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type AnalyticsStudentFilterInput = {
  and?: InputMaybe<Array<AnalyticsStudentFilterInput>>;
  assignments?: InputMaybe<AnalyticsReportAssignmentFilterInput>;
  email?: InputMaybe<AnalyticsStudentFilterEmail>;
  firstName?: InputMaybe<AnalyticsStudentFilterFirstName>;
  id?: InputMaybe<AnalyticsStudentFilterId>;
  lastName?: InputMaybe<AnalyticsStudentFilterLastName>;
  not?: InputMaybe<Array<AnalyticsStudentFilterInput>>;
  or?: InputMaybe<Array<AnalyticsStudentFilterInput>>;
  studentAssignments?: InputMaybe<AnalyticsStudentAssignmentFilterInput>;
  username?: InputMaybe<AnalyticsStudentFilterUsername>;
};

export type AnalyticsStudentFilterLastName = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type AnalyticsStudentFilterUsername = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export enum AnalyticsStudentSortField {
  Email = 'EMAIL',
  FirstName = 'FIRST_NAME',
  Id = 'ID',
  LastName = 'LAST_NAME',
  Username = 'USERNAME'
}

export type AnalyticsStudentSortInput = {
  field: AnalyticsStudentSortField;
  order?: InputMaybe<SortOrder>;
};

export type AnalyticsSubject = {
  __typename?: 'AnalyticsSubject';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: SubjectType;
  urlSlug: Scalars['String']['output'];
};

export type AnalyticsTeacher = {
  __typename?: 'AnalyticsTeacher';
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
};

export enum AnnotationTargetKind {
  Question = 'QUESTION',
  Supplement = 'SUPPLEMENT'
}

export type ApproveCoppaConsentGrantInput = {
  verificationCode: Scalars['String']['input'];
};

/** The result of the :approve_coppa_consent_grant mutation */
export type ApproveCoppaConsentGrantResult = {
  __typename?: 'ApproveCoppaConsentGrantResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<CoppaConsentGrant>;
};

/** The result of the :archive_question mutation */
export type ArchiveQuestionResult = {
  __typename?: 'ArchiveQuestionResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<Question>;
};

export type Assignment = {
  __typename?: 'Assignment';
  /**
   * Whether the assignment is assigned to at least one of the given
   * classrooms. Used to scope the educator assignment index down to a
   * selected classroom.
   */
  assignedToClassrooms?: Maybe<Scalars['Boolean']['output']>;
  assignmentType?: Maybe<Scalars['String']['output']>;
  /**
   * This assignment's per-classroom rows — the level at which grade release and
   * lock authorization are decided. An educator sees only rows for classrooms they teach.
   */
  classroomAssignments: Array<ClassroomAssignment>;
  /**
   * Count of in-scope (class, student) pairings the student has submitted —
   * the numerator of the educator index's "x/x submissions" display.
   */
  countOfCompletedStudents: Scalars['Int']['output'];
  /** Submitted guesses currently being graded (status grading_in_progress) */
  countOfGradingInProgressGuesses: Scalars['Int']['output'];
  /**
   * Submitted guesses on this assignment's manually-graded questions whose
   * teacher grade is not finished: ungraded, or in progress without a
   * complete evaluation. A finished grade waiting on release is not counted,
   * whether or not its class was already released.
   */
  countOfIncompleteGuesses: Scalars['Int']['output'];
  /**
   * Count of in-scope (class, student) pairings the student has not yet
   * submitted. With count_of_completed_students this gives the
   * "x/x submissions" totals.
   */
  countOfIncompleteStudents: Scalars['Int']['output'];
  /**
   * Guesses on this assignment's manually-graded questions whose grades have
   * not yet been released to the student's class but would become visible on
   * release.
   */
  countOfReleasableGradedGuesses: Scalars['Int']['output'];
  /**
   * Count of in-scope (class, student) pairings the student has submitted
   * but still has a manually-graded guess whose grade is not finished, so a
   * release now leaves them on the awaiting-grading state. Same pairing
   * scope as count_of_completed_students and count_of_incomplete_students,
   * so the three subtract cleanly: completed - awaiting is the pairings a
   * release reaches.
   *
   * A pairing counts once however many FRQs are unfinished.
   */
  countOfStudentsAwaitingGrade: Scalars['Int']['output'];
  /** All submitted guesses (ungraded, grading_in_progress, published) on this assignment's manually-graded questions */
  countOfSubmittedManuallyGradedGuesses: Scalars['Int']['output'];
  /** Submitted guesses awaiting grading (status ungraded) on this assignment's manually-graded questions */
  countOfUngradedGuesses: Scalars['Int']['output'];
  /**
   * The full name of the assignment's creator (its teacher), for the
   * document-details modal. Nil when the creator has no name set.
   */
  creatorName?: Maybe<Scalars['String']['output']>;
  /**
   * The assignment's status for the current educator, computed over the
   * (class, student) pairings of active classrooms they teach or
   * administrate — optionally narrowed to `classroom_ids` for a
   * class-scoped view. One of open,
   * scheduled, closed, or draft (precedence: open > scheduled > closed).
   * A pairing without a start date is available immediately, so it can be
   * open but never scheduled.
   */
  educatorStatus: AssignmentStatus;
  /**
   * Whether this assignment contains a question restricted at the school of a classroom it
   * is assigned to.
   *
   * Both halves matter: a restriction at one of those schools that doesn't cover any
   * question in this assignment reads false, and so does a restriction covering these
   * questions at a school with no classroom on the assignment.
   *
   * Scoped to the attached classrooms rather than to the viewer, so teachers and admins get
   * the same answer. The corollary is that it reads false until a classroom is attached,
   * there being no school to evaluate against before that. Publication state does not enter
   * into it: a draft that already carries classrooms answers like an assigned assignment.
   *
   * Reports the state of the content, not whether students are currently blocked, so it
   * stays true once an admin has granted lock authorization for the class.
   *
   * Answers for every classroom attached to the assignment, not for the ones the viewer
   * teaches. Anything comparing it against a per-viewer or per-class authorization state can
   * see the two disagree on a co-taught or multi-school assignment without either being
   * wrong.
   */
  hasLockedContent: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  /**
   * The latest effective due date across the educator's in-scope
   * (class, student) pairings. Nil when no in-scope pairing has a due date
   * (e.g. drafts).
   */
  maxDueDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The latest effective start date across the educator's in-scope
   * (class, student) pairings. Nil when no in-scope pairing has a start date.
   */
  maxStartDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The earliest effective due date across the educator's in-scope
   * (class, student) pairings. Used as the due-date sort key. Nil when no
   * in-scope pairing has a due date (e.g. drafts).
   */
  minDueDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The earliest effective start date across the educator's in-scope
   * (class, student) pairings. Used for the scheduled-tab date range and its
   * sort key. Nil when no in-scope pairing has a start date.
   */
  minStartDate?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  settings?: Maybe<DefaultAssignmentSettings>;
  teacherId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


export type AssignmentAssignedToClassroomsArgs = {
  classroomIds: Array<Scalars['ID']['input']>;
};


export type AssignmentClassroomAssignmentsArgs = {
  filter?: InputMaybe<ClassroomAssignmentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ClassroomAssignmentSortInput>>>;
};


export type AssignmentCountOfCompletedStudentsArgs = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type AssignmentCountOfGradingInProgressGuessesArgs = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type AssignmentCountOfIncompleteGuessesArgs = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type AssignmentCountOfIncompleteStudentsArgs = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type AssignmentCountOfReleasableGradedGuessesArgs = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type AssignmentCountOfStudentsAwaitingGradeArgs = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type AssignmentCountOfSubmittedManuallyGradedGuessesArgs = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type AssignmentCountOfUngradedGuessesArgs = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type AssignmentEducatorStatusArgs = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type AssignmentMaxDueDateArgs = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type AssignmentMaxStartDateArgs = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type AssignmentMinDueDateArgs = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type AssignmentMinStartDateArgs = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AssignmentAssignedToClassroomsFieldInput = {
  classroomIds: Array<Scalars['ID']['input']>;
};

export enum AssignmentCalculatorSetting {
  Basic = 'BASIC',
  FollowContent = 'FOLLOW_CONTENT',
  Graphing = 'GRAPHING',
  None = 'NONE',
  Scientific = 'SCIENTIFIC'
}

export type AssignmentCountOfCompletedStudentsFieldInput = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AssignmentCountOfGradingInProgressGuessesFieldInput = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AssignmentCountOfIncompleteGuessesFieldInput = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AssignmentCountOfIncompleteStudentsFieldInput = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AssignmentCountOfReleasableGradedGuessesFieldInput = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AssignmentCountOfStudentsAwaitingGradeFieldInput = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AssignmentCountOfSubmittedManuallyGradedGuessesFieldInput = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AssignmentCountOfUngradedGuessesFieldInput = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AssignmentEducatorStatusFieldInput = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AssignmentFilterAssignedToClassrooms = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  input?: InputMaybe<AssignmentAssignedToClassroomsFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssignmentFilterAssignmentType = {
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type AssignmentFilterCountOfCompletedStudents = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  input?: InputMaybe<AssignmentCountOfCompletedStudentsFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type AssignmentFilterCountOfGradingInProgressGuesses = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  input?: InputMaybe<AssignmentCountOfGradingInProgressGuessesFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type AssignmentFilterCountOfIncompleteGuesses = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  input?: InputMaybe<AssignmentCountOfIncompleteGuessesFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type AssignmentFilterCountOfIncompleteStudents = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  input?: InputMaybe<AssignmentCountOfIncompleteStudentsFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type AssignmentFilterCountOfReleasableGradedGuesses = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  input?: InputMaybe<AssignmentCountOfReleasableGradedGuessesFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type AssignmentFilterCountOfStudentsAwaitingGrade = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  input?: InputMaybe<AssignmentCountOfStudentsAwaitingGradeFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type AssignmentFilterCountOfSubmittedManuallyGradedGuesses = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  input?: InputMaybe<AssignmentCountOfSubmittedManuallyGradedGuessesFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type AssignmentFilterCountOfUngradedGuesses = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  input?: InputMaybe<AssignmentCountOfUngradedGuessesFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type AssignmentFilterCreatorName = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type AssignmentFilterEducatorStatus = {
  eq?: InputMaybe<AssignmentStatus>;
  greaterThan?: InputMaybe<AssignmentStatus>;
  greaterThanOrEqual?: InputMaybe<AssignmentStatus>;
  in?: InputMaybe<Array<AssignmentStatus>>;
  input?: InputMaybe<AssignmentEducatorStatusFieldInput>;
  isDistinctFrom?: InputMaybe<AssignmentStatus>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<AssignmentStatus>;
  lessThan?: InputMaybe<AssignmentStatus>;
  lessThanOrEqual?: InputMaybe<AssignmentStatus>;
  notEq?: InputMaybe<AssignmentStatus>;
};

export type AssignmentFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type AssignmentFilterInput = {
  and?: InputMaybe<Array<AssignmentFilterInput>>;
  /**
   * Whether the assignment is assigned to at least one of the given
   * classrooms. Used to scope the educator assignment index down to a
   * selected classroom.
   */
  assignedToClassrooms?: InputMaybe<AssignmentFilterAssignedToClassrooms>;
  assignmentType?: InputMaybe<AssignmentFilterAssignmentType>;
  /**
   * This assignment's per-classroom rows — the level at which grade release and
   * lock authorization are decided. An educator sees only rows for classrooms they teach.
   */
  classroomAssignments?: InputMaybe<ClassroomAssignmentFilterInput>;
  /**
   * Count of in-scope (class, student) pairings the student has submitted —
   * the numerator of the educator index's "x/x submissions" display.
   */
  countOfCompletedStudents?: InputMaybe<AssignmentFilterCountOfCompletedStudents>;
  /** Submitted guesses currently being graded (status grading_in_progress) */
  countOfGradingInProgressGuesses?: InputMaybe<AssignmentFilterCountOfGradingInProgressGuesses>;
  /**
   * Submitted guesses on this assignment's manually-graded questions whose
   * teacher grade is not finished: ungraded, or in progress without a
   * complete evaluation. A finished grade waiting on release is not counted,
   * whether or not its class was already released.
   */
  countOfIncompleteGuesses?: InputMaybe<AssignmentFilterCountOfIncompleteGuesses>;
  /**
   * Count of in-scope (class, student) pairings the student has not yet
   * submitted. With count_of_completed_students this gives the
   * "x/x submissions" totals.
   */
  countOfIncompleteStudents?: InputMaybe<AssignmentFilterCountOfIncompleteStudents>;
  /**
   * Guesses on this assignment's manually-graded questions whose grades have
   * not yet been released to the student's class but would become visible on
   * release.
   */
  countOfReleasableGradedGuesses?: InputMaybe<AssignmentFilterCountOfReleasableGradedGuesses>;
  /**
   * Count of in-scope (class, student) pairings the student has submitted
   * but still has a manually-graded guess whose grade is not finished, so a
   * release now leaves them on the awaiting-grading state. Same pairing
   * scope as count_of_completed_students and count_of_incomplete_students,
   * so the three subtract cleanly: completed - awaiting is the pairings a
   * release reaches.
   *
   * A pairing counts once however many FRQs are unfinished.
   */
  countOfStudentsAwaitingGrade?: InputMaybe<AssignmentFilterCountOfStudentsAwaitingGrade>;
  /** All submitted guesses (ungraded, grading_in_progress, published) on this assignment's manually-graded questions */
  countOfSubmittedManuallyGradedGuesses?: InputMaybe<AssignmentFilterCountOfSubmittedManuallyGradedGuesses>;
  /** Submitted guesses awaiting grading (status ungraded) on this assignment's manually-graded questions */
  countOfUngradedGuesses?: InputMaybe<AssignmentFilterCountOfUngradedGuesses>;
  /**
   * The full name of the assignment's creator (its teacher), for the
   * document-details modal. Nil when the creator has no name set.
   */
  creatorName?: InputMaybe<AssignmentFilterCreatorName>;
  /**
   * The assignment's status for the current educator, computed over the
   * (class, student) pairings of active classrooms they teach or
   * administrate — optionally narrowed to `classroom_ids` for a
   * class-scoped view. One of open,
   * scheduled, closed, or draft (precedence: open > scheduled > closed).
   * A pairing without a start date is available immediately, so it can be
   * open but never scheduled.
   */
  educatorStatus?: InputMaybe<AssignmentFilterEducatorStatus>;
  id?: InputMaybe<AssignmentFilterId>;
  insertedAt?: InputMaybe<AssignmentFilterInsertedAt>;
  /**
   * The latest effective due date across the educator's in-scope
   * (class, student) pairings. Nil when no in-scope pairing has a due date
   * (e.g. drafts).
   */
  maxDueDate?: InputMaybe<AssignmentFilterMaxDueDate>;
  /**
   * The latest effective start date across the educator's in-scope
   * (class, student) pairings. Nil when no in-scope pairing has a start date.
   */
  maxStartDate?: InputMaybe<AssignmentFilterMaxStartDate>;
  /**
   * The earliest effective due date across the educator's in-scope
   * (class, student) pairings. Used as the due-date sort key. Nil when no
   * in-scope pairing has a due date (e.g. drafts).
   */
  minDueDate?: InputMaybe<AssignmentFilterMinDueDate>;
  /**
   * The earliest effective start date across the educator's in-scope
   * (class, student) pairings. Used for the scheduled-tab date range and its
   * sort key. Nil when no in-scope pairing has a start date.
   */
  minStartDate?: InputMaybe<AssignmentFilterMinStartDate>;
  name?: InputMaybe<AssignmentFilterName>;
  not?: InputMaybe<Array<AssignmentFilterInput>>;
  or?: InputMaybe<Array<AssignmentFilterInput>>;
  settings?: InputMaybe<AssignmentFilterSettings>;
  teacherId?: InputMaybe<AssignmentFilterTeacherId>;
  updatedAt?: InputMaybe<AssignmentFilterUpdatedAt>;
};

export type AssignmentFilterInsertedAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AssignmentFilterMaxDueDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  input?: InputMaybe<AssignmentMaxDueDateFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AssignmentFilterMaxStartDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  input?: InputMaybe<AssignmentMaxStartDateFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AssignmentFilterMinDueDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  input?: InputMaybe<AssignmentMinDueDateFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AssignmentFilterMinStartDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  input?: InputMaybe<AssignmentMinStartDateFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AssignmentFilterName = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type AssignmentFilterSettings = {
  eq?: InputMaybe<DefaultAssignmentSettingsInput>;
  greaterThan?: InputMaybe<DefaultAssignmentSettingsInput>;
  greaterThanOrEqual?: InputMaybe<DefaultAssignmentSettingsInput>;
  in?: InputMaybe<Array<InputMaybe<DefaultAssignmentSettingsInput>>>;
  isDistinctFrom?: InputMaybe<DefaultAssignmentSettingsInput>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<DefaultAssignmentSettingsInput>;
  lessThan?: InputMaybe<DefaultAssignmentSettingsInput>;
  lessThanOrEqual?: InputMaybe<DefaultAssignmentSettingsInput>;
  notEq?: InputMaybe<DefaultAssignmentSettingsInput>;
};

export type AssignmentFilterTeacherId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type AssignmentFilterUpdatedAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AssignmentMaxDueDateFieldInput = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AssignmentMaxStartDateFieldInput = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AssignmentMinDueDateFieldInput = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AssignmentMinStartDateFieldInput = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum AssignmentSortField {
  AssignedToClassrooms = 'ASSIGNED_TO_CLASSROOMS',
  AssignmentType = 'ASSIGNMENT_TYPE',
  CountOfCompletedStudents = 'COUNT_OF_COMPLETED_STUDENTS',
  CountOfGradingInProgressGuesses = 'COUNT_OF_GRADING_IN_PROGRESS_GUESSES',
  CountOfIncompleteGuesses = 'COUNT_OF_INCOMPLETE_GUESSES',
  CountOfIncompleteStudents = 'COUNT_OF_INCOMPLETE_STUDENTS',
  CountOfReleasableGradedGuesses = 'COUNT_OF_RELEASABLE_GRADED_GUESSES',
  CountOfStudentsAwaitingGrade = 'COUNT_OF_STUDENTS_AWAITING_GRADE',
  CountOfSubmittedManuallyGradedGuesses = 'COUNT_OF_SUBMITTED_MANUALLY_GRADED_GUESSES',
  CountOfUngradedGuesses = 'COUNT_OF_UNGRADED_GUESSES',
  CreatorName = 'CREATOR_NAME',
  EducatorStatus = 'EDUCATOR_STATUS',
  Id = 'ID',
  InsertedAt = 'INSERTED_AT',
  MaxDueDate = 'MAX_DUE_DATE',
  MaxStartDate = 'MAX_START_DATE',
  MinDueDate = 'MIN_DUE_DATE',
  MinStartDate = 'MIN_START_DATE',
  Name = 'NAME',
  Settings = 'SETTINGS',
  TeacherId = 'TEACHER_ID',
  UpdatedAt = 'UPDATED_AT'
}

export type AssignmentSortInput = {
  assignedToClassroomsInput?: InputMaybe<AssignmentAssignedToClassroomsFieldInput>;
  countOfCompletedStudentsInput?: InputMaybe<AssignmentCountOfCompletedStudentsFieldInput>;
  countOfGradingInProgressGuessesInput?: InputMaybe<AssignmentCountOfGradingInProgressGuessesFieldInput>;
  countOfIncompleteGuessesInput?: InputMaybe<AssignmentCountOfIncompleteGuessesFieldInput>;
  countOfIncompleteStudentsInput?: InputMaybe<AssignmentCountOfIncompleteStudentsFieldInput>;
  countOfReleasableGradedGuessesInput?: InputMaybe<AssignmentCountOfReleasableGradedGuessesFieldInput>;
  countOfStudentsAwaitingGradeInput?: InputMaybe<AssignmentCountOfStudentsAwaitingGradeFieldInput>;
  countOfSubmittedManuallyGradedGuessesInput?: InputMaybe<AssignmentCountOfSubmittedManuallyGradedGuessesFieldInput>;
  countOfUngradedGuessesInput?: InputMaybe<AssignmentCountOfUngradedGuessesFieldInput>;
  educatorStatusInput?: InputMaybe<AssignmentEducatorStatusFieldInput>;
  field: AssignmentSortField;
  maxDueDateInput?: InputMaybe<AssignmentMaxDueDateFieldInput>;
  maxStartDateInput?: InputMaybe<AssignmentMaxStartDateFieldInput>;
  minDueDateInput?: InputMaybe<AssignmentMinDueDateFieldInput>;
  minStartDateInput?: InputMaybe<AssignmentMinStartDateFieldInput>;
  order?: InputMaybe<SortOrder>;
};

export enum AssignmentStatus {
  Closed = 'CLOSED',
  Draft = 'DRAFT',
  Open = 'OPEN',
  Scheduled = 'SCHEDULED'
}

export type AudioSupplementContent = {
  __typename?: 'AudioSupplementContent';
  audio: Scalars['String']['output'];
  audioStatus?: Maybe<SupplementGenerationStatus>;
  audioText?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  languageCode?: Maybe<Scalars['String']['output']>;
  voiceId?: Maybe<Scalars['String']['output']>;
};

export type AuthoringFeedback = {
  __typename?: 'AuthoringFeedback';
  /** Content of the email sent to the question's author. Defaults to message. */
  emailMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  message: Scalars['String']['output'];
  question: Question;
  questionId: Scalars['ID']['output'];
  sentEmailAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['ID']['output'];
  /** Info about the user who left the feedback. Exposed as a calculation because user policies are self-read only; joining out to the user resource would come back empty for other reviewers' feedback. */
  userInfo?: Maybe<AuthoringFeedbackUserInfo>;
};

export type AuthoringFeedbackFilterEmailMessage = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type AuthoringFeedbackFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type AuthoringFeedbackFilterInput = {
  and?: InputMaybe<Array<AuthoringFeedbackFilterInput>>;
  /** Content of the email sent to the question's author. Defaults to message. */
  emailMessage?: InputMaybe<AuthoringFeedbackFilterEmailMessage>;
  id?: InputMaybe<AuthoringFeedbackFilterId>;
  insertedAt?: InputMaybe<AuthoringFeedbackFilterInsertedAt>;
  message?: InputMaybe<AuthoringFeedbackFilterMessage>;
  not?: InputMaybe<Array<AuthoringFeedbackFilterInput>>;
  or?: InputMaybe<Array<AuthoringFeedbackFilterInput>>;
  question?: InputMaybe<QuestionFilterInput>;
  questionId?: InputMaybe<AuthoringFeedbackFilterQuestionId>;
  sentEmailAt?: InputMaybe<AuthoringFeedbackFilterSentEmailAt>;
  updatedAt?: InputMaybe<AuthoringFeedbackFilterUpdatedAt>;
  user?: InputMaybe<UserFilterInput>;
  userId?: InputMaybe<AuthoringFeedbackFilterUserId>;
};

export type AuthoringFeedbackFilterInsertedAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AuthoringFeedbackFilterMessage = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type AuthoringFeedbackFilterQuestionId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type AuthoringFeedbackFilterSentEmailAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AuthoringFeedbackFilterUpdatedAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AuthoringFeedbackFilterUserId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export enum AuthoringFeedbackSortField {
  EmailMessage = 'EMAIL_MESSAGE',
  Id = 'ID',
  InsertedAt = 'INSERTED_AT',
  Message = 'MESSAGE',
  QuestionId = 'QUESTION_ID',
  SentEmailAt = 'SENT_EMAIL_AT',
  UpdatedAt = 'UPDATED_AT',
  UserId = 'USER_ID'
}

export type AuthoringFeedbackSortInput = {
  field: AuthoringFeedbackSortField;
  order?: InputMaybe<SortOrder>;
};

export type AuthoringFeedbackUserInfo = {
  __typename?: 'AuthoringFeedbackUserInfo';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type BulkCreateManagedUsersInput = {
  coppaConsentEmail: Scalars['String']['input'];
  schoolId: Scalars['ID']['input'];
  students: Array<ManagedUserStudentInput>;
};

/** The result of the :bulk_create_managed_users mutation */
export type BulkCreateManagedUsersResult = {
  __typename?: 'BulkCreateManagedUsersResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<Array<ManagedUserCreateResult>>;
};

export type BulkCreateStandardsInput = {
  /**
   * Whether to allow creating standards whose title or description match an already
   * existing standard in the same standard set.
   */
  allowDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
  standards: Array<StandardBulkCreateInput>;
};

export type BulkSetLicenseAccessStatusInput = {
  ids: Array<Scalars['ID']['input']>;
  status: Scalars['String']['input'];
};

export type BulkStatusUpdateResult = {
  __typename?: 'BulkStatusUpdateResult';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type BuySubscriptions = {
  __typename?: 'BuySubscriptions';
  amount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  subscriptionIds?: Maybe<Array<Scalars['ID']['output']>>;
};

export type BuySubscriptionsInput = {
  cardToken?: InputMaybe<Scalars['String']['input']>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  fingerprint?: InputMaybe<Scalars['String']['input']>;
  subscriptionDetails: Array<BuySubscriptionsSubscriptionDetailsInput>;
};

/** The result of the :buy_subscriptions mutation */
export type BuySubscriptionsResult = {
  __typename?: 'BuySubscriptionsResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<BuySubscriptions>;
};

export type BuySubscriptionsSubscriptionDetailsInput = {
  expiresInMonths?: InputMaybe<Scalars['Int']['input']>;
  subjectId?: InputMaybe<Scalars['ID']['input']>;
};

export enum CalculatorType {
  Basic = 'BASIC',
  Graphing = 'GRAPHING',
  None = 'NONE',
  Scientific = 'SCIENTIFIC'
}

export type CheckUsernameAvailabilityInput = {
  username: Scalars['String']['input'];
};

export type ClassroomAssignment = {
  __typename?: 'ClassroomAssignment';
  assignmentId: Scalars['ID']['output'];
  assignmentType: Scalars['String']['output'];
  classroomId: Scalars['ID']['output'];
  /** Whether the assignment contains any manually-graded questions (rubric type in Grading.Rubric.manually_graded_types/0, e.g. criteria) — the questions whose grades are gated by teacher release. */
  containsManuallyGradedQuestions?: Maybe<Scalars['Boolean']['output']>;
  countOfQuestions: Scalars['Int']['output'];
  /** Whether finalized grades are viewable by students for this class: true when a teacher has released, or when the assignment has no manually-graded questions to gate. */
  gradesReleased?: Maybe<Scalars['Boolean']['output']>;
  gradesReleasedAt?: Maybe<Scalars['DateTime']['output']>;
  hasStarted?: Maybe<Scalars['Boolean']['output']>;
  hasStudentSubmitted?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /**
   * Whether students in this classroom may access locked question content inside
   * this assignment (admin-only decision). This is the value a student's access
   * resolves from, and the only one: every classroom starts out not authorized
   * when it is added to an assignment, nothing is inherited, seeded or cascaded
   * from the assignment, and nothing but an admin's explicit write on this row
   * changes it.
   */
  lockAuthorized: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  settings: ClassroomAssignmentSettings;
  studentAllowLateSubmissions: Scalars['Boolean']['output'];
  /**
   * The acting student's own student_assignment for this assignment — the place to read
   * their grade and submission state from. Nil until the student has been assigned, and for
   * non-student actors.
   */
  studentAssignment?: Maybe<StudentAssignment>;
  studentCorrectAnswerSetting: Scalars['String']['output'];
  studentDueDate: Scalars['DateTime']['output'];
  studentPartialCreditEnabled: Scalars['Boolean']['output'];
};

export type ClassroomAssignmentFilterAssignmentId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type ClassroomAssignmentFilterAssignmentType = {
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type ClassroomAssignmentFilterClassroomId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type ClassroomAssignmentFilterContainsManuallyGradedQuestions = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClassroomAssignmentFilterCountOfQuestions = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type ClassroomAssignmentFilterGradesReleased = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClassroomAssignmentFilterGradesReleasedAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ClassroomAssignmentFilterHasStarted = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClassroomAssignmentFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type ClassroomAssignmentFilterInput = {
  and?: InputMaybe<Array<ClassroomAssignmentFilterInput>>;
  assignmentId?: InputMaybe<ClassroomAssignmentFilterAssignmentId>;
  assignmentType?: InputMaybe<ClassroomAssignmentFilterAssignmentType>;
  classroomId?: InputMaybe<ClassroomAssignmentFilterClassroomId>;
  /** Whether the assignment contains any manually-graded questions (rubric type in Grading.Rubric.manually_graded_types/0, e.g. criteria) — the questions whose grades are gated by teacher release. */
  containsManuallyGradedQuestions?: InputMaybe<ClassroomAssignmentFilterContainsManuallyGradedQuestions>;
  countOfQuestions?: InputMaybe<ClassroomAssignmentFilterCountOfQuestions>;
  /** Whether finalized grades are viewable by students for this class: true when a teacher has released, or when the assignment has no manually-graded questions to gate. */
  gradesReleased?: InputMaybe<ClassroomAssignmentFilterGradesReleased>;
  gradesReleasedAt?: InputMaybe<ClassroomAssignmentFilterGradesReleasedAt>;
  hasStarted?: InputMaybe<ClassroomAssignmentFilterHasStarted>;
  id?: InputMaybe<ClassroomAssignmentFilterId>;
  /**
   * Whether students in this classroom may access locked question content inside
   * this assignment (admin-only decision). This is the value a student's access
   * resolves from, and the only one: every classroom starts out not authorized
   * when it is added to an assignment, nothing is inherited, seeded or cascaded
   * from the assignment, and nothing but an admin's explicit write on this row
   * changes it.
   */
  lockAuthorized?: InputMaybe<ClassroomAssignmentFilterLockAuthorized>;
  name?: InputMaybe<ClassroomAssignmentFilterName>;
  not?: InputMaybe<Array<ClassroomAssignmentFilterInput>>;
  or?: InputMaybe<Array<ClassroomAssignmentFilterInput>>;
  settings?: InputMaybe<ClassroomAssignmentFilterSettings>;
  studentAllowLateSubmissions?: InputMaybe<ClassroomAssignmentFilterStudentAllowLateSubmissions>;
  /**
   * The acting student's own student_assignment for this assignment — the place to read
   * their grade and submission state from. Nil until the student has been assigned, and for
   * non-student actors.
   */
  studentAssignment?: InputMaybe<StudentAssignmentFilterInput>;
  studentCorrectAnswerSetting?: InputMaybe<ClassroomAssignmentFilterStudentCorrectAnswerSetting>;
  studentDueDate?: InputMaybe<ClassroomAssignmentFilterStudentDueDate>;
  studentPartialCreditEnabled?: InputMaybe<ClassroomAssignmentFilterStudentPartialCreditEnabled>;
};

export type ClassroomAssignmentFilterLockAuthorized = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClassroomAssignmentFilterName = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type ClassroomAssignmentFilterSettings = {
  eq?: InputMaybe<ClassroomAssignmentSettingsInput>;
  greaterThan?: InputMaybe<ClassroomAssignmentSettingsInput>;
  greaterThanOrEqual?: InputMaybe<ClassroomAssignmentSettingsInput>;
  in?: InputMaybe<Array<ClassroomAssignmentSettingsInput>>;
  isDistinctFrom?: InputMaybe<ClassroomAssignmentSettingsInput>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<ClassroomAssignmentSettingsInput>;
  lessThan?: InputMaybe<ClassroomAssignmentSettingsInput>;
  lessThanOrEqual?: InputMaybe<ClassroomAssignmentSettingsInput>;
  notEq?: InputMaybe<ClassroomAssignmentSettingsInput>;
};

export type ClassroomAssignmentFilterStudentAllowLateSubmissions = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClassroomAssignmentFilterStudentCorrectAnswerSetting = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type ClassroomAssignmentFilterStudentDueDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ClassroomAssignmentFilterStudentPartialCreditEnabled = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClassroomAssignmentSettings = {
  __typename?: 'ClassroomAssignmentSettings';
  allowLateSubmissions: Scalars['Boolean']['output'];
  autoAssignNewClassroomEnrollees?: Maybe<Scalars['Boolean']['output']>;
  calculatorSetting: AssignmentCalculatorSetting;
  correctAnswerSetting: Scalars['String']['output'];
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  googleCourseworkId?: Maybe<Scalars['String']['output']>;
  lockdownModeEnabled: Scalars['Boolean']['output'];
  ltiLineItemId?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  partialCreditEnabled?: Maybe<Scalars['Boolean']['output']>;
  randomizeQuestionOrder?: Maybe<Scalars['Boolean']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  timeLimit?: Maybe<Scalars['Int']['output']>;
  translationAccess?: Maybe<Scalars['Boolean']['output']>;
};

export type ClassroomAssignmentSettingsInput = {
  allowLateSubmissions: Scalars['Boolean']['input'];
  autoAssignNewClassroomEnrollees?: InputMaybe<Scalars['Boolean']['input']>;
  calculatorSetting: AssignmentCalculatorSetting;
  correctAnswerSetting: Scalars['String']['input'];
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  googleCourseworkId?: InputMaybe<Scalars['String']['input']>;
  lockdownModeEnabled: Scalars['Boolean']['input'];
  ltiLineItemId?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  partialCreditEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  randomizeQuestionOrder?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  timeLimit?: InputMaybe<Scalars['Int']['input']>;
  translationAccess?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ClassroomAssignmentSortField {
  AssignmentId = 'ASSIGNMENT_ID',
  AssignmentType = 'ASSIGNMENT_TYPE',
  ClassroomId = 'CLASSROOM_ID',
  ContainsManuallyGradedQuestions = 'CONTAINS_MANUALLY_GRADED_QUESTIONS',
  CountOfQuestions = 'COUNT_OF_QUESTIONS',
  GradesReleased = 'GRADES_RELEASED',
  GradesReleasedAt = 'GRADES_RELEASED_AT',
  HasStarted = 'HAS_STARTED',
  Id = 'ID',
  LockAuthorized = 'LOCK_AUTHORIZED',
  Name = 'NAME',
  Settings = 'SETTINGS',
  StudentAllowLateSubmissions = 'STUDENT_ALLOW_LATE_SUBMISSIONS',
  StudentCorrectAnswerSetting = 'STUDENT_CORRECT_ANSWER_SETTING',
  StudentDueDate = 'STUDENT_DUE_DATE',
  StudentPartialCreditEnabled = 'STUDENT_PARTIAL_CREDIT_ENABLED'
}

export type ClassroomAssignmentSortInput = {
  field: ClassroomAssignmentSortField;
  order?: InputMaybe<SortOrder>;
};

export type ClassroomContentAccess = {
  __typename?: 'ClassroomContentAccess';
  /** The classroom these facts answer for. */
  classroomId: Scalars['ID']['output'];
  /**
   * Whether any of the given questions is restricted at this classroom's school.
   *
   * Answers for the classroom's school, never the viewer's: a teacher with classes
   * at two schools gets a different answer per class, which the per-viewer
   * redaction on questions cannot express.
   *
   * Reports the state of the content, not whether students are currently blocked,
   * so it stays true once an admin has granted access — the same convention as
   * `Assignment.hasLockedContent`. A restriction also outlives the platform-wide
   * switch that suspends redaction, so this is unaffected by it.
   */
  contentRestricted: Scalars['Boolean']['output'];
  /**
   * Whether this classroom's school holds an active Pro license.
   *
   * False alongside `contentRestricted: true` is the lapsed-Pro state: Pro is
   * required to create restrictions but not to enforce them, so restrictions
   * outlive the license that created them. Nothing on the server refuses a grant
   * for a non-Pro school today — this reports the license, and the client is what
   * withholds the control.
   */
  schoolHasPro: Scalars['Boolean']['output'];
  /**
   * Whether the caller is an approved administrator at this classroom's school.
   *
   * This is the school half of what `setClassroomAssignmentLockAuthorization`
   * requires, so it will not offer a control to someone whose role would be
   * refused. It is not the whole gate: that mutation also requires the assignment
   * to be published, which this query does not report, so a grant on a draft is
   * rejected even where this is true. Always true for superusers.
   */
  viewerAdministersSchool: Scalars['Boolean']['output'];
};

export type ClassroomDiagnosticConfig = {
  __typename?: 'ClassroomDiagnosticConfig';
  /**
   * Whether this class-level recipient's class is archived — see
   * `Mandark.Assignments.Calculations.ArchivedRecipient`. The settings editor groups recipients on
   * this so an educator is never shown archived and active recipients as one group.
   */
  archived?: Maybe<Scalars['Boolean']['output']>;
  classroom: ClassroomsClassroom;
  classroomId: Scalars['ID']['output'];
  diagnostic: Diagnostic;
  diagnosticId: Scalars['ID']['output'];
  diagnosticSettings: DiagnosticSettings;
  diagnosticSettingsId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
};

export type ClassroomDiagnosticConfigFilterArchived = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClassroomDiagnosticConfigFilterClassroomId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type ClassroomDiagnosticConfigFilterDiagnosticId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type ClassroomDiagnosticConfigFilterDiagnosticSettingsId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type ClassroomDiagnosticConfigFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type ClassroomDiagnosticConfigFilterInput = {
  and?: InputMaybe<Array<ClassroomDiagnosticConfigFilterInput>>;
  /**
   * Whether this class-level recipient's class is archived — see
   * `Mandark.Assignments.Calculations.ArchivedRecipient`. The settings editor groups recipients on
   * this so an educator is never shown archived and active recipients as one group.
   */
  archived?: InputMaybe<ClassroomDiagnosticConfigFilterArchived>;
  classroom?: InputMaybe<ClassroomsClassroomFilterInput>;
  classroomId?: InputMaybe<ClassroomDiagnosticConfigFilterClassroomId>;
  diagnostic?: InputMaybe<DiagnosticFilterInput>;
  diagnosticId?: InputMaybe<ClassroomDiagnosticConfigFilterDiagnosticId>;
  diagnosticSettings?: InputMaybe<DiagnosticSettingsFilterInput>;
  diagnosticSettingsId?: InputMaybe<ClassroomDiagnosticConfigFilterDiagnosticSettingsId>;
  id?: InputMaybe<ClassroomDiagnosticConfigFilterId>;
  not?: InputMaybe<Array<ClassroomDiagnosticConfigFilterInput>>;
  or?: InputMaybe<Array<ClassroomDiagnosticConfigFilterInput>>;
};

export enum ClassroomDiagnosticConfigSortField {
  Archived = 'ARCHIVED',
  ClassroomId = 'CLASSROOM_ID',
  DiagnosticId = 'DIAGNOSTIC_ID',
  DiagnosticSettingsId = 'DIAGNOSTIC_SETTINGS_ID',
  Id = 'ID'
}

export type ClassroomDiagnosticConfigSortInput = {
  field: ClassroomDiagnosticConfigSortField;
  order?: InputMaybe<SortOrder>;
};

export type ClassroomInvitation = {
  __typename?: 'ClassroomInvitation';
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  needsApproval?: Maybe<Scalars['Boolean']['output']>;
  sentEmailAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ClassroomInvitationBulkCreateInput = {
  attributes: Array<ClassroomInvitationInput>;
};

export type ClassroomInvitationBulkItemResult = {
  __typename?: 'ClassroomInvitationBulkItemResult';
  email: Scalars['String']['output'];
  errorCode?: Maybe<Scalars['String']['output']>;
  errorDetail?: Maybe<Scalars['String']['output']>;
  invitation?: Maybe<ClassroomInvitation>;
};

export type ClassroomInvitationBulkReinviteInput = {
  attributes: Array<ClassroomInvitationInput>;
};

export type ClassroomInvitationInput = {
  classroomId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  issuerId: Scalars['String']['input'];
};

export type ClassroomInvitationReinviteInput = {
  attributes: ClassroomInvitationInput;
};

export type ClassroomSkillPathConfig = {
  __typename?: 'ClassroomSkillPathConfig';
  /**
   * Whether this class-level recipient's class is archived — see
   * `Mandark.Learning.Calculations.ArchivedRecipient`. The skill modal groups recipients on this
   * so a teacher is never shown archived and active recipients as one group.
   */
  archived?: Maybe<Scalars['Boolean']['output']>;
  classroom: ClassroomsClassroom;
  classroomId: Scalars['ID']['output'];
  guideLevel?: Maybe<GuideLevel>;
  guideLevelId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  skillPathSettings: SkillPathSettings;
  skillPathSettingsId: Scalars['ID']['output'];
  unfilteredGuideLevel: GuideLevel;
};


export type ClassroomSkillPathConfigSkillPathSettingsArgs = {
  asEducatorId?: InputMaybe<Scalars['ID']['input']>;
};

export type ClassroomSkillPathConfigFilterArchived = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClassroomSkillPathConfigFilterClassroomId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type ClassroomSkillPathConfigFilterGuideLevelId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type ClassroomSkillPathConfigFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type ClassroomSkillPathConfigFilterInput = {
  and?: InputMaybe<Array<ClassroomSkillPathConfigFilterInput>>;
  /**
   * Whether this class-level recipient's class is archived — see
   * `Mandark.Learning.Calculations.ArchivedRecipient`. The skill modal groups recipients on this
   * so a teacher is never shown archived and active recipients as one group.
   */
  archived?: InputMaybe<ClassroomSkillPathConfigFilterArchived>;
  classroom?: InputMaybe<ClassroomsClassroomFilterInput>;
  classroomId?: InputMaybe<ClassroomSkillPathConfigFilterClassroomId>;
  guideLevel?: InputMaybe<GuideLevelFilterInput>;
  guideLevelId?: InputMaybe<ClassroomSkillPathConfigFilterGuideLevelId>;
  id?: InputMaybe<ClassroomSkillPathConfigFilterId>;
  not?: InputMaybe<Array<ClassroomSkillPathConfigFilterInput>>;
  or?: InputMaybe<Array<ClassroomSkillPathConfigFilterInput>>;
  skillPathSettings?: InputMaybe<SkillPathSettingsFilterInput>;
  skillPathSettingsId?: InputMaybe<ClassroomSkillPathConfigFilterSkillPathSettingsId>;
  unfilteredGuideLevel?: InputMaybe<GuideLevelFilterInput>;
};

export type ClassroomSkillPathConfigFilterSkillPathSettingsId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export enum ClassroomSkillPathConfigSortField {
  Archived = 'ARCHIVED',
  ClassroomId = 'CLASSROOM_ID',
  GuideLevelId = 'GUIDE_LEVEL_ID',
  Id = 'ID',
  SkillPathSettingsId = 'SKILL_PATH_SETTINGS_ID'
}

export type ClassroomSkillPathConfigSortInput = {
  field: ClassroomSkillPathConfigSortField;
  order?: InputMaybe<SortOrder>;
};

export type ClassroomSubject = {
  __typename?: 'ClassroomSubject';
  classroom: ClassroomsClassroom;
  classroomId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  partialCreditEnabled?: Maybe<Scalars['Boolean']['output']>;
  restrictFreePractice?: Maybe<Scalars['Boolean']['output']>;
  subject?: Maybe<Subject>;
  subjectId: Scalars['ID']['output'];
  unfilteredSubject: Subject;
};

export type ClassroomSubjectFilterClassroomId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type ClassroomSubjectFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type ClassroomSubjectFilterInput = {
  and?: InputMaybe<Array<ClassroomSubjectFilterInput>>;
  classroom?: InputMaybe<ClassroomsClassroomFilterInput>;
  classroomId?: InputMaybe<ClassroomSubjectFilterClassroomId>;
  id?: InputMaybe<ClassroomSubjectFilterId>;
  not?: InputMaybe<Array<ClassroomSubjectFilterInput>>;
  or?: InputMaybe<Array<ClassroomSubjectFilterInput>>;
  partialCreditEnabled?: InputMaybe<ClassroomSubjectFilterPartialCreditEnabled>;
  restrictFreePractice?: InputMaybe<ClassroomSubjectFilterRestrictFreePractice>;
  subject?: InputMaybe<SubjectFilterInput>;
  subjectId?: InputMaybe<ClassroomSubjectFilterSubjectId>;
  unfilteredSubject?: InputMaybe<SubjectFilterInput>;
};

export type ClassroomSubjectFilterPartialCreditEnabled = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClassroomSubjectFilterRestrictFreePractice = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClassroomSubjectFilterSubjectId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export enum ClassroomSubjectSortField {
  ClassroomId = 'CLASSROOM_ID',
  Id = 'ID',
  PartialCreditEnabled = 'PARTIAL_CREDIT_ENABLED',
  RestrictFreePractice = 'RESTRICT_FREE_PRACTICE',
  SubjectId = 'SUBJECT_ID'
}

export type ClassroomSubjectSortInput = {
  field: ClassroomSubjectSortField;
  order?: InputMaybe<SortOrder>;
};

export type ClassroomsClassroom = {
  __typename?: 'ClassroomsClassroom';
  classroomAssignments: Array<ClassroomAssignment>;
  id: Scalars['ID']['output'];
};


export type ClassroomsClassroomClassroomAssignmentsArgs = {
  filter?: InputMaybe<ClassroomAssignmentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ClassroomAssignmentSortInput>>>;
};

export type ClassroomsClassroomFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type ClassroomsClassroomFilterInput = {
  and?: InputMaybe<Array<ClassroomsClassroomFilterInput>>;
  classroomAssignments?: InputMaybe<ClassroomAssignmentFilterInput>;
  id?: InputMaybe<ClassroomsClassroomFilterId>;
  not?: InputMaybe<Array<ClassroomsClassroomFilterInput>>;
  or?: InputMaybe<Array<ClassroomsClassroomFilterInput>>;
};

export enum ClassroomsClassroomSortField {
  Id = 'ID'
}

export type ClassroomsClassroomSortInput = {
  field: ClassroomsClassroomSortField;
  order?: InputMaybe<SortOrder>;
};

/** The result of the :complete_workflow_step mutation */
export type CompleteWorkflowStepResult = {
  __typename?: 'CompleteWorkflowStepResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<UserWorkflowStep>;
};

export type ContainsRubric = {
  __typename?: 'ContainsRubric';
  validResponse: Scalars['JsonString']['output'];
};

export type ContainsRubricInput = {
  validResponse: Scalars['JsonString']['input'];
};

export type ContentLock = {
  __typename?: 'ContentLock';
  createdBy: Scalars['ID']['output'];
  creator: User;
  id: Scalars['ID']['output'];
  lockType: Scalars['String']['output'];
  school: School;
  schoolId: Scalars['ID']['output'];
  sourceId: Scalars['ID']['output'];
};

export type ContentLockFilterCreatedBy = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type ContentLockFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type ContentLockFilterInput = {
  and?: InputMaybe<Array<ContentLockFilterInput>>;
  createdBy?: InputMaybe<ContentLockFilterCreatedBy>;
  creator?: InputMaybe<UserFilterInput>;
  id?: InputMaybe<ContentLockFilterId>;
  lockType?: InputMaybe<ContentLockFilterLockType>;
  not?: InputMaybe<Array<ContentLockFilterInput>>;
  or?: InputMaybe<Array<ContentLockFilterInput>>;
  school?: InputMaybe<SchoolFilterInput>;
  schoolId?: InputMaybe<ContentLockFilterSchoolId>;
  sourceId?: InputMaybe<ContentLockFilterSourceId>;
};

export type ContentLockFilterLockType = {
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type ContentLockFilterSchoolId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type ContentLockFilterSourceId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type ContentLockGracePeriod = {
  __typename?: 'ContentLockGracePeriod';
  /** When the school's content locks are removed unless pro is restored first. A day boundary, since admins are told a date. */
  endDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  school: School;
  schoolId: Scalars['ID']['output'];
  /** When the school was first observed without an active pro license. */
  startDate: Scalars['DateTime']['output'];
};

export type ContentLockGracePeriodFilterEndDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ContentLockGracePeriodFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type ContentLockGracePeriodFilterInput = {
  and?: InputMaybe<Array<ContentLockGracePeriodFilterInput>>;
  /** When the school's content locks are removed unless pro is restored first. A day boundary, since admins are told a date. */
  endDate?: InputMaybe<ContentLockGracePeriodFilterEndDate>;
  id?: InputMaybe<ContentLockGracePeriodFilterId>;
  not?: InputMaybe<Array<ContentLockGracePeriodFilterInput>>;
  or?: InputMaybe<Array<ContentLockGracePeriodFilterInput>>;
  school?: InputMaybe<SchoolFilterInput>;
  schoolId?: InputMaybe<ContentLockGracePeriodFilterSchoolId>;
  /** When the school was first observed without an active pro license. */
  startDate?: InputMaybe<ContentLockGracePeriodFilterStartDate>;
};

export type ContentLockGracePeriodFilterSchoolId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type ContentLockGracePeriodFilterStartDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum ContentLockGracePeriodSortField {
  EndDate = 'END_DATE',
  Id = 'ID',
  SchoolId = 'SCHOOL_ID',
  StartDate = 'START_DATE'
}

export type ContentLockGracePeriodSortInput = {
  field: ContentLockGracePeriodSortField;
  order?: InputMaybe<SortOrder>;
};

export enum ContentLockSortField {
  CreatedBy = 'CREATED_BY',
  Id = 'ID',
  LockType = 'LOCK_TYPE',
  SchoolId = 'SCHOOL_ID',
  SourceId = 'SOURCE_ID'
}

export type ContentLockSortInput = {
  field: ContentLockSortField;
  order?: InputMaybe<SortOrder>;
};

export type CoppaConsentGrant = {
  __typename?: 'CoppaConsentGrant';
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Email address of the consenting parent/guardian. */
  consentEmail: Scalars['String']['output'];
  consentMethod?: Maybe<CoppaConsentMethod>;
  consenterMetadata: Scalars['JsonString']['output'];
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  sentEmailAt?: Maybe<Scalars['DateTime']['output']>;
  user: User;
  userId: Scalars['ID']['output'];
};

export type CoppaConsentGrantFilterApprovedAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CoppaConsentGrantFilterConsentEmail = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type CoppaConsentGrantFilterConsentMethod = {
  eq?: InputMaybe<CoppaConsentMethod>;
  greaterThan?: InputMaybe<CoppaConsentMethod>;
  greaterThanOrEqual?: InputMaybe<CoppaConsentMethod>;
  in?: InputMaybe<Array<InputMaybe<CoppaConsentMethod>>>;
  isDistinctFrom?: InputMaybe<CoppaConsentMethod>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<CoppaConsentMethod>;
  lessThan?: InputMaybe<CoppaConsentMethod>;
  lessThanOrEqual?: InputMaybe<CoppaConsentMethod>;
  notEq?: InputMaybe<CoppaConsentMethod>;
};

export type CoppaConsentGrantFilterConsenterMetadata = {
  eq?: InputMaybe<Scalars['JsonString']['input']>;
  greaterThan?: InputMaybe<Scalars['JsonString']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['JsonString']['input']>;
  in?: InputMaybe<Array<Scalars['JsonString']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['JsonString']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['JsonString']['input']>;
  lessThan?: InputMaybe<Scalars['JsonString']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['JsonString']['input']>;
  notEq?: InputMaybe<Scalars['JsonString']['input']>;
};

export type CoppaConsentGrantFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type CoppaConsentGrantFilterInput = {
  and?: InputMaybe<Array<CoppaConsentGrantFilterInput>>;
  approvedAt?: InputMaybe<CoppaConsentGrantFilterApprovedAt>;
  /** Email address of the consenting parent/guardian. */
  consentEmail?: InputMaybe<CoppaConsentGrantFilterConsentEmail>;
  consentMethod?: InputMaybe<CoppaConsentGrantFilterConsentMethod>;
  consenterMetadata?: InputMaybe<CoppaConsentGrantFilterConsenterMetadata>;
  id?: InputMaybe<CoppaConsentGrantFilterId>;
  insertedAt?: InputMaybe<CoppaConsentGrantFilterInsertedAt>;
  not?: InputMaybe<Array<CoppaConsentGrantFilterInput>>;
  or?: InputMaybe<Array<CoppaConsentGrantFilterInput>>;
  sentEmailAt?: InputMaybe<CoppaConsentGrantFilterSentEmailAt>;
  user?: InputMaybe<UserFilterInput>;
  userId?: InputMaybe<CoppaConsentGrantFilterUserId>;
};

export type CoppaConsentGrantFilterInsertedAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CoppaConsentGrantFilterSentEmailAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CoppaConsentGrantFilterUserId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export enum CoppaConsentGrantSortField {
  ApprovedAt = 'APPROVED_AT',
  ConsenterMetadata = 'CONSENTER_METADATA',
  ConsentEmail = 'CONSENT_EMAIL',
  ConsentMethod = 'CONSENT_METHOD',
  Id = 'ID',
  InsertedAt = 'INSERTED_AT',
  SentEmailAt = 'SENT_EMAIL_AT',
  UserId = 'USER_ID'
}

export type CoppaConsentGrantSortInput = {
  field: CoppaConsentGrantSortField;
  order?: InputMaybe<SortOrder>;
};

export enum CoppaConsentMethod {
  AdminCreate = 'ADMIN_CREATE',
  Batch = 'BATCH',
  ClassroomEnroll = 'CLASSROOM_ENROLL',
  Email = 'EMAIL'
}

export type CouponQuote = {
  __typename?: 'CouponQuote';
  code: Scalars['String']['output'];
  discountCents: Scalars['Int']['output'];
  finalCents: Scalars['Int']['output'];
  subtotalCents: Scalars['Int']['output'];
};

export type CreateAuthoringFeedbackInput = {
  /** Content of the email sent to the question's author. Defaults to message. */
  emailMessage?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  questionId: Scalars['ID']['input'];
};

/** The result of the :create_authoring_feedback mutation */
export type CreateAuthoringFeedbackResult = {
  __typename?: 'CreateAuthoringFeedbackResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<AuthoringFeedback>;
};

export type CreateClassroomInvitationInput = {
  classroomId?: InputMaybe<Scalars['ID']['input']>;
  email: Scalars['String']['input'];
  issuerId?: InputMaybe<Scalars['ID']['input']>;
};

/** The result of the :create_classroom_invitation mutation */
export type CreateClassroomInvitationResult = {
  __typename?: 'CreateClassroomInvitationResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<ClassroomInvitation>;
};

export type CreateCustomerFeedbackEntryInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  grade: Scalars['Int']['input'];
  urlSlug: Scalars['String']['input'];
};

/** The result of the :create_customer_feedback_entry mutation */
export type CreateCustomerFeedbackEntryResult = {
  __typename?: 'CreateCustomerFeedbackEntryResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<CustomerFeedbackEntry>;
};

export type CreateDiagnosticInput = {
  diagnosticTemplateId?: InputMaybe<Scalars['ID']['input']>;
  guideId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  recipientGroups?: InputMaybe<Array<DiagnosticRecipientGroupInput>>;
  skillIds: Array<Scalars['ID']['input']>;
};

/** The result of the :create_diagnostic mutation */
export type CreateDiagnosticResult = {
  __typename?: 'CreateDiagnosticResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<Diagnostic>;
};

export type CreateDistrictInput = {
  cleverId?: InputMaybe<Scalars['String']['input']>;
  county: Scalars['String']['input'];
  name: Scalars['String']['input'];
  ncesId?: InputMaybe<Scalars['String']['input']>;
  ncesLocale: NcesLocale;
  state?: InputMaybe<UsState>;
};

/** The result of the :create_district mutation */
export type CreateDistrictResult = {
  __typename?: 'CreateDistrictResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<District>;
};

export type CreateGuideInput = {
  /**
   * The adaptive advance threshold for every skill in this guide, if any. Resolved the same
   * way as `adaptive_range`.
   */
  adaptiveAdvanceThreshold?: InputMaybe<Scalars['Int']['input']>;
  /**
   * The adaptive fallback threshold for every skill in this guide, if any. Resolved the same
   * way as `adaptive_range`.
   */
  adaptiveFallbackThreshold?: InputMaybe<Scalars['Int']['input']>;
  /**
   * The diagnostic scoring engine's k-factor (learning rate) for every skill in this guide,
   * if any. Resolved the same way as `adaptive_range`.
   */
  adaptiveKFactor?: InputMaybe<Scalars['Float']['input']>;
  /**
   * The adaptive range setting for every skill in this guide, if any. Skills and their
   * ancestors override it; the subject and the global default back it up. Read the effective
   * value from a guide level's `effective_adaptive_range` calculation rather than here.
   */
  adaptiveRange?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  /**
   * Content's display order for this guide within its subject. Guides without one sort after
   * those that have one; ties break alphabetically. Callers listing guides to users sort by
   * `position` ascending with nulls last, then `name`.
   */
  position?: InputMaybe<Scalars['Int']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  subjectId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

/** The result of the :create_guide mutation */
export type CreateGuideResult = {
  __typename?: 'CreateGuideResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<Guide>;
};

export type CreateQuestionInput = {
  answerBreakdown?: InputMaybe<Scalars['JsonString']['input']>;
  authorId: Scalars['ID']['input'];
  /**
   * The highest calculator tier this question allows, if set. Tiers are additive: graphing also
   * permits scientific and basic. An explicit `none` withholds the calculator.
   * This is only the stored value. Unset means the question has no setting of its own; clients resolve
   * availability from its guide levels.
   */
  calculatorType?: InputMaybe<CalculatorType>;
  chainPath?: InputMaybe<Scalars['Json']['input']>;
  difficulty?: InputMaybe<Scalars['Int']['input']>;
  guideLevel?: InputMaybe<Scalars['ID']['input']>;
  /** Auto-generated if not provided. Only used by the adaptive import process. */
  legacyQuestionSetSlugId?: InputMaybe<Scalars['String']['input']>;
  ownerId: Scalars['ID']['input'];
  prompt?: InputMaybe<Scalars['String']['input']>;
  rubric: RubricInput;
  slugId?: InputMaybe<Scalars['String']['input']>;
  solutionText?: InputMaybe<Scalars['String']['input']>;
  standards?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<QuestionStatus>;
  subjectId: Scalars['ID']['input'];
  tags?: InputMaybe<Array<Scalars['ID']['input']>>;
  title: Scalars['String']['input'];
  translate?: InputMaybe<Scalars['Boolean']['input']>;
  translateSupplements?: InputMaybe<Scalars['Boolean']['input']>;
  typeAttributes: QuestionTypeAttributesInput;
};

/** The result of the :create_question mutation */
export type CreateQuestionResult = {
  __typename?: 'CreateQuestionResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<Question>;
};

export type CreateStandardInput = {
  caseId?: InputMaybe<Scalars['ID']['input']>;
  description: Scalars['String']['input'];
  standardSetId: Scalars['ID']['input'];
  statusEndDate?: InputMaybe<Scalars['Date']['input']>;
  statusStartDate?: InputMaybe<Scalars['Date']['input']>;
  title: Scalars['String']['input'];
  uri?: InputMaybe<Scalars['String']['input']>;
};

/** The result of the :create_standard mutation */
export type CreateStandardResult = {
  __typename?: 'CreateStandardResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<Standard>;
};

export type CreateStandardSetCreatorInput = {
  name: Scalars['String']['input'];
  /**
   * What kind of body publishes this creator's standards. Nullable because the only UI that
   * creates publishers — the Dennis standard set editor — has never collected a type, so rows
   * created through it have none. Feeds the `standard_set_creator_type` analytics dimension.
   */
  type?: InputMaybe<StandardSetCreatorType>;
};

/** The result of the :create_standard_set_creator mutation */
export type CreateStandardSetCreatorResult = {
  __typename?: 'CreateStandardSetCreatorResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<StandardSetCreator>;
};

export type CreateStandardSetInput = {
  adoptionStatus?: InputMaybe<Scalars['String']['input']>;
  caseId?: InputMaybe<Scalars['ID']['input']>;
  /** The curriculum areas the standard set belongs to. At least one is required. */
  curriculumAreaIds: Array<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  officialSourceUrl?: InputMaybe<Scalars['String']['input']>;
  standardSetCreatorId?: InputMaybe<Scalars['ID']['input']>;
  statusEndDate?: InputMaybe<Scalars['Date']['input']>;
  statusStartDate?: InputMaybe<Scalars['Date']['input']>;
  /** The subjects whose questions may align to standards in this standard set. */
  subjectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  title: Scalars['String']['input'];
  uri?: InputMaybe<Scalars['String']['input']>;
};

/** The result of the :create_standard_set mutation */
export type CreateStandardSetResult = {
  __typename?: 'CreateStandardSetResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<StandardSet>;
};

export type CreateStripeCardInput = {
  cardToken: Scalars['String']['input'];
};

/** The result of the :create_stripe_card mutation */
export type CreateStripeCardResult = {
  __typename?: 'CreateStripeCardResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<StripeCard>;
};

export type CreateSubjectFaqInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  subjectId: Scalars['ID']['input'];
};

/** The result of the :create_subject_faq mutation */
export type CreateSubjectFaqResult = {
  __typename?: 'CreateSubjectFaqResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<SubjectFaq>;
};

export type CreateSubjectInput = {
  adaptive: Scalars['Boolean']['input'];
  /**
   * The adaptive advance threshold for every skill in this subject, if any. Resolved the same
   * way as `adaptive_range`.
   */
  adaptiveAdvanceThreshold?: InputMaybe<Scalars['Int']['input']>;
  /**
   * The adaptive fallback threshold for every skill in this subject, if any. Resolved the same
   * way as `adaptive_range`.
   */
  adaptiveFallbackThreshold?: InputMaybe<Scalars['Int']['input']>;
  /**
   * The diagnostic scoring engine's k-factor (learning rate) for every skill in this subject,
   * if any. Resolved the same way as `adaptive_range`.
   */
  adaptiveKFactor?: InputMaybe<Scalars['Float']['input']>;
  /**
   * The adaptive range setting for every skill in this subject, if any. Skills, their
   * ancestors, and their guide override it; the global default backs it up. Read the effective
   * value from a guide level's `effective_adaptive_range` calculation rather than here.
   */
  adaptiveRange?: InputMaybe<Scalars['Int']['input']>;
  alternateName?: InputMaybe<Scalars['String']['input']>;
  badge?: InputMaybe<Scalars['String']['input']>;
  banner?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  curriculumAreaId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  featuredAs?: InputMaybe<Scalars['String']['input']>;
  footerText?: InputMaybe<Scalars['String']['input']>;
  freeResponseQuestionsPublished: Scalars['Boolean']['input'];
  hidden: Scalars['Boolean']['input'];
  logoImageUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  published: Scalars['Boolean']['input'];
  shouldShowLabelTable: Scalars['Boolean']['input'];
  subscriptionsPrices?: InputMaybe<Array<Scalars['JsonString']['input']>>;
  translateQuestions: Scalars['Boolean']['input'];
  translateSupplements: Scalars['Boolean']['input'];
  type: SubjectType;
  urlSlug: Scalars['String']['input'];
};

/** The result of the :create_subject mutation */
export type CreateSubjectResult = {
  __typename?: 'CreateSubjectResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<Subject>;
};

export type CreateSubscriptionInput = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  subjectId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

/** The result of the :create_subscription mutation */
export type CreateSubscriptionResult = {
  __typename?: 'CreateSubscriptionResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<RetailSubscription>;
};

export type CreateSupplementInput = {
  content: SupplementContentInput;
  name: Scalars['String']['input'];
  subjectId: Scalars['ID']['input'];
  translate?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of the :create_supplement mutation */
export type CreateSupplementResult = {
  __typename?: 'CreateSupplementResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<Supplement>;
};

export type CreateTagCategoryInput = {
  name: Scalars['String']['input'];
  /**
   * Ordered list of tag ids to include in the category. Omitted, `null`, and `[]` all
   * create an untagged category — there is no prior membership for `null` to preserve,
   * so it cannot mean "no change" the way it does on `update`.
   */
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** The result of the :create_tag_category mutation */
export type CreateTagCategoryResult = {
  __typename?: 'CreateTagCategoryResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<TagCategory>;
};

export type CreateTagInput = {
  name: Scalars['String']['input'];
};

/** The result of the :create_tag mutation */
export type CreateTagResult = {
  __typename?: 'CreateTagResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<Tag>;
};

export type CreateTranslationJobInput = {
  language: Scalars['String']['input'];
  translationRequests: Array<Scalars['JsonString']['input']>;
};

/** The result of the :create_translation_job mutation */
export type CreateTranslationJobResult = {
  __typename?: 'CreateTranslationJobResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<TranslationJob>;
};

export type CreateUserFeedbackInput = {
  comment: Scalars['String']['input'];
  feedbackType: UserFeedbackType;
  questionId: Scalars['ID']['input'];
  reportedDevice?: InputMaybe<UserFeedbackReportedDevice>;
  userAgent?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

/** The result of the :create_user_feedback mutation */
export type CreateUserFeedbackResult = {
  __typename?: 'CreateUserFeedbackResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<UserFeedback>;
};

export type CreateUserInput = {
  cleverId?: InputMaybe<Scalars['String']['input']>;
  /** The user's preferred color mode: light, dark, or system */
  colorModePreference?: InputMaybe<Scalars['String']['input']>;
  /** The user's content preferences for suggested content */
  contentPreferences?: InputMaybe<Scalars['JsonString']['input']>;
  coppaConsentEmail?: InputMaybe<Scalars['String']['input']>;
  customerFeedbackReminderDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The user's email address */
  email: Scalars['String']['input'];
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  isAuthor?: InputMaybe<Scalars['Boolean']['input']>;
  isSchoolAdministrator?: InputMaybe<Scalars['Boolean']['input']>;
  isTeacher?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  ltiId?: InputMaybe<Scalars['String']['input']>;
  /** Issuer of the LTI platform `lti_id` belongs to; identity is the (lti_iss, lti_id) pair. */
  ltiIss?: InputMaybe<Scalars['String']['input']>;
  needsCoppa?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of completed onboarding steps for the user */
  onboardingSteps?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The user's password hash */
  password: Scalars['String']['input'];
  salutation?: InputMaybe<Scalars['String']['input']>;
  schoolId?: InputMaybe<Scalars['ID']['input']>;
  signUpMethod?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subjectAuthors?: InputMaybe<Array<UserCreateSubjectAuthorsInput>>;
  /** The user's username */
  username: Scalars['String']['input'];
};

/** The result of the :create_user mutation */
export type CreateUserResult = {
  __typename?: 'CreateUserResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<User>;
};

export type CriteriaRubric = {
  __typename?: 'CriteriaRubric';
  criteria: Array<Maybe<RubricCriterion>>;
};

export type CriteriaRubricInput = {
  criteria: Array<InputMaybe<RubricCriterionInput>>;
};

export type CurriculumArea = {
  __typename?: 'CurriculumArea';
  color: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CurriculumAreaFilterColor = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type CurriculumAreaFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type CurriculumAreaFilterInput = {
  and?: InputMaybe<Array<CurriculumAreaFilterInput>>;
  color?: InputMaybe<CurriculumAreaFilterColor>;
  id?: InputMaybe<CurriculumAreaFilterId>;
  name?: InputMaybe<CurriculumAreaFilterName>;
  not?: InputMaybe<Array<CurriculumAreaFilterInput>>;
  or?: InputMaybe<Array<CurriculumAreaFilterInput>>;
};

export type CurriculumAreaFilterName = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export enum CurriculumAreaSortField {
  Color = 'COLOR',
  Id = 'ID',
  Name = 'NAME'
}

export type CurriculumAreaSortInput = {
  field: CurriculumAreaSortField;
  order?: InputMaybe<SortOrder>;
};

export type CustomerFeedbackEntry = {
  __typename?: 'CustomerFeedbackEntry';
  comment?: Maybe<Scalars['String']['output']>;
  grade: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  urlSlug: Scalars['String']['output'];
  user: User;
  userId: Scalars['ID']['output'];
};

export type DefaultAssignmentSettings = {
  __typename?: 'DefaultAssignmentSettings';
  allowLateSubmissions: Scalars['Boolean']['output'];
  autoAssignNewClassroomEnrollees?: Maybe<Scalars['Boolean']['output']>;
  calculatorSetting: AssignmentCalculatorSetting;
  correctAnswerSetting: Scalars['String']['output'];
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  lockdownModeEnabled: Scalars['Boolean']['output'];
  ltiLineItemId?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  partialCreditEnabled?: Maybe<Scalars['Boolean']['output']>;
  randomizeQuestionOrder?: Maybe<Scalars['Boolean']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  timeLimit?: Maybe<Scalars['Int']['output']>;
  translationAccess?: Maybe<Scalars['Boolean']['output']>;
};

export type DefaultAssignmentSettingsInput = {
  allowLateSubmissions: Scalars['Boolean']['input'];
  autoAssignNewClassroomEnrollees?: InputMaybe<Scalars['Boolean']['input']>;
  calculatorSetting: AssignmentCalculatorSetting;
  correctAnswerSetting: Scalars['String']['input'];
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  lockdownModeEnabled: Scalars['Boolean']['input'];
  ltiLineItemId?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  partialCreditEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  randomizeQuestionOrder?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  timeLimit?: InputMaybe<Scalars['Int']['input']>;
  translationAccess?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of the :delete_diagnostic mutation */
export type DeleteDiagnosticResult = {
  __typename?: 'DeleteDiagnosticResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<Diagnostic>;
};

/** The result of the :delete_question mutation */
export type DeleteQuestionResult = {
  __typename?: 'DeleteQuestionResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<Question>;
};

export type DeleteRecipientGroupsInput = {
  skillPathSettingsIds: Array<Scalars['ID']['input']>;
};

export type DeleteStripeCardInput = {
  fingerprint: Scalars['String']['input'];
};

/** The result of the :delete_subscription mutation */
export type DeleteSubscriptionResult = {
  __typename?: 'DeleteSubscriptionResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The record that was successfully deleted */
  result?: Maybe<RetailSubscription>;
};

/** The result of the :delete_supplement mutation */
export type DeleteSupplementResult = {
  __typename?: 'DeleteSupplementResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The record that was successfully deleted */
  result?: Maybe<Supplement>;
};

/** The result of the :destroy_authoring_feedback mutation */
export type DestroyAuthoringFeedbackResult = {
  __typename?: 'DestroyAuthoringFeedbackResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The record that was successfully deleted */
  result?: Maybe<AuthoringFeedback>;
};

/** The result of the :destroy_district mutation */
export type DestroyDistrictResult = {
  __typename?: 'DestroyDistrictResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The record that was successfully deleted */
  result?: Maybe<District>;
};

/** The result of the :destroy_guide mutation */
export type DestroyGuideResult = {
  __typename?: 'DestroyGuideResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The record that was successfully deleted */
  result?: Maybe<Guide>;
};

/** The result of the :destroy_standard mutation */
export type DestroyStandardResult = {
  __typename?: 'DestroyStandardResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The record that was successfully deleted */
  result?: Maybe<Standard>;
};

/** The result of the :destroy_standard_set mutation */
export type DestroyStandardSetResult = {
  __typename?: 'DestroyStandardSetResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The record that was successfully deleted */
  result?: Maybe<StandardSet>;
};

/** The result of the :destroy_subject_faq mutation */
export type DestroySubjectFaqResult = {
  __typename?: 'DestroySubjectFaqResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The record that was successfully deleted */
  result?: Maybe<SubjectFaq>;
};

/** The result of the :destroy_subject mutation */
export type DestroySubjectResult = {
  __typename?: 'DestroySubjectResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The record that was successfully deleted */
  result?: Maybe<Subject>;
};

/** The result of the :destroy_tag_category mutation */
export type DestroyTagCategoryResult = {
  __typename?: 'DestroyTagCategoryResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The record that was successfully deleted */
  result?: Maybe<TagCategory>;
};

/** The result of the :destroy_upgrade mutation */
export type DestroyUpgradeResult = {
  __typename?: 'DestroyUpgradeResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The record that was successfully deleted */
  result?: Maybe<Upgrade>;
};

/** The result of the :destroy_user_feedback mutation */
export type DestroyUserFeedbackResult = {
  __typename?: 'DestroyUserFeedbackResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The record that was successfully deleted */
  result?: Maybe<UserFeedback>;
};

/** The result of the :destroy_user_subject_tag_preference mutation */
export type DestroyUserSubjectTagPreferenceResult = {
  __typename?: 'DestroyUserSubjectTagPreferenceResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The record that was successfully deleted */
  result?: Maybe<UserSubjectTagPreference>;
};

export type Diagnostic = {
  __typename?: 'Diagnostic';
  /**
   * Whether the diagnostic has at least one recipient group in the educator's current view — the
   * row-level scope filter for the index. Omit `classroomIds` for All Classes, which spans the
   * actor's active classes and so excludes a diagnostic reachable only through an archived class.
   *
   * Passing an empty list matches nothing.
   */
  assignedToClassrooms?: Maybe<Scalars['Boolean']['output']>;
  /**
   * How many of the in-scope assigned students have completed the diagnostic — the numerator of
   * the row's "8 / 12 completed". Omit `classroomIds` for the All Classes view; pass a class to
   * scope to it.
   *
   * Deliberately takes no `status`: the fraction describes the students, so it should hold steady
   * as the teacher changes the status filter.
   */
  countOfCompletedStudents: Scalars['Int']['output'];
  /**
   * How many in-scope assigned students have not yet completed the diagnostic. With
   * `countOfCompletedStudents` this gives the row's completion total, matching how the assignment
   * index derives its "x / x submissions".
   *
   * A student unassigned after starting is excluded from both counts, since the soft-deleted
   * record no longer represents an assignment.
   */
  countOfIncompleteStudents: Scalars['Int']['output'];
  createdBy: User;
  createdById: Scalars['ID']['output'];
  diagnosticSettings: Array<DiagnosticSettings>;
  diagnosticTemplate?: Maybe<DiagnosticTemplate>;
  diagnosticTemplateId?: Maybe<Scalars['ID']['output']>;
  /**
   * A list of student IDs for students who are externally assigned to this diagnostic. Externally assigned means that the student
   * is taught by the current actor, BUT the current actor does not teach the student's enrolled_via_classroom.
   * This means the assignment cannot be managed by the current actor, but the FE needs to be aware of that external assignment
   * in order to prevent the current actor from trying to create a new assignment for that student and getting unique constraint errors.
   *
   * This enables the FE to show some sort of warning state explaining that this student is already assigned and that the current actor
   * doesn't have the permissions to manage that assignment in any way.
   */
  externallyAssignedStudentIds: Array<Scalars['ID']['output']>;
  guide: Guide;
  guideId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  /**
   * The latest due date across the in-scope recipient groups, forming the upper bound of the
   * row's due-date range. Scopes and narrows by status exactly as `minDueDate` does.
   */
  maxDueDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The latest start date across the in-scope recipient groups, forming the upper bound of the
   * row's start-date range. Scopes and narrows by status exactly as `minStartDate` does.
   */
  maxStartDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The earliest due date across the in-scope recipient groups, and the due-date sort key for a
   * list filtered to one status. A list mixing statuses wants `statusScopedMinDueDate`, which
   * scopes to each row's own. Omit `classroomIds` for the All Classes view; pass a class to
   * scope to it.
   *
   * Pass `status` to draw the range only from the groups holding that status, so an Open row
   * shows the open groups' dates rather than a closed group's expired one. Omitting it spans
   * every in-scope group regardless of status.
   *
   * Nil when no in-scope group matches.
   */
  minDueDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The earliest start date across the in-scope recipient groups. Scopes and narrows by status
   * exactly as `minDueDate` does; a Scheduled row pairs this with `maxStartDate` to show when the
   * diagnostic opens. A list mixing statuses wants `statusScopedMinStartDate`.
   *
   * Nil when no in-scope group matches or none of them set a start date — a group without one is
   * available immediately.
   */
  minStartDate?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  skills: Array<GuideLevel>;
  /**
   * The diagnostic's status in the educator's current view, derived from the per-group statuses
   * of the in-scope recipient groups by the priority open > scheduled > closed. Omit
   * `classroomIds` for the All Classes view (the actor's active classes); pass a class to scope
   * to it.
   *
   * A diagnostic can hold different statuses in different scopes — open in All Classes but
   * closed within one class — which is the point: the same diagnostic that is closed for Period 1
   * should not read Open while you are looking at Period 1.
   *
   * Closed when no group is in scope, so a diagnostic reachable only through an archived class
   * does not read Open in All Classes.
   */
  status?: Maybe<DiagnosticStatus>;
  /**
   * The earliest due date across the in-scope recipient groups holding the row's own status — the
   * sort key for a list mixing statuses, where `minDueDate` without a status would order a row by
   * a group whose date it does not display. Nil only when no group is in scope.
   */
  statusScopedMinDueDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The earliest start date across the in-scope recipient groups holding the row's own status —
   * the start-date sort key a list mixing statuses needs, as `statusScopedMinDueDate` is its
   * due-date one.
   *
   * Nil when no group holding that status set a start date, because such a group began
   * immediately. That is more often than `minStartDate`, which spans every status. A plain
   * ascending or descending sort puts those rows last or first; pass a `NULLS` ordering to
   * place them where you want them.
   */
  statusScopedMinStartDate?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


export type DiagnosticAssignedToClassroomsArgs = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type DiagnosticCountOfCompletedStudentsArgs = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type DiagnosticCountOfIncompleteStudentsArgs = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type DiagnosticDiagnosticSettingsArgs = {
  filter?: InputMaybe<DiagnosticSettingsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DiagnosticSettingsSortInput>>>;
};


export type DiagnosticMaxDueDateArgs = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<DiagnosticStatus>;
};


export type DiagnosticMaxStartDateArgs = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<DiagnosticStatus>;
};


export type DiagnosticMinDueDateArgs = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<DiagnosticStatus>;
};


export type DiagnosticMinStartDateArgs = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<DiagnosticStatus>;
};


export type DiagnosticSkillsArgs = {
  filter?: InputMaybe<GuideLevelFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GuideLevelSortInput>>>;
};


export type DiagnosticStatusArgs = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type DiagnosticStatusScopedMinDueDateArgs = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type DiagnosticStatusScopedMinStartDateArgs = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type DiagnosticAssignedToClassroomsFieldInput = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type DiagnosticCountOfCompletedStudentsFieldInput = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type DiagnosticCountOfIncompleteStudentsFieldInput = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type DiagnosticDifficultyPositions = {
  __typename?: 'DiagnosticDifficultyPositions';
  easy: Scalars['Float']['output'];
  hard: Scalars['Float']['output'];
  medium: Scalars['Float']['output'];
};

export type DiagnosticDifficultyProbabilities = {
  __typename?: 'DiagnosticDifficultyProbabilities';
  easy: Scalars['Float']['output'];
  hard: Scalars['Float']['output'];
  medium: Scalars['Float']['output'];
};

export type DiagnosticFilterAssignedToClassrooms = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  input?: InputMaybe<DiagnosticAssignedToClassroomsFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DiagnosticFilterCountOfCompletedStudents = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  input?: InputMaybe<DiagnosticCountOfCompletedStudentsFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type DiagnosticFilterCountOfIncompleteStudents = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  input?: InputMaybe<DiagnosticCountOfIncompleteStudentsFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type DiagnosticFilterCreatedById = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type DiagnosticFilterDiagnosticTemplateId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type DiagnosticFilterGuideId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type DiagnosticFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type DiagnosticFilterInput = {
  and?: InputMaybe<Array<DiagnosticFilterInput>>;
  /**
   * Whether the diagnostic has at least one recipient group in the educator's current view — the
   * row-level scope filter for the index. Omit `classroomIds` for All Classes, which spans the
   * actor's active classes and so excludes a diagnostic reachable only through an archived class.
   *
   * Passing an empty list matches nothing.
   */
  assignedToClassrooms?: InputMaybe<DiagnosticFilterAssignedToClassrooms>;
  /**
   * How many of the in-scope assigned students have completed the diagnostic — the numerator of
   * the row's "8 / 12 completed". Omit `classroomIds` for the All Classes view; pass a class to
   * scope to it.
   *
   * Deliberately takes no `status`: the fraction describes the students, so it should hold steady
   * as the teacher changes the status filter.
   */
  countOfCompletedStudents?: InputMaybe<DiagnosticFilterCountOfCompletedStudents>;
  /**
   * How many in-scope assigned students have not yet completed the diagnostic. With
   * `countOfCompletedStudents` this gives the row's completion total, matching how the assignment
   * index derives its "x / x submissions".
   *
   * A student unassigned after starting is excluded from both counts, since the soft-deleted
   * record no longer represents an assignment.
   */
  countOfIncompleteStudents?: InputMaybe<DiagnosticFilterCountOfIncompleteStudents>;
  createdBy?: InputMaybe<UserFilterInput>;
  createdById?: InputMaybe<DiagnosticFilterCreatedById>;
  diagnosticSettings?: InputMaybe<DiagnosticSettingsFilterInput>;
  diagnosticTemplate?: InputMaybe<DiagnosticTemplateFilterInput>;
  diagnosticTemplateId?: InputMaybe<DiagnosticFilterDiagnosticTemplateId>;
  guide?: InputMaybe<GuideFilterInput>;
  guideId?: InputMaybe<DiagnosticFilterGuideId>;
  id?: InputMaybe<DiagnosticFilterId>;
  insertedAt?: InputMaybe<DiagnosticFilterInsertedAt>;
  /**
   * The latest due date across the in-scope recipient groups, forming the upper bound of the
   * row's due-date range. Scopes and narrows by status exactly as `minDueDate` does.
   */
  maxDueDate?: InputMaybe<DiagnosticFilterMaxDueDate>;
  /**
   * The latest start date across the in-scope recipient groups, forming the upper bound of the
   * row's start-date range. Scopes and narrows by status exactly as `minStartDate` does.
   */
  maxStartDate?: InputMaybe<DiagnosticFilterMaxStartDate>;
  /**
   * The earliest due date across the in-scope recipient groups, and the due-date sort key for a
   * list filtered to one status. A list mixing statuses wants `statusScopedMinDueDate`, which
   * scopes to each row's own. Omit `classroomIds` for the All Classes view; pass a class to
   * scope to it.
   *
   * Pass `status` to draw the range only from the groups holding that status, so an Open row
   * shows the open groups' dates rather than a closed group's expired one. Omitting it spans
   * every in-scope group regardless of status.
   *
   * Nil when no in-scope group matches.
   */
  minDueDate?: InputMaybe<DiagnosticFilterMinDueDate>;
  /**
   * The earliest start date across the in-scope recipient groups. Scopes and narrows by status
   * exactly as `minDueDate` does; a Scheduled row pairs this with `maxStartDate` to show when the
   * diagnostic opens. A list mixing statuses wants `statusScopedMinStartDate`.
   *
   * Nil when no in-scope group matches or none of them set a start date — a group without one is
   * available immediately.
   */
  minStartDate?: InputMaybe<DiagnosticFilterMinStartDate>;
  name?: InputMaybe<DiagnosticFilterName>;
  not?: InputMaybe<Array<DiagnosticFilterInput>>;
  or?: InputMaybe<Array<DiagnosticFilterInput>>;
  skills?: InputMaybe<GuideLevelFilterInput>;
  /**
   * The diagnostic's status in the educator's current view, derived from the per-group statuses
   * of the in-scope recipient groups by the priority open > scheduled > closed. Omit
   * `classroomIds` for the All Classes view (the actor's active classes); pass a class to scope
   * to it.
   *
   * A diagnostic can hold different statuses in different scopes — open in All Classes but
   * closed within one class — which is the point: the same diagnostic that is closed for Period 1
   * should not read Open while you are looking at Period 1.
   *
   * Closed when no group is in scope, so a diagnostic reachable only through an archived class
   * does not read Open in All Classes.
   */
  status?: InputMaybe<DiagnosticFilterStatus>;
  /**
   * The earliest due date across the in-scope recipient groups holding the row's own status — the
   * sort key for a list mixing statuses, where `minDueDate` without a status would order a row by
   * a group whose date it does not display. Nil only when no group is in scope.
   */
  statusScopedMinDueDate?: InputMaybe<DiagnosticFilterStatusScopedMinDueDate>;
  /**
   * The earliest start date across the in-scope recipient groups holding the row's own status —
   * the start-date sort key a list mixing statuses needs, as `statusScopedMinDueDate` is its
   * due-date one.
   *
   * Nil when no group holding that status set a start date, because such a group began
   * immediately. That is more often than `minStartDate`, which spans every status. A plain
   * ascending or descending sort puts those rows last or first; pass a `NULLS` ordering to
   * place them where you want them.
   */
  statusScopedMinStartDate?: InputMaybe<DiagnosticFilterStatusScopedMinStartDate>;
  updatedAt?: InputMaybe<DiagnosticFilterUpdatedAt>;
};

export type DiagnosticFilterInsertedAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DiagnosticFilterMaxDueDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  input?: InputMaybe<DiagnosticMaxDueDateFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DiagnosticFilterMaxStartDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  input?: InputMaybe<DiagnosticMaxStartDateFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DiagnosticFilterMinDueDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  input?: InputMaybe<DiagnosticMinDueDateFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DiagnosticFilterMinStartDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  input?: InputMaybe<DiagnosticMinStartDateFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DiagnosticFilterName = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type DiagnosticFilterStatus = {
  eq?: InputMaybe<DiagnosticStatus>;
  greaterThan?: InputMaybe<DiagnosticStatus>;
  greaterThanOrEqual?: InputMaybe<DiagnosticStatus>;
  in?: InputMaybe<Array<DiagnosticStatus>>;
  input?: InputMaybe<DiagnosticStatusFieldInput>;
  isDistinctFrom?: InputMaybe<DiagnosticStatus>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<DiagnosticStatus>;
  lessThan?: InputMaybe<DiagnosticStatus>;
  lessThanOrEqual?: InputMaybe<DiagnosticStatus>;
  notEq?: InputMaybe<DiagnosticStatus>;
};

export type DiagnosticFilterStatusScopedMinDueDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  input?: InputMaybe<DiagnosticStatusScopedMinDueDateFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DiagnosticFilterStatusScopedMinStartDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  input?: InputMaybe<DiagnosticStatusScopedMinStartDateFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DiagnosticFilterUpdatedAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DiagnosticMaxDueDateFieldInput = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<DiagnosticStatus>;
};

export type DiagnosticMaxStartDateFieldInput = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<DiagnosticStatus>;
};

export type DiagnosticMinDueDateFieldInput = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<DiagnosticStatus>;
};

export type DiagnosticMinStartDateFieldInput = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<DiagnosticStatus>;
};

export type DiagnosticRecipientGroupClassroomDiagnosticConfigsInput = {
  classroomId: Scalars['ID']['input'];
};

export type DiagnosticRecipientGroupInput = {
  classroomDiagnosticConfigs: Array<InputMaybe<DiagnosticRecipientGroupClassroomDiagnosticConfigsInput>>;
  diagnosticSettingsId?: InputMaybe<Scalars['ID']['input']>;
  settings: DiagnosticRecipientGroupSettingsInput;
  studentDiagnostics: Array<InputMaybe<DiagnosticRecipientGroupStudentDiagnosticsInput>>;
};

export type DiagnosticRecipientGroupSettingsInput = {
  dueDate: Scalars['DateTime']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  timeLimit?: InputMaybe<Scalars['Int']['input']>;
  translationAccess?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DiagnosticRecipientGroupStudentDiagnosticsInput = {
  /**
   * The classroom the student's assignment is associated with. This serves 2 main purposes:
   * signaling to the FE which classroom to display the student's assignment under in cases where that student shows up in multiple assigned classrooms,
   * and gating which teachers can change that student's settings.
   *
   * Students can ONLY be assigned via 1 classroom. i.e. for a given diagnostic_id + student_id combination, there can only be 1 StudentDiagnostic record,
   * so if the student is in multiple classrooms, only 1 of those classrooms can be the source of the assignment.
   */
  enrolledViaClassroomId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};

export type DiagnosticScoringAudit = {
  __typename?: 'DiagnosticScoringAudit';
  params: DiagnosticScoringParams;
  skills: Array<Maybe<DiagnosticScoringAuditSkill>>;
};

export type DiagnosticScoringAuditAttempt = {
  __typename?: 'DiagnosticScoringAuditAttempt';
  answeredAt?: Maybe<Scalars['DateTime']['output']>;
  classificationIfTerminatedHere?: Maybe<Scalars['String']['output']>;
  muAfter?: Maybe<Scalars['Float']['output']>;
  muBefore?: Maybe<Scalars['Float']['output']>;
  outcome: Scalars['String']['output'];
  predictedP?: Maybe<Scalars['Float']['output']>;
  questionDifficulty?: Maybe<Scalars['String']['output']>;
  questionId: Scalars['ID']['output'];
  scored: Scalars['Boolean']['output'];
  scoredAs: Scalars['String']['output'];
  sigmaAfter?: Maybe<Scalars['Float']['output']>;
  sigmaBefore?: Maybe<Scalars['Float']['output']>;
  timeElapsedMs?: Maybe<Scalars['Int']['output']>;
};

export type DiagnosticScoringAuditSkill = {
  __typename?: 'DiagnosticScoringAuditSkill';
  attempts: Array<Maybe<DiagnosticScoringAuditAttempt>>;
  classificationIfTerminatedNow: Scalars['String']['output'];
  difficultyProbabilities: DiagnosticDifficultyProbabilities;
  finalClassification?: Maybe<Scalars['String']['output']>;
  kFactor: Scalars['Float']['output'];
  maxQuestions: Scalars['Int']['output'];
  mu: Scalars['Float']['output'];
  order: Scalars['Int']['output'];
  questionsAnswered: Scalars['Int']['output'];
  sigmaBelief: Scalars['Float']['output'];
  skillId: Scalars['ID']['output'];
  skillName?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  terminationReason?: Maybe<Scalars['String']['output']>;
};

export type DiagnosticScoringParams = {
  __typename?: 'DiagnosticScoringParams';
  difficulties: DiagnosticDifficultyPositions;
  perQuestionTimeLimitMs: Scalars['Int']['output'];
  proficiencyThreshold: Scalars['Float']['output'];
  sigmaConfidenceThreshold: Scalars['Float']['output'];
  sigmaPerformance: Scalars['Float']['output'];
  skipWeight: Scalars['Int']['output'];
  startingMu: Scalars['Float']['output'];
  startingSigma: Scalars['Float']['output'];
};

export type DiagnosticSettings = {
  __typename?: 'DiagnosticSettings';
  classroomDiagnosticConfigs: Array<ClassroomDiagnosticConfig>;
  diagnostic: Diagnostic;
  diagnosticId: Scalars['ID']['output'];
  dueDate: Scalars['DateTime']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Whether any recipient in this group belongs to an archived class — see
   * `Mandark.Assignments.Calculations.ArchivedRecipient`.
   *
   * An edit to a group holding both archived and active recipients must leave the archived ones on
   * their existing settings, so this joins `full_access` as a reason for
   * `Mandark.Assignments.Diagnostic.Changes.SaveRecipientGroups` to fork the group rather than
   * update it in place. Unlike `full_access` it is not an authorization question: the educator may
   * well teach every class in the group.
   */
  hasArchivedRecipients?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
  studentDiagnostics: Array<StudentDiagnostic>;
  /**
   * Per-recipient-group time limit in minutes. Nil means no limit — the diagnostic runs off the
   * start/due/end dates only. When set, each student's countdown runs continuously in wall-clock
   * time from their `StudentDiagnostic.started_at`; see `StudentDiagnostic.expires_at`.
   */
  timeLimit?: Maybe<Scalars['Int']['output']>;
  translationAccess: Scalars['Boolean']['output'];
};


export type DiagnosticSettingsClassroomDiagnosticConfigsArgs = {
  filter?: InputMaybe<ClassroomDiagnosticConfigFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ClassroomDiagnosticConfigSortInput>>>;
};


export type DiagnosticSettingsStudentDiagnosticsArgs = {
  filter?: InputMaybe<StudentDiagnosticFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<StudentDiagnosticSortInput>>>;
};

export type DiagnosticSettingsFilterDiagnosticId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type DiagnosticSettingsFilterDueDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DiagnosticSettingsFilterEndDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DiagnosticSettingsFilterHasArchivedRecipients = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DiagnosticSettingsFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type DiagnosticSettingsFilterInput = {
  and?: InputMaybe<Array<DiagnosticSettingsFilterInput>>;
  classroomDiagnosticConfigs?: InputMaybe<ClassroomDiagnosticConfigFilterInput>;
  diagnostic?: InputMaybe<DiagnosticFilterInput>;
  diagnosticId?: InputMaybe<DiagnosticSettingsFilterDiagnosticId>;
  dueDate?: InputMaybe<DiagnosticSettingsFilterDueDate>;
  endDate?: InputMaybe<DiagnosticSettingsFilterEndDate>;
  /**
   * Whether any recipient in this group belongs to an archived class — see
   * `Mandark.Assignments.Calculations.ArchivedRecipient`.
   *
   * An edit to a group holding both archived and active recipients must leave the archived ones on
   * their existing settings, so this joins `full_access` as a reason for
   * `Mandark.Assignments.Diagnostic.Changes.SaveRecipientGroups` to fork the group rather than
   * update it in place. Unlike `full_access` it is not an authorization question: the educator may
   * well teach every class in the group.
   */
  hasArchivedRecipients?: InputMaybe<DiagnosticSettingsFilterHasArchivedRecipients>;
  id?: InputMaybe<DiagnosticSettingsFilterId>;
  not?: InputMaybe<Array<DiagnosticSettingsFilterInput>>;
  or?: InputMaybe<Array<DiagnosticSettingsFilterInput>>;
  startDate?: InputMaybe<DiagnosticSettingsFilterStartDate>;
  studentDiagnostics?: InputMaybe<StudentDiagnosticFilterInput>;
  /**
   * Per-recipient-group time limit in minutes. Nil means no limit — the diagnostic runs off the
   * start/due/end dates only. When set, each student's countdown runs continuously in wall-clock
   * time from their `StudentDiagnostic.started_at`; see `StudentDiagnostic.expires_at`.
   */
  timeLimit?: InputMaybe<DiagnosticSettingsFilterTimeLimit>;
  translationAccess?: InputMaybe<DiagnosticSettingsFilterTranslationAccess>;
};

export type DiagnosticSettingsFilterStartDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DiagnosticSettingsFilterTimeLimit = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type DiagnosticSettingsFilterTranslationAccess = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum DiagnosticSettingsSortField {
  DiagnosticId = 'DIAGNOSTIC_ID',
  DueDate = 'DUE_DATE',
  EndDate = 'END_DATE',
  HasArchivedRecipients = 'HAS_ARCHIVED_RECIPIENTS',
  Id = 'ID',
  StartDate = 'START_DATE',
  TimeLimit = 'TIME_LIMIT',
  TranslationAccess = 'TRANSLATION_ACCESS'
}

export type DiagnosticSettingsSortInput = {
  field: DiagnosticSettingsSortField;
  order?: InputMaybe<SortOrder>;
};

export enum DiagnosticSortField {
  AssignedToClassrooms = 'ASSIGNED_TO_CLASSROOMS',
  CountOfCompletedStudents = 'COUNT_OF_COMPLETED_STUDENTS',
  CountOfIncompleteStudents = 'COUNT_OF_INCOMPLETE_STUDENTS',
  CreatedById = 'CREATED_BY_ID',
  DiagnosticTemplateId = 'DIAGNOSTIC_TEMPLATE_ID',
  GuideId = 'GUIDE_ID',
  Id = 'ID',
  InsertedAt = 'INSERTED_AT',
  MaxDueDate = 'MAX_DUE_DATE',
  MaxStartDate = 'MAX_START_DATE',
  MinDueDate = 'MIN_DUE_DATE',
  MinStartDate = 'MIN_START_DATE',
  Name = 'NAME',
  Status = 'STATUS',
  StatusScopedMinDueDate = 'STATUS_SCOPED_MIN_DUE_DATE',
  StatusScopedMinStartDate = 'STATUS_SCOPED_MIN_START_DATE',
  UpdatedAt = 'UPDATED_AT'
}

export type DiagnosticSortInput = {
  assignedToClassroomsInput?: InputMaybe<DiagnosticAssignedToClassroomsFieldInput>;
  countOfCompletedStudentsInput?: InputMaybe<DiagnosticCountOfCompletedStudentsFieldInput>;
  countOfIncompleteStudentsInput?: InputMaybe<DiagnosticCountOfIncompleteStudentsFieldInput>;
  field: DiagnosticSortField;
  maxDueDateInput?: InputMaybe<DiagnosticMaxDueDateFieldInput>;
  maxStartDateInput?: InputMaybe<DiagnosticMaxStartDateFieldInput>;
  minDueDateInput?: InputMaybe<DiagnosticMinDueDateFieldInput>;
  minStartDateInput?: InputMaybe<DiagnosticMinStartDateFieldInput>;
  order?: InputMaybe<SortOrder>;
  statusInput?: InputMaybe<DiagnosticStatusFieldInput>;
  statusScopedMinDueDateInput?: InputMaybe<DiagnosticStatusScopedMinDueDateFieldInput>;
  statusScopedMinStartDateInput?: InputMaybe<DiagnosticStatusScopedMinStartDateFieldInput>;
};

export enum DiagnosticStatus {
  Closed = 'CLOSED',
  Open = 'OPEN',
  Scheduled = 'SCHEDULED'
}

export type DiagnosticStatusFieldInput = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type DiagnosticStatusScopedMinDueDateFieldInput = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type DiagnosticStatusScopedMinStartDateFieldInput = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type DiagnosticTemplate = {
  __typename?: 'DiagnosticTemplate';
  /**
   * Recommended session length in minutes, set by the content team. Used by the front end to pre-fill
   * the time limit when a teacher assigns this template. Nil means the platform default applies.
   */
  defaultTimeLimit?: Maybe<Scalars['Int']['output']>;
  guide: Guide;
  guideId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /**
   * True when the template has at least one tag from every given group —
   * OR within a group, AND across groups. Filter on this to apply
   * category-aware tag filtering.
   */
  matchesTagGroups?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  skills: Array<GuideLevel>;
  tags: Array<Tag>;
};


export type DiagnosticTemplateMatchesTagGroupsArgs = {
  tagIdGroups: Array<Array<Scalars['ID']['input']>>;
};


export type DiagnosticTemplateSkillsArgs = {
  filter?: InputMaybe<GuideLevelFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GuideLevelSortInput>>>;
};


export type DiagnosticTemplateTagsArgs = {
  filter?: InputMaybe<TagFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TagSortInput>>>;
};

export type DiagnosticTemplateFilterDefaultTimeLimit = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type DiagnosticTemplateFilterGuideId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type DiagnosticTemplateFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type DiagnosticTemplateFilterInput = {
  and?: InputMaybe<Array<DiagnosticTemplateFilterInput>>;
  /**
   * Recommended session length in minutes, set by the content team. Used by the front end to pre-fill
   * the time limit when a teacher assigns this template. Nil means the platform default applies.
   */
  defaultTimeLimit?: InputMaybe<DiagnosticTemplateFilterDefaultTimeLimit>;
  guide?: InputMaybe<GuideFilterInput>;
  guideId?: InputMaybe<DiagnosticTemplateFilterGuideId>;
  id?: InputMaybe<DiagnosticTemplateFilterId>;
  /**
   * True when the template has at least one tag from every given group —
   * OR within a group, AND across groups. Filter on this to apply
   * category-aware tag filtering.
   */
  matchesTagGroups?: InputMaybe<DiagnosticTemplateFilterMatchesTagGroups>;
  name?: InputMaybe<DiagnosticTemplateFilterName>;
  not?: InputMaybe<Array<DiagnosticTemplateFilterInput>>;
  or?: InputMaybe<Array<DiagnosticTemplateFilterInput>>;
  skills?: InputMaybe<GuideLevelFilterInput>;
  tags?: InputMaybe<TagFilterInput>;
};

export type DiagnosticTemplateFilterMatchesTagGroups = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  input?: InputMaybe<DiagnosticTemplateMatchesTagGroupsFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DiagnosticTemplateFilterName = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type DiagnosticTemplateMatchesTagGroupsFieldInput = {
  tagIdGroups: Array<Array<Scalars['ID']['input']>>;
};

export enum DiagnosticTemplateSortField {
  DefaultTimeLimit = 'DEFAULT_TIME_LIMIT',
  GuideId = 'GUIDE_ID',
  Id = 'ID',
  MatchesTagGroups = 'MATCHES_TAG_GROUPS',
  Name = 'NAME'
}

export type DiagnosticTemplateSortInput = {
  field: DiagnosticTemplateSortField;
  matchesTagGroupsInput?: InputMaybe<DiagnosticTemplateMatchesTagGroupsFieldInput>;
  order?: InputMaybe<SortOrder>;
};

export type District = {
  __typename?: 'District';
  cleverId?: Maybe<Scalars['String']['output']>;
  county: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  ncesId?: Maybe<Scalars['String']['output']>;
  ncesLocale: NcesLocale;
  state?: Maybe<UsState>;
};

export type DistrictFilterCleverId = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type DistrictFilterCounty = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type DistrictFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type DistrictFilterInput = {
  and?: InputMaybe<Array<DistrictFilterInput>>;
  cleverId?: InputMaybe<DistrictFilterCleverId>;
  county?: InputMaybe<DistrictFilterCounty>;
  id?: InputMaybe<DistrictFilterId>;
  name?: InputMaybe<DistrictFilterName>;
  ncesId?: InputMaybe<DistrictFilterNcesId>;
  ncesLocale?: InputMaybe<DistrictFilterNcesLocale>;
  not?: InputMaybe<Array<DistrictFilterInput>>;
  or?: InputMaybe<Array<DistrictFilterInput>>;
  state?: InputMaybe<DistrictFilterState>;
};

export type DistrictFilterName = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type DistrictFilterNcesId = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type DistrictFilterNcesLocale = {
  eq?: InputMaybe<NcesLocale>;
  greaterThan?: InputMaybe<NcesLocale>;
  greaterThanOrEqual?: InputMaybe<NcesLocale>;
  in?: InputMaybe<Array<NcesLocale>>;
  isDistinctFrom?: InputMaybe<NcesLocale>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<NcesLocale>;
  lessThan?: InputMaybe<NcesLocale>;
  lessThanOrEqual?: InputMaybe<NcesLocale>;
  notEq?: InputMaybe<NcesLocale>;
};

export type DistrictFilterState = {
  eq?: InputMaybe<UsState>;
  greaterThan?: InputMaybe<UsState>;
  greaterThanOrEqual?: InputMaybe<UsState>;
  in?: InputMaybe<Array<InputMaybe<UsState>>>;
  isDistinctFrom?: InputMaybe<UsState>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<UsState>;
  lessThan?: InputMaybe<UsState>;
  lessThanOrEqual?: InputMaybe<UsState>;
  notEq?: InputMaybe<UsState>;
};

export enum DistrictSortField {
  CleverId = 'CLEVER_ID',
  County = 'COUNTY',
  Id = 'ID',
  Name = 'NAME',
  NcesId = 'NCES_ID',
  NcesLocale = 'NCES_LOCALE',
  State = 'STATE'
}

export type DistrictSortInput = {
  field: DistrictSortField;
  order?: InputMaybe<SortOrder>;
};

export type EditableRegionsRubric = {
  __typename?: 'EditableRegionsRubric';
  validResponse: Scalars['Json']['output'];
};

export type EditableRegionsRubricInput = {
  validResponse: Scalars['Json']['input'];
};

export type ExactRubric = {
  __typename?: 'ExactRubric';
  validResponse: Scalars['Json']['output'];
};

export type ExactRubricInput = {
  validResponse: Scalars['Json']['input'];
};

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type FreeFormSupplementContent = {
  __typename?: 'FreeFormSupplementContent';
  text: Scalars['String']['output'];
};

export type GradeInput = {
  teacherEvaluation?: InputMaybe<GuessManualEvaluationInput>;
};

export type GradeLevel = {
  __typename?: 'GradeLevel';
  gradeLevelType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** A zero padded version of the grade level type for sorting purposes. */
  paddedGradeLevelType?: Maybe<Scalars['String']['output']>;
};

export type GradeLevelFilterGradeLevelType = {
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type GradeLevelFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type GradeLevelFilterInput = {
  and?: InputMaybe<Array<GradeLevelFilterInput>>;
  gradeLevelType?: InputMaybe<GradeLevelFilterGradeLevelType>;
  id?: InputMaybe<GradeLevelFilterId>;
  not?: InputMaybe<Array<GradeLevelFilterInput>>;
  or?: InputMaybe<Array<GradeLevelFilterInput>>;
  /** A zero padded version of the grade level type for sorting purposes. */
  paddedGradeLevelType?: InputMaybe<GradeLevelFilterPaddedGradeLevelType>;
};

export type GradeLevelFilterPaddedGradeLevelType = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export enum GradeLevelSortField {
  GradeLevelType = 'GRADE_LEVEL_TYPE',
  Id = 'ID',
  PaddedGradeLevelType = 'PADDED_GRADE_LEVEL_TYPE'
}

export type GradeLevelSortInput = {
  field: GradeLevelSortField;
  order?: InputMaybe<SortOrder>;
};

/** The result of the :grade mutation */
export type GradeResult = {
  __typename?: 'GradeResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<Guess>;
};

export type GraphContainsEntity = {
  __typename?: 'GraphContainsEntity';
  elements: Scalars['JsonString']['output'];
  type: Scalars['String']['output'];
};

export type GraphContainsEntityInput = {
  elements: Scalars['JsonString']['input'];
  type: Scalars['String']['input'];
};

export type GraphContainsRubric = {
  __typename?: 'GraphContainsRubric';
  validResponse: Array<Maybe<GraphContainsRubricValidResponseItem>>;
};

export type GraphContainsRubricAttributes = {
  __typename?: 'GraphContainsRubricAttributes';
  inclusive?: Maybe<Scalars['Boolean']['output']>;
};

export type GraphContainsRubricAttributesInput = {
  inclusive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GraphContainsRubricCorrectAnswerSettings = {
  __typename?: 'GraphContainsRubricCorrectAnswerSettings';
  centerPoint?: Maybe<Scalars['Boolean']['output']>;
  direction?: Maybe<Scalars['Boolean']['output']>;
  exact?: Maybe<Scalars['Boolean']['output']>;
  inclusive?: Maybe<Scalars['Boolean']['output']>;
  length?: Maybe<Scalars['Boolean']['output']>;
  radiusLength?: Maybe<Scalars['Boolean']['output']>;
  slope?: Maybe<Scalars['Boolean']['output']>;
  startingPoint?: Maybe<Scalars['Boolean']['output']>;
  yIntercept?: Maybe<Scalars['Boolean']['output']>;
};

export type GraphContainsRubricCorrectAnswerSettingsInput = {
  centerPoint?: InputMaybe<Scalars['Boolean']['input']>;
  direction?: InputMaybe<Scalars['Boolean']['input']>;
  exact?: InputMaybe<Scalars['Boolean']['input']>;
  inclusive?: InputMaybe<Scalars['Boolean']['input']>;
  length?: InputMaybe<Scalars['Boolean']['input']>;
  radiusLength?: InputMaybe<Scalars['Boolean']['input']>;
  slope?: InputMaybe<Scalars['Boolean']['input']>;
  startingPoint?: InputMaybe<Scalars['Boolean']['input']>;
  yIntercept?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GraphContainsRubricGraphElement = {
  __typename?: 'GraphContainsRubricGraphElement';
  center?: Maybe<Scalars['Json']['output']>;
  curvePoint?: Maybe<Scalars['Json']['output']>;
  point?: Maybe<Scalars['Json']['output']>;
  points?: Maybe<Array<Scalars['Json']['output']>>;
  radiusPoint?: Maybe<Scalars['Json']['output']>;
  vertex?: Maybe<Scalars['Json']['output']>;
};

export type GraphContainsRubricGraphElementInput = {
  center?: InputMaybe<Scalars['Json']['input']>;
  curvePoint?: InputMaybe<Scalars['Json']['input']>;
  point?: InputMaybe<Scalars['Json']['input']>;
  points?: InputMaybe<Array<Scalars['Json']['input']>>;
  radiusPoint?: InputMaybe<Scalars['Json']['input']>;
  vertex?: InputMaybe<Scalars['Json']['input']>;
};

export type GraphContainsRubricInput = {
  validResponse: Array<InputMaybe<GraphContainsRubricValidResponseItemInput>>;
};

export type GraphContainsRubricValidResponseItem = {
  __typename?: 'GraphContainsRubricValidResponseItem';
  attributes?: Maybe<GraphContainsRubricAttributes>;
  correctAnswerSettings: GraphContainsRubricCorrectAnswerSettings;
  elements: GraphContainsRubricGraphElement;
  type: Scalars['String']['output'];
};

export type GraphContainsRubricValidResponseItemInput = {
  attributes?: InputMaybe<GraphContainsRubricAttributesInput>;
  correctAnswerSettings: GraphContainsRubricCorrectAnswerSettingsInput;
  elements: GraphContainsRubricGraphElementInput;
  type: Scalars['String']['input'];
};

export type Guess = {
  __typename?: 'Guess';
  /** When a guess was placed and or updated. Updates refer only to content changes. */
  answeredAt: Scalars['DateTime']['output'];
  /**
   * The guess's score under the grading mode its assignment was configured for:
   * the partial-credit `grade` for manually-graded (criteria-rubric) questions and
   * for guesses whose effective partial-credit setting is on;
   * otherwise the binary score. Nil until graded, and nil
   * for skips.
   */
  canonicalGrade?: Maybe<Scalars['Decimal']['output']>;
  content: Scalars['JsonString']['output'];
  correct?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether the assignment's correct-answer setting currently allows showing this
   * guess's correctness: always for non-assignment guesses (adaptive practice,
   * diagnostics); showAfterAll requires the student to have submitted;
   * showAfterDueDate requires the due date to have passed. A missing
   * student_assignment row behaves like legacy (visible): the COALESCE'd
   * setting matches neither hide branch, so both resolve to a definite false.
   */
  correctnessVisible?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether release conditions for this guess's teacher-graded fields are met:
   * the question is not manually graded, or the grade is finalized (published)
   * and a teacher has released grades to the student's class
   * (classroom_assignment.grades_released_at, actively-enrolled classrooms
   * only). Null/false when the guess has no student_assignment context
   * (adaptive practice, diagnostics) — such evaluations are never released.
   */
  evaluationReleased?: Maybe<Scalars['Boolean']['output']>;
  grade?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Whether this guess's grade and evaluation are currently viewable by the
   * student: the assignment's correct-answer setting allows it, and — for
   * manually graded questions — the grade is published and released.
   */
  gradeAvailable?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  question: Question;
  questionId: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  student: User;
  teacherEvaluation?: Maybe<GuessManualEvaluation>;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
};

export type GuessCriterionScore = {
  __typename?: 'GuessCriterionScore';
  criterionId: Scalars['ID']['output'];
  feedback?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

export type GuessCriterionScoreInput = {
  criterionId: Scalars['ID']['input'];
  feedback?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['Float']['input']>;
};

export type GuessManualEvaluation = {
  __typename?: 'GuessManualEvaluation';
  criteriaScores?: Maybe<Array<Maybe<GuessCriterionScore>>>;
  overallFeedback?: Maybe<Scalars['String']['output']>;
  overallScore?: Maybe<Scalars['Float']['output']>;
};

export type GuessManualEvaluationInput = {
  criteriaScores?: InputMaybe<Array<InputMaybe<GuessCriterionScoreInput>>>;
  overallFeedback?: InputMaybe<Scalars['String']['input']>;
  overallScore?: InputMaybe<Scalars['Float']['input']>;
};

export enum GuessSortField {
  AnsweredAt = 'ANSWERED_AT',
  Content = 'CONTENT',
  CorrectnessVisible = 'CORRECTNESS_VISIBLE',
  EvaluationReleased = 'EVALUATION_RELEASED',
  GradeAvailable = 'GRADE_AVAILABLE',
  Id = 'ID',
  InsertedAt = 'INSERTED_AT',
  QuestionId = 'QUESTION_ID',
  UpdatedAt = 'UPDATED_AT',
  UserId = 'USER_ID'
}

export type GuessSortInput = {
  field: GuessSortField;
  order?: InputMaybe<SortOrder>;
};

export type Guide = {
  __typename?: 'Guide';
  abQuestionCount?: Maybe<Scalars['Int']['output']>;
  /**
   * The adaptive advance threshold for every skill in this guide, if any. Resolved the same
   * way as `adaptive_range`.
   */
  adaptiveAdvanceThreshold?: Maybe<Scalars['Int']['output']>;
  /**
   * The adaptive fallback threshold for every skill in this guide, if any. Resolved the same
   * way as `adaptive_range`.
   */
  adaptiveFallbackThreshold?: Maybe<Scalars['Int']['output']>;
  /**
   * The diagnostic scoring engine's k-factor (learning rate) for every skill in this guide,
   * if any. Resolved the same way as `adaptive_range`.
   */
  adaptiveKFactor?: Maybe<Scalars['Float']['output']>;
  /**
   * The adaptive range setting for every skill in this guide, if any. Skills and their
   * ancestors override it; the subject and the global default back it up. Read the effective
   * value from a guide level's `effective_adaptive_range` calculation rather than here.
   */
  adaptiveRange?: Maybe<Scalars['Int']['output']>;
  allSkills: Array<GuideLevel>;
  guideLevels: Array<GuideLevel>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /**
   * Content's display order for this guide within its subject. Guides without one sort after
   * those that have one; ties break alphabetically. Callers listing guides to users sort by
   * `position` ascending with nulls last, then `name`.
   */
  position?: Maybe<Scalars['Int']['output']>;
  published: Scalars['Boolean']['output'];
  subject?: Maybe<Subject>;
  subjectId: Scalars['ID']['output'];
  tags: Array<Tag>;
  toDoSkills: Array<GuideLevel>;
  type: Scalars['String']['output'];
  unfilteredGuideLevels: Array<GuideLevel>;
  unfilteredSubject: Subject;
};


export type GuideAbQuestionCountArgs = {
  guideLevels?: InputMaybe<Array<Scalars['ID']['input']>>;
  hideAssessmentQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  hidePreviouslyAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  questionDifficulties?: InputMaybe<Array<Scalars['Int']['input']>>;
  questionTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  standardSets?: InputMaybe<Array<Scalars['ID']['input']>>;
  standards?: InputMaybe<Array<Scalars['ID']['input']>>;
  subjects?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type GuideAllSkillsArgs = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  filter?: InputMaybe<GuideLevelFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GuideLevelSortInput>>>;
};


export type GuideGuideLevelsArgs = {
  filter?: InputMaybe<GuideLevelFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GuideLevelSortInput>>>;
};


export type GuideTagsArgs = {
  filter?: InputMaybe<TagFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TagSortInput>>>;
};


export type GuideToDoSkillsArgs = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  filter?: InputMaybe<GuideLevelFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  recencyRange?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GuideLevelSortInput>>>;
};


export type GuideUnfilteredGuideLevelsArgs = {
  filter?: InputMaybe<GuideLevelFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GuideLevelSortInput>>>;
};

export type GuideAbQuestionCountFieldInput = {
  guideLevels?: InputMaybe<Array<Scalars['ID']['input']>>;
  hideAssessmentQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  hidePreviouslyAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  questionDifficulties?: InputMaybe<Array<Scalars['Int']['input']>>;
  questionTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  standardSets?: InputMaybe<Array<Scalars['ID']['input']>>;
  standards?: InputMaybe<Array<Scalars['ID']['input']>>;
  subjects?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GuideFilterAdaptiveAdvanceThreshold = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type GuideFilterAdaptiveFallbackThreshold = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type GuideFilterAdaptiveKFactor = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Float']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Float']['input']>;
  lessThan?: InputMaybe<Scalars['Float']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Float']['input']>;
  notEq?: InputMaybe<Scalars['Float']['input']>;
};

export type GuideFilterAdaptiveRange = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type GuideFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type GuideFilterInput = {
  /**
   * The adaptive advance threshold for every skill in this guide, if any. Resolved the same
   * way as `adaptive_range`.
   */
  adaptiveAdvanceThreshold?: InputMaybe<GuideFilterAdaptiveAdvanceThreshold>;
  /**
   * The adaptive fallback threshold for every skill in this guide, if any. Resolved the same
   * way as `adaptive_range`.
   */
  adaptiveFallbackThreshold?: InputMaybe<GuideFilterAdaptiveFallbackThreshold>;
  /**
   * The diagnostic scoring engine's k-factor (learning rate) for every skill in this guide,
   * if any. Resolved the same way as `adaptive_range`.
   */
  adaptiveKFactor?: InputMaybe<GuideFilterAdaptiveKFactor>;
  /**
   * The adaptive range setting for every skill in this guide, if any. Skills and their
   * ancestors override it; the subject and the global default back it up. Read the effective
   * value from a guide level's `effective_adaptive_range` calculation rather than here.
   */
  adaptiveRange?: InputMaybe<GuideFilterAdaptiveRange>;
  allSkills?: InputMaybe<GuideLevelFilterInput>;
  and?: InputMaybe<Array<GuideFilterInput>>;
  guideLevels?: InputMaybe<GuideLevelFilterInput>;
  id?: InputMaybe<GuideFilterId>;
  name?: InputMaybe<GuideFilterName>;
  not?: InputMaybe<Array<GuideFilterInput>>;
  or?: InputMaybe<Array<GuideFilterInput>>;
  /**
   * Content's display order for this guide within its subject. Guides without one sort after
   * those that have one; ties break alphabetically. Callers listing guides to users sort by
   * `position` ascending with nulls last, then `name`.
   */
  position?: InputMaybe<GuideFilterPosition>;
  published?: InputMaybe<GuideFilterPublished>;
  subject?: InputMaybe<SubjectFilterInput>;
  subjectId?: InputMaybe<GuideFilterSubjectId>;
  tags?: InputMaybe<TagFilterInput>;
  toDoSkills?: InputMaybe<GuideLevelFilterInput>;
  type?: InputMaybe<GuideFilterType>;
  unfilteredGuideLevels?: InputMaybe<GuideLevelFilterInput>;
  unfilteredSubject?: InputMaybe<SubjectFilterInput>;
};

export type GuideFilterName = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type GuideFilterPosition = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type GuideFilterPublished = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GuideFilterSubjectId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type GuideFilterType = {
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type GuideLevel = {
  __typename?: 'GuideLevel';
  abQuestionCount?: Maybe<Scalars['Int']['output']>;
  /**
   * The adaptive advance threshold setting for this guide level, if any.
   * This is only the stored value. Clients should only use this directly in an authoring context.
   * Use the `effective_adaptive_advance_threshold` calculation to get the effective threshold for a user, which
   * falls back to ancestors if not set on this level.
   */
  adaptiveAdvanceThreshold?: Maybe<Scalars['Int']['output']>;
  /**
   * Seconds from now to the most relevant date for sort ordering.
   * NOTE: This duplicates the definitions for `nearest_skill_path_due_date` and `most_recent_practice_date`
   */
  adaptiveDateProximity?: Maybe<Scalars['Int']['output']>;
  /**
   * The adaptive fallback threshold setting for this guide level, if any.
   * This is only the stored value. Clients should only use this directly in an authoring context.
   * Use the `effective_adaptive_fallback_threshold` calculation to get the effective threshold for a user, which
   * falls back to ancestors if not set on this level.
   */
  adaptiveFallbackThreshold?: Maybe<Scalars['Int']['output']>;
  /**
   * The diagnostic scoring engine's k-factor (learning rate) for this guide level, if any.
   * This is only the stored value. Clients should only use this directly in an authoring context.
   * Use the `effective_adaptive_k_factor` calculation to get the effective k-factor, which
   * falls back to ancestors, the guide, and the subject if not set on this level.
   */
  adaptiveKFactor?: Maybe<Scalars['Float']['output']>;
  /**
   * The adaptive range setting for this guide level, if any.
   * This is only the stored value. Clients should only use this directly in an authoring context.
   * Use the `effective_adaptive_range` calculation to get the effective range for a user, which
   * falls back to ancestors if not set on this level.
   */
  adaptiveRange?: Maybe<Scalars['Int']['output']>;
  /**
   * The highest calculator tier this guide level allows, if set. Tiers are additive: graphing also
   * permits scientific and basic. An explicit `none` withholds the calculator.
   * This is only the stored value. Unset means this level has no setting of its own. Use the
   * `effective_calculator_type` calculation for the value a student gets, which falls back to ancestors.
   */
  calculatorType?: Maybe<CalculatorType>;
  children: Array<GuideLevel>;
  code?: Maybe<Scalars['String']['output']>;
  comingSoon: Scalars['Boolean']['output'];
  countChildren: Scalars['Int']['output'];
  countMatchingQuestions?: Maybe<Scalars['Int']['output']>;
  countOfQuestions?: Maybe<Scalars['Int']['output']>;
  countStandards: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** The first adaptive_advance_threshold value found on this guide level, its closest ancestor with one set, its guide, or its subject, falling back to the global default */
  effectiveAdaptiveAdvanceThreshold?: Maybe<Scalars['Int']['output']>;
  /** The first adaptive_fallback_threshold value found on this guide level, its closest ancestor with one set, its guide, or its subject, falling back to the global default */
  effectiveAdaptiveFallbackThreshold?: Maybe<Scalars['Int']['output']>;
  /** The first adaptive_k_factor value found on this guide level, its closest ancestor with one set, its guide, or its subject, falling back to the global default */
  effectiveAdaptiveKFactor?: Maybe<Scalars['Float']['output']>;
  /** The first adaptive_range value found on this guide level, its closest ancestor with one set, its guide, or its subject, falling back to the global default */
  effectiveAdaptiveRange?: Maybe<Scalars['Int']['output']>;
  /** The calculator_type set on this guide level or its closest ancestor with one set, or none if no level in the chain sets one */
  effectiveCalculatorType?: Maybe<CalculatorType>;
  /** The effective coming_soon value for this guide level, which is true if this level or any ancestor has coming_soon = true */
  effectiveComingSoon?: Maybe<Scalars['Boolean']['output']>;
  /** The effective published value for this guide level, which is true if this level and all ancestors are published */
  effectivePublished?: Maybe<Scalars['Boolean']['output']>;
  free: Scalars['Boolean']['output'];
  guide?: Maybe<Guide>;
  guideId: Scalars['ID']['output'];
  hasQuestions?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** Whether the student has practiced this skill independently (not on their skill path) and hasn't mastered it */
  independentAdaptivePractice?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether this guide level is restricted for the current actor by a school admin's
   * content lock (a `:guide_level` lock on this level or an ancestor, or a `:guide`
   * lock on this guide). Restrictive across all of a teacher's / admin's affiliated
   * schools. Returns false for unaffiliated or anonymous actors.
   */
  isContentLocked?: Maybe<Scalars['Boolean']['output']>;
  level?: Maybe<Scalars['Json']['output']>;
  /** Whether the guide level matches the given search term. Search fields may be any of name, code, description. Defaults to name and code. */
  matchesSearch?: Maybe<Scalars['Boolean']['output']>;
  /** Date at which student most recently placed a guess for this skill */
  mostRecentPracticeDate?: Maybe<Scalars['DateTime']['output']>;
  /** The student's most recent proficiency level for this skill */
  myCurrentProficiencyLevel?: Maybe<Scalars['Int']['output']>;
  /**
   * Delegate to `my_skill_path_proficiency_level` or `my_current_skill_path_level`
   * based on whether the skill is on the student's skill path.
   */
  myProficiencyLevel?: Maybe<Scalars['Int']['output']>;
  /**
   * The student's highest proficiency level for this skill across all active settings on their skill path.
   * Uses the earliest start_date among competing settings. If any setting has no start_date, considers all practices.
   */
  mySkillPathProficiencyLevel?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  /** Nearest due date to now (past or future) across active settings for this skill on the student's skill path */
  nearestSkillPathDueDate?: Maybe<Scalars['DateTime']['output']>;
  nlevel?: Maybe<Scalars['Int']['output']>;
  /** Whether this skill is on the current student's skill path */
  onSkillPath?: Maybe<Scalars['Boolean']['output']>;
  /** Whether any of the current teacher's classrooms have students with this skill on their skill path, or have a skill path config for this skill */
  onStudentsSkillPaths?: Maybe<Scalars['Boolean']['output']>;
  parent?: Maybe<GuideLevel>;
  parentId?: Maybe<Scalars['ID']['output']>;
  position: Scalars['Int']['output'];
  published: Scalars['Boolean']['output'];
  /**
   * How many of `skill_path_student_count` count as complete, per `StudentSkillPath.fulfilled`
   * — a student with an advanced practice that began after their group's start date.
   */
  skillPathCompletedStudentCount: Scalars['Int']['output'];
  /**
   * Whether the range spanned by the in-scope groups holding `status` overlaps the window.
   * Omitting `status` spans every in-scope group regardless of it.
   *
   * Exactly what pairing `skill_path_max_due_date >= start` with `skill_path_min_due_date <= end`
   * answers, and deliberately so — `max(due_date) >= start` holds precisely when some group is due
   * at or after `start`, and `min(due_date) <= end` when some group is due at or before it. Same
   * answer, but each half is an `exists` that stops at its first match rather than an aggregate
   * that must evaluate `teacher_status` for every group.
   *
   * Callers wanting the stricter question — is any single group due inside the window — need a
   * different predicate; this one deliberately answers range overlap.
   */
  skillPathDueRangeOverlaps?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The most recent `updated_at` across this skill's in-scope recipient groups and their
   * recipient rows — the default sort for the Skill Paths list. It ranges over the rows rather
   * than recording an edit event, so removing a recipient can move it backwards: the removed
   * row is no longer there to be the maximum.
   */
  skillPathLastEditedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Latest due date across the in-scope recipient groups holding `status`. Scopes by status
   * exactly as `skill_path_min_due_date` does, including omitting it to span every group.
   */
  skillPathMaxDueDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Latest start date across the in-scope recipient groups holding `status`. Scopes by status
   * exactly as `skill_path_min_start_date` does, including omitting it to span every group.
   */
  skillPathMaxStartDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Earliest due date across the in-scope recipient groups holding `status`. Pass the status
   * the list was filtered by; omitting it spans every in-scope group regardless of status. A list
   * mixing statuses wants `skillPathStatusScopedMinDueDate`, which scopes to each row's own.
   */
  skillPathMinDueDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Earliest start date across the in-scope recipient groups holding `status`; omitting
   * `status` spans every in-scope group regardless of it. Groups with no start date began
   * immediately and have no date to contribute, so they are skipped — under a `status` that
   * admits them the earliest reported start can sit after a group that is already running. A list
   * mixing statuses wants `skillPathStatusScopedMinStartDate`, which scopes to each row's own.
   */
  skillPathMinStartDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * This skill's status for the scoped teacher, rolled up from its recipient groups in scope
   * with the precedence open > scheduled > closed. The same skill can hold different statuses
   * in different scopes.
   */
  skillPathStatus?: Maybe<SkillPathStatus>;
  /**
   * The earliest due date across the in-scope groups holding the row's own status — the sort key
   * for a list mixing statuses, where `skillPathMinDueDate` without a status would order a row by
   * a group whose date it does not display.
   */
  skillPathStatusScopedMinDueDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The earliest start date across the in-scope groups holding the row's own status — the
   * start-date sort key a list mixing statuses needs, as `skillPathStatusScopedMinDueDate` is its
   * due-date one.
   *
   * Nil when no group holding that status set a start date, because such a group began
   * immediately. That is more often than `skillPathMinStartDate`, which spans every status. A
   * plain ascending or descending sort puts those rows last or first; pass a `NULLS` ordering to
   * place them where you want them.
   */
  skillPathStatusScopedMinStartDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * How many in-scope students have this skill on their path, counted distinctly — a student
   * reachable through two classes the teacher takes is still one student.
   *
   * Not narrowed to the row's status: completion is defined over every in-scope student who
   * has the skill on their path, so the fraction stays stable as the status filter changes.
   */
  skillPathStudentCount: Scalars['Int']['output'];
  standards: Array<Standard>;
  subject?: Maybe<Subject>;
  subjectId: Scalars['ID']['output'];
  themeImg?: Maybe<Scalars['String']['output']>;
  unfilteredAncestors: Array<GuideLevel>;
  unfilteredChildren: Array<GuideLevel>;
  unfilteredCountChildren: Scalars['Int']['output'];
  unfilteredDescendants: Array<GuideLevel>;
  unfilteredGuide: Guide;
  unfilteredParent?: Maybe<GuideLevel>;
  unfilteredSubject: Subject;
  urlSlug?: Maybe<Scalars['String']['output']>;
};


export type GuideLevelAbQuestionCountArgs = {
  guideLevels?: InputMaybe<Array<Scalars['ID']['input']>>;
  hideAssessmentQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  hidePreviouslyAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  questionDifficulties?: InputMaybe<Array<Scalars['Int']['input']>>;
  questionTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  standardSets?: InputMaybe<Array<Scalars['ID']['input']>>;
  standards?: InputMaybe<Array<Scalars['ID']['input']>>;
  subjects?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type GuideLevelAdaptiveDateProximityArgs = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type GuideLevelChildrenArgs = {
  filter?: InputMaybe<GuideLevelFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GuideLevelSortInput>>>;
};


export type GuideLevelCountMatchingQuestionsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  standardIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type GuideLevelIndependentAdaptivePracticeArgs = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type GuideLevelMatchesSearchArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  searchFields?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type GuideLevelMyProficiencyLevelArgs = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type GuideLevelMySkillPathProficiencyLevelArgs = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type GuideLevelNearestSkillPathDueDateArgs = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type GuideLevelOnSkillPathArgs = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type GuideLevelSkillPathDueRangeOverlapsArgs = {
  onOrAfter?: InputMaybe<Scalars['DateTime']['input']>;
  onOrBefore?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<SkillPathStatus>;
};


export type GuideLevelSkillPathMaxDueDateArgs = {
  status?: InputMaybe<SkillPathStatus>;
};


export type GuideLevelSkillPathMaxStartDateArgs = {
  status?: InputMaybe<SkillPathStatus>;
};


export type GuideLevelSkillPathMinDueDateArgs = {
  status?: InputMaybe<SkillPathStatus>;
};


export type GuideLevelSkillPathMinStartDateArgs = {
  status?: InputMaybe<SkillPathStatus>;
};


export type GuideLevelStandardsArgs = {
  filter?: InputMaybe<StandardFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<StandardSortInput>>>;
};


export type GuideLevelUnfilteredAncestorsArgs = {
  filter?: InputMaybe<GuideLevelFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GuideLevelSortInput>>>;
};


export type GuideLevelUnfilteredChildrenArgs = {
  filter?: InputMaybe<GuideLevelFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GuideLevelSortInput>>>;
};


export type GuideLevelUnfilteredDescendantsArgs = {
  filter?: InputMaybe<GuideLevelFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GuideLevelSortInput>>>;
};

export type GuideLevelAbQuestionCountFieldInput = {
  guideLevels?: InputMaybe<Array<Scalars['ID']['input']>>;
  hideAssessmentQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  hidePreviouslyAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  questionDifficulties?: InputMaybe<Array<Scalars['Int']['input']>>;
  questionTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  standardSets?: InputMaybe<Array<Scalars['ID']['input']>>;
  standards?: InputMaybe<Array<Scalars['ID']['input']>>;
  subjects?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GuideLevelAdaptiveDateProximityFieldInput = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GuideLevelCountMatchingQuestionsFieldInput = {
  search?: InputMaybe<Scalars['String']['input']>;
  standardIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GuideLevelFilterAdaptiveAdvanceThreshold = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type GuideLevelFilterAdaptiveDateProximity = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  input?: InputMaybe<GuideLevelAdaptiveDateProximityFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type GuideLevelFilterAdaptiveFallbackThreshold = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type GuideLevelFilterAdaptiveKFactor = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Float']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Float']['input']>;
  lessThan?: InputMaybe<Scalars['Float']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Float']['input']>;
  notEq?: InputMaybe<Scalars['Float']['input']>;
};

export type GuideLevelFilterAdaptiveRange = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type GuideLevelFilterCalculatorType = {
  eq?: InputMaybe<CalculatorType>;
  greaterThan?: InputMaybe<CalculatorType>;
  greaterThanOrEqual?: InputMaybe<CalculatorType>;
  in?: InputMaybe<Array<InputMaybe<CalculatorType>>>;
  isDistinctFrom?: InputMaybe<CalculatorType>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<CalculatorType>;
  lessThan?: InputMaybe<CalculatorType>;
  lessThanOrEqual?: InputMaybe<CalculatorType>;
  notEq?: InputMaybe<CalculatorType>;
};

export type GuideLevelFilterCode = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type GuideLevelFilterComingSoon = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GuideLevelFilterCountChildren = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type GuideLevelFilterCountMatchingQuestions = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  input?: InputMaybe<GuideLevelCountMatchingQuestionsFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type GuideLevelFilterCountOfQuestions = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type GuideLevelFilterCountStandards = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type GuideLevelFilterDescription = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type GuideLevelFilterEffectiveAdaptiveAdvanceThreshold = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type GuideLevelFilterEffectiveAdaptiveFallbackThreshold = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type GuideLevelFilterEffectiveAdaptiveKFactor = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Float']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Float']['input']>;
  lessThan?: InputMaybe<Scalars['Float']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Float']['input']>;
  notEq?: InputMaybe<Scalars['Float']['input']>;
};

export type GuideLevelFilterEffectiveAdaptiveRange = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type GuideLevelFilterEffectiveCalculatorType = {
  eq?: InputMaybe<CalculatorType>;
  greaterThan?: InputMaybe<CalculatorType>;
  greaterThanOrEqual?: InputMaybe<CalculatorType>;
  in?: InputMaybe<Array<CalculatorType>>;
  isDistinctFrom?: InputMaybe<CalculatorType>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<CalculatorType>;
  lessThan?: InputMaybe<CalculatorType>;
  lessThanOrEqual?: InputMaybe<CalculatorType>;
  notEq?: InputMaybe<CalculatorType>;
};

export type GuideLevelFilterEffectiveComingSoon = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GuideLevelFilterEffectivePublished = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GuideLevelFilterFree = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GuideLevelFilterGuideId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type GuideLevelFilterHasQuestions = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GuideLevelFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type GuideLevelFilterIndependentAdaptivePractice = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  input?: InputMaybe<GuideLevelIndependentAdaptivePracticeFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GuideLevelFilterInput = {
  /**
   * The adaptive advance threshold setting for this guide level, if any.
   * This is only the stored value. Clients should only use this directly in an authoring context.
   * Use the `effective_adaptive_advance_threshold` calculation to get the effective threshold for a user, which
   * falls back to ancestors if not set on this level.
   */
  adaptiveAdvanceThreshold?: InputMaybe<GuideLevelFilterAdaptiveAdvanceThreshold>;
  /**
   * Seconds from now to the most relevant date for sort ordering.
   * NOTE: This duplicates the definitions for `nearest_skill_path_due_date` and `most_recent_practice_date`
   */
  adaptiveDateProximity?: InputMaybe<GuideLevelFilterAdaptiveDateProximity>;
  /**
   * The adaptive fallback threshold setting for this guide level, if any.
   * This is only the stored value. Clients should only use this directly in an authoring context.
   * Use the `effective_adaptive_fallback_threshold` calculation to get the effective threshold for a user, which
   * falls back to ancestors if not set on this level.
   */
  adaptiveFallbackThreshold?: InputMaybe<GuideLevelFilterAdaptiveFallbackThreshold>;
  /**
   * The diagnostic scoring engine's k-factor (learning rate) for this guide level, if any.
   * This is only the stored value. Clients should only use this directly in an authoring context.
   * Use the `effective_adaptive_k_factor` calculation to get the effective k-factor, which
   * falls back to ancestors, the guide, and the subject if not set on this level.
   */
  adaptiveKFactor?: InputMaybe<GuideLevelFilterAdaptiveKFactor>;
  /**
   * The adaptive range setting for this guide level, if any.
   * This is only the stored value. Clients should only use this directly in an authoring context.
   * Use the `effective_adaptive_range` calculation to get the effective range for a user, which
   * falls back to ancestors if not set on this level.
   */
  adaptiveRange?: InputMaybe<GuideLevelFilterAdaptiveRange>;
  and?: InputMaybe<Array<GuideLevelFilterInput>>;
  /**
   * The highest calculator tier this guide level allows, if set. Tiers are additive: graphing also
   * permits scientific and basic. An explicit `none` withholds the calculator.
   * This is only the stored value. Unset means this level has no setting of its own. Use the
   * `effective_calculator_type` calculation for the value a student gets, which falls back to ancestors.
   */
  calculatorType?: InputMaybe<GuideLevelFilterCalculatorType>;
  children?: InputMaybe<GuideLevelFilterInput>;
  code?: InputMaybe<GuideLevelFilterCode>;
  comingSoon?: InputMaybe<GuideLevelFilterComingSoon>;
  countChildren?: InputMaybe<GuideLevelFilterCountChildren>;
  countMatchingQuestions?: InputMaybe<GuideLevelFilterCountMatchingQuestions>;
  countOfQuestions?: InputMaybe<GuideLevelFilterCountOfQuestions>;
  countStandards?: InputMaybe<GuideLevelFilterCountStandards>;
  description?: InputMaybe<GuideLevelFilterDescription>;
  /** The first adaptive_advance_threshold value found on this guide level, its closest ancestor with one set, its guide, or its subject, falling back to the global default */
  effectiveAdaptiveAdvanceThreshold?: InputMaybe<GuideLevelFilterEffectiveAdaptiveAdvanceThreshold>;
  /** The first adaptive_fallback_threshold value found on this guide level, its closest ancestor with one set, its guide, or its subject, falling back to the global default */
  effectiveAdaptiveFallbackThreshold?: InputMaybe<GuideLevelFilterEffectiveAdaptiveFallbackThreshold>;
  /** The first adaptive_k_factor value found on this guide level, its closest ancestor with one set, its guide, or its subject, falling back to the global default */
  effectiveAdaptiveKFactor?: InputMaybe<GuideLevelFilterEffectiveAdaptiveKFactor>;
  /** The first adaptive_range value found on this guide level, its closest ancestor with one set, its guide, or its subject, falling back to the global default */
  effectiveAdaptiveRange?: InputMaybe<GuideLevelFilterEffectiveAdaptiveRange>;
  /** The calculator_type set on this guide level or its closest ancestor with one set, or none if no level in the chain sets one */
  effectiveCalculatorType?: InputMaybe<GuideLevelFilterEffectiveCalculatorType>;
  /** The effective coming_soon value for this guide level, which is true if this level or any ancestor has coming_soon = true */
  effectiveComingSoon?: InputMaybe<GuideLevelFilterEffectiveComingSoon>;
  /** The effective published value for this guide level, which is true if this level and all ancestors are published */
  effectivePublished?: InputMaybe<GuideLevelFilterEffectivePublished>;
  free?: InputMaybe<GuideLevelFilterFree>;
  guide?: InputMaybe<GuideFilterInput>;
  guideId?: InputMaybe<GuideLevelFilterGuideId>;
  hasQuestions?: InputMaybe<GuideLevelFilterHasQuestions>;
  id?: InputMaybe<GuideLevelFilterId>;
  /** Whether the student has practiced this skill independently (not on their skill path) and hasn't mastered it */
  independentAdaptivePractice?: InputMaybe<GuideLevelFilterIndependentAdaptivePractice>;
  level?: InputMaybe<GuideLevelFilterLevel>;
  /** Whether the guide level matches the given search term. Search fields may be any of name, code, description. Defaults to name and code. */
  matchesSearch?: InputMaybe<GuideLevelFilterMatchesSearch>;
  /** Date at which student most recently placed a guess for this skill */
  mostRecentPracticeDate?: InputMaybe<GuideLevelFilterMostRecentPracticeDate>;
  /** The student's most recent proficiency level for this skill */
  myCurrentProficiencyLevel?: InputMaybe<GuideLevelFilterMyCurrentProficiencyLevel>;
  name?: InputMaybe<GuideLevelFilterName>;
  /** Nearest due date to now (past or future) across active settings for this skill on the student's skill path */
  nearestSkillPathDueDate?: InputMaybe<GuideLevelFilterNearestSkillPathDueDate>;
  nlevel?: InputMaybe<GuideLevelFilterNlevel>;
  not?: InputMaybe<Array<GuideLevelFilterInput>>;
  /** Whether this skill is on the current student's skill path */
  onSkillPath?: InputMaybe<GuideLevelFilterOnSkillPath>;
  /** Whether any of the current teacher's classrooms have students with this skill on their skill path, or have a skill path config for this skill */
  onStudentsSkillPaths?: InputMaybe<GuideLevelFilterOnStudentsSkillPaths>;
  or?: InputMaybe<Array<GuideLevelFilterInput>>;
  parent?: InputMaybe<GuideLevelFilterInput>;
  parentId?: InputMaybe<GuideLevelFilterParentId>;
  position?: InputMaybe<GuideLevelFilterPosition>;
  published?: InputMaybe<GuideLevelFilterPublished>;
  /**
   * How many of `skill_path_student_count` count as complete, per `StudentSkillPath.fulfilled`
   * — a student with an advanced practice that began after their group's start date.
   */
  skillPathCompletedStudentCount?: InputMaybe<GuideLevelFilterSkillPathCompletedStudentCount>;
  /**
   * Whether the range spanned by the in-scope groups holding `status` overlaps the window.
   * Omitting `status` spans every in-scope group regardless of it.
   *
   * Exactly what pairing `skill_path_max_due_date >= start` with `skill_path_min_due_date <= end`
   * answers, and deliberately so — `max(due_date) >= start` holds precisely when some group is due
   * at or after `start`, and `min(due_date) <= end` when some group is due at or before it. Same
   * answer, but each half is an `exists` that stops at its first match rather than an aggregate
   * that must evaluate `teacher_status` for every group.
   *
   * Callers wanting the stricter question — is any single group due inside the window — need a
   * different predicate; this one deliberately answers range overlap.
   */
  skillPathDueRangeOverlaps?: InputMaybe<GuideLevelFilterSkillPathDueRangeOverlaps>;
  /**
   * The most recent `updated_at` across this skill's in-scope recipient groups and their
   * recipient rows — the default sort for the Skill Paths list. It ranges over the rows rather
   * than recording an edit event, so removing a recipient can move it backwards: the removed
   * row is no longer there to be the maximum.
   */
  skillPathLastEditedAt?: InputMaybe<GuideLevelFilterSkillPathLastEditedAt>;
  /**
   * Latest due date across the in-scope recipient groups holding `status`. Scopes by status
   * exactly as `skill_path_min_due_date` does, including omitting it to span every group.
   */
  skillPathMaxDueDate?: InputMaybe<GuideLevelFilterSkillPathMaxDueDate>;
  /**
   * Latest start date across the in-scope recipient groups holding `status`. Scopes by status
   * exactly as `skill_path_min_start_date` does, including omitting it to span every group.
   */
  skillPathMaxStartDate?: InputMaybe<GuideLevelFilterSkillPathMaxStartDate>;
  /**
   * Earliest due date across the in-scope recipient groups holding `status`. Pass the status
   * the list was filtered by; omitting it spans every in-scope group regardless of status. A list
   * mixing statuses wants `skillPathStatusScopedMinDueDate`, which scopes to each row's own.
   */
  skillPathMinDueDate?: InputMaybe<GuideLevelFilterSkillPathMinDueDate>;
  /**
   * Earliest start date across the in-scope recipient groups holding `status`; omitting
   * `status` spans every in-scope group regardless of it. Groups with no start date began
   * immediately and have no date to contribute, so they are skipped — under a `status` that
   * admits them the earliest reported start can sit after a group that is already running. A list
   * mixing statuses wants `skillPathStatusScopedMinStartDate`, which scopes to each row's own.
   */
  skillPathMinStartDate?: InputMaybe<GuideLevelFilterSkillPathMinStartDate>;
  /**
   * This skill's status for the scoped teacher, rolled up from its recipient groups in scope
   * with the precedence open > scheduled > closed. The same skill can hold different statuses
   * in different scopes.
   */
  skillPathStatus?: InputMaybe<GuideLevelFilterSkillPathStatus>;
  /**
   * The earliest due date across the in-scope groups holding the row's own status — the sort key
   * for a list mixing statuses, where `skillPathMinDueDate` without a status would order a row by
   * a group whose date it does not display.
   */
  skillPathStatusScopedMinDueDate?: InputMaybe<GuideLevelFilterSkillPathStatusScopedMinDueDate>;
  /**
   * The earliest start date across the in-scope groups holding the row's own status — the
   * start-date sort key a list mixing statuses needs, as `skillPathStatusScopedMinDueDate` is its
   * due-date one.
   *
   * Nil when no group holding that status set a start date, because such a group began
   * immediately. That is more often than `skillPathMinStartDate`, which spans every status. A
   * plain ascending or descending sort puts those rows last or first; pass a `NULLS` ordering to
   * place them where you want them.
   */
  skillPathStatusScopedMinStartDate?: InputMaybe<GuideLevelFilterSkillPathStatusScopedMinStartDate>;
  /**
   * How many in-scope students have this skill on their path, counted distinctly — a student
   * reachable through two classes the teacher takes is still one student.
   *
   * Not narrowed to the row's status: completion is defined over every in-scope student who
   * has the skill on their path, so the fraction stays stable as the status filter changes.
   */
  skillPathStudentCount?: InputMaybe<GuideLevelFilterSkillPathStudentCount>;
  standards?: InputMaybe<StandardFilterInput>;
  subject?: InputMaybe<SubjectFilterInput>;
  subjectId?: InputMaybe<GuideLevelFilterSubjectId>;
  themeImg?: InputMaybe<GuideLevelFilterThemeImg>;
  unfilteredAncestors?: InputMaybe<GuideLevelFilterInput>;
  unfilteredChildren?: InputMaybe<GuideLevelFilterInput>;
  unfilteredCountChildren?: InputMaybe<GuideLevelFilterUnfilteredCountChildren>;
  unfilteredDescendants?: InputMaybe<GuideLevelFilterInput>;
  unfilteredGuide?: InputMaybe<GuideFilterInput>;
  unfilteredParent?: InputMaybe<GuideLevelFilterInput>;
  unfilteredSubject?: InputMaybe<SubjectFilterInput>;
  urlSlug?: InputMaybe<GuideLevelFilterUrlSlug>;
};

export type GuideLevelFilterLevel = {
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GuideLevelFilterMatchesSearch = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  input?: InputMaybe<GuideLevelMatchesSearchFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GuideLevelFilterMostRecentPracticeDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GuideLevelFilterMyCurrentProficiencyLevel = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type GuideLevelFilterName = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type GuideLevelFilterNearestSkillPathDueDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  input?: InputMaybe<GuideLevelNearestSkillPathDueDateFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GuideLevelFilterNlevel = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type GuideLevelFilterOnSkillPath = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  input?: InputMaybe<GuideLevelOnSkillPathFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GuideLevelFilterOnStudentsSkillPaths = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GuideLevelFilterParentId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type GuideLevelFilterPosition = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type GuideLevelFilterPublished = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GuideLevelFilterSkillPathCompletedStudentCount = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type GuideLevelFilterSkillPathDueRangeOverlaps = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  input?: InputMaybe<GuideLevelSkillPathDueRangeOverlapsFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GuideLevelFilterSkillPathLastEditedAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GuideLevelFilterSkillPathMaxDueDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  input?: InputMaybe<GuideLevelSkillPathMaxDueDateFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GuideLevelFilterSkillPathMaxStartDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  input?: InputMaybe<GuideLevelSkillPathMaxStartDateFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GuideLevelFilterSkillPathMinDueDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  input?: InputMaybe<GuideLevelSkillPathMinDueDateFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GuideLevelFilterSkillPathMinStartDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  input?: InputMaybe<GuideLevelSkillPathMinStartDateFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GuideLevelFilterSkillPathStatus = {
  eq?: InputMaybe<SkillPathStatus>;
  greaterThan?: InputMaybe<SkillPathStatus>;
  greaterThanOrEqual?: InputMaybe<SkillPathStatus>;
  in?: InputMaybe<Array<SkillPathStatus>>;
  isDistinctFrom?: InputMaybe<SkillPathStatus>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<SkillPathStatus>;
  lessThan?: InputMaybe<SkillPathStatus>;
  lessThanOrEqual?: InputMaybe<SkillPathStatus>;
  notEq?: InputMaybe<SkillPathStatus>;
};

export type GuideLevelFilterSkillPathStatusScopedMinDueDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GuideLevelFilterSkillPathStatusScopedMinStartDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GuideLevelFilterSkillPathStudentCount = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type GuideLevelFilterSubjectId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type GuideLevelFilterThemeImg = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type GuideLevelFilterUnfilteredCountChildren = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type GuideLevelFilterUrlSlug = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type GuideLevelIndependentAdaptivePracticeFieldInput = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GuideLevelMatchesSearchFieldInput = {
  search?: InputMaybe<Scalars['String']['input']>;
  searchFields?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GuideLevelMyProficiencyLevelFieldInput = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GuideLevelMySkillPathProficiencyLevelFieldInput = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GuideLevelNearestSkillPathDueDateFieldInput = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GuideLevelOnSkillPathFieldInput = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GuideLevelSearchResult = {
  __typename?: 'GuideLevelSearchResult';
  children?: Maybe<Array<Maybe<GuideLevelSearchResult>>>;
  code?: Maybe<Scalars['String']['output']>;
  comingSoon?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  level?: Maybe<Array<Scalars['String']['output']>>;
  matchesSearch?: Maybe<Scalars['Boolean']['output']>;
  myCurrentProficiencyLevel?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  onStudentsSkillPaths?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GuideLevelSkillPathDueRangeOverlapsFieldInput = {
  onOrAfter?: InputMaybe<Scalars['DateTime']['input']>;
  onOrBefore?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<SkillPathStatus>;
};

export type GuideLevelSkillPathMaxDueDateFieldInput = {
  status?: InputMaybe<SkillPathStatus>;
};

export type GuideLevelSkillPathMaxStartDateFieldInput = {
  status?: InputMaybe<SkillPathStatus>;
};

export type GuideLevelSkillPathMinDueDateFieldInput = {
  status?: InputMaybe<SkillPathStatus>;
};

export type GuideLevelSkillPathMinStartDateFieldInput = {
  status?: InputMaybe<SkillPathStatus>;
};

export enum GuideLevelSortField {
  AdaptiveAdvanceThreshold = 'ADAPTIVE_ADVANCE_THRESHOLD',
  AdaptiveDateProximity = 'ADAPTIVE_DATE_PROXIMITY',
  AdaptiveFallbackThreshold = 'ADAPTIVE_FALLBACK_THRESHOLD',
  AdaptiveKFactor = 'ADAPTIVE_K_FACTOR',
  AdaptiveRange = 'ADAPTIVE_RANGE',
  CalculatorType = 'CALCULATOR_TYPE',
  Code = 'CODE',
  ComingSoon = 'COMING_SOON',
  CountChildren = 'COUNT_CHILDREN',
  CountMatchingQuestions = 'COUNT_MATCHING_QUESTIONS',
  CountOfQuestions = 'COUNT_OF_QUESTIONS',
  CountStandards = 'COUNT_STANDARDS',
  Description = 'DESCRIPTION',
  EffectiveAdaptiveAdvanceThreshold = 'EFFECTIVE_ADAPTIVE_ADVANCE_THRESHOLD',
  EffectiveAdaptiveFallbackThreshold = 'EFFECTIVE_ADAPTIVE_FALLBACK_THRESHOLD',
  EffectiveAdaptiveKFactor = 'EFFECTIVE_ADAPTIVE_K_FACTOR',
  EffectiveAdaptiveRange = 'EFFECTIVE_ADAPTIVE_RANGE',
  EffectiveCalculatorType = 'EFFECTIVE_CALCULATOR_TYPE',
  EffectiveComingSoon = 'EFFECTIVE_COMING_SOON',
  EffectivePublished = 'EFFECTIVE_PUBLISHED',
  Free = 'FREE',
  GuideId = 'GUIDE_ID',
  HasQuestions = 'HAS_QUESTIONS',
  Id = 'ID',
  IndependentAdaptivePractice = 'INDEPENDENT_ADAPTIVE_PRACTICE',
  Level = 'LEVEL',
  MatchesSearch = 'MATCHES_SEARCH',
  MostRecentPracticeDate = 'MOST_RECENT_PRACTICE_DATE',
  MyCurrentProficiencyLevel = 'MY_CURRENT_PROFICIENCY_LEVEL',
  Name = 'NAME',
  NearestSkillPathDueDate = 'NEAREST_SKILL_PATH_DUE_DATE',
  Nlevel = 'NLEVEL',
  OnSkillPath = 'ON_SKILL_PATH',
  OnStudentsSkillPaths = 'ON_STUDENTS_SKILL_PATHS',
  ParentId = 'PARENT_ID',
  Position = 'POSITION',
  Published = 'PUBLISHED',
  SkillPathCompletedStudentCount = 'SKILL_PATH_COMPLETED_STUDENT_COUNT',
  SkillPathDueRangeOverlaps = 'SKILL_PATH_DUE_RANGE_OVERLAPS',
  SkillPathLastEditedAt = 'SKILL_PATH_LAST_EDITED_AT',
  SkillPathMaxDueDate = 'SKILL_PATH_MAX_DUE_DATE',
  SkillPathMaxStartDate = 'SKILL_PATH_MAX_START_DATE',
  SkillPathMinDueDate = 'SKILL_PATH_MIN_DUE_DATE',
  SkillPathMinStartDate = 'SKILL_PATH_MIN_START_DATE',
  SkillPathStatus = 'SKILL_PATH_STATUS',
  SkillPathStatusScopedMinDueDate = 'SKILL_PATH_STATUS_SCOPED_MIN_DUE_DATE',
  SkillPathStatusScopedMinStartDate = 'SKILL_PATH_STATUS_SCOPED_MIN_START_DATE',
  SkillPathStudentCount = 'SKILL_PATH_STUDENT_COUNT',
  SubjectId = 'SUBJECT_ID',
  ThemeImg = 'THEME_IMG',
  UnfilteredCountChildren = 'UNFILTERED_COUNT_CHILDREN',
  UrlSlug = 'URL_SLUG'
}

export type GuideLevelSortInput = {
  abQuestionCountInput?: InputMaybe<GuideLevelAbQuestionCountFieldInput>;
  adaptiveDateProximityInput?: InputMaybe<GuideLevelAdaptiveDateProximityFieldInput>;
  countMatchingQuestionsInput?: InputMaybe<GuideLevelCountMatchingQuestionsFieldInput>;
  field: GuideLevelSortField;
  independentAdaptivePracticeInput?: InputMaybe<GuideLevelIndependentAdaptivePracticeFieldInput>;
  matchesSearchInput?: InputMaybe<GuideLevelMatchesSearchFieldInput>;
  myProficiencyLevelInput?: InputMaybe<GuideLevelMyProficiencyLevelFieldInput>;
  mySkillPathProficiencyLevelInput?: InputMaybe<GuideLevelMySkillPathProficiencyLevelFieldInput>;
  nearestSkillPathDueDateInput?: InputMaybe<GuideLevelNearestSkillPathDueDateFieldInput>;
  onSkillPathInput?: InputMaybe<GuideLevelOnSkillPathFieldInput>;
  order?: InputMaybe<SortOrder>;
  skillPathDueRangeOverlapsInput?: InputMaybe<GuideLevelSkillPathDueRangeOverlapsFieldInput>;
  skillPathMaxDueDateInput?: InputMaybe<GuideLevelSkillPathMaxDueDateFieldInput>;
  skillPathMaxStartDateInput?: InputMaybe<GuideLevelSkillPathMaxStartDateFieldInput>;
  skillPathMinDueDateInput?: InputMaybe<GuideLevelSkillPathMinDueDateFieldInput>;
  skillPathMinStartDateInput?: InputMaybe<GuideLevelSkillPathMinStartDateFieldInput>;
};

export enum GuideSortField {
  AdaptiveAdvanceThreshold = 'ADAPTIVE_ADVANCE_THRESHOLD',
  AdaptiveFallbackThreshold = 'ADAPTIVE_FALLBACK_THRESHOLD',
  AdaptiveKFactor = 'ADAPTIVE_K_FACTOR',
  AdaptiveRange = 'ADAPTIVE_RANGE',
  Id = 'ID',
  Name = 'NAME',
  Position = 'POSITION',
  Published = 'PUBLISHED',
  SubjectId = 'SUBJECT_ID',
  Type = 'TYPE'
}

export type GuideSortInput = {
  abQuestionCountInput?: InputMaybe<GuideAbQuestionCountFieldInput>;
  field: GuideSortField;
  order?: InputMaybe<SortOrder>;
};

export type ImageSupplementContent = {
  __typename?: 'ImageSupplementContent';
  alttext?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  generationMode?: Maybe<SupplementImageGenerationMode>;
  height?: Maybe<Scalars['Int']['output']>;
  image: Scalars['String']['output'];
  imagePrompt?: Maybe<Scalars['String']['output']>;
  imageSize?: Maybe<Scalars['Int']['output']>;
  imageStatus?: Maybe<SupplementGenerationStatus>;
  width?: Maybe<Scalars['Int']['output']>;
  x?: Maybe<Scalars['Int']['output']>;
  y?: Maybe<Scalars['Int']['output']>;
};

export type ImpactPreview = {
  __typename?: 'ImpactPreview';
  closedAssignmentCount: Scalars['Int']['output'];
  openAssignmentCount: Scalars['Int']['output'];
};

/** A keyset page of :adaptive_practice */
export type KeysetPageOfAdaptivePractice = {
  __typename?: 'KeysetPageOfAdaptivePractice';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** The last keyset in the results */
  endKeyset?: Maybe<Scalars['String']['output']>;
  /** The records contained in the page */
  results?: Maybe<Array<AdaptivePractice>>;
  /** The first keyset in the results */
  startKeyset?: Maybe<Scalars['String']['output']>;
};

/** A keyset page of :assignment */
export type KeysetPageOfAssignment = {
  __typename?: 'KeysetPageOfAssignment';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** The last keyset in the results */
  endKeyset?: Maybe<Scalars['String']['output']>;
  /** The records contained in the page */
  results?: Maybe<Array<Assignment>>;
  /** The first keyset in the results */
  startKeyset?: Maybe<Scalars['String']['output']>;
};

/** A keyset page of :authoring_feedback */
export type KeysetPageOfAuthoringFeedback = {
  __typename?: 'KeysetPageOfAuthoringFeedback';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** The last keyset in the results */
  endKeyset?: Maybe<Scalars['String']['output']>;
  /** The records contained in the page */
  results?: Maybe<Array<AuthoringFeedback>>;
  /** The first keyset in the results */
  startKeyset?: Maybe<Scalars['String']['output']>;
};

/** A keyset page of :curriculum_area */
export type KeysetPageOfCurriculumArea = {
  __typename?: 'KeysetPageOfCurriculumArea';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** The last keyset in the results */
  endKeyset?: Maybe<Scalars['String']['output']>;
  /** The records contained in the page */
  results?: Maybe<Array<CurriculumArea>>;
  /** The first keyset in the results */
  startKeyset?: Maybe<Scalars['String']['output']>;
};

/** A keyset page of :diagnostic */
export type KeysetPageOfDiagnostic = {
  __typename?: 'KeysetPageOfDiagnostic';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** The last keyset in the results */
  endKeyset?: Maybe<Scalars['String']['output']>;
  /** The records contained in the page */
  results?: Maybe<Array<Diagnostic>>;
  /** The first keyset in the results */
  startKeyset?: Maybe<Scalars['String']['output']>;
};

/** A keyset page of :diagnostic_template */
export type KeysetPageOfDiagnosticTemplate = {
  __typename?: 'KeysetPageOfDiagnosticTemplate';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** The last keyset in the results */
  endKeyset?: Maybe<Scalars['String']['output']>;
  /** The records contained in the page */
  results?: Maybe<Array<DiagnosticTemplate>>;
  /** The first keyset in the results */
  startKeyset?: Maybe<Scalars['String']['output']>;
};

/** A keyset page of :district */
export type KeysetPageOfDistrict = {
  __typename?: 'KeysetPageOfDistrict';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** The last keyset in the results */
  endKeyset?: Maybe<Scalars['String']['output']>;
  /** The records contained in the page */
  results?: Maybe<Array<District>>;
  /** The first keyset in the results */
  startKeyset?: Maybe<Scalars['String']['output']>;
};

/** A keyset page of :grade_level */
export type KeysetPageOfGradeLevel = {
  __typename?: 'KeysetPageOfGradeLevel';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** The last keyset in the results */
  endKeyset?: Maybe<Scalars['String']['output']>;
  /** The records contained in the page */
  results?: Maybe<Array<GradeLevel>>;
  /** The first keyset in the results */
  startKeyset?: Maybe<Scalars['String']['output']>;
};

/** A keyset page of :guide */
export type KeysetPageOfGuide = {
  __typename?: 'KeysetPageOfGuide';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** The last keyset in the results */
  endKeyset?: Maybe<Scalars['String']['output']>;
  /** The records contained in the page */
  results?: Maybe<Array<Guide>>;
  /** The first keyset in the results */
  startKeyset?: Maybe<Scalars['String']['output']>;
};

/** A keyset page of :guide_level */
export type KeysetPageOfGuideLevel = {
  __typename?: 'KeysetPageOfGuideLevel';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** The last keyset in the results */
  endKeyset?: Maybe<Scalars['String']['output']>;
  /** The records contained in the page */
  results?: Maybe<Array<GuideLevel>>;
  /** The first keyset in the results */
  startKeyset?: Maybe<Scalars['String']['output']>;
};

/** A keyset page of :question */
export type KeysetPageOfQuestion = {
  __typename?: 'KeysetPageOfQuestion';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** The last keyset in the results */
  endKeyset?: Maybe<Scalars['String']['output']>;
  /** The records contained in the page */
  results?: Maybe<Array<Question>>;
  /** The first keyset in the results */
  startKeyset?: Maybe<Scalars['String']['output']>;
};

/** A keyset page of :school */
export type KeysetPageOfSchool = {
  __typename?: 'KeysetPageOfSchool';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** The last keyset in the results */
  endKeyset?: Maybe<Scalars['String']['output']>;
  /** The records contained in the page */
  results?: Maybe<Array<School>>;
  /** The first keyset in the results */
  startKeyset?: Maybe<Scalars['String']['output']>;
};

/** A keyset page of :school_license */
export type KeysetPageOfSchoolLicense = {
  __typename?: 'KeysetPageOfSchoolLicense';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** The last keyset in the results */
  endKeyset?: Maybe<Scalars['String']['output']>;
  /** The records contained in the page */
  results?: Maybe<Array<SchoolLicense>>;
  /** The first keyset in the results */
  startKeyset?: Maybe<Scalars['String']['output']>;
};

/** A keyset page of :skill_path_settings */
export type KeysetPageOfSkillPathSettings = {
  __typename?: 'KeysetPageOfSkillPathSettings';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** The last keyset in the results */
  endKeyset?: Maybe<Scalars['String']['output']>;
  /** The records contained in the page */
  results?: Maybe<Array<SkillPathSettings>>;
  /** The first keyset in the results */
  startKeyset?: Maybe<Scalars['String']['output']>;
};

/** A keyset page of :standard */
export type KeysetPageOfStandard = {
  __typename?: 'KeysetPageOfStandard';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** The last keyset in the results */
  endKeyset?: Maybe<Scalars['String']['output']>;
  /** The records contained in the page */
  results?: Maybe<Array<Standard>>;
  /** The first keyset in the results */
  startKeyset?: Maybe<Scalars['String']['output']>;
};

/** A keyset page of :standard_set */
export type KeysetPageOfStandardSet = {
  __typename?: 'KeysetPageOfStandardSet';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** The last keyset in the results */
  endKeyset?: Maybe<Scalars['String']['output']>;
  /** The records contained in the page */
  results?: Maybe<Array<StandardSet>>;
  /** The first keyset in the results */
  startKeyset?: Maybe<Scalars['String']['output']>;
};

/** A keyset page of :standard_set_creator */
export type KeysetPageOfStandardSetCreator = {
  __typename?: 'KeysetPageOfStandardSetCreator';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** The last keyset in the results */
  endKeyset?: Maybe<Scalars['String']['output']>;
  /** The records contained in the page */
  results?: Maybe<Array<StandardSetCreator>>;
  /** The first keyset in the results */
  startKeyset?: Maybe<Scalars['String']['output']>;
};

/** A keyset page of :student_diagnostic */
export type KeysetPageOfStudentDiagnostic = {
  __typename?: 'KeysetPageOfStudentDiagnostic';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** The last keyset in the results */
  endKeyset?: Maybe<Scalars['String']['output']>;
  /** The records contained in the page */
  results?: Maybe<Array<StudentDiagnostic>>;
  /** The first keyset in the results */
  startKeyset?: Maybe<Scalars['String']['output']>;
};

/** A keyset page of :subject */
export type KeysetPageOfSubject = {
  __typename?: 'KeysetPageOfSubject';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** The last keyset in the results */
  endKeyset?: Maybe<Scalars['String']['output']>;
  /** The records contained in the page */
  results?: Maybe<Array<Subject>>;
  /** The first keyset in the results */
  startKeyset?: Maybe<Scalars['String']['output']>;
};

/** A keyset page of :upgrade */
export type KeysetPageOfUpgrade = {
  __typename?: 'KeysetPageOfUpgrade';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** The last keyset in the results */
  endKeyset?: Maybe<Scalars['String']['output']>;
  /** The records contained in the page */
  results?: Maybe<Array<Upgrade>>;
  /** The first keyset in the results */
  startKeyset?: Maybe<Scalars['String']['output']>;
};

/** A keyset page of :user_feedback */
export type KeysetPageOfUserFeedback = {
  __typename?: 'KeysetPageOfUserFeedback';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** The last keyset in the results */
  endKeyset?: Maybe<Scalars['String']['output']>;
  /** The records contained in the page */
  results?: Maybe<Array<UserFeedback>>;
  /** The first keyset in the results */
  startKeyset?: Maybe<Scalars['String']['output']>;
};

export enum LicenseType {
  AlbertLite = 'ALBERT_LITE',
  Annual = 'ANNUAL',
  Author = 'AUTHOR',
  Classroom = 'CLASSROOM',
  Custom = 'CUSTOM',
  Demo = 'DEMO',
  Extension = 'EXTENSION',
  HalfYear = 'HALF_YEAR',
  Homeschool = 'HOMESCHOOL',
  Internal = 'INTERNAL',
  OneAndAHalfYear = 'ONE_AND_A_HALF_YEAR',
  Other = 'OTHER',
  Pilot = 'PILOT',
  Standard = 'STANDARD',
  Teacher = 'TEACHER',
  ThreeYear = 'THREE_YEAR',
  Tutoring = 'TUTORING',
  TwoYear = 'TWO_YEAR',
  Ultimate = 'ULTIMATE'
}

export type LockAuthorizationRequest = {
  __typename?: 'LockAuthorizationRequest';
  adminIds: Array<Scalars['ID']['output']>;
  assignmentId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  message?: Maybe<Scalars['String']['output']>;
  requestingTeacherId: Scalars['ID']['output'];
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type LockContentInput = {
  lockType: Scalars['String']['input'];
  schoolId: Scalars['ID']['input'];
  sourceId: Scalars['ID']['input'];
};

/** The result of the :lock_content mutation */
export type LockContentResult = {
  __typename?: 'LockContentResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<ContentLock>;
};

export type ManagedUserCreateResult = {
  __typename?: 'ManagedUserCreateResult';
  email: Scalars['String']['output'];
  errorMessages?: Maybe<Array<Scalars['String']['output']>>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  username: Scalars['String']['output'];
};

export type ManagedUserStudentInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type MarkAsCorrectRubric = {
  __typename?: 'MarkAsCorrectRubric';
  /**
   * Must be "markAsCorrect" to identify this rubric type.
   * This field is required where it isn't on other rubric types, simply because we can't have a union type without any fields.
   */
  type: Scalars['String']['output'];
};

export type MarkAsCorrectRubricInput = {
  /**
   * Must be "markAsCorrect" to identify this rubric type.
   * This field is required where it isn't on other rubric types, simply because we can't have a union type without any fields.
   */
  type: Scalars['String']['input'];
};

/** The result of the :mark_evaluation_seen mutation */
export type MarkEvaluationSeenResult = {
  __typename?: 'MarkEvaluationSeenResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<StudentAssignment>;
};

/** The result of the :mark_workflow_step_not_applicable mutation */
export type MarkWorkflowStepNotApplicableResult = {
  __typename?: 'MarkWorkflowStepNotApplicableResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<UserWorkflowStep>;
};

export type MathContainsRubric = {
  __typename?: 'MathContainsRubric';
  threshold?: Maybe<Scalars['Float']['output']>;
  validResponse: Scalars['JsonString']['output'];
};

export type MathContainsRubricInput = {
  threshold?: InputMaybe<Scalars['Float']['input']>;
  validResponse: Scalars['JsonString']['input'];
};

export type MetricInput = MetricInputGradingMode | MetricInputProficiencyRangeEnd | MetricInputProficiencyRangeStart;

export type MetricInputGradingMode = {
  __typename?: 'MetricInputGradingMode';
  value: Scalars['JsonString']['output'];
};

export type MetricInputInput = {
  gradingMode?: InputMaybe<Scalars['JsonString']['input']>;
  proficiencyRangeEnd?: InputMaybe<Scalars['JsonString']['input']>;
  proficiencyRangeStart?: InputMaybe<Scalars['JsonString']['input']>;
};

export type MetricInputProficiencyRangeEnd = {
  __typename?: 'MetricInputProficiencyRangeEnd';
  value: Scalars['JsonString']['output'];
};

export type MetricInputProficiencyRangeStart = {
  __typename?: 'MetricInputProficiencyRangeStart';
  value: Scalars['JsonString']['output'];
};

export type MostEqualRubric = {
  __typename?: 'MostEqualRubric';
  validResponse: Scalars['Json']['output'];
};

export type MostEqualRubricInput = {
  validResponse: Scalars['Json']['input'];
};

/** An error generated by a failed mutation */
export type MutationError = {
  __typename?: 'MutationError';
  /** An error code for the given error */
  code?: Maybe<Scalars['String']['output']>;
  /** The field or fields that produced the error */
  fields?: Maybe<Array<Scalars['String']['output']>>;
  /** The human readable error message */
  message?: Maybe<Scalars['String']['output']>;
  /** The path to the field that produced the error */
  path?: Maybe<Array<Scalars['String']['output']>>;
  /** A shorter error message, with vars not replaced */
  shortMessage?: Maybe<Scalars['String']['output']>;
  /** Replacements for the short message */
  vars?: Maybe<Scalars['Json']['output']>;
};

export enum NcesLocale {
  CityLarge = 'CITY_LARGE',
  CityMidsize = 'CITY_MIDSIZE',
  CitySmall = 'CITY_SMALL',
  RuralDistant = 'RURAL_DISTANT',
  RuralFringe = 'RURAL_FRINGE',
  RuralRemote = 'RURAL_REMOTE',
  SuburbLarge = 'SUBURB_LARGE',
  SuburbMidsize = 'SUBURB_MIDSIZE',
  SuburbSmall = 'SUBURB_SMALL',
  TownDistant = 'TOWN_DISTANT',
  TownFringe = 'TOWN_FRINGE',
  TownRemote = 'TOWN_REMOTE'
}

/** A page of :content_lock_grace_period */
export type PageOfContentLockGracePeriod = {
  __typename?: 'PageOfContentLockGracePeriod';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** Whether or not there is a next page */
  hasNextPage: Scalars['Boolean']['output'];
  /** Whether or not there is a previous page */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The number of the last page */
  lastPage: Scalars['Int']['output'];
  /** The number of records per page */
  limit: Scalars['Int']['output'];
  /** The number of the current page */
  pageNumber: Scalars['Int']['output'];
  /** The records contained in the page */
  results?: Maybe<Array<ContentLockGracePeriod>>;
};

/** A page of :district */
export type PageOfDistrict = {
  __typename?: 'PageOfDistrict';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** Whether or not there is a next page */
  hasNextPage: Scalars['Boolean']['output'];
  /** Whether or not there is a previous page */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The number of the last page */
  lastPage: Scalars['Int']['output'];
  /** The number of records per page */
  limit: Scalars['Int']['output'];
  /** The number of the current page */
  pageNumber: Scalars['Int']['output'];
  /** The records contained in the page */
  results?: Maybe<Array<District>>;
};

/** A page of :guide_level */
export type PageOfGuideLevel = {
  __typename?: 'PageOfGuideLevel';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** Whether or not there is a next page */
  hasNextPage: Scalars['Boolean']['output'];
  /** Whether or not there is a previous page */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The number of the last page */
  lastPage: Scalars['Int']['output'];
  /** The number of records per page */
  limit: Scalars['Int']['output'];
  /** The number of the current page */
  pageNumber: Scalars['Int']['output'];
  /** The records contained in the page */
  results?: Maybe<Array<GuideLevel>>;
};

/** A page of :question */
export type PageOfQuestion = {
  __typename?: 'PageOfQuestion';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** Whether or not there is a next page */
  hasNextPage: Scalars['Boolean']['output'];
  /** Whether or not there is a previous page */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The number of the last page */
  lastPage: Scalars['Int']['output'];
  /** The number of records per page */
  limit: Scalars['Int']['output'];
  /** The number of the current page */
  pageNumber: Scalars['Int']['output'];
  /** The records contained in the page */
  results?: Maybe<Array<Question>>;
};

/** A page of :standard */
export type PageOfStandard = {
  __typename?: 'PageOfStandard';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** Whether or not there is a next page */
  hasNextPage: Scalars['Boolean']['output'];
  /** Whether or not there is a previous page */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The number of the last page */
  lastPage: Scalars['Int']['output'];
  /** The number of records per page */
  limit: Scalars['Int']['output'];
  /** The number of the current page */
  pageNumber: Scalars['Int']['output'];
  /** The records contained in the page */
  results?: Maybe<Array<Standard>>;
};

/** A page of :standard_set */
export type PageOfStandardSet = {
  __typename?: 'PageOfStandardSet';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** Whether or not there is a next page */
  hasNextPage: Scalars['Boolean']['output'];
  /** Whether or not there is a previous page */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The number of the last page */
  lastPage: Scalars['Int']['output'];
  /** The number of records per page */
  limit: Scalars['Int']['output'];
  /** The number of the current page */
  pageNumber: Scalars['Int']['output'];
  /** The records contained in the page */
  results?: Maybe<Array<StandardSet>>;
};

/** A page of :standard_set_creator */
export type PageOfStandardSetCreator = {
  __typename?: 'PageOfStandardSetCreator';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** Whether or not there is a next page */
  hasNextPage: Scalars['Boolean']['output'];
  /** Whether or not there is a previous page */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The number of the last page */
  lastPage: Scalars['Int']['output'];
  /** The number of records per page */
  limit: Scalars['Int']['output'];
  /** The number of the current page */
  pageNumber: Scalars['Int']['output'];
  /** The records contained in the page */
  results?: Maybe<Array<StandardSetCreator>>;
};

/** A page of :student_assignment */
export type PageOfStudentAssignment = {
  __typename?: 'PageOfStudentAssignment';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** Whether or not there is a next page */
  hasNextPage: Scalars['Boolean']['output'];
  /** Whether or not there is a previous page */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The number of the last page */
  lastPage: Scalars['Int']['output'];
  /** The number of records per page */
  limit: Scalars['Int']['output'];
  /** The number of the current page */
  pageNumber: Scalars['Int']['output'];
  /** The records contained in the page */
  results?: Maybe<Array<StudentAssignment>>;
};

/** A page of :subject */
export type PageOfSubject = {
  __typename?: 'PageOfSubject';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** Whether or not there is a next page */
  hasNextPage: Scalars['Boolean']['output'];
  /** Whether or not there is a previous page */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The number of the last page */
  lastPage: Scalars['Int']['output'];
  /** The number of records per page */
  limit: Scalars['Int']['output'];
  /** The number of the current page */
  pageNumber: Scalars['Int']['output'];
  /** The records contained in the page */
  results?: Maybe<Array<Subject>>;
};

/** A page of :supplement */
export type PageOfSupplement = {
  __typename?: 'PageOfSupplement';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** Whether or not there is a next page */
  hasNextPage: Scalars['Boolean']['output'];
  /** Whether or not there is a previous page */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The number of the last page */
  lastPage: Scalars['Int']['output'];
  /** The number of records per page */
  limit: Scalars['Int']['output'];
  /** The number of the current page */
  pageNumber: Scalars['Int']['output'];
  /** The records contained in the page */
  results?: Maybe<Array<Supplement>>;
};

/** A page of :tag */
export type PageOfTag = {
  __typename?: 'PageOfTag';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** Whether or not there is a next page */
  hasNextPage: Scalars['Boolean']['output'];
  /** Whether or not there is a previous page */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The number of the last page */
  lastPage: Scalars['Int']['output'];
  /** The number of records per page */
  limit: Scalars['Int']['output'];
  /** The number of the current page */
  pageNumber: Scalars['Int']['output'];
  /** The records contained in the page */
  results?: Maybe<Array<Tag>>;
};

/** A page of :tag_category */
export type PageOfTagCategory = {
  __typename?: 'PageOfTagCategory';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** Whether or not there is a next page */
  hasNextPage: Scalars['Boolean']['output'];
  /** Whether or not there is a previous page */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The number of the last page */
  lastPage: Scalars['Int']['output'];
  /** The number of records per page */
  limit: Scalars['Int']['output'];
  /** The number of the current page */
  pageNumber: Scalars['Int']['output'];
  /** The records contained in the page */
  results?: Maybe<Array<TagCategory>>;
};

/** A page of :user */
export type PageOfUser = {
  __typename?: 'PageOfUser';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** Whether or not there is a next page */
  hasNextPage: Scalars['Boolean']['output'];
  /** Whether or not there is a previous page */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The number of the last page */
  lastPage: Scalars['Int']['output'];
  /** The number of records per page */
  limit: Scalars['Int']['output'];
  /** The number of the current page */
  pageNumber: Scalars['Int']['output'];
  /** The records contained in the page */
  results?: Maybe<Array<User>>;
};

export type PassageSupplementContent = {
  __typename?: 'PassageSupplementContent';
  excludeHeaders?: Maybe<Scalars['Boolean']['output']>;
  excludeWhiteSpace: Scalars['Boolean']['output'];
  hideLineNumbers: Scalars['Boolean']['output'];
  ignoreWhiteSpace: Scalars['Boolean']['output'];
  lineNumberAlignment?: Maybe<Scalars['String']['output']>;
  lineNumberIncrement?: Maybe<Scalars['Int']['output']>;
  setMaxHeight?: Maybe<Scalars['Boolean']['output']>;
  text: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type PerformSignupStepInput = {
  input: SignupStepInputInput;
};

export type ProficiencyLevelChange = {
  __typename?: 'ProficiencyLevelChange';
  adaptivePractice: AdaptivePractice;
  adaptivePracticeId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  newLevel: Scalars['Int']['output'];
};

export type ProficiencyLevelChangeFilterAdaptivePracticeId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type ProficiencyLevelChangeFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type ProficiencyLevelChangeFilterInput = {
  adaptivePractice?: InputMaybe<AdaptivePracticeFilterInput>;
  adaptivePracticeId?: InputMaybe<ProficiencyLevelChangeFilterAdaptivePracticeId>;
  and?: InputMaybe<Array<ProficiencyLevelChangeFilterInput>>;
  id?: InputMaybe<ProficiencyLevelChangeFilterId>;
  newLevel?: InputMaybe<ProficiencyLevelChangeFilterNewLevel>;
  not?: InputMaybe<Array<ProficiencyLevelChangeFilterInput>>;
  or?: InputMaybe<Array<ProficiencyLevelChangeFilterInput>>;
};

export type ProficiencyLevelChangeFilterNewLevel = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export enum ProficiencyLevelChangeSortField {
  AdaptivePracticeId = 'ADAPTIVE_PRACTICE_ID',
  Id = 'ID',
  NewLevel = 'NEW_LEVEL'
}

export type ProficiencyLevelChangeSortInput = {
  field: ProficiencyLevelChangeSortField;
  order?: InputMaybe<SortOrder>;
};

export type PublishGradeInput = {
  teacherEvaluation?: InputMaybe<GuessManualEvaluationInput>;
};

/** The result of the :publish_grade mutation */
export type PublishGradeResult = {
  __typename?: 'PublishGradeResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<Guess>;
};

export type Question = {
  __typename?: 'Question';
  answerBreakdown?: Maybe<Scalars['JsonString']['output']>;
  author: User;
  authorId: Scalars['ID']['output'];
  /** Since user policies are fairly sparse and locked down, it's easiest to expose author info as a calculation on the question rather than trying to join out to the author resource and deal with policies there. This is a bit redundant since we also have the full author relationship, but it keeps things simple for Dennis and doesn't expose any additional info that we wouldn't want exposed. */
  authorInfo?: Maybe<QuestionAuthorInfo>;
  /**
   * The highest calculator tier this question allows, if set. Tiers are additive: graphing also
   * permits scientific and basic. An explicit `none` withholds the calculator.
   * This is only the stored value. Unset means the question has no setting of its own; clients resolve
   * availability from its guide levels.
   */
  calculatorType?: Maybe<CalculatorType>;
  chainPath?: Maybe<Scalars['Json']['output']>;
  difficulty?: Maybe<Scalars['Int']['output']>;
  guideLevels: Array<GuideLevel>;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  /** Positive signal that the question's content is redacted for the actor — mirrors the `is_content_locked: true` stamp the legacy V1/V2/V3 JSON:API endpoints attach via `QuestionEnforcement`. FE consumers branch on this to render the locked-content UX. */
  isContentLocked?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a multiple-choice question accepts more than one correct answer (the author's "Multiple correct answers" checkbox). False for every question type that has no such setting, so pair it with a `question_type` filter. */
  isMultiSelect?: Maybe<Scalars['Boolean']['output']>;
  legacyQuestionSetSlugId?: Maybe<Scalars['String']['output']>;
  /** Whether this question matched the search string. Search fields may be any of document_stems, solution_document_stems. Defaults to both. */
  matchesSearch?: Maybe<Scalars['Boolean']['output']>;
  /** The next published question in the chain, skipping non-published ones */
  nextInChainId?: Maybe<Scalars['ID']['output']>;
  owner: User;
  ownerId: Scalars['ID']['output'];
  points: Scalars['Int']['output'];
  prompt?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * A vestige of the past when questions belonged to question sets.
   * This is still used as the foreign key for some join tables, but can be thought of as an alternate ID for the question.
   * When creating a question via this resource, this will be automatically set by database triggers.
   */
  questionSetId?: Maybe<Scalars['ID']['output']>;
  questionType: Scalars['String']['output'];
  questionTypeAttributes?: Maybe<Scalars['JsonString']['output']>;
  rubric?: Maybe<Rubric>;
  slugId?: Maybe<Scalars['String']['output']>;
  solutionText?: Maybe<Scalars['String']['output']>;
  standards: Array<Standard>;
  status: QuestionStatus;
  subject?: Maybe<Subject>;
  subjectId: Scalars['ID']['output'];
  supplements: Array<Supplement>;
  tags: Array<Tag>;
  title?: Maybe<Scalars['String']['output']>;
  translate?: Maybe<Scalars['Boolean']['output']>;
  translateSupplements?: Maybe<Scalars['Boolean']['output']>;
  typeAttributes?: Maybe<QuestionTypeAttributes>;
  unfilteredGuideLevels: Array<GuideLevel>;
  unfilteredSubject: Subject;
  updatedAt: Scalars['DateTime']['output'];
};


export type QuestionGuideLevelsArgs = {
  filter?: InputMaybe<GuideLevelFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GuideLevelSortInput>>>;
};


export type QuestionMatchesSearchArgs = {
  search: Scalars['String']['input'];
  searchFields?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QuestionStandardsArgs = {
  filter?: InputMaybe<StandardFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<StandardSortInput>>>;
};


export type QuestionSupplementsArgs = {
  filter?: InputMaybe<SupplementFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SupplementSortInput>>>;
};


export type QuestionTagsArgs = {
  filter?: InputMaybe<TagFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TagSortInput>>>;
};


export type QuestionUnfilteredGuideLevelsArgs = {
  filter?: InputMaybe<GuideLevelFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GuideLevelSortInput>>>;
};

export type QuestionAuthorInfo = {
  __typename?: 'QuestionAuthorInfo';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type QuestionFilterAnswerBreakdown = {
  eq?: InputMaybe<Scalars['JsonString']['input']>;
  greaterThan?: InputMaybe<Scalars['JsonString']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['JsonString']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JsonString']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['JsonString']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['JsonString']['input']>;
  lessThan?: InputMaybe<Scalars['JsonString']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['JsonString']['input']>;
  notEq?: InputMaybe<Scalars['JsonString']['input']>;
};

export type QuestionFilterAuthorId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type QuestionFilterCalculatorType = {
  eq?: InputMaybe<CalculatorType>;
  greaterThan?: InputMaybe<CalculatorType>;
  greaterThanOrEqual?: InputMaybe<CalculatorType>;
  in?: InputMaybe<Array<InputMaybe<CalculatorType>>>;
  isDistinctFrom?: InputMaybe<CalculatorType>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<CalculatorType>;
  lessThan?: InputMaybe<CalculatorType>;
  lessThanOrEqual?: InputMaybe<CalculatorType>;
  notEq?: InputMaybe<CalculatorType>;
};

export type QuestionFilterChainPath = {
  eq?: InputMaybe<Scalars['Json']['input']>;
  greaterThan?: InputMaybe<Scalars['Json']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Json']['input']>;
  in?: InputMaybe<Scalars['Json']['input']>;
  isDistinctFrom?: InputMaybe<Scalars['Json']['input']>;
  isNil?: InputMaybe<Scalars['Json']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Json']['input']>;
  lessThan?: InputMaybe<Scalars['Json']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Json']['input']>;
  notEq?: InputMaybe<Scalars['Json']['input']>;
};

export type QuestionFilterDifficulty = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type QuestionFilterInput = {
  and?: InputMaybe<Array<QuestionFilterInput>>;
  answerBreakdown?: InputMaybe<QuestionFilterAnswerBreakdown>;
  author?: InputMaybe<UserFilterInput>;
  authorId?: InputMaybe<QuestionFilterAuthorId>;
  /**
   * The highest calculator tier this question allows, if set. Tiers are additive: graphing also
   * permits scientific and basic. An explicit `none` withholds the calculator.
   * This is only the stored value. Unset means the question has no setting of its own; clients resolve
   * availability from its guide levels.
   */
  calculatorType?: InputMaybe<QuestionFilterCalculatorType>;
  chainPath?: InputMaybe<QuestionFilterChainPath>;
  difficulty?: InputMaybe<QuestionFilterDifficulty>;
  guideLevels?: InputMaybe<GuideLevelFilterInput>;
  id?: InputMaybe<QuestionFilterId>;
  insertedAt?: InputMaybe<QuestionFilterInsertedAt>;
  /** Whether a multiple-choice question accepts more than one correct answer (the author's "Multiple correct answers" checkbox). False for every question type that has no such setting, so pair it with a `question_type` filter. */
  isMultiSelect?: InputMaybe<QuestionFilterIsMultiSelect>;
  legacyQuestionSetSlugId?: InputMaybe<QuestionFilterLegacyQuestionSetSlugId>;
  /** Whether this question matched the search string. Search fields may be any of document_stems, solution_document_stems. Defaults to both. */
  matchesSearch?: InputMaybe<QuestionFilterMatchesSearch>;
  /** The next published question in the chain, skipping non-published ones */
  nextInChainId?: InputMaybe<QuestionFilterNextInChainId>;
  not?: InputMaybe<Array<QuestionFilterInput>>;
  or?: InputMaybe<Array<QuestionFilterInput>>;
  owner?: InputMaybe<UserFilterInput>;
  ownerId?: InputMaybe<QuestionFilterOwnerId>;
  points?: InputMaybe<QuestionFilterPoints>;
  prompt?: InputMaybe<QuestionFilterPrompt>;
  publishedAt?: InputMaybe<QuestionFilterPublishedAt>;
  /**
   * A vestige of the past when questions belonged to question sets.
   * This is still used as the foreign key for some join tables, but can be thought of as an alternate ID for the question.
   * When creating a question via this resource, this will be automatically set by database triggers.
   */
  questionSetId?: InputMaybe<QuestionFilterQuestionSetId>;
  questionType?: InputMaybe<QuestionFilterQuestionType>;
  questionTypeAttributes?: InputMaybe<QuestionFilterQuestionTypeAttributes>;
  slugId?: InputMaybe<QuestionFilterSlugId>;
  solutionText?: InputMaybe<QuestionFilterSolutionText>;
  standards?: InputMaybe<StandardFilterInput>;
  status?: InputMaybe<QuestionFilterStatus>;
  subject?: InputMaybe<SubjectFilterInput>;
  subjectId?: InputMaybe<QuestionFilterSubjectId>;
  supplements?: InputMaybe<SupplementFilterInput>;
  tags?: InputMaybe<TagFilterInput>;
  title?: InputMaybe<QuestionFilterTitle>;
  translate?: InputMaybe<QuestionFilterTranslate>;
  translateSupplements?: InputMaybe<QuestionFilterTranslateSupplements>;
  unfilteredGuideLevels?: InputMaybe<GuideLevelFilterInput>;
  unfilteredSubject?: InputMaybe<SubjectFilterInput>;
  updatedAt?: InputMaybe<QuestionFilterUpdatedAt>;
};

export type QuestionFilterInsertedAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QuestionFilterIsMultiSelect = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuestionFilterLegacyQuestionSetSlugId = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionFilterMatchesSearch = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  input?: InputMaybe<QuestionMatchesSearchFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuestionFilterNextInChainId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type QuestionFilterOwnerId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type QuestionFilterPoints = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionFilterPrompt = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionFilterPublishedAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QuestionFilterQuestionSetId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type QuestionFilterQuestionType = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionFilterQuestionTypeAttributes = {
  eq?: InputMaybe<Scalars['JsonString']['input']>;
  greaterThan?: InputMaybe<Scalars['JsonString']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['JsonString']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JsonString']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['JsonString']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['JsonString']['input']>;
  lessThan?: InputMaybe<Scalars['JsonString']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['JsonString']['input']>;
  notEq?: InputMaybe<Scalars['JsonString']['input']>;
};

export type QuestionFilterSlugId = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionFilterSolutionText = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionFilterStatus = {
  eq?: InputMaybe<QuestionStatus>;
  greaterThan?: InputMaybe<QuestionStatus>;
  greaterThanOrEqual?: InputMaybe<QuestionStatus>;
  in?: InputMaybe<Array<QuestionStatus>>;
  isDistinctFrom?: InputMaybe<QuestionStatus>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<QuestionStatus>;
  lessThan?: InputMaybe<QuestionStatus>;
  lessThanOrEqual?: InputMaybe<QuestionStatus>;
  notEq?: InputMaybe<QuestionStatus>;
};

export type QuestionFilterSubjectId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type QuestionFilterTitle = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionFilterTranslate = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuestionFilterTranslateSupplements = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuestionFilterUpdatedAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QuestionMatchesSearchFieldInput = {
  search: Scalars['String']['input'];
  searchFields?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum QuestionSortField {
  AnswerBreakdown = 'ANSWER_BREAKDOWN',
  AuthorId = 'AUTHOR_ID',
  CalculatorType = 'CALCULATOR_TYPE',
  ChainPath = 'CHAIN_PATH',
  Difficulty = 'DIFFICULTY',
  Id = 'ID',
  InsertedAt = 'INSERTED_AT',
  LegacyQuestionSetSlugId = 'LEGACY_QUESTION_SET_SLUG_ID',
  MatchesSearch = 'MATCHES_SEARCH',
  NextInChainId = 'NEXT_IN_CHAIN_ID',
  OwnerId = 'OWNER_ID',
  Points = 'POINTS',
  Prompt = 'PROMPT',
  PublishedAt = 'PUBLISHED_AT',
  QuestionSetId = 'QUESTION_SET_ID',
  QuestionType = 'QUESTION_TYPE',
  QuestionTypeAttributes = 'QUESTION_TYPE_ATTRIBUTES',
  SlugId = 'SLUG_ID',
  SolutionText = 'SOLUTION_TEXT',
  Status = 'STATUS',
  SubjectId = 'SUBJECT_ID',
  Title = 'TITLE',
  Translate = 'TRANSLATE',
  TranslateSupplements = 'TRANSLATE_SUPPLEMENTS',
  UpdatedAt = 'UPDATED_AT'
}

export type QuestionSortInput = {
  field: QuestionSortField;
  matchesSearchInput?: InputMaybe<QuestionMatchesSearchFieldInput>;
  order?: InputMaybe<SortOrder>;
};

export enum QuestionStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Hidden = 'HIDDEN',
  Pending = 'PENDING',
  Published = 'PUBLISHED',
  Rejected = 'REJECTED'
}

export type QuestionTypeAttributes = QuestionTypeAttributesFillInTheBlank | QuestionTypeAttributesFreeEntry | QuestionTypeAttributesFreeResponse | QuestionTypeAttributesGraphContains | QuestionTypeAttributesItemBank | QuestionTypeAttributesMultipleChoice | QuestionTypeAttributesOrdering | QuestionTypeAttributesPassageCorrection | QuestionTypeAttributesSnippetSelection | QuestionTypeAttributesTextHighlight | QuestionTypeAttributesTwoWay;

export type QuestionTypeAttributesFillInTheBlank = {
  __typename?: 'QuestionTypeAttributesFillInTheBlank';
  dropdownText?: Maybe<Scalars['String']['output']>;
  dropdowns: Array<QuestionTypeAttributesFillInTheBlankDropdown>;
};

export type QuestionTypeAttributesFillInTheBlankDropdown = {
  __typename?: 'QuestionTypeAttributesFillInTheBlankDropdown';
  choices: Array<QuestionTypeAttributesFillInTheBlankDropdownChoice>;
  id: Scalars['String']['output'];
  position: Scalars['Int']['output'];
};

export type QuestionTypeAttributesFillInTheBlankDropdownChoice = {
  __typename?: 'QuestionTypeAttributesFillInTheBlankDropdownChoice';
  id: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type QuestionTypeAttributesFillInTheBlankDropdownChoiceInput = {
  id: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type QuestionTypeAttributesFillInTheBlankDropdownInput = {
  choices: Array<QuestionTypeAttributesFillInTheBlankDropdownChoiceInput>;
  id: Scalars['String']['input'];
  position: Scalars['Int']['input'];
};

export type QuestionTypeAttributesFillInTheBlankInput = {
  dropdownText?: InputMaybe<Scalars['String']['input']>;
  dropdowns: Array<QuestionTypeAttributesFillInTheBlankDropdownInput>;
};

export type QuestionTypeAttributesFreeEntry = {
  __typename?: 'QuestionTypeAttributesFreeEntry';
  inputs: Array<QuestionTypeAttributesInputElement>;
};

export type QuestionTypeAttributesFreeEntryInput = {
  inputs: Array<QuestionTypeAttributesInputElementInput>;
};

export type QuestionTypeAttributesFreeResponse = {
  __typename?: 'QuestionTypeAttributesFreeResponse';
  sample?: Maybe<Scalars['String']['output']>;
};

export type QuestionTypeAttributesFreeResponseInput = {
  sample?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionTypeAttributesGraphContains = {
  __typename?: 'QuestionTypeAttributesGraphContains';
  allowedEntities: Array<Scalars['String']['output']>;
  labelBottom?: Maybe<Scalars['String']['output']>;
  labelLeft?: Maybe<Scalars['String']['output']>;
  providedEntities?: Maybe<Array<GraphContainsEntity>>;
  xInterval: Scalars['Int']['output'];
  xLabel?: Maybe<Scalars['String']['output']>;
  xMax: Scalars['Int']['output'];
  xMin: Scalars['Int']['output'];
  yInterval: Scalars['Int']['output'];
  yLabel?: Maybe<Scalars['String']['output']>;
  yMax: Scalars['Int']['output'];
  yMin: Scalars['Int']['output'];
};

export type QuestionTypeAttributesGraphContainsInput = {
  allowedEntities: Array<Scalars['String']['input']>;
  labelBottom?: InputMaybe<Scalars['String']['input']>;
  labelLeft?: InputMaybe<Scalars['String']['input']>;
  providedEntities?: InputMaybe<Array<GraphContainsEntityInput>>;
  xInterval: Scalars['Int']['input'];
  xLabel?: InputMaybe<Scalars['String']['input']>;
  xMax: Scalars['Int']['input'];
  xMin: Scalars['Int']['input'];
  yInterval: Scalars['Int']['input'];
  yLabel?: InputMaybe<Scalars['String']['input']>;
  yMax: Scalars['Int']['input'];
  yMin: Scalars['Int']['input'];
};

export type QuestionTypeAttributesInput = {
  fillInTheBlank?: InputMaybe<QuestionTypeAttributesFillInTheBlankInput>;
  freeEntry?: InputMaybe<QuestionTypeAttributesFreeEntryInput>;
  freeResponse?: InputMaybe<QuestionTypeAttributesFreeResponseInput>;
  graphContains?: InputMaybe<QuestionTypeAttributesGraphContainsInput>;
  itemBank?: InputMaybe<QuestionTypeAttributesItemBankInput>;
  multipleChoice?: InputMaybe<QuestionTypeAttributesMultipleChoiceInput>;
  ordering?: InputMaybe<QuestionTypeAttributesOrderingInput>;
  passageCorrection?: InputMaybe<QuestionTypeAttributesPassageCorrectionInput>;
  snippetSelection?: InputMaybe<QuestionTypeAttributesSnippetSelectionInput>;
  textHighlight?: InputMaybe<QuestionTypeAttributesTextHighlightInput>;
  twoWay?: InputMaybe<QuestionTypeAttributesTwoWayInput>;
};

/** An object representing an input prompt for a question, used by a few different question types. */
export type QuestionTypeAttributesInputElement = {
  __typename?: 'QuestionTypeAttributesInputElement';
  id: Scalars['String']['output'];
  text?: Maybe<Scalars['String']['output']>;
};

/** An object representing an input prompt for a question, used by a few different question types. */
export type QuestionTypeAttributesInputElementInput = {
  id: Scalars['String']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionTypeAttributesItemBank = {
  __typename?: 'QuestionTypeAttributesItemBank';
  bank: Array<Maybe<QuestionTypeAttributesItemBankElement>>;
  slots: Array<Maybe<QuestionTypeAttributesItemBankElement>>;
};

export type QuestionTypeAttributesItemBankElement = {
  __typename?: 'QuestionTypeAttributesItemBankElement';
  id: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type QuestionTypeAttributesItemBankElementInput = {
  id: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type QuestionTypeAttributesItemBankInput = {
  bank: Array<InputMaybe<QuestionTypeAttributesItemBankElementInput>>;
  slots: Array<InputMaybe<QuestionTypeAttributesItemBankElementInput>>;
};

export type QuestionTypeAttributesMultipleChoice = {
  __typename?: 'QuestionTypeAttributesMultipleChoice';
  isSelectMultiple: Scalars['Boolean']['output'];
  options: Array<QuestionTypeAttributesOption>;
};

export type QuestionTypeAttributesMultipleChoiceInput = {
  isSelectMultiple: Scalars['Boolean']['input'];
  options: Array<QuestionTypeAttributesOptionInput>;
};

export type QuestionTypeAttributesOption = {
  __typename?: 'QuestionTypeAttributesOption';
  id: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type QuestionTypeAttributesOptionInput = {
  id: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionTypeAttributesOrdering = {
  __typename?: 'QuestionTypeAttributesOrdering';
  items: Array<Maybe<QuestionTypeAttributesItemBankElement>>;
  slots: Array<Maybe<QuestionTypeAttributesOrderingSlot>>;
};

export type QuestionTypeAttributesOrderingInput = {
  items: Array<InputMaybe<QuestionTypeAttributesItemBankElementInput>>;
  slots: Array<InputMaybe<QuestionTypeAttributesOrderingSlotInput>>;
};

export type QuestionTypeAttributesOrderingSlot = {
  __typename?: 'QuestionTypeAttributesOrderingSlot';
  id: Scalars['String']['output'];
};

export type QuestionTypeAttributesOrderingSlotInput = {
  id: Scalars['String']['input'];
};

export type QuestionTypeAttributesPassageCorrection = {
  __typename?: 'QuestionTypeAttributesPassageCorrection';
  uncorrectedText?: Maybe<Scalars['String']['output']>;
};

export type QuestionTypeAttributesPassageCorrectionInput = {
  uncorrectedText?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionTypeAttributesSnippetSelection = {
  __typename?: 'QuestionTypeAttributesSnippetSelection';
  options: Array<QuestionTypeAttributesOption>;
  snippetPrompt?: Maybe<Scalars['String']['output']>;
};

export type QuestionTypeAttributesSnippetSelectionInput = {
  options: Array<QuestionTypeAttributesOptionInput>;
  snippetPrompt?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionTypeAttributesTextHighlight = {
  __typename?: 'QuestionTypeAttributesTextHighlight';
  highlightPrompt?: Maybe<Scalars['String']['output']>;
  preferredPermutation?: Maybe<Scalars['String']['output']>;
};

export type QuestionTypeAttributesTextHighlightInput = {
  highlightPrompt?: InputMaybe<Scalars['String']['input']>;
  preferredPermutation?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionTypeAttributesTwoWay = {
  __typename?: 'QuestionTypeAttributesTwoWay';
  headerLeft?: Maybe<Scalars['String']['output']>;
  headerRight?: Maybe<Scalars['String']['output']>;
  rows: Array<QuestionTypeAttributesTwoWayRow>;
};

export type QuestionTypeAttributesTwoWayColumn = {
  __typename?: 'QuestionTypeAttributesTwoWayColumn';
  id: Scalars['String']['output'];
  text?: Maybe<Scalars['String']['output']>;
};

export type QuestionTypeAttributesTwoWayColumnInput = {
  id: Scalars['String']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionTypeAttributesTwoWayColumns = {
  __typename?: 'QuestionTypeAttributesTwoWayColumns';
  left: QuestionTypeAttributesTwoWayColumn;
  right: QuestionTypeAttributesTwoWayColumn;
};

export type QuestionTypeAttributesTwoWayColumnsInput = {
  left: QuestionTypeAttributesTwoWayColumnInput;
  right: QuestionTypeAttributesTwoWayColumnInput;
};

export type QuestionTypeAttributesTwoWayInput = {
  headerLeft?: InputMaybe<Scalars['String']['input']>;
  headerRight?: InputMaybe<Scalars['String']['input']>;
  rows: Array<QuestionTypeAttributesTwoWayRowInput>;
};

export type QuestionTypeAttributesTwoWayRow = {
  __typename?: 'QuestionTypeAttributesTwoWayRow';
  columns: QuestionTypeAttributesTwoWayColumns;
  id: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  statement?: Maybe<Scalars['String']['output']>;
};

export type QuestionTypeAttributesTwoWayRowInput = {
  columns: QuestionTypeAttributesTwoWayColumnsInput;
  id: Scalars['String']['input'];
  index: Scalars['Int']['input'];
  statement?: InputMaybe<Scalars['String']['input']>;
};

export type RecipientGroupClassroomSkillPathConfigsInput = {
  classroomId: Scalars['ID']['input'];
};

export type RecipientGroupInput = {
  classroomSkillPathConfigs: Array<InputMaybe<RecipientGroupClassroomSkillPathConfigsInput>>;
  settings: RecipientGroupSettingsInput;
  skillId: Scalars['ID']['input'];
  skillPathSettingsId?: InputMaybe<Scalars['ID']['input']>;
  studentSkillPaths: Array<InputMaybe<RecipientGroupStudentSkillPathsInput>>;
};

export type RecipientGroupSettingsInput = {
  dueDate: Scalars['DateTime']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RecipientGroupStudentSkillPathsInput = {
  classroomId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};

export type RecordLockdownViolationInput = {
  violationType: Scalars['String']['input'];
};

/** The result of the :record_lockdown_violation mutation */
export type RecordLockdownViolationResult = {
  __typename?: 'RecordLockdownViolationResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<StudentAssignment>;
};

/** The result of the :regenerate_report mutation */
export type RegenerateReportResult = {
  __typename?: 'RegenerateReportResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<AnalyticsReport>;
};

/** The result of the :regenerate_supplement mutation */
export type RegenerateSupplementResult = {
  __typename?: 'RegenerateSupplementResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<Supplement>;
};

export type RejectCoppaConsentGrantInput = {
  verificationCode: Scalars['String']['input'];
};

/** The result of the :reject_coppa_consent_grant mutation */
export type RejectCoppaConsentGrantResult = {
  __typename?: 'RejectCoppaConsentGrantResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The record that was successfully deleted */
  result?: Maybe<CoppaConsentGrant>;
};

export type ReleaseGradesInput = {
  assignmentId: Scalars['ID']['input'];
  /**
   * Release only for these classrooms. Omit to release for every
   * classroom of the assignment the actor teaches.
   */
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ReorderSubjectGuidesInput = {
  /**
   * Every guide in the subject, in the order they should be displayed. The first id gets
   * position 0. Guides omitted from the list are rejected rather than left unordered, so a
   * stale client cannot silently strand a guide's position.
   */
  guideIds: Array<Scalars['ID']['input']>;
};

/** The result of the :reorder_subject_guides mutation */
export type ReorderSubjectGuidesResult = {
  __typename?: 'ReorderSubjectGuidesResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<Subject>;
};

export type ReportFilter = {
  __typename?: 'ReportFilter';
  field?: Maybe<Scalars['String']['output']>;
  operator: Scalars['String']['output'];
  type: Scalars['String']['output'];
  values?: Maybe<Array<Scalars['Any']['output']>>;
};

export type ReportResult = {
  __typename?: 'ReportResult';
  assignment?: Maybe<AnalyticsReportAssignment>;
  assignmentsStudentAssignments: Array<AnalyticsStudentAssignment>;
  classroom?: Maybe<AnalyticsReportClassroom>;
  diagnostic?: Maybe<AnalyticsReportDiagnostic>;
  gradebookStudentAssignment?: Maybe<AnalyticsStudentAssignment>;
  guide?: Maybe<AnalyticsReportGuide>;
  guideLevel?: Maybe<AnalyticsReportGuideLevel>;
  id: Scalars['ID']['output'];
  isContentLocked?: Maybe<Scalars['Boolean']['output']>;
  metrics: Scalars['Json']['output'];
  primaryDimensionId: Scalars['ID']['output'];
  primaryDimensionType: Scalars['String']['output'];
  question?: Maybe<AnalyticsReportQuestion>;
  report?: Maybe<AnalyticsReport>;
  reportId: Scalars['ID']['output'];
  school?: Maybe<AnalyticsSchool>;
  secondaryAssignment?: Maybe<AnalyticsReportAssignment>;
  secondaryClassroom?: Maybe<AnalyticsReportClassroom>;
  secondaryDimensionId?: Maybe<Scalars['ID']['output']>;
  secondaryDimensionType?: Maybe<Scalars['String']['output']>;
  standard?: Maybe<AnalyticsStandard>;
  standardSet?: Maybe<AnalyticsStandardSet>;
  student?: Maybe<AnalyticsStudent>;
  studentsStudentAssignments: Array<AnalyticsStudentAssignment>;
  subject?: Maybe<AnalyticsSubject>;
  teacher?: Maybe<AnalyticsTeacher>;
};


export type ReportResultAssignmentsStudentAssignmentsArgs = {
  filter?: InputMaybe<AnalyticsStudentAssignmentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AnalyticsStudentAssignmentSortInput>>>;
};


export type ReportResultStudentsStudentAssignmentsArgs = {
  filter?: InputMaybe<AnalyticsStudentAssignmentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AnalyticsStudentAssignmentSortInput>>>;
};

export type ReportResultPaginationInput = {
  primaryLimit: Scalars['Int']['input'];
  primaryOffset?: InputMaybe<Scalars['Int']['input']>;
  secondaryLimit?: InputMaybe<Scalars['Int']['input']>;
  secondaryOffset?: InputMaybe<Scalars['Int']['input']>;
};

export type RequestLockAuthorizationInput = {
  adminIds: Array<Scalars['ID']['input']>;
  assignmentId: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
};

/** The result of the :request_lock_authorization mutation */
export type RequestLockAuthorizationResult = {
  __typename?: 'RequestLockAuthorizationResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<LockAuthorizationRequest>;
};

/** The result of the :resend_confirmation_email mutation */
export type ResendConfirmationEmailResult = {
  __typename?: 'ResendConfirmationEmailResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<User>;
};

/** The result of the :resend_created_user_email mutation */
export type ResendCreatedUserEmailResult = {
  __typename?: 'ResendCreatedUserEmailResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<User>;
};

/** The result of the :resend_password_reset_email mutation */
export type ResendPasswordResetEmailResult = {
  __typename?: 'ResendPasswordResetEmailResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<User>;
};

/** The result of the :reset_diagnostic_timer mutation */
export type ResetDiagnosticTimerResult = {
  __typename?: 'ResetDiagnosticTimerResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<StudentDiagnostic>;
};

export type ResetDiagnosticTimersForClassroomInput = {
  /**
   * The classroom within this recipient group whose students' timers to reset. Only students
   * assigned via this classroom (that the acting teacher teaches) are affected.
   */
  classroomId: Scalars['ID']['input'];
};

/** The result of the :reset_diagnostic_timers_for_classroom mutation */
export type ResetDiagnosticTimersForClassroomResult = {
  __typename?: 'ResetDiagnosticTimersForClassroomResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<DiagnosticSettings>;
};

export type ResetManagedUserPasswordInput = {
  newPassword: Scalars['String']['input'];
};

export type ResetOwnPasswordInput = {
  newPassword: Scalars['String']['input'];
};

export type ResetPasswordResult = {
  __typename?: 'ResetPasswordResult';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ResetPasswordWithTokenInput = {
  newPassword: Scalars['String']['input'];
  passwordResetLink: Scalars['String']['input'];
};

/** The result of the :resume_after_reset mutation */
export type ResumeAfterResetResult = {
  __typename?: 'ResumeAfterResetResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<StudentAssignment>;
};

/** The result of the :resume_student_diagnostic mutation */
export type ResumeStudentDiagnosticResult = {
  __typename?: 'ResumeStudentDiagnosticResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<StudentDiagnostic>;
};

export type RetailSubscription = {
  __typename?: 'RetailSubscription';
  endDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  startDate: Scalars['DateTime']['output'];
  subject?: Maybe<Subject>;
  subjectId: Scalars['ID']['output'];
  unfilteredSubject: Subject;
  user: User;
  userId: Scalars['ID']['output'];
};

export type RetailSubscriptionFilterEndDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RetailSubscriptionFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type RetailSubscriptionFilterInput = {
  and?: InputMaybe<Array<RetailSubscriptionFilterInput>>;
  endDate?: InputMaybe<RetailSubscriptionFilterEndDate>;
  id?: InputMaybe<RetailSubscriptionFilterId>;
  not?: InputMaybe<Array<RetailSubscriptionFilterInput>>;
  or?: InputMaybe<Array<RetailSubscriptionFilterInput>>;
  startDate?: InputMaybe<RetailSubscriptionFilterStartDate>;
  subject?: InputMaybe<SubjectFilterInput>;
  subjectId?: InputMaybe<RetailSubscriptionFilterSubjectId>;
  unfilteredSubject?: InputMaybe<SubjectFilterInput>;
  user?: InputMaybe<UserFilterInput>;
  userId?: InputMaybe<RetailSubscriptionFilterUserId>;
};

export type RetailSubscriptionFilterStartDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RetailSubscriptionFilterSubjectId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type RetailSubscriptionFilterUserId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export enum RetailSubscriptionSortField {
  EndDate = 'END_DATE',
  Id = 'ID',
  StartDate = 'START_DATE',
  SubjectId = 'SUBJECT_ID',
  UserId = 'USER_ID'
}

export type RetailSubscriptionSortInput = {
  field: RetailSubscriptionSortField;
  order?: InputMaybe<SortOrder>;
};

export type RootMutationType = {
  __typename?: 'RootMutationType';
  approveCoppaConsentGrant: ApproveCoppaConsentGrantResult;
  archiveQuestion: ArchiveQuestionResult;
  bulkCreateManagedUsers: BulkCreateManagedUsersResult;
  /**
   * Creates many standards at once. Every standard in the request must belong to the same
   * standard set, and none of them may reuse a CASE ID already taken within that set.
   * Unless `allow_duplicates` is set, reusing a title or description is also rejected.
   */
  bulkCreateStandards: Array<Standard>;
  /**
   * Sets the license access status for multiple school personnel at once.
   *
   * Accepts a list of school personnel IDs and a status, and updates all matching records.
   * Returns a result for each ID indicating success or failure.
   */
  bulkSetLicenseAccessStatus: Array<BulkStatusUpdateResult>;
  buySubscriptions: BuySubscriptionsResult;
  /** Check whether a username is available and valid. */
  checkUsernameAvailability: UsernameAvailability;
  classroomInvitationBulkCreate: Array<ClassroomInvitationBulkItemResult>;
  classroomInvitationBulkReinvite: Array<ClassroomInvitationBulkItemResult>;
  classroomInvitationReinvite: ClassroomInvitation;
  /** Mark a workflow step as complete. Dependencies must be resolved first. */
  completeWorkflowStep: CompleteWorkflowStepResult;
  createAuthoringFeedback: CreateAuthoringFeedbackResult;
  createClassroomInvitation: CreateClassroomInvitationResult;
  createCustomerFeedbackEntry: CreateCustomerFeedbackEntryResult;
  createDiagnostic: CreateDiagnosticResult;
  createDistrict: CreateDistrictResult;
  createGuide: CreateGuideResult;
  createQuestion: CreateQuestionResult;
  createStandard: CreateStandardResult;
  createStandardSet: CreateStandardSetResult;
  createStandardSetCreator: CreateStandardSetCreatorResult;
  createStripeCard: CreateStripeCardResult;
  createSubject: CreateSubjectResult;
  createSubjectFaq: CreateSubjectFaqResult;
  createSubscription: CreateSubscriptionResult;
  createSupplement: CreateSupplementResult;
  createTag: CreateTagResult;
  createTagCategory: CreateTagCategoryResult;
  createTranslationJob: CreateTranslationJobResult;
  createUser: CreateUserResult;
  createUserFeedback: CreateUserFeedbackResult;
  /**
   * Deletes the diagnostic on the acting teacher's behalf. A teacher who manages every recipient
   * stamps `deleted_at`, hiding it everywhere while preserving its groups and student_diagnostics
   * (recoverable manually; no in-app restore). A teacher who manages only some recipients cannot
   * delete the diagnostic itself — instead every recipient they manage is soft-deleted (started or
   * not) so the diagnostic leaves their dashboard while the other teachers keep theirs. See
   * `Mandark.Assignments.Diagnostic.Changes.SoftDelete`.
   */
  deleteDiagnostic: DeleteDiagnosticResult;
  deleteQuestion: DeleteQuestionResult;
  deleteRecipientGroups: Scalars['String']['output'];
  deleteStripeCard: Scalars['Boolean']['output'];
  deleteSubscription: DeleteSubscriptionResult;
  deleteSupplement: DeleteSupplementResult;
  destroyAuthoringFeedback: DestroyAuthoringFeedbackResult;
  destroyDistrict: DestroyDistrictResult;
  destroyGuide: DestroyGuideResult;
  destroyStandard: DestroyStandardResult;
  destroyStandardSet: DestroyStandardSetResult;
  destroySubject: DestroySubjectResult;
  destroySubjectFaq: DestroySubjectFaqResult;
  destroyTagCategory: DestroyTagCategoryResult;
  destroyUpgrade: DestroyUpgradeResult;
  destroyUserFeedback: DestroyUserFeedbackResult;
  destroyUserSubjectTagPreference: DestroyUserSubjectTagPreferenceResult;
  forgotPassword: Scalars['Boolean']['output'];
  grade: GradeResult;
  lockContent: LockContentResult;
  /** Marks the current released grade/evaluation as seen by the student. */
  markEvaluationSeen: MarkEvaluationSeenResult;
  /** Mark a workflow step as not applicable to this user. Bypasses dependency checks. */
  markWorkflowStepNotApplicable: MarkWorkflowStepNotApplicableResult;
  /**
   * Perform a signup onboarding step.
   *
   * Takes a union input that determines which step to perform and carries
   * its typed arguments. See Mandark.Accounts.User.Signup.PerformStep for
   * dispatch logic.
   */
  performSignupStep: Scalars['Boolean']['output'];
  publishGrade: PublishGradeResult;
  /** Records a lockdown violation by appending to the violations array. */
  recordLockdownViolation: RecordLockdownViolationResult;
  regenerateReport: RegenerateReportResult;
  regenerateSupplement: RegenerateSupplementResult;
  rejectCoppaConsentGrant: RejectCoppaConsentGrantResult;
  /**
   * Releases finalized manual grades to students for the assignment's
   * classroom assignments. Unless the actor is a super user, only
   * classrooms the actor teaches are affected; other classrooms of the
   * assignment are silently skipped. A classroom not yet released is
   * released only when one of its students has a finished grade.
   * Already-released classroom assignments keep their original
   * `grades_released_at`. Returns the released classroom assignments.
   *
   * Releasing also publishes any complete in-progress manual grades for
   * students of the released classrooms.
   */
  releaseGrades: Array<ClassroomAssignment>;
  /** Reorder the FAQs for a subject to be in the order of the given list of FAQ IDs */
  reorderSubjectFaqs: Scalars['Boolean']['output'];
  /** Sets the display order of this subject's guides from an ordered list of guide ids. */
  reorderSubjectGuides: ReorderSubjectGuidesResult;
  /**
   * Records a teacher's request that one or more admins lock-authorize the
   * assignment, and enqueues a single notification email addressed to all
   * selected admins. Upserts on (assignment_id, requesting_teacher_id): a
   * resend replaces `admin_ids`, writes `message` if the caller supplied
   * a new one (otherwise preserves the original via
   * `PreserveMessageOnResend`), and bumps `updated_at`. `sent_at` is left
   * alone until delivery succeeds.
   *
   * An identical resend (same `admin_ids`, same resulting `message`)
   * arriving within a minute of the previous submission is treated as a
   * double-submit and does not send a second email; past that window a
   * re-request always notifies, so a teacher can nudge an unresponsive
   * admin.
   */
  requestLockAuthorization: RequestLockAuthorizationResult;
  resendConfirmationEmail: ResendConfirmationEmailResult;
  resendCreatedUserEmail: ResendCreatedUserEmailResult;
  resendPasswordResetEmail: ResendPasswordResetEmailResult;
  /**
   * Teacher-initiated reset of a student's timer. Clears `started_at` — returning the student to
   * not-started with the full time restored — and stamps `reset_at`, so the student is told their
   * timer was reset and must explicitly `resume`. Progress (answered questions and classified
   * skills, held on the StudentDiagnosticSkill records and `current_skill`/`current_question`) is
   * preserved. Valid only for a session in progress or out of time: rejected once the diagnostic
   * is completed, and rejected before it has started — a not-yet-started student has no session to
   * restore, and stamping `reset_at` on them would strand them (the FE would send them to
   * `resume`, which does not initialize a session).
   */
  resetDiagnosticTimer: ResetDiagnosticTimerResult;
  /**
   * Teacher-initiated bulk reset of the timers of every not-yet-completed student in one classroom
   * of a recipient group.
   *
   * In GraphQL, `id` is this recipient group's id (a `DiagnosticSettings` record — the entity a
   * group's timer/date settings live on), and `classroomId` selects one classroom within that
   * group; only that classroom's students are reset. Each student returns to not-started with their
   * full time restored, keeping their answered questions and classified skills.
   *
   * The reset runs in an after_action, so the group row itself is untouched (its `updated_at` does
   * not move). See `Mandark.Assignments.DiagnosticSettings.Changes.ResetClassroomTimers`.
   */
  resetDiagnosticTimersForClassroom: ResetDiagnosticTimersForClassroomResult;
  /** Reset a user's password if they are a managed user that the current actor has permission to manage. */
  resetManagedUserPassword: ResetPasswordResult;
  /** Allow the current authenticated user to reset their own password without providing their old password. */
  resetOwnPassword: ResetPasswordResult;
  resetPasswordWithToken: ResetPasswordResult;
  /** Clears `reset_at` after a teacher reset, signalling the student has re-engaged with the assignment. Idempotent. */
  resumeAfterReset: ResumeAfterResetResult;
  /**
   * Student-initiated resume after a teacher reset. Re-stamps `started_at`, restarting the full
   * countdown, and clears `reset_at`. Unlike `:start` it does not re-initialize the session, so
   * the student continues from the skill and question they were on. Valid only when a reset is
   * pending; a never-started diagnostic is entered via `:start`.
   */
  resumeStudentDiagnostic: ResumeStudentDiagnosticResult;
  /**
   * Upserts one target's complete annotation array. The target must be live
   * content of the assignment: a question it lists, or a supplement of one.
   */
  saveAnnotationSet: SaveAnnotationSetResult;
  saveRecipientGroups: Array<SkillPathSettings>;
  /** Create or fully replace the current user's saved tag set for a subject. */
  saveUserSubjectTagPreference: SaveUserSubjectTagPreferenceResult;
  /**
   * Sets whether students in this classroom may access locked question content
   * inside this assignment. Restricted to approved admins at the classroom's
   * school, and only while that school carries an active pro upgrade.
   */
  setClassroomAssignmentLockAuthorization: SetClassroomAssignmentLockAuthorizationResult;
  /**
   * Sets a school personnel's license access approval status.
   *
   * Accepts a status argument (:approved, :pending, or :rejected) and sets it directly.
   */
  setLicenseAccessStatus: SetLicenseAccessStatusResult;
  setSubjectTagCategories: SetSubjectTagCategoriesResult;
  /** Mark a workflow step as skipped by user choice. Bypasses dependency checks. */
  skipWorkflowStep: SkipWorkflowStepResult;
  /**
   * Default behavior is to retrieve the most recently created practice.
   *   A new practice is created if the student hasn't started one yet.
   *   Optionally, the student may choose to 'repractice', in which case a new practice is created and their proficiency begins again back at 0.
   */
  startAdaptivePractice: StartAdaptivePracticeResult;
  startStudentDiagnostic: StartStudentDiagnosticResult;
  /** Generate unique username suggestions based on first and last name. */
  suggestUsernames: Array<Scalars['String']['output']>;
  unlinkUserIdentity: UnlinkUserIdentityResult;
  /** Removes a lock. The record of the removal is kept, so it can be audited and reinstated by Albert staff. */
  unlockContent: UnlockContentResult;
  updateClassroomSubjectAccess: UpdateClassroomSubjectAccessResult;
  updateDiagnostic: UpdateDiagnosticResult;
  updateDistrict: UpdateDistrictResult;
  updateGuide: UpdateGuideResult;
  updateQuestion: UpdateQuestionResult;
  updateSchoolLicense: UpdateSchoolLicenseResult;
  /** Updates translation and classroom enrollment settings for a school's administrators. */
  updateSchoolSettings: UpdateSchoolSettingsResult;
  updateStandard: UpdateStandardResult;
  updateStandardSet: UpdateStandardSetResult;
  updateStandardSetCreator: UpdateStandardSetCreatorResult;
  /**
   * Updates a saved card. An argument that is not provided is left unchanged;
   * only the fields given are sent to Stripe.
   */
  updateStripeCard: StripeCardResult;
  updateSubject: UpdateSubjectResult;
  updateSubjectFaq: UpdateSubjectFaqResult;
  updateSubscription: UpdateSubscriptionResult;
  updateSupplement: UpdateSupplementResult;
  updateTagCategory: UpdateTagCategoryResult;
  updateUpgrade: UpdateUpgradeResult;
  updateUser: UpdateUserResult;
  upsertReport: UpsertReportResult;
  upsertTranslatedQuestionField: UpsertTranslatedQuestionFieldResult;
  upsertTranslatedSupplementField: UpsertTranslatedSupplementFieldResult;
};


export type RootMutationTypeApproveCoppaConsentGrantArgs = {
  id: Scalars['ID']['input'];
  input: ApproveCoppaConsentGrantInput;
};


export type RootMutationTypeArchiveQuestionArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeBulkCreateManagedUsersArgs = {
  input: BulkCreateManagedUsersInput;
};


export type RootMutationTypeBulkCreateStandardsArgs = {
  input: BulkCreateStandardsInput;
};


export type RootMutationTypeBulkSetLicenseAccessStatusArgs = {
  input: BulkSetLicenseAccessStatusInput;
};


export type RootMutationTypeBuySubscriptionsArgs = {
  input: BuySubscriptionsInput;
};


export type RootMutationTypeCheckUsernameAvailabilityArgs = {
  input: CheckUsernameAvailabilityInput;
};


export type RootMutationTypeClassroomInvitationBulkCreateArgs = {
  input: ClassroomInvitationBulkCreateInput;
};


export type RootMutationTypeClassroomInvitationBulkReinviteArgs = {
  input: ClassroomInvitationBulkReinviteInput;
};


export type RootMutationTypeClassroomInvitationReinviteArgs = {
  input: ClassroomInvitationReinviteInput;
};


export type RootMutationTypeCompleteWorkflowStepArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeCreateAuthoringFeedbackArgs = {
  input: CreateAuthoringFeedbackInput;
};


export type RootMutationTypeCreateClassroomInvitationArgs = {
  input: CreateClassroomInvitationInput;
};


export type RootMutationTypeCreateCustomerFeedbackEntryArgs = {
  input: CreateCustomerFeedbackEntryInput;
};


export type RootMutationTypeCreateDiagnosticArgs = {
  input: CreateDiagnosticInput;
};


export type RootMutationTypeCreateDistrictArgs = {
  input: CreateDistrictInput;
};


export type RootMutationTypeCreateGuideArgs = {
  input: CreateGuideInput;
};


export type RootMutationTypeCreateQuestionArgs = {
  input: CreateQuestionInput;
};


export type RootMutationTypeCreateStandardArgs = {
  input: CreateStandardInput;
};


export type RootMutationTypeCreateStandardSetArgs = {
  input: CreateStandardSetInput;
};


export type RootMutationTypeCreateStandardSetCreatorArgs = {
  input: CreateStandardSetCreatorInput;
};


export type RootMutationTypeCreateStripeCardArgs = {
  input: CreateStripeCardInput;
};


export type RootMutationTypeCreateSubjectArgs = {
  input: CreateSubjectInput;
};


export type RootMutationTypeCreateSubjectFaqArgs = {
  input: CreateSubjectFaqInput;
};


export type RootMutationTypeCreateSubscriptionArgs = {
  input: CreateSubscriptionInput;
};


export type RootMutationTypeCreateSupplementArgs = {
  input: CreateSupplementInput;
};


export type RootMutationTypeCreateTagArgs = {
  input: CreateTagInput;
};


export type RootMutationTypeCreateTagCategoryArgs = {
  input: CreateTagCategoryInput;
};


export type RootMutationTypeCreateTranslationJobArgs = {
  input: CreateTranslationJobInput;
};


export type RootMutationTypeCreateUserArgs = {
  input: CreateUserInput;
};


export type RootMutationTypeCreateUserFeedbackArgs = {
  input: CreateUserFeedbackInput;
};


export type RootMutationTypeDeleteDiagnosticArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteQuestionArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteRecipientGroupsArgs = {
  input: DeleteRecipientGroupsInput;
};


export type RootMutationTypeDeleteStripeCardArgs = {
  input: DeleteStripeCardInput;
};


export type RootMutationTypeDeleteSubscriptionArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteSupplementArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDestroyAuthoringFeedbackArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDestroyDistrictArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDestroyGuideArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDestroyStandardArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDestroyStandardSetArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDestroySubjectArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDestroySubjectFaqArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDestroyTagCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDestroyUpgradeArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDestroyUserFeedbackArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDestroyUserSubjectTagPreferenceArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


export type RootMutationTypeGradeArgs = {
  assignmentId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  input?: InputMaybe<GradeInput>;
  questionId?: InputMaybe<Scalars['ID']['input']>;
  studentId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeLockContentArgs = {
  input: LockContentInput;
};


export type RootMutationTypeMarkEvaluationSeenArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeMarkWorkflowStepNotApplicableArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypePerformSignupStepArgs = {
  input: PerformSignupStepInput;
};


export type RootMutationTypePublishGradeArgs = {
  assignmentId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  input?: InputMaybe<PublishGradeInput>;
  questionId?: InputMaybe<Scalars['ID']['input']>;
  studentId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeRecordLockdownViolationArgs = {
  id: Scalars['ID']['input'];
  input: RecordLockdownViolationInput;
};


export type RootMutationTypeRegenerateReportArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeRegenerateSupplementArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeRejectCoppaConsentGrantArgs = {
  id: Scalars['ID']['input'];
  input: RejectCoppaConsentGrantInput;
};


export type RootMutationTypeReleaseGradesArgs = {
  input: ReleaseGradesInput;
};


export type RootMutationTypeReorderSubjectFaqsArgs = {
  newOrder: Array<Scalars['ID']['input']>;
  subjectId: Scalars['ID']['input'];
};


export type RootMutationTypeReorderSubjectGuidesArgs = {
  id: Scalars['ID']['input'];
  input: ReorderSubjectGuidesInput;
};


export type RootMutationTypeRequestLockAuthorizationArgs = {
  input: RequestLockAuthorizationInput;
};


export type RootMutationTypeResendConfirmationEmailArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeResendCreatedUserEmailArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeResendPasswordResetEmailArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeResetDiagnosticTimerArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeResetDiagnosticTimersForClassroomArgs = {
  id: Scalars['ID']['input'];
  input: ResetDiagnosticTimersForClassroomInput;
};


export type RootMutationTypeResetManagedUserPasswordArgs = {
  input: ResetManagedUserPasswordInput;
  userId: Scalars['ID']['input'];
};


export type RootMutationTypeResetOwnPasswordArgs = {
  input: ResetOwnPasswordInput;
};


export type RootMutationTypeResetPasswordWithTokenArgs = {
  input: ResetPasswordWithTokenInput;
  userId: Scalars['ID']['input'];
};


export type RootMutationTypeResumeAfterResetArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeResumeStudentDiagnosticArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeSaveAnnotationSetArgs = {
  input: SaveAnnotationSetInput;
};


export type RootMutationTypeSaveRecipientGroupsArgs = {
  input: SaveRecipientGroupsInput;
};


export type RootMutationTypeSaveUserSubjectTagPreferenceArgs = {
  input: SaveUserSubjectTagPreferenceInput;
};


export type RootMutationTypeSetClassroomAssignmentLockAuthorizationArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<SetClassroomAssignmentLockAuthorizationInput>;
};


export type RootMutationTypeSetLicenseAccessStatusArgs = {
  id: Scalars['ID']['input'];
  input: SetLicenseAccessStatusInput;
};


export type RootMutationTypeSetSubjectTagCategoriesArgs = {
  id: Scalars['ID']['input'];
  input: SetSubjectTagCategoriesInput;
};


export type RootMutationTypeSkipWorkflowStepArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeStartAdaptivePracticeArgs = {
  input: StartAdaptivePracticeInput;
};


export type RootMutationTypeStartStudentDiagnosticArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeSuggestUsernamesArgs = {
  input: SuggestUsernamesInput;
};


export type RootMutationTypeUnlinkUserIdentityArgs = {
  id: Scalars['ID']['input'];
  input: UnlinkUserIdentityInput;
};


export type RootMutationTypeUnlockContentArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateClassroomSubjectAccessArgs = {
  classroomId: Scalars['ID']['input'];
  input?: InputMaybe<UpdateClassroomSubjectAccessInput>;
  subjectId: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateDiagnosticArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<UpdateDiagnosticInput>;
};


export type RootMutationTypeUpdateDistrictArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<UpdateDistrictInput>;
};


export type RootMutationTypeUpdateGuideArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<UpdateGuideInput>;
};


export type RootMutationTypeUpdateQuestionArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<UpdateQuestionInput>;
};


export type RootMutationTypeUpdateSchoolLicenseArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<UpdateSchoolLicenseInput>;
};


export type RootMutationTypeUpdateSchoolSettingsArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<UpdateSchoolSettingsInput>;
};


export type RootMutationTypeUpdateStandardArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<UpdateStandardInput>;
};


export type RootMutationTypeUpdateStandardSetArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<UpdateStandardSetInput>;
};


export type RootMutationTypeUpdateStandardSetCreatorArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<UpdateStandardSetCreatorInput>;
};


export type RootMutationTypeUpdateStripeCardArgs = {
  input: UpdateStripeCardInput;
};


export type RootMutationTypeUpdateSubjectArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<UpdateSubjectInput>;
};


export type RootMutationTypeUpdateSubjectFaqArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<UpdateSubjectFaqInput>;
};


export type RootMutationTypeUpdateSubscriptionArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<UpdateSubscriptionInput>;
};


export type RootMutationTypeUpdateSupplementArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<UpdateSupplementInput>;
};


export type RootMutationTypeUpdateTagCategoryArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<UpdateTagCategoryInput>;
};


export type RootMutationTypeUpdateUpgradeArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<UpdateUpgradeInput>;
};


export type RootMutationTypeUpdateUserArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<UpdateUserInput>;
};


export type RootMutationTypeUpsertReportArgs = {
  input: UpsertReportInput;
};


export type RootMutationTypeUpsertTranslatedQuestionFieldArgs = {
  input: UpsertTranslatedQuestionFieldInput;
};


export type RootMutationTypeUpsertTranslatedSupplementFieldArgs = {
  input: UpsertTranslatedSupplementFieldInput;
};

export type RootQueryType = {
  __typename?: 'RootQueryType';
  /** Returns AB total question count given the provided filters. */
  abQuestionCount: Scalars['Int']['output'];
  /** Returns AB question counts grouped by a dimension given the provided filters. */
  abQuestionCountsByDimension: Array<AbQuestionCountEntry>;
  /**
   * Returns one page of question ids for the Assignment Builder search, in display order,
   * and the total number of matching questions. Uses the same filters as
   * `ab_question_count`. Load the questions' content separately by id.
   */
  abQuestionSearch: AbQuestionSearchResult;
  /** Total count of adaptive practices on in scope classroom subjects at each level */
  adaptiveAchievement: Scalars['JsonString']['output'];
  adaptivePractice?: Maybe<AdaptivePractice>;
  adaptivePractices?: Maybe<KeysetPageOfAdaptivePractice>;
  aiGradingAvailableModels: Array<Scalars['String']['output']>;
  aiGradingAvailableStyles: Array<AiGradingFeedbackStyle>;
  /** Returns skills that are on the student's skill path or have independent practice, scoped to non-restricted classrooms, sorted by date proximity. */
  allSkills: Array<GuideLevel>;
  /**
   * Annotation sets for one assignment across the students the actor teaches,
   * optionally narrowed to the given student ids; all targets, unpaginated. Not limited
   * to submitted attempts, and independent of the `student_annotations` flag.
   */
  annotationSetsAsEducator: Array<StudentAnnotationSet>;
  /**
   * Lists assignments for an educator's assignment index views: drafts and
   * published assignments they created, plus published assignments assigned
   * to classrooms they teach.
   *
   * Supers and school admins may request another educator's index by passing
   * `as_educator_id` ("acting as" / masquerading). The set is scoped to that
   * educator by the ScopeToEducatorIndex preparation; the policies then bound
   * what the acting actor may actually see — an admin sees the assignments of
   * educators they administrate, matching the legacy scoping.
   */
  assignmentsAsEducator?: Maybe<KeysetPageOfAssignment>;
  authoringFeedbacks?: Maybe<KeysetPageOfAuthoringFeedback>;
  classroom?: Maybe<ClassroomsClassroom>;
  classroomAssignment?: Maybe<ClassroomAssignment>;
  /** Lists an assignment's classroom-assignment lock-authorization rows for the admin settings UI. Coarse admin gate; the update action enforces the precise scope. */
  classroomAssignmentsForLockAuthorization: Array<ClassroomAssignment>;
  /**
   * Per-classroom restricted-content facts for a list of questions: whether the
   * questions are restricted at each classroom's school, whether that school
   * holds Pro, and whether the caller administers it.
   *
   * Takes the questions rather than an assignment id so the answer is available
   * before an assignment exists (the builder badges classrooms while unsaved)
   * and stays right for a draft whose question list has unsaved edits. Use
   * `Assignment.hasLockedContent` where a saved assignment's one-bit summary is
   * enough.
   *
   * Returns a row only for a classroom the caller teaches or administers;
   * others are dropped, so a missing row means "not yours to ask about" rather
   * than "not restricted".
   */
  classroomContentAccess: Array<ClassroomContentAccess>;
  /** Grace periods that are still running. A removal sweep reads the whole set; an admin reads it scoped to their own schools by the read policy, where a result means those schools' content locks come off on `end_date` unless pro is restored first. */
  contentLockGracePeriods?: Maybe<PageOfContentLockGracePeriod>;
  contentLocks: Array<ContentLock>;
  currentUser?: Maybe<User>;
  /**
   * The signed-in user's own record, read from the primary database so it
   * always reflects the caller's most recent writes. Query this — not
   * currentUser — for signup/onboarding decisions taken right after account
   * creation or a signup-step mutation.
   */
  currentUserForSignup?: Maybe<User>;
  curriculumArea?: Maybe<CurriculumArea>;
  curriculumAreas?: Maybe<KeysetPageOfCurriculumArea>;
  customerFeedbackEntry?: Maybe<CustomerFeedbackEntry>;
  diagnostic?: Maybe<Diagnostic>;
  diagnosticTemplate?: Maybe<DiagnosticTemplate>;
  diagnosticTemplates?: Maybe<KeysetPageOfDiagnosticTemplate>;
  diagnostics?: Maybe<KeysetPageOfDiagnostic>;
  district?: Maybe<District>;
  districts?: Maybe<KeysetPageOfDistrict>;
  districtsOffset?: Maybe<PageOfDistrict>;
  featureFlag?: Maybe<FeatureFlag>;
  gradeLevels?: Maybe<KeysetPageOfGradeLevel>;
  guessesForGrading: Array<Guess>;
  /** Reads published guides. Authoring screens read unpublished ones through `unfilteredGuides` and `unfilteredGuide`. */
  guide?: Maybe<Guide>;
  guideLevel?: Maybe<GuideLevel>;
  /** tree aware search for guide levels */
  guideLevelTreeSearch: Array<GuideLevelSearchResult>;
  /** Tree aware search for guide levels within standards and standard sets. */
  guideLevelTreeSearchByStandard: Array<GuideLevelSearchResult>;
  guideLevels?: Maybe<KeysetPageOfGuideLevel>;
  guideLevelsOffset?: Maybe<PageOfGuideLevel>;
  /** Reads published guides. Authoring screens read unpublished ones through `unfilteredGuides` and `unfilteredGuide`. */
  guides?: Maybe<KeysetPageOfGuide>;
  /**
   * Answers "who are the admins I could reach out to?" for a teacher
   * or teacher-admin. Scoped to schools the actor is actually active
   * at, and to schools with a real license — an unlicensed school's
   * admin list isn't a meaningful contact target — and the actor's
   * own row is filtered so a teacher-admin doesn't self-suggest.
   *
   * Because these are hand-picked as safe to surface publicly by
   * name, this action also opts into peer-user traversal for its
   * results (see `LoadedFromPeerAuthorizedAction`). Other actions
   * that return SchoolPersonnel do not carry that opt-in; each new
   * one has to decide for itself.
   */
  myAdmins: Array<SchoolPersonnel>;
  /** One student's annotation sets for one assignment, all targets, unpaginated. */
  myAnnotationSets: Array<StudentAnnotationSet>;
  /** The requesting student's own guesses */
  myGuesses: Array<Guess>;
  previewLockImpact: ImpactPreview;
  question?: Maybe<Question>;
  questions?: Maybe<KeysetPageOfQuestion>;
  questionsOffset?: Maybe<PageOfQuestion>;
  report?: Maybe<AnalyticsReport>;
  reportResults: Array<ReportResult>;
  school?: Maybe<School>;
  /**
   * Licenses of a school the actor is approved personnel at. Excludes
   * soft-deleted licenses; supers wanting those use `read_all`.
   */
  schoolLicense?: Maybe<SchoolLicense>;
  /**
   * Licenses of a school the actor is approved personnel at. Excludes
   * soft-deleted licenses; supers wanting those use `read_all`.
   */
  schoolLicenses?: Maybe<KeysetPageOfSchoolLicense>;
  /**
   * Finds schools by location so users can identify their own (during
   * signup, for example). Requires a postal code so the school directory
   * cannot be enumerated; generated GraphQL filters compose on top of
   * (and cannot bypass) this scope.
   */
  schoolSearch?: Maybe<KeysetPageOfSchool>;
  /**
   * Unconstrained listing for internal admin tooling (Dennis). The search
   * term matches school name, postal code, license type, or district name.
   */
  schools?: Maybe<KeysetPageOfSchool>;
  /** Searches supplement metadata for content administration. */
  searchSupplements?: Maybe<PageOfSupplement>;
  /**
   * One row per skill on a skill path reaching the acting teacher, for the Skill Paths list.
   *
   * `classroom_ids` selects the scope: nil spans their active classes (the All Classes view),
   * a list narrows to those classes and may include an archived one (the class view). Paths
   * created by co-teachers of those classes are included.
   *
   * Supers and school admins may request another teacher's list by naming that teacher in
   * `as_educator_id` (masquerading), the same way the assignments `read_as_educator` does. A
   * super sees the teacher's whole list; an admin sees the teacher's classes at schools they
   * administer.
   *
   * Unlike the primary read this does not filter to published skills — a skill that was
   * unpublished after being assigned still needs managing, and the sibling `all_skills` behaves
   * the same way.
   */
  skillPathEntries?: Maybe<PageOfGuideLevel>;
  skillPathSetting?: Maybe<SkillPathSettings>;
  skillPathSettings?: Maybe<KeysetPageOfSkillPathSettings>;
  standard?: Maybe<Standard>;
  standardSet?: Maybe<StandardSet>;
  standardSetCreator?: Maybe<StandardSetCreator>;
  standardSetCreators?: Maybe<KeysetPageOfStandardSetCreator>;
  standardSetCreatorsOffset?: Maybe<PageOfStandardSetCreator>;
  standardSets?: Maybe<KeysetPageOfStandardSet>;
  standardSetsOffset?: Maybe<PageOfStandardSet>;
  standards?: Maybe<KeysetPageOfStandard>;
  standardsOffset?: Maybe<PageOfStandard>;
  stripeCards: Array<StripeCard>;
  /** Reads a student assignment as an educator. Used by teachers to view lockdown violation details. */
  studentAssignmentAsEducator?: Maybe<StudentAssignment>;
  studentDiagnostic?: Maybe<StudentDiagnostic>;
  studentDiagnostics?: Maybe<KeysetPageOfStudentDiagnostic>;
  subject?: Maybe<Subject>;
  subjects?: Maybe<KeysetPageOfSubject>;
  subjectsOffset?: Maybe<PageOfSubject>;
  supplement?: Maybe<Supplement>;
  tag?: Maybe<Tag>;
  tagCategories?: Maybe<PageOfTagCategory>;
  tagCategory?: Maybe<TagCategory>;
  tags?: Maybe<PageOfTag>;
  /** Returns skills the student should work on next: skills currently on the student's skill path or recently practiced independent skills, scoped to non-restricted classrooms, sorted by date proximity. */
  toDoSkills: Array<GuideLevel>;
  translatedQuestion?: Maybe<TranslatedQuestion>;
  translatedSupplement?: Maybe<TranslatedSupplement>;
  translationJob?: Maybe<TranslationJob>;
  /** Reads guides whether or not they are published, for authoring screens. Supers, content managers and any author may call it. */
  unfilteredGuide?: Maybe<Guide>;
  /** Reads guide levels whether or not they are published, for authoring screens. Content managers and any author may call it. */
  unfilteredGuideLevel?: Maybe<GuideLevel>;
  /** Reads guide levels whether or not they are published, for authoring screens. Content managers and any author may call it. */
  unfilteredGuideLevels?: Maybe<KeysetPageOfGuideLevel>;
  /** Reads guide levels whether or not they are published, for authoring screens. Content managers and any author may call it. */
  unfilteredGuideLevelsOffset?: Maybe<PageOfGuideLevel>;
  /** Reads guides whether or not they are published, for authoring screens. Supers, content managers and any author may call it. */
  unfilteredGuides?: Maybe<KeysetPageOfGuide>;
  unfilteredSubject?: Maybe<Subject>;
  unfilteredSubjects?: Maybe<KeysetPageOfSubject>;
  unfilteredSubjectsOffset?: Maybe<PageOfSubject>;
  upgrade?: Maybe<Upgrade>;
  upgrades?: Maybe<KeysetPageOfUpgrade>;
  user?: Maybe<User>;
  userFeedbacks?: Maybe<KeysetPageOfUserFeedback>;
  /** The current user's saved tag preference for a subject, if any. */
  userSubjectTagPreference?: Maybe<UserSubjectTagPreference>;
  users?: Maybe<PageOfUser>;
  validateCoupon: CouponQuote;
};


export type RootQueryTypeAbQuestionCountArgs = {
  countOpts?: InputMaybe<AbQuestionCountOptsInput>;
};


export type RootQueryTypeAbQuestionCountsByDimensionArgs = {
  countOpts?: InputMaybe<AbQuestionCountOptsInput>;
  dimension: Scalars['String']['input'];
};


export type RootQueryTypeAbQuestionSearchArgs = {
  countOpts?: InputMaybe<AbQuestionCountOptsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  randomSeed?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<AbQuestionSort>;
};


export type RootQueryTypeAdaptiveAchievementArgs = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type RootQueryTypeAdaptivePracticeArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeAdaptivePracticesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AdaptivePracticeFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AdaptivePracticeSortInput>>>;
};


export type RootQueryTypeAiGradingAvailableStylesArgs = {
  rubricType: Scalars['String']['input'];
};


export type RootQueryTypeAllSkillsArgs = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  filter?: InputMaybe<GuideLevelFilterInput>;
  sort?: InputMaybe<Array<InputMaybe<GuideLevelSortInput>>>;
};


export type RootQueryTypeAnnotationSetsAsEducatorArgs = {
  assignmentId: Scalars['ID']['input'];
  studentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type RootQueryTypeAssignmentsAsEducatorArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  asEducatorId?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AssignmentFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AssignmentSortInput>>>;
};


export type RootQueryTypeAuthoringFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AuthoringFeedbackFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AuthoringFeedbackSortInput>>>;
};


export type RootQueryTypeClassroomArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeClassroomAssignmentArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeClassroomAssignmentsForLockAuthorizationArgs = {
  assignmentId: Scalars['ID']['input'];
  filter?: InputMaybe<ClassroomAssignmentFilterInput>;
  sort?: InputMaybe<Array<InputMaybe<ClassroomAssignmentSortInput>>>;
};


export type RootQueryTypeClassroomContentAccessArgs = {
  classroomIds: Array<Scalars['ID']['input']>;
  questionIds: Array<Scalars['ID']['input']>;
};


export type RootQueryTypeContentLockGracePeriodsArgs = {
  filter?: InputMaybe<ContentLockGracePeriodFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ContentLockGracePeriodSortInput>>>;
};


export type RootQueryTypeContentLocksArgs = {
  filter?: InputMaybe<ContentLockFilterInput>;
  schoolId: Scalars['ID']['input'];
  sort?: InputMaybe<Array<InputMaybe<ContentLockSortInput>>>;
};


export type RootQueryTypeCurriculumAreaArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeCurriculumAreasArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CurriculumAreaFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CurriculumAreaSortInput>>>;
};


export type RootQueryTypeCustomerFeedbackEntryArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeDiagnosticArgs = {
  asEducatorId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};


export type RootQueryTypeDiagnosticTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeDiagnosticTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DiagnosticTemplateFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DiagnosticTemplateSortInput>>>;
};


export type RootQueryTypeDiagnosticsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  asEducatorId?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DiagnosticFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DiagnosticSortInput>>>;
};


export type RootQueryTypeDistrictArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeDistrictsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DistrictFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DistrictSortInput>>>;
};


export type RootQueryTypeDistrictsOffsetArgs = {
  filter?: InputMaybe<DistrictFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DistrictSortInput>>>;
};


export type RootQueryTypeFeatureFlagArgs = {
  name: Scalars['String']['input'];
};


export type RootQueryTypeGradeLevelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<GradeLevelFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GradeLevelSortInput>>>;
};


export type RootQueryTypeGuessesForGradingArgs = {
  assignmentId?: InputMaybe<Scalars['ID']['input']>;
  questionId?: InputMaybe<Scalars['ID']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GuessSortInput>>>;
  studentId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeGuideArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeGuideLevelArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeGuideLevelTreeSearchArgs = {
  guideId: Scalars['ID']['input'];
  proficiencyLevels?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  standardIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  standardSetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tagIdGroups?: InputMaybe<Array<Array<Scalars['ID']['input']>>>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type RootQueryTypeGuideLevelTreeSearchByStandardArgs = {
  applyPersonalizationSettings?: InputMaybe<Scalars['Boolean']['input']>;
  curriculumAreaIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  guideId: Scalars['ID']['input'];
  proficiencyLevels?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  standardIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  standardSetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tagIdGroups?: InputMaybe<Array<Array<Scalars['ID']['input']>>>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type RootQueryTypeGuideLevelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<GuideLevelFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GuideLevelSortInput>>>;
};


export type RootQueryTypeGuideLevelsOffsetArgs = {
  filter?: InputMaybe<GuideLevelFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GuideLevelSortInput>>>;
};


export type RootQueryTypeGuidesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<GuideFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GuideSortInput>>>;
};


export type RootQueryTypeMyAnnotationSetsArgs = {
  assignmentId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};


export type RootQueryTypeMyGuessesArgs = {
  assignmentId?: InputMaybe<Scalars['ID']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GuessSortInput>>>;
};


export type RootQueryTypePreviewLockImpactArgs = {
  lockType: Scalars['String']['input'];
  schoolId: Scalars['ID']['input'];
  sourceId: Scalars['ID']['input'];
};


export type RootQueryTypeQuestionArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeQuestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<QuestionFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<QuestionSortInput>>>;
};


export type RootQueryTypeQuestionsOffsetArgs = {
  filter?: InputMaybe<QuestionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<QuestionSortInput>>>;
};


export type RootQueryTypeReportArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeReportResultsArgs = {
  excludeUnlicensedClassrooms?: InputMaybe<Scalars['Boolean']['input']>;
  pagination: ReportResultPaginationInput;
  reportId: Scalars['ID']['input'];
  sorts?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeSchoolArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeSchoolLicenseArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeSchoolLicensesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SchoolLicenseFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SchoolLicenseSortInput>>>;
};


export type RootQueryTypeSchoolSearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SchoolFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  sort?: InputMaybe<Array<InputMaybe<SchoolSortInput>>>;
};


export type RootQueryTypeSchoolsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SchoolFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SchoolSortInput>>>;
};


export type RootQueryTypeSearchSupplementsArgs = {
  filter?: InputMaybe<SupplementFilterInput>;
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  ownerQuery?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SupplementSortInput>>>;
  subjectId?: InputMaybe<Scalars['ID']['input']>;
  supplementType?: InputMaybe<SupplementType>;
};


export type RootQueryTypeSkillPathEntriesArgs = {
  asEducatorId?: InputMaybe<Scalars['ID']['input']>;
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  filter?: InputMaybe<GuideLevelFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GuideLevelSortInput>>>;
};


export type RootQueryTypeSkillPathSettingArgs = {
  asEducatorId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};


export type RootQueryTypeSkillPathSettingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  asEducatorId?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SkillPathSettingsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SkillPathSettingsSortInput>>>;
};


export type RootQueryTypeStandardArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeStandardSetArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeStandardSetCreatorArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeStandardSetCreatorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<StandardSetCreatorFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<StandardSetCreatorSortInput>>>;
};


export type RootQueryTypeStandardSetCreatorsOffsetArgs = {
  filter?: InputMaybe<StandardSetCreatorFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<StandardSetCreatorSortInput>>>;
};


export type RootQueryTypeStandardSetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<StandardSetFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<StandardSetSortInput>>>;
};


export type RootQueryTypeStandardSetsOffsetArgs = {
  filter?: InputMaybe<StandardSetFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<StandardSetSortInput>>>;
};


export type RootQueryTypeStandardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<StandardFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<StandardSortInput>>>;
};


export type RootQueryTypeStandardsOffsetArgs = {
  filter?: InputMaybe<StandardFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<StandardSortInput>>>;
};


export type RootQueryTypeStripeCardsArgs = {
  filter?: InputMaybe<StripeCardFilterInput>;
  sort?: InputMaybe<Array<InputMaybe<StripeCardSortInput>>>;
};


export type RootQueryTypeStudentAssignmentAsEducatorArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeStudentDiagnosticArgs = {
  diagnosticId: Scalars['ID']['input'];
};


export type RootQueryTypeStudentDiagnosticsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<StudentDiagnosticFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<StudentDiagnosticSortInput>>>;
};


export type RootQueryTypeSubjectArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeSubjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SubjectFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SubjectSortInput>>>;
};


export type RootQueryTypeSubjectsOffsetArgs = {
  filter?: InputMaybe<SubjectFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SubjectSortInput>>>;
};


export type RootQueryTypeSupplementArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeTagArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeTagCategoriesArgs = {
  filter?: InputMaybe<TagCategoryFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TagCategorySortInput>>>;
};


export type RootQueryTypeTagCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeTagsArgs = {
  filter?: InputMaybe<TagFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TagSortInput>>>;
};


export type RootQueryTypeToDoSkillsArgs = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  filter?: InputMaybe<GuideLevelFilterInput>;
  recencyRange?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GuideLevelSortInput>>>;
};


export type RootQueryTypeTranslatedQuestionArgs = {
  id: Scalars['ID']['input'];
  includeDrafts?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
};


export type RootQueryTypeTranslatedSupplementArgs = {
  id: Scalars['ID']['input'];
  includeDrafts?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
};


export type RootQueryTypeTranslationJobArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeUnfilteredGuideArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeUnfilteredGuideLevelArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeUnfilteredGuideLevelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<GuideLevelFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GuideLevelSortInput>>>;
};


export type RootQueryTypeUnfilteredGuideLevelsOffsetArgs = {
  filter?: InputMaybe<GuideLevelFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GuideLevelSortInput>>>;
};


export type RootQueryTypeUnfilteredGuidesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<GuideFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GuideSortInput>>>;
};


export type RootQueryTypeUnfilteredSubjectArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeUnfilteredSubjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SubjectFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SubjectSortInput>>>;
};


export type RootQueryTypeUnfilteredSubjectsOffsetArgs = {
  filter?: InputMaybe<SubjectFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SubjectSortInput>>>;
};


export type RootQueryTypeUpgradeArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeUpgradesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<UpgradeFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<UpgradeSortInput>>>;
};


export type RootQueryTypeUserArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeUserFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<UserFeedbackFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<UserFeedbackSortInput>>>;
};


export type RootQueryTypeUserSubjectTagPreferenceArgs = {
  subjectId: Scalars['ID']['input'];
};


export type RootQueryTypeUsersArgs = {
  filter?: InputMaybe<UserFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<UserSortInput>>>;
};


export type RootQueryTypeValidateCouponArgs = {
  couponCode: Scalars['String']['input'];
  subscriptionDetails: Array<BuySubscriptionsSubscriptionDetailsInput>;
};

export type Rubric = ContainsRubric | CriteriaRubric | EditableRegionsRubric | ExactRubric | GraphContainsRubric | MarkAsCorrectRubric | MathContainsRubric | MostEqualRubric;

export type RubricCriterion = {
  __typename?: 'RubricCriterion';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  maxScore: Scalars['Float']['output'];
  title: Scalars['String']['output'];
};

export type RubricCriterionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  maxScore: Scalars['Float']['input'];
  title: Scalars['String']['input'];
};

export type RubricInput = {
  contains?: InputMaybe<ContainsRubricInput>;
  criteria?: InputMaybe<CriteriaRubricInput>;
  editableRegions?: InputMaybe<EditableRegionsRubricInput>;
  exact?: InputMaybe<ExactRubricInput>;
  graphContains?: InputMaybe<GraphContainsRubricInput>;
  markAsCorrect?: InputMaybe<MarkAsCorrectRubricInput>;
  mathContains?: InputMaybe<MathContainsRubricInput>;
  mostEqual?: InputMaybe<MostEqualRubricInput>;
};

export type SaveAnnotationSetInput = {
  /**
   * The FE `Annotation[]` for this target, verbatim (camelCase, anchor v1).
   * Order is meaningful. Sent as a JSON-encoded string (the `Json` scalar's
   * input form); returned decoded. Limits: 200
   * per target, notes ≤ 2000 characters.
   */
  annotations?: InputMaybe<Scalars['Json']['input']>;
  assignmentId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
  /** The annotated question or supplement. */
  targetId: Scalars['ID']['input'];
  /** Whether `target_id` names a question or a supplement. */
  targetKind: AnnotationTargetKind;
};

/** The result of the :save_annotation_set mutation */
export type SaveAnnotationSetResult = {
  __typename?: 'SaveAnnotationSetResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<StudentAnnotationSet>;
};

export type SaveRecipientGroupsInput = {
  recipientGroups: Array<RecipientGroupInput>;
};

export type SaveUserSubjectTagPreferenceInput = {
  subjectId: Scalars['ID']['input'];
  /** The full set of preferred tag ids; replaces any previously saved set. */
  tagIds: Array<Scalars['ID']['input']>;
};

/** The result of the :save_user_subject_tag_preference mutation */
export type SaveUserSubjectTagPreferenceResult = {
  __typename?: 'SaveUserSubjectTagPreferenceResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<UserSubjectTagPreference>;
};

export type School = {
  __typename?: 'School';
  /**
   * Nil for anyone who is not approved personnel at the school — see
   * `school_licenses`.
   */
  activeSchoolLicense?: Maybe<SchoolLicense>;
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  allowTranslations?: Maybe<Scalars['Boolean']['output']>;
  beganBetaTestingAt?: Maybe<Scalars['DateTime']['output']>;
  city: Scalars['String']['output'];
  cleverId?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  customMessage?: Maybe<Scalars['String']['output']>;
  district?: Maybe<District>;
  districtId?: Maybe<Scalars['ID']['output']>;
  hardCap?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the school currently holds an active license. */
  hasActiveLicense?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  licenseNotificationSentAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  /** End of the school's nearest license; nil if it has never held one. */
  nearestLicenseEndDate?: Maybe<Scalars['DateTime']['output']>;
  /** Seats granted by the school's nearest license; nil if it has never held one. */
  nearestLicenseSeats?: Maybe<Scalars['Int']['output']>;
  /** Start of the school's nearest license; nil if it has never held one. */
  nearestLicenseStartDate?: Maybe<Scalars['DateTime']['output']>;
  /** Type of the school's nearest license; nil if it has never held one. */
  nearestLicenseType?: Maybe<LicenseType>;
  postalCode?: Maybe<Scalars['String']['output']>;
  restrictClassroomEnrollment?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Empty unless the actor is approved personnel at the school: a school is
   * readable by more people than its licenses are. Legacy `schools_v5` failed
   * the whole request in that case; here the relationship simply resolves
   * empty, so callers must not read it as "this school is unlicensed".
   */
  schoolLicenses: Array<SchoolLicense>;
  schoolType?: Maybe<SchoolType>;
  state?: Maybe<Scalars['String']['output']>;
};


export type SchoolSchoolLicensesArgs = {
  filter?: InputMaybe<SchoolLicenseFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SchoolLicenseSortInput>>>;
};

export type SchoolFilterAddressLine1 = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SchoolFilterAddressLine2 = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SchoolFilterCity = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SchoolFilterCountry = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SchoolFilterDistrictId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type SchoolFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type SchoolFilterInput = {
  addressLine1?: InputMaybe<SchoolFilterAddressLine1>;
  addressLine2?: InputMaybe<SchoolFilterAddressLine2>;
  and?: InputMaybe<Array<SchoolFilterInput>>;
  city?: InputMaybe<SchoolFilterCity>;
  country?: InputMaybe<SchoolFilterCountry>;
  districtId?: InputMaybe<SchoolFilterDistrictId>;
  id?: InputMaybe<SchoolFilterId>;
  name?: InputMaybe<SchoolFilterName>;
  /** End of the school's nearest license; nil if it has never held one. */
  nearestLicenseEndDate?: InputMaybe<SchoolFilterNearestLicenseEndDate>;
  /** Seats granted by the school's nearest license; nil if it has never held one. */
  nearestLicenseSeats?: InputMaybe<SchoolFilterNearestLicenseSeats>;
  /** Start of the school's nearest license; nil if it has never held one. */
  nearestLicenseStartDate?: InputMaybe<SchoolFilterNearestLicenseStartDate>;
  /** Type of the school's nearest license; nil if it has never held one. */
  nearestLicenseType?: InputMaybe<SchoolFilterNearestLicenseType>;
  not?: InputMaybe<Array<SchoolFilterInput>>;
  or?: InputMaybe<Array<SchoolFilterInput>>;
  postalCode?: InputMaybe<SchoolFilterPostalCode>;
  schoolType?: InputMaybe<SchoolFilterSchoolType>;
  state?: InputMaybe<SchoolFilterState>;
};

export type SchoolFilterName = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SchoolFilterNearestLicenseEndDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SchoolFilterNearestLicenseSeats = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type SchoolFilterNearestLicenseStartDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SchoolFilterNearestLicenseType = {
  eq?: InputMaybe<LicenseType>;
  greaterThan?: InputMaybe<LicenseType>;
  greaterThanOrEqual?: InputMaybe<LicenseType>;
  in?: InputMaybe<Array<LicenseType>>;
  isDistinctFrom?: InputMaybe<LicenseType>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<LicenseType>;
  lessThan?: InputMaybe<LicenseType>;
  lessThanOrEqual?: InputMaybe<LicenseType>;
  notEq?: InputMaybe<LicenseType>;
};

export type SchoolFilterPostalCode = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SchoolFilterSchoolType = {
  eq?: InputMaybe<SchoolType>;
  greaterThan?: InputMaybe<SchoolType>;
  greaterThanOrEqual?: InputMaybe<SchoolType>;
  in?: InputMaybe<Array<SchoolType>>;
  isDistinctFrom?: InputMaybe<SchoolType>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<SchoolType>;
  lessThan?: InputMaybe<SchoolType>;
  lessThanOrEqual?: InputMaybe<SchoolType>;
  notEq?: InputMaybe<SchoolType>;
};

export type SchoolFilterState = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SchoolLicense = {
  __typename?: 'SchoolLicense';
  /** The last instant of the day the license lapses, inclusive. */
  endDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Whether now falls inside the license's window and it has not been deleted. */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  licenseType: LicenseType;
  /** The number of licensed students the school may enroll. */
  numberOfSeats: Scalars['Int']['output'];
  school?: Maybe<School>;
  schoolId: Scalars['ID']['output'];
  /** Named subject bundles this license grants. */
  schoolLicenseSubjectGroups: Array<SchoolLicenseSubjectGroup>;
  /** Midnight CDT on the day the license takes effect, inclusive. */
  startDate: Scalars['DateTime']['output'];
  /** The published subjects this license grants directly, outside of any subject group. */
  subjects: Array<Subject>;
  upgrades: Array<Upgrade>;
};


export type SchoolLicenseSchoolLicenseSubjectGroupsArgs = {
  filter?: InputMaybe<SchoolLicenseSubjectGroupFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SchoolLicenseSubjectGroupSortInput>>>;
};


export type SchoolLicenseSubjectsArgs = {
  filter?: InputMaybe<SubjectFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SubjectSortInput>>>;
};


export type SchoolLicenseUpgradesArgs = {
  filter?: InputMaybe<UpgradeFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<UpgradeSortInput>>>;
};

export type SchoolLicenseFilterEndDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SchoolLicenseFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type SchoolLicenseFilterInput = {
  and?: InputMaybe<Array<SchoolLicenseFilterInput>>;
  /** The last instant of the day the license lapses, inclusive. */
  endDate?: InputMaybe<SchoolLicenseFilterEndDate>;
  id?: InputMaybe<SchoolLicenseFilterId>;
  /** Whether now falls inside the license's window and it has not been deleted. */
  isActive?: InputMaybe<SchoolLicenseFilterIsActive>;
  licenseType?: InputMaybe<SchoolLicenseFilterLicenseType>;
  not?: InputMaybe<Array<SchoolLicenseFilterInput>>;
  /** The number of licensed students the school may enroll. */
  numberOfSeats?: InputMaybe<SchoolLicenseFilterNumberOfSeats>;
  or?: InputMaybe<Array<SchoolLicenseFilterInput>>;
  schoolId?: InputMaybe<SchoolLicenseFilterSchoolId>;
  /** Midnight CDT on the day the license takes effect, inclusive. */
  startDate?: InputMaybe<SchoolLicenseFilterStartDate>;
};

export type SchoolLicenseFilterIsActive = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SchoolLicenseFilterLicenseType = {
  eq?: InputMaybe<LicenseType>;
  greaterThan?: InputMaybe<LicenseType>;
  greaterThanOrEqual?: InputMaybe<LicenseType>;
  in?: InputMaybe<Array<LicenseType>>;
  isDistinctFrom?: InputMaybe<LicenseType>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<LicenseType>;
  lessThan?: InputMaybe<LicenseType>;
  lessThanOrEqual?: InputMaybe<LicenseType>;
  notEq?: InputMaybe<LicenseType>;
};

export type SchoolLicenseFilterNumberOfSeats = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type SchoolLicenseFilterSchoolId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type SchoolLicenseFilterStartDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum SchoolLicenseSortField {
  EndDate = 'END_DATE',
  Id = 'ID',
  IsActive = 'IS_ACTIVE',
  LicenseType = 'LICENSE_TYPE',
  NumberOfSeats = 'NUMBER_OF_SEATS',
  StartDate = 'START_DATE'
}

export type SchoolLicenseSortInput = {
  field: SchoolLicenseSortField;
  order?: InputMaybe<SortOrder>;
};

export type SchoolLicenseSubjectGroup = {
  __typename?: 'SchoolLicenseSubjectGroup';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  subjects: Array<Subject>;
};


export type SchoolLicenseSubjectGroupSubjectsArgs = {
  filter?: InputMaybe<SubjectFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SubjectSortInput>>>;
};

export type SchoolLicenseSubjectGroupFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type SchoolLicenseSubjectGroupFilterInput = {
  and?: InputMaybe<Array<SchoolLicenseSubjectGroupFilterInput>>;
  id?: InputMaybe<SchoolLicenseSubjectGroupFilterId>;
  name?: InputMaybe<SchoolLicenseSubjectGroupFilterName>;
  not?: InputMaybe<Array<SchoolLicenseSubjectGroupFilterInput>>;
  or?: InputMaybe<Array<SchoolLicenseSubjectGroupFilterInput>>;
};

export type SchoolLicenseSubjectGroupFilterName = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export enum SchoolLicenseSubjectGroupSortField {
  Id = 'ID',
  Name = 'NAME'
}

export type SchoolLicenseSubjectGroupSortInput = {
  field: SchoolLicenseSubjectGroupSortField;
  order?: InputMaybe<SortOrder>;
};

export type SchoolPersonnel = {
  __typename?: 'SchoolPersonnel';
  id: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  teacherId?: Maybe<Scalars['ID']['output']>;
  user?: Maybe<User>;
};

export enum SchoolSortField {
  City = 'CITY',
  Country = 'COUNTRY',
  HasActiveLicense = 'HAS_ACTIVE_LICENSE',
  Id = 'ID',
  Name = 'NAME',
  NearestLicenseEndDate = 'NEAREST_LICENSE_END_DATE',
  NearestLicenseSeats = 'NEAREST_LICENSE_SEATS',
  NearestLicenseStartDate = 'NEAREST_LICENSE_START_DATE',
  NearestLicenseType = 'NEAREST_LICENSE_TYPE',
  PostalCode = 'POSTAL_CODE',
  SchoolType = 'SCHOOL_TYPE',
  State = 'STATE'
}

export type SchoolSortInput = {
  field: SchoolSortField;
  order?: InputMaybe<SortOrder>;
};

export enum SchoolType {
  Charter = 'CHARTER',
  College = 'COLLEGE',
  District = 'DISTRICT',
  Homeschool = 'HOMESCHOOL',
  Internal = 'INTERNAL',
  International = 'INTERNATIONAL',
  K_12 = 'K_12',
  Private = 'PRIVATE',
  Public = 'PUBLIC',
  Tutoring = 'TUTORING'
}

export type SetClassroomAssignmentLockAuthorizationInput = {
  /**
   * Whether students in this classroom may access locked question content inside
   * this assignment (admin-only decision). This is the value a student's access
   * resolves from, and the only one: every classroom starts out not authorized
   * when it is added to an assignment, nothing is inherited, seeded or cascaded
   * from the assignment, and nothing but an admin's explicit write on this row
   * changes it.
   */
  lockAuthorized?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of the :set_classroom_assignment_lock_authorization mutation */
export type SetClassroomAssignmentLockAuthorizationResult = {
  __typename?: 'SetClassroomAssignmentLockAuthorizationResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<ClassroomAssignment>;
};

export type SetLicenseAccessStatusInput = {
  status: Scalars['String']['input'];
};

/** The result of the :set_license_access_status mutation */
export type SetLicenseAccessStatusResult = {
  __typename?: 'SetLicenseAccessStatusResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<SchoolPersonnel>;
};

export type SetSubjectTagCategoriesInput = {
  /** Ordered list of tag category ids; replaces the subject's current categories. */
  tagCategoryIds: Array<Scalars['ID']['input']>;
};

/** The result of the :set_subject_tag_categories mutation */
export type SetSubjectTagCategoriesResult = {
  __typename?: 'SetSubjectTagCategoriesResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<Subject>;
};

export type SignupStepInputInput = {
  accountCompletion?: InputMaybe<UserInputAccountCompletionInput>;
  accountTypeSelection?: InputMaybe<UserInputAccountTypeSelectionInput>;
  contentPersonalization?: InputMaybe<UserInputContentPersonalizationInput>;
  coppaAgeScreening?: InputMaybe<UserInputCoppaAgeScreeningInput>;
  homeschoolSchoolSetup?: InputMaybe<UserInputHomeschoolSchoolSetupInput>;
  parentalConsent?: InputMaybe<UserInputParentalConsentInput>;
};

export type SignupWorkflow = {
  __typename?: 'SignupWorkflow';
  complete: Array<Maybe<SignupWorkflowStep>>;
  incomplete: Array<Maybe<SignupWorkflowStep>>;
  nextStep?: Maybe<Scalars['String']['output']>;
  notApplicable: Array<Maybe<SignupWorkflowStep>>;
  skipped: Array<Maybe<SignupWorkflowStep>>;
};

export type SignupWorkflowStep = {
  __typename?: 'SignupWorkflowStep';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  key: Scalars['String']['output'];
  skippedAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
};

export type SkillPathSettings = {
  __typename?: 'SkillPathSettings';
  classroomSkillPathConfigs: Array<ClassroomSkillPathConfig>;
  dueDate: Scalars['DateTime']['output'];
  guideLevel?: Maybe<GuideLevel>;
  guideLevelId: Scalars['ID']['output'];
  /**
   * Whether any recipient in this group belongs to an archived class — see
   * `Mandark.Learning.Calculations.ArchivedRecipient`.
   *
   * An edit to a group holding both archived and active recipients must leave the archived ones
   * on their existing settings, so this joins `full_access` as a reason for
   * `Mandark.Learning.SkillPathSettings.Actions.SaveRecipientGroups` to fork the group rather
   * than update it in place. Unlike `full_access` it is not an authorization question: the
   * teacher may well teach every class in the group.
   */
  hasArchivedRecipients?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
  studentSkillPaths: Array<StudentSkillPath>;
  unfilteredGuideLevel: GuideLevel;
};


export type SkillPathSettingsClassroomSkillPathConfigsArgs = {
  filter?: InputMaybe<ClassroomSkillPathConfigFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ClassroomSkillPathConfigSortInput>>>;
};


export type SkillPathSettingsStudentSkillPathsArgs = {
  filter?: InputMaybe<StudentSkillPathFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<StudentSkillPathSortInput>>>;
};

export type SkillPathSettingsFilterDueDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SkillPathSettingsFilterGuideLevelId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type SkillPathSettingsFilterHasArchivedRecipients = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SkillPathSettingsFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type SkillPathSettingsFilterInput = {
  and?: InputMaybe<Array<SkillPathSettingsFilterInput>>;
  classroomSkillPathConfigs?: InputMaybe<ClassroomSkillPathConfigFilterInput>;
  dueDate?: InputMaybe<SkillPathSettingsFilterDueDate>;
  guideLevel?: InputMaybe<GuideLevelFilterInput>;
  guideLevelId?: InputMaybe<SkillPathSettingsFilterGuideLevelId>;
  /**
   * Whether any recipient in this group belongs to an archived class — see
   * `Mandark.Learning.Calculations.ArchivedRecipient`.
   *
   * An edit to a group holding both archived and active recipients must leave the archived ones
   * on their existing settings, so this joins `full_access` as a reason for
   * `Mandark.Learning.SkillPathSettings.Actions.SaveRecipientGroups` to fork the group rather
   * than update it in place. Unlike `full_access` it is not an authorization question: the
   * teacher may well teach every class in the group.
   */
  hasArchivedRecipients?: InputMaybe<SkillPathSettingsFilterHasArchivedRecipients>;
  id?: InputMaybe<SkillPathSettingsFilterId>;
  not?: InputMaybe<Array<SkillPathSettingsFilterInput>>;
  or?: InputMaybe<Array<SkillPathSettingsFilterInput>>;
  startDate?: InputMaybe<SkillPathSettingsFilterStartDate>;
  studentSkillPaths?: InputMaybe<StudentSkillPathFilterInput>;
  unfilteredGuideLevel?: InputMaybe<GuideLevelFilterInput>;
};

export type SkillPathSettingsFilterStartDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum SkillPathSettingsSortField {
  DueDate = 'DUE_DATE',
  GuideLevelId = 'GUIDE_LEVEL_ID',
  HasArchivedRecipients = 'HAS_ARCHIVED_RECIPIENTS',
  Id = 'ID',
  StartDate = 'START_DATE'
}

export type SkillPathSettingsSortInput = {
  field: SkillPathSettingsSortField;
  order?: InputMaybe<SortOrder>;
};

export enum SkillPathStatus {
  Closed = 'CLOSED',
  Open = 'OPEN',
  Scheduled = 'SCHEDULED'
}

/** The result of the :skip_workflow_step mutation */
export type SkipWorkflowStepResult = {
  __typename?: 'SkipWorkflowStepResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<UserWorkflowStep>;
};

export enum SortOrder {
  Asc = 'ASC',
  AscNullsFirst = 'ASC_NULLS_FIRST',
  AscNullsLast = 'ASC_NULLS_LAST',
  Desc = 'DESC',
  DescNullsFirst = 'DESC_NULLS_FIRST',
  DescNullsLast = 'DESC_NULLS_LAST'
}

export type SortableTableSupplementContent = {
  __typename?: 'SortableTableSupplementContent';
  hasTotal: Scalars['Boolean']['output'];
  text: Scalars['String']['output'];
};

export type Standard = {
  __typename?: 'Standard';
  abQuestionCount?: Maybe<Scalars['Int']['output']>;
  caseId?: Maybe<Scalars['ID']['output']>;
  countGuideLevels: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  guideLevels: Array<GuideLevel>;
  hasAlignedQuestions?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  matchesSearch?: Maybe<Scalars['Boolean']['output']>;
  questions: Array<Question>;
  standardSet: StandardSet;
  standardSetId: Scalars['ID']['output'];
  /** The title of the standard set this standard belongs to. Mainly intended for sorting purposes */
  standardSetTitle?: Maybe<Scalars['String']['output']>;
  statusEndDate?: Maybe<Scalars['Date']['output']>;
  statusStartDate?: Maybe<Scalars['Date']['output']>;
  title: Scalars['String']['output'];
  unfilteredGuideLevels: Array<GuideLevel>;
  uri?: Maybe<Scalars['String']['output']>;
};


export type StandardAbQuestionCountArgs = {
  guideLevels?: InputMaybe<Array<Scalars['ID']['input']>>;
  hideAssessmentQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  hidePreviouslyAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  questionDifficulties?: InputMaybe<Array<Scalars['Int']['input']>>;
  questionTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  subjects?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type StandardGuideLevelsArgs = {
  filter?: InputMaybe<GuideLevelFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GuideLevelSortInput>>>;
};


export type StandardMatchesSearchArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type StandardQuestionsArgs = {
  filter?: InputMaybe<QuestionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<QuestionSortInput>>>;
};


export type StandardUnfilteredGuideLevelsArgs = {
  filter?: InputMaybe<GuideLevelFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GuideLevelSortInput>>>;
};

export type StandardAbQuestionCountFieldInput = {
  guideLevels?: InputMaybe<Array<Scalars['ID']['input']>>;
  hideAssessmentQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  hidePreviouslyAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  questionDifficulties?: InputMaybe<Array<Scalars['Int']['input']>>;
  questionTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  subjects?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type StandardBulkCreateInput = {
  caseId?: InputMaybe<Scalars['ID']['input']>;
  description: Scalars['String']['input'];
  standardSetId: Scalars['ID']['input'];
  statusEndDate?: InputMaybe<Scalars['Date']['input']>;
  statusStartDate?: InputMaybe<Scalars['Date']['input']>;
  title: Scalars['String']['input'];
  uri?: InputMaybe<Scalars['String']['input']>;
};

export type StandardFilterCaseId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type StandardFilterCountGuideLevels = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type StandardFilterDescription = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StandardFilterHasAlignedQuestions = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StandardFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type StandardFilterInput = {
  and?: InputMaybe<Array<StandardFilterInput>>;
  caseId?: InputMaybe<StandardFilterCaseId>;
  countGuideLevels?: InputMaybe<StandardFilterCountGuideLevels>;
  description?: InputMaybe<StandardFilterDescription>;
  guideLevels?: InputMaybe<GuideLevelFilterInput>;
  hasAlignedQuestions?: InputMaybe<StandardFilterHasAlignedQuestions>;
  id?: InputMaybe<StandardFilterId>;
  matchesSearch?: InputMaybe<StandardFilterMatchesSearch>;
  not?: InputMaybe<Array<StandardFilterInput>>;
  or?: InputMaybe<Array<StandardFilterInput>>;
  questions?: InputMaybe<QuestionFilterInput>;
  standardSet?: InputMaybe<StandardSetFilterInput>;
  standardSetId?: InputMaybe<StandardFilterStandardSetId>;
  statusEndDate?: InputMaybe<StandardFilterStatusEndDate>;
  statusStartDate?: InputMaybe<StandardFilterStatusStartDate>;
  title?: InputMaybe<StandardFilterTitle>;
  unfilteredGuideLevels?: InputMaybe<GuideLevelFilterInput>;
  uri?: InputMaybe<StandardFilterUri>;
};

export type StandardFilterMatchesSearch = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  input?: InputMaybe<StandardMatchesSearchFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StandardFilterStandardSetId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type StandardFilterStatusEndDate = {
  eq?: InputMaybe<Scalars['Date']['input']>;
  greaterThan?: InputMaybe<Scalars['Date']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Date']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Date']['input']>;
  lessThan?: InputMaybe<Scalars['Date']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Date']['input']>;
  notEq?: InputMaybe<Scalars['Date']['input']>;
};

export type StandardFilterStatusStartDate = {
  eq?: InputMaybe<Scalars['Date']['input']>;
  greaterThan?: InputMaybe<Scalars['Date']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Date']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Date']['input']>;
  lessThan?: InputMaybe<Scalars['Date']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Date']['input']>;
  notEq?: InputMaybe<Scalars['Date']['input']>;
};

export type StandardFilterTitle = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StandardFilterUri = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StandardMatchesSearchFieldInput = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export type StandardSet = {
  __typename?: 'StandardSet';
  abQuestionCount?: Maybe<Scalars['Int']['output']>;
  adoptionStatus?: Maybe<Scalars['String']['output']>;
  caseId?: Maybe<Scalars['ID']['output']>;
  curriculumAreas: Array<CurriculumArea>;
  description?: Maybe<Scalars['String']['output']>;
  /** Whether the standard set contains any standards. A set that does cannot be destroyed. */
  hasStandards?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  matchesSearch?: Maybe<Scalars['Boolean']['output']>;
  officialSourceUrl?: Maybe<Scalars['String']['output']>;
  standardSetCreator?: Maybe<StandardSetCreator>;
  standardSetCreatorId?: Maybe<Scalars['ID']['output']>;
  standards: Array<Standard>;
  statusEndDate?: Maybe<Scalars['Date']['output']>;
  statusStartDate?: Maybe<Scalars['Date']['output']>;
  subjects: Array<Subject>;
  title: Scalars['String']['output'];
  uri?: Maybe<Scalars['String']['output']>;
};


export type StandardSetAbQuestionCountArgs = {
  guideLevels?: InputMaybe<Array<Scalars['ID']['input']>>;
  hideAssessmentQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  hidePreviouslyAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  negateStandardsFilter?: InputMaybe<Scalars['Boolean']['input']>;
  questionDifficulties?: InputMaybe<Array<Scalars['Int']['input']>>;
  questionTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  standards?: InputMaybe<Array<Scalars['ID']['input']>>;
  subjects?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type StandardSetCurriculumAreasArgs = {
  filter?: InputMaybe<CurriculumAreaFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CurriculumAreaSortInput>>>;
};


export type StandardSetMatchesSearchArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type StandardSetStandardsArgs = {
  filter?: InputMaybe<StandardFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<StandardSortInput>>>;
};


export type StandardSetSubjectsArgs = {
  filter?: InputMaybe<SubjectFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SubjectSortInput>>>;
};

export type StandardSetAbQuestionCountFieldInput = {
  guideLevels?: InputMaybe<Array<Scalars['ID']['input']>>;
  hideAssessmentQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  hidePreviouslyAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  negateStandardsFilter?: InputMaybe<Scalars['Boolean']['input']>;
  questionDifficulties?: InputMaybe<Array<Scalars['Int']['input']>>;
  questionTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  standards?: InputMaybe<Array<Scalars['ID']['input']>>;
  subjects?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type StandardSetCreator = {
  __typename?: 'StandardSetCreator';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /**
   * What kind of body publishes this creator's standards. Nullable because the only UI that
   * creates publishers — the Dennis standard set editor — has never collected a type, so rows
   * created through it have none. Feeds the `standard_set_creator_type` analytics dimension.
   */
  type?: Maybe<StandardSetCreatorType>;
};

export type StandardSetCreatorFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type StandardSetCreatorFilterInput = {
  and?: InputMaybe<Array<StandardSetCreatorFilterInput>>;
  id?: InputMaybe<StandardSetCreatorFilterId>;
  name?: InputMaybe<StandardSetCreatorFilterName>;
  not?: InputMaybe<Array<StandardSetCreatorFilterInput>>;
  or?: InputMaybe<Array<StandardSetCreatorFilterInput>>;
  /**
   * What kind of body publishes this creator's standards. Nullable because the only UI that
   * creates publishers — the Dennis standard set editor — has never collected a type, so rows
   * created through it have none. Feeds the `standard_set_creator_type` analytics dimension.
   */
  type?: InputMaybe<StandardSetCreatorFilterType>;
};

export type StandardSetCreatorFilterName = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StandardSetCreatorFilterType = {
  eq?: InputMaybe<StandardSetCreatorType>;
  greaterThan?: InputMaybe<StandardSetCreatorType>;
  greaterThanOrEqual?: InputMaybe<StandardSetCreatorType>;
  in?: InputMaybe<Array<InputMaybe<StandardSetCreatorType>>>;
  isDistinctFrom?: InputMaybe<StandardSetCreatorType>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<StandardSetCreatorType>;
  lessThan?: InputMaybe<StandardSetCreatorType>;
  lessThanOrEqual?: InputMaybe<StandardSetCreatorType>;
  notEq?: InputMaybe<StandardSetCreatorType>;
};

export enum StandardSetCreatorSortField {
  Id = 'ID',
  Name = 'NAME',
  Type = 'TYPE'
}

export type StandardSetCreatorSortInput = {
  field: StandardSetCreatorSortField;
  order?: InputMaybe<SortOrder>;
};

export enum StandardSetCreatorType {
  Internal = 'INTERNAL',
  National = 'NATIONAL',
  State = 'STATE'
}

export type StandardSetFilterAdoptionStatus = {
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type StandardSetFilterCaseId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type StandardSetFilterDescription = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StandardSetFilterHasStandards = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StandardSetFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type StandardSetFilterInput = {
  adoptionStatus?: InputMaybe<StandardSetFilterAdoptionStatus>;
  and?: InputMaybe<Array<StandardSetFilterInput>>;
  caseId?: InputMaybe<StandardSetFilterCaseId>;
  curriculumAreas?: InputMaybe<CurriculumAreaFilterInput>;
  description?: InputMaybe<StandardSetFilterDescription>;
  /** Whether the standard set contains any standards. A set that does cannot be destroyed. */
  hasStandards?: InputMaybe<StandardSetFilterHasStandards>;
  id?: InputMaybe<StandardSetFilterId>;
  matchesSearch?: InputMaybe<StandardSetFilterMatchesSearch>;
  not?: InputMaybe<Array<StandardSetFilterInput>>;
  officialSourceUrl?: InputMaybe<StandardSetFilterOfficialSourceUrl>;
  or?: InputMaybe<Array<StandardSetFilterInput>>;
  standardSetCreator?: InputMaybe<StandardSetCreatorFilterInput>;
  standardSetCreatorId?: InputMaybe<StandardSetFilterStandardSetCreatorId>;
  standards?: InputMaybe<StandardFilterInput>;
  statusEndDate?: InputMaybe<StandardSetFilterStatusEndDate>;
  statusStartDate?: InputMaybe<StandardSetFilterStatusStartDate>;
  subjects?: InputMaybe<SubjectFilterInput>;
  title?: InputMaybe<StandardSetFilterTitle>;
  uri?: InputMaybe<StandardSetFilterUri>;
};

export type StandardSetFilterMatchesSearch = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  input?: InputMaybe<StandardSetMatchesSearchFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StandardSetFilterOfficialSourceUrl = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StandardSetFilterStandardSetCreatorId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type StandardSetFilterStatusEndDate = {
  eq?: InputMaybe<Scalars['Date']['input']>;
  greaterThan?: InputMaybe<Scalars['Date']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Date']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Date']['input']>;
  lessThan?: InputMaybe<Scalars['Date']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Date']['input']>;
  notEq?: InputMaybe<Scalars['Date']['input']>;
};

export type StandardSetFilterStatusStartDate = {
  eq?: InputMaybe<Scalars['Date']['input']>;
  greaterThan?: InputMaybe<Scalars['Date']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Date']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Date']['input']>;
  lessThan?: InputMaybe<Scalars['Date']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Date']['input']>;
  notEq?: InputMaybe<Scalars['Date']['input']>;
};

export type StandardSetFilterTitle = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StandardSetFilterUri = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StandardSetMatchesSearchFieldInput = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export enum StandardSetSortField {
  AdoptionStatus = 'ADOPTION_STATUS',
  CaseId = 'CASE_ID',
  Description = 'DESCRIPTION',
  HasStandards = 'HAS_STANDARDS',
  Id = 'ID',
  MatchesSearch = 'MATCHES_SEARCH',
  OfficialSourceUrl = 'OFFICIAL_SOURCE_URL',
  StandardSetCreatorId = 'STANDARD_SET_CREATOR_ID',
  StatusEndDate = 'STATUS_END_DATE',
  StatusStartDate = 'STATUS_START_DATE',
  Title = 'TITLE',
  Uri = 'URI'
}

export type StandardSetSortInput = {
  abQuestionCountInput?: InputMaybe<StandardSetAbQuestionCountFieldInput>;
  field: StandardSetSortField;
  matchesSearchInput?: InputMaybe<StandardSetMatchesSearchFieldInput>;
  order?: InputMaybe<SortOrder>;
};

export enum StandardSortField {
  CaseId = 'CASE_ID',
  CountGuideLevels = 'COUNT_GUIDE_LEVELS',
  Description = 'DESCRIPTION',
  HasAlignedQuestions = 'HAS_ALIGNED_QUESTIONS',
  Id = 'ID',
  MatchesSearch = 'MATCHES_SEARCH',
  StandardSetId = 'STANDARD_SET_ID',
  StandardSetTitle = 'STANDARD_SET_TITLE',
  StatusEndDate = 'STATUS_END_DATE',
  StatusStartDate = 'STATUS_START_DATE',
  Title = 'TITLE',
  Uri = 'URI'
}

export type StandardSortInput = {
  abQuestionCountInput?: InputMaybe<StandardAbQuestionCountFieldInput>;
  field: StandardSortField;
  matchesSearchInput?: InputMaybe<StandardMatchesSearchFieldInput>;
  order?: InputMaybe<SortOrder>;
};

export type StartAdaptivePracticeInput = {
  guideLevelId: Scalars['ID']['input'];
  repractice?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of the :start_adaptive_practice mutation */
export type StartAdaptivePracticeResult = {
  __typename?: 'StartAdaptivePracticeResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<AdaptivePractice>;
};

/** The result of the :start_student_diagnostic mutation */
export type StartStudentDiagnosticResult = {
  __typename?: 'StartStudentDiagnosticResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<StudentDiagnostic>;
};

export type StripeCard = {
  __typename?: 'StripeCard';
  addressCountry?: Maybe<Scalars['String']['output']>;
  addressZip?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  default?: Maybe<Scalars['Boolean']['output']>;
  expMonth?: Maybe<Scalars['Int']['output']>;
  expYear?: Maybe<Scalars['Int']['output']>;
  fingerprint?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  last4?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<StripeCardMetadata>;
};

export type StripeCardFilterAddressCountry = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StripeCardFilterAddressZip = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StripeCardFilterBrand = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StripeCardFilterDefault = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StripeCardFilterExpMonth = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type StripeCardFilterExpYear = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type StripeCardFilterFingerprint = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StripeCardFilterId = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StripeCardFilterInput = {
  addressCountry?: InputMaybe<StripeCardFilterAddressCountry>;
  addressZip?: InputMaybe<StripeCardFilterAddressZip>;
  and?: InputMaybe<Array<StripeCardFilterInput>>;
  brand?: InputMaybe<StripeCardFilterBrand>;
  default?: InputMaybe<StripeCardFilterDefault>;
  expMonth?: InputMaybe<StripeCardFilterExpMonth>;
  expYear?: InputMaybe<StripeCardFilterExpYear>;
  fingerprint?: InputMaybe<StripeCardFilterFingerprint>;
  id?: InputMaybe<StripeCardFilterId>;
  last4?: InputMaybe<StripeCardFilterLast4>;
  not?: InputMaybe<Array<StripeCardFilterInput>>;
  or?: InputMaybe<Array<StripeCardFilterInput>>;
};

export type StripeCardFilterLast4 = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StripeCardMetadata = {
  __typename?: 'StripeCardMetadata';
  international: Scalars['Boolean']['output'];
};

export type StripeCardResult = {
  __typename?: 'StripeCardResult';
  addressCountry?: Maybe<Scalars['String']['output']>;
  addressZip?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  default?: Maybe<Scalars['Boolean']['output']>;
  expMonth?: Maybe<Scalars['Int']['output']>;
  expYear?: Maybe<Scalars['Int']['output']>;
  fingerprint?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  last4?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<StripeCardMetadata>;
};

export enum StripeCardSortField {
  AddressCountry = 'ADDRESS_COUNTRY',
  AddressZip = 'ADDRESS_ZIP',
  Brand = 'BRAND',
  Default = 'DEFAULT',
  ExpMonth = 'EXP_MONTH',
  ExpYear = 'EXP_YEAR',
  Fingerprint = 'FINGERPRINT',
  Id = 'ID',
  Last4 = 'LAST4'
}

export type StripeCardSortInput = {
  field: StripeCardSortField;
  order?: InputMaybe<SortOrder>;
};

export type StudentAnnotationSet = {
  __typename?: 'StudentAnnotationSet';
  /**
   * The FE `Annotation[]` for this target, verbatim (camelCase, anchor v1).
   * Order is meaningful. Sent as a JSON-encoded string (the `Json` scalar's
   * input form); returned decoded. Limits: 200
   * per target, notes ≤ 2000 characters.
   */
  annotations?: Maybe<Scalars['Json']['output']>;
  assignmentId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  studentId: Scalars['ID']['output'];
  /** The annotated question or supplement. */
  targetId: Scalars['ID']['output'];
  /** Whether `target_id` names a question or a supplement. */
  targetKind: AnnotationTargetKind;
  updatedAt: Scalars['DateTime']['output'];
};

export type StudentAssignment = {
  __typename?: 'StudentAssignment';
  allowLateSubmissions?: Maybe<Scalars['Boolean']['output']>;
  assignmentId: Scalars['ID']['output'];
  assignmentType: Scalars['String']['output'];
  /** Classrooms this assignment is assigned in where the student is actively enrolled. */
  classrooms: Array<ClassroomsClassroom>;
  /** Whether the assignment contains any manually-graded questions (rubric type in Grading.Rubric.manually_graded_types/0, e.g. criteria) — the questions whose grades are gated by teacher release. */
  containsManuallyGradedQuestions?: Maybe<Scalars['Boolean']['output']>;
  correctAnswerSetting?: Maybe<Scalars['String']['output']>;
  /**
   * Whether the assignment's correct-answer setting currently allows showing guess
   * correctness/evaluations to this student: showAfterAll requires the student to
   * have submitted; showAfterDueDate requires the due date to have passed; every
   * other setting (or none) is always visible.
   */
  correctnessVisible?: Maybe<Scalars['Boolean']['output']>;
  countOfQuestions?: Maybe<Scalars['Int']['output']>;
  countOfScoredQuestions: Scalars['Int']['output'];
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  dueDateProximity?: Maybe<Scalars['Int']['output']>;
  grade?: Maybe<Scalars['Float']['output']>;
  /** Whether finalized grades are viewable by the student for this assignment: true when the assignment has no manually-graded questions to gate, or when any classroom_assignment for an enrolled classroom has grades_released_at set. */
  gradesReleased?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the assignment has started, cascading from student settings to classroom settings. */
  hasStarted?: Maybe<Scalars['Boolean']['output']>;
  hasSubmitted?: Maybe<Scalars['Boolean']['output']>;
  /**
   * True if any finalized (published) guess on a manually-graded question carries
   * non-blank written feedback (overall_feedback or any criteria_scores[].feedback).
   * Deliberately NOT gated on release or correct-answer visibility — compose with
   * grades_released and correctness_visible when filtering student-facing views
   * (e.g. unread grades: has_written_feedback AND grades_released AND
   * correctness_visible AND NOT student_has_seen_evaluation).
   */
  hasWrittenFeedback?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** Whether the student can still submit. True when not submitted and either no due date, due date is in the future, or due date is past but late submissions are allowed. */
  isOpen?: Maybe<Scalars['Boolean']['output']>;
  /** The reason the assignment was auto-submitted by lockdown mode. nil means not auto-submitted. */
  lockdownAutoSubmitReason?: Maybe<StudentAssignmentLockdownAutoSubmitReason>;
  /** Chronological list of lockdown violations. Each entry is a map with `type` and `recorded_at` keys. */
  lockdownViolations: Scalars['Json']['output'];
  name: Scalars['String']['output'];
  partialCreditEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Set when a teacher resets submission status; cleared by the `resume_after_reset` action when the student re-engages. Used by the FE to suppress the lockdown session-interrupted check on the post-reset retake. */
  resetAt?: Maybe<Scalars['DateTime']['output']>;
  settings?: Maybe<StudentAssignmentSettings>;
  /** The time the assignment becomes available to the student */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** The time the student actually began working on the assignment */
  startTime?: Maybe<Scalars['DateTime']['output']>;
  /** The current status of the assignment for the student, calculated based on submission status, due date, late submission policy, and start time. */
  status?: Maybe<StudentAssignmentStatus>;
  student: User;
  /**
   * Whether the student has seen the current grade/evaluation; true by
   * default (nothing new to review). Set to false whenever a teacher
   * finalizes a grade (publish_grade), regardless of release state —
   * visibility composes at query time (grades_released,
   * correctness_visible); set back to true only by the student via
   * mark_evaluation_seen.
   */
  studentHasSeenEvaluation: Scalars['Boolean']['output'];
  studentId: Scalars['ID']['output'];
  submitted?: Maybe<Scalars['DateTime']['output']>;
};


export type StudentAssignmentClassroomsArgs = {
  filter?: InputMaybe<ClassroomsClassroomFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ClassroomsClassroomSortInput>>>;
};

export type StudentAssignmentFilterAllowLateSubmissions = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudentAssignmentFilterAssignmentId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type StudentAssignmentFilterAssignmentType = {
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAssignmentFilterContainsManuallyGradedQuestions = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudentAssignmentFilterCorrectAnswerSetting = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAssignmentFilterCorrectnessVisible = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudentAssignmentFilterCountOfQuestions = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type StudentAssignmentFilterCountOfScoredQuestions = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type StudentAssignmentFilterDueDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StudentAssignmentFilterDueDateProximity = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type StudentAssignmentFilterGradesReleased = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudentAssignmentFilterHasStarted = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudentAssignmentFilterHasSubmitted = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudentAssignmentFilterHasWrittenFeedback = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudentAssignmentFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type StudentAssignmentFilterInput = {
  allowLateSubmissions?: InputMaybe<StudentAssignmentFilterAllowLateSubmissions>;
  and?: InputMaybe<Array<StudentAssignmentFilterInput>>;
  assignmentId?: InputMaybe<StudentAssignmentFilterAssignmentId>;
  assignmentType?: InputMaybe<StudentAssignmentFilterAssignmentType>;
  /** Classrooms this assignment is assigned in where the student is actively enrolled. */
  classrooms?: InputMaybe<ClassroomsClassroomFilterInput>;
  /** Whether the assignment contains any manually-graded questions (rubric type in Grading.Rubric.manually_graded_types/0, e.g. criteria) — the questions whose grades are gated by teacher release. */
  containsManuallyGradedQuestions?: InputMaybe<StudentAssignmentFilterContainsManuallyGradedQuestions>;
  correctAnswerSetting?: InputMaybe<StudentAssignmentFilterCorrectAnswerSetting>;
  /**
   * Whether the assignment's correct-answer setting currently allows showing guess
   * correctness/evaluations to this student: showAfterAll requires the student to
   * have submitted; showAfterDueDate requires the due date to have passed; every
   * other setting (or none) is always visible.
   */
  correctnessVisible?: InputMaybe<StudentAssignmentFilterCorrectnessVisible>;
  countOfQuestions?: InputMaybe<StudentAssignmentFilterCountOfQuestions>;
  countOfScoredQuestions?: InputMaybe<StudentAssignmentFilterCountOfScoredQuestions>;
  dueDate?: InputMaybe<StudentAssignmentFilterDueDate>;
  dueDateProximity?: InputMaybe<StudentAssignmentFilterDueDateProximity>;
  /** Whether finalized grades are viewable by the student for this assignment: true when the assignment has no manually-graded questions to gate, or when any classroom_assignment for an enrolled classroom has grades_released_at set. */
  gradesReleased?: InputMaybe<StudentAssignmentFilterGradesReleased>;
  /** Whether the assignment has started, cascading from student settings to classroom settings. */
  hasStarted?: InputMaybe<StudentAssignmentFilterHasStarted>;
  hasSubmitted?: InputMaybe<StudentAssignmentFilterHasSubmitted>;
  /**
   * True if any finalized (published) guess on a manually-graded question carries
   * non-blank written feedback (overall_feedback or any criteria_scores[].feedback).
   * Deliberately NOT gated on release or correct-answer visibility — compose with
   * grades_released and correctness_visible when filtering student-facing views
   * (e.g. unread grades: has_written_feedback AND grades_released AND
   * correctness_visible AND NOT student_has_seen_evaluation).
   */
  hasWrittenFeedback?: InputMaybe<StudentAssignmentFilterHasWrittenFeedback>;
  id?: InputMaybe<StudentAssignmentFilterId>;
  /** Whether the student can still submit. True when not submitted and either no due date, due date is in the future, or due date is past but late submissions are allowed. */
  isOpen?: InputMaybe<StudentAssignmentFilterIsOpen>;
  /** The reason the assignment was auto-submitted by lockdown mode. nil means not auto-submitted. */
  lockdownAutoSubmitReason?: InputMaybe<StudentAssignmentFilterLockdownAutoSubmitReason>;
  /** Chronological list of lockdown violations. Each entry is a map with `type` and `recorded_at` keys. */
  lockdownViolations?: InputMaybe<StudentAssignmentFilterLockdownViolations>;
  name?: InputMaybe<StudentAssignmentFilterName>;
  not?: InputMaybe<Array<StudentAssignmentFilterInput>>;
  or?: InputMaybe<Array<StudentAssignmentFilterInput>>;
  partialCreditEnabled?: InputMaybe<StudentAssignmentFilterPartialCreditEnabled>;
  /** Set when a teacher resets submission status; cleared by the `resume_after_reset` action when the student re-engages. Used by the FE to suppress the lockdown session-interrupted check on the post-reset retake. */
  resetAt?: InputMaybe<StudentAssignmentFilterResetAt>;
  settings?: InputMaybe<StudentAssignmentFilterSettings>;
  /** The time the assignment becomes available to the student */
  startDate?: InputMaybe<StudentAssignmentFilterStartDate>;
  /** The time the student actually began working on the assignment */
  startTime?: InputMaybe<StudentAssignmentFilterStartTime>;
  /** The current status of the assignment for the student, calculated based on submission status, due date, late submission policy, and start time. */
  status?: InputMaybe<StudentAssignmentFilterStatus>;
  student?: InputMaybe<UserFilterInput>;
  /**
   * Whether the student has seen the current grade/evaluation; true by
   * default (nothing new to review). Set to false whenever a teacher
   * finalizes a grade (publish_grade), regardless of release state —
   * visibility composes at query time (grades_released,
   * correctness_visible); set back to true only by the student via
   * mark_evaluation_seen.
   */
  studentHasSeenEvaluation?: InputMaybe<StudentAssignmentFilterStudentHasSeenEvaluation>;
  studentId?: InputMaybe<StudentAssignmentFilterStudentId>;
  submitted?: InputMaybe<StudentAssignmentFilterSubmitted>;
};

export type StudentAssignmentFilterIsOpen = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudentAssignmentFilterLockdownAutoSubmitReason = {
  eq?: InputMaybe<StudentAssignmentLockdownAutoSubmitReason>;
  greaterThan?: InputMaybe<StudentAssignmentLockdownAutoSubmitReason>;
  greaterThanOrEqual?: InputMaybe<StudentAssignmentLockdownAutoSubmitReason>;
  in?: InputMaybe<Array<InputMaybe<StudentAssignmentLockdownAutoSubmitReason>>>;
  isDistinctFrom?: InputMaybe<StudentAssignmentLockdownAutoSubmitReason>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<StudentAssignmentLockdownAutoSubmitReason>;
  lessThan?: InputMaybe<StudentAssignmentLockdownAutoSubmitReason>;
  lessThanOrEqual?: InputMaybe<StudentAssignmentLockdownAutoSubmitReason>;
  notEq?: InputMaybe<StudentAssignmentLockdownAutoSubmitReason>;
};

export type StudentAssignmentFilterLockdownViolations = {
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudentAssignmentFilterName = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAssignmentFilterPartialCreditEnabled = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudentAssignmentFilterResetAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StudentAssignmentFilterSettings = {
  eq?: InputMaybe<StudentAssignmentSettingsInput>;
  greaterThan?: InputMaybe<StudentAssignmentSettingsInput>;
  greaterThanOrEqual?: InputMaybe<StudentAssignmentSettingsInput>;
  in?: InputMaybe<Array<InputMaybe<StudentAssignmentSettingsInput>>>;
  isDistinctFrom?: InputMaybe<StudentAssignmentSettingsInput>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<StudentAssignmentSettingsInput>;
  lessThan?: InputMaybe<StudentAssignmentSettingsInput>;
  lessThanOrEqual?: InputMaybe<StudentAssignmentSettingsInput>;
  notEq?: InputMaybe<StudentAssignmentSettingsInput>;
};

export type StudentAssignmentFilterStartDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StudentAssignmentFilterStartTime = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StudentAssignmentFilterStatus = {
  eq?: InputMaybe<StudentAssignmentStatus>;
  greaterThan?: InputMaybe<StudentAssignmentStatus>;
  greaterThanOrEqual?: InputMaybe<StudentAssignmentStatus>;
  in?: InputMaybe<Array<StudentAssignmentStatus>>;
  isDistinctFrom?: InputMaybe<StudentAssignmentStatus>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<StudentAssignmentStatus>;
  lessThan?: InputMaybe<StudentAssignmentStatus>;
  lessThanOrEqual?: InputMaybe<StudentAssignmentStatus>;
  notEq?: InputMaybe<StudentAssignmentStatus>;
};

export type StudentAssignmentFilterStudentHasSeenEvaluation = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudentAssignmentFilterStudentId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type StudentAssignmentFilterSubmitted = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum StudentAssignmentLockdownAutoSubmitReason {
  CountdownTimeout = 'COUNTDOWN_TIMEOUT',
  SessionInterrupted = 'SESSION_INTERRUPTED',
  ViolationsExceeded = 'VIOLATIONS_EXCEEDED'
}

export type StudentAssignmentSettings = {
  __typename?: 'StudentAssignmentSettings';
  allowLateSubmissions: Scalars['Boolean']['output'];
  autoAssignNewClassroomEnrollees?: Maybe<Scalars['Boolean']['output']>;
  calculatorSetting?: Maybe<AssignmentCalculatorSetting>;
  correctAnswerSetting: Scalars['String']['output'];
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  lockdownModeEnabled?: Maybe<Scalars['Boolean']['output']>;
  ltiLineItemId?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  randomizeQuestionOrder?: Maybe<Scalars['Boolean']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  timeLimit?: Maybe<Scalars['Int']['output']>;
  translationAccess?: Maybe<Scalars['Boolean']['output']>;
};

export type StudentAssignmentSettingsInput = {
  allowLateSubmissions: Scalars['Boolean']['input'];
  autoAssignNewClassroomEnrollees?: InputMaybe<Scalars['Boolean']['input']>;
  calculatorSetting?: InputMaybe<AssignmentCalculatorSetting>;
  correctAnswerSetting: Scalars['String']['input'];
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  lockdownModeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  ltiLineItemId?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  randomizeQuestionOrder?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  timeLimit?: InputMaybe<Scalars['Int']['input']>;
  translationAccess?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum StudentAssignmentSortField {
  AllowLateSubmissions = 'ALLOW_LATE_SUBMISSIONS',
  AssignmentId = 'ASSIGNMENT_ID',
  AssignmentType = 'ASSIGNMENT_TYPE',
  ContainsManuallyGradedQuestions = 'CONTAINS_MANUALLY_GRADED_QUESTIONS',
  CorrectnessVisible = 'CORRECTNESS_VISIBLE',
  CorrectAnswerSetting = 'CORRECT_ANSWER_SETTING',
  CountOfQuestions = 'COUNT_OF_QUESTIONS',
  CountOfScoredQuestions = 'COUNT_OF_SCORED_QUESTIONS',
  DueDate = 'DUE_DATE',
  DueDateProximity = 'DUE_DATE_PROXIMITY',
  GradesReleased = 'GRADES_RELEASED',
  HasStarted = 'HAS_STARTED',
  HasSubmitted = 'HAS_SUBMITTED',
  HasWrittenFeedback = 'HAS_WRITTEN_FEEDBACK',
  Id = 'ID',
  IsOpen = 'IS_OPEN',
  LockdownAutoSubmitReason = 'LOCKDOWN_AUTO_SUBMIT_REASON',
  LockdownViolations = 'LOCKDOWN_VIOLATIONS',
  Name = 'NAME',
  PartialCreditEnabled = 'PARTIAL_CREDIT_ENABLED',
  ResetAt = 'RESET_AT',
  Settings = 'SETTINGS',
  StartDate = 'START_DATE',
  StartTime = 'START_TIME',
  Status = 'STATUS',
  StudentHasSeenEvaluation = 'STUDENT_HAS_SEEN_EVALUATION',
  StudentId = 'STUDENT_ID',
  Submitted = 'SUBMITTED'
}

export type StudentAssignmentSortInput = {
  field: StudentAssignmentSortField;
  order?: InputMaybe<SortOrder>;
};

export enum StudentAssignmentStatus {
  Closed = 'CLOSED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  PastDue = 'PAST_DUE'
}

export type StudentDiagnostic = {
  __typename?: 'StudentDiagnostic';
  /**
   * Whether the class this student was assigned through is archived — see
   * `Mandark.Assignments.Calculations.ArchivedRecipient`. This is what makes a student added via an
   * archived class an archived recipient, whatever their other enrolments.
   */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether this student can work on the diagnostic right now, and if not, why:
   * `:open` when it is available to work on, `:completed` once the student has finished it,
   * `:not_yet_started` before its assigned window opens, `:window_closed` after that window ends,
   * and `:timer_expired` when its time limit has run out. Completion takes precedence, so a student
   * who finished sees `:completed` even after the window or timer has passed.
   */
  availability?: Maybe<StudentDiagnosticAvailability>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  currentQuestion?: Maybe<Question>;
  currentQuestionId?: Maybe<Scalars['ID']['output']>;
  currentSkill?: Maybe<GuideLevel>;
  currentSkillId?: Maybe<Scalars['ID']['output']>;
  diagnostic: Diagnostic;
  diagnosticId: Scalars['ID']['output'];
  diagnosticSettings: DiagnosticSettings;
  diagnosticSettingsId: Scalars['ID']['output'];
  /**
   * The classroom the student's assignment is associated with. This serves 2 main purposes:
   * signaling to the FE which classroom to display the student's assignment under in cases where that student shows up in multiple assigned classrooms,
   * and gating which teachers can change that student's settings.
   *
   * Students can ONLY be assigned via 1 classroom. i.e. for a given diagnostic_id + student_id combination, there can only be 1 StudentDiagnostic record,
   * so if the student is in multiple classrooms, only 1 of those classrooms can be the source of the assignment.
   */
  enrolledViaClassroom: ClassroomsClassroom;
  enrolledViaClassroomId: Scalars['ID']['output'];
  /**
   * The wall-clock instant this student's timer runs out: `started_at` plus the recipient group's
   * `time_limit` (in minutes). Null when the student hasn't started or the group has no time limit.
   * The countdown is continuous — it keeps running whether or not the student is in the diagnostic,
   * so the client counts down to this instant rather than tracking elapsed time itself. Carries the
   * same microsecond precision as `started_at`, so it and `out_of_time` agree to the instant.
   */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** Whether the diagnostic is currently open for this student to work on; true exactly when `availability` is `:open`. */
  isOpen?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether this student's timer has run out (`now >= expires_at`). Always false when there is no
   * time limit or the student hasn't started. Defined in terms of `expires_at` so the two can never
   * disagree. This is the timer's contribution to Part 7's open/closed determination — the
   * lowest-priority closed reason (out of time).
   */
  outOfTime?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Set when a teacher resets this student's timer (`:reset_timer`), which clears `started_at`
   * back to not-started while preserving progress. Distinguishes a reset student — who is told
   * their timer was reset and must explicitly `:resume` — from one who simply never started.
   * Cleared by `:resume` when the student re-engages, restarting the full countdown.
   */
  resetAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Internal-only audit of the adaptive scoring engine's state for this session —
   * per-skill belief (μ, σ_belief), per-difficulty probabilities, the classification
   * each skill would receive if it terminated now, and the full attempt history with
   * the model's prediction before each answer.
   *
   * Null unless the `diagnostic_scoring_debug` feature flag is enabled for the
   * requesting user: it reveals per-question correctness, which students must not see
   * while taking a diagnostic.
   */
  scoringAudit?: Maybe<DiagnosticScoringAudit>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<StudentDiagnosticStatus>;
  student: User;
  studentId: Scalars['ID']['output'];
};

export enum StudentDiagnosticAvailability {
  Completed = 'COMPLETED',
  NotYetStarted = 'NOT_YET_STARTED',
  Open = 'OPEN',
  TimerExpired = 'TIMER_EXPIRED',
  WindowClosed = 'WINDOW_CLOSED'
}

export type StudentDiagnosticFilterArchived = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudentDiagnosticFilterAvailability = {
  eq?: InputMaybe<StudentDiagnosticAvailability>;
  greaterThan?: InputMaybe<StudentDiagnosticAvailability>;
  greaterThanOrEqual?: InputMaybe<StudentDiagnosticAvailability>;
  in?: InputMaybe<Array<StudentDiagnosticAvailability>>;
  isDistinctFrom?: InputMaybe<StudentDiagnosticAvailability>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<StudentDiagnosticAvailability>;
  lessThan?: InputMaybe<StudentDiagnosticAvailability>;
  lessThanOrEqual?: InputMaybe<StudentDiagnosticAvailability>;
  notEq?: InputMaybe<StudentDiagnosticAvailability>;
};

export type StudentDiagnosticFilterCompletedAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StudentDiagnosticFilterCurrentQuestionId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type StudentDiagnosticFilterCurrentSkillId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type StudentDiagnosticFilterDiagnosticId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type StudentDiagnosticFilterDiagnosticSettingsId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type StudentDiagnosticFilterEnrolledViaClassroomId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type StudentDiagnosticFilterExpiresAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StudentDiagnosticFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type StudentDiagnosticFilterInput = {
  and?: InputMaybe<Array<StudentDiagnosticFilterInput>>;
  /**
   * Whether the class this student was assigned through is archived — see
   * `Mandark.Assignments.Calculations.ArchivedRecipient`. This is what makes a student added via an
   * archived class an archived recipient, whatever their other enrolments.
   */
  archived?: InputMaybe<StudentDiagnosticFilterArchived>;
  /**
   * Whether this student can work on the diagnostic right now, and if not, why:
   * `:open` when it is available to work on, `:completed` once the student has finished it,
   * `:not_yet_started` before its assigned window opens, `:window_closed` after that window ends,
   * and `:timer_expired` when its time limit has run out. Completion takes precedence, so a student
   * who finished sees `:completed` even after the window or timer has passed.
   */
  availability?: InputMaybe<StudentDiagnosticFilterAvailability>;
  completedAt?: InputMaybe<StudentDiagnosticFilterCompletedAt>;
  currentQuestion?: InputMaybe<QuestionFilterInput>;
  currentQuestionId?: InputMaybe<StudentDiagnosticFilterCurrentQuestionId>;
  currentSkill?: InputMaybe<GuideLevelFilterInput>;
  currentSkillId?: InputMaybe<StudentDiagnosticFilterCurrentSkillId>;
  diagnostic?: InputMaybe<DiagnosticFilterInput>;
  diagnosticId?: InputMaybe<StudentDiagnosticFilterDiagnosticId>;
  diagnosticSettings?: InputMaybe<DiagnosticSettingsFilterInput>;
  diagnosticSettingsId?: InputMaybe<StudentDiagnosticFilterDiagnosticSettingsId>;
  /**
   * The classroom the student's assignment is associated with. This serves 2 main purposes:
   * signaling to the FE which classroom to display the student's assignment under in cases where that student shows up in multiple assigned classrooms,
   * and gating which teachers can change that student's settings.
   *
   * Students can ONLY be assigned via 1 classroom. i.e. for a given diagnostic_id + student_id combination, there can only be 1 StudentDiagnostic record,
   * so if the student is in multiple classrooms, only 1 of those classrooms can be the source of the assignment.
   */
  enrolledViaClassroom?: InputMaybe<ClassroomsClassroomFilterInput>;
  enrolledViaClassroomId?: InputMaybe<StudentDiagnosticFilterEnrolledViaClassroomId>;
  /**
   * The wall-clock instant this student's timer runs out: `started_at` plus the recipient group's
   * `time_limit` (in minutes). Null when the student hasn't started or the group has no time limit.
   * The countdown is continuous — it keeps running whether or not the student is in the diagnostic,
   * so the client counts down to this instant rather than tracking elapsed time itself. Carries the
   * same microsecond precision as `started_at`, so it and `out_of_time` agree to the instant.
   */
  expiresAt?: InputMaybe<StudentDiagnosticFilterExpiresAt>;
  id?: InputMaybe<StudentDiagnosticFilterId>;
  /** Whether the diagnostic is currently open for this student to work on; true exactly when `availability` is `:open`. */
  isOpen?: InputMaybe<StudentDiagnosticFilterIsOpen>;
  not?: InputMaybe<Array<StudentDiagnosticFilterInput>>;
  or?: InputMaybe<Array<StudentDiagnosticFilterInput>>;
  /**
   * Whether this student's timer has run out (`now >= expires_at`). Always false when there is no
   * time limit or the student hasn't started. Defined in terms of `expires_at` so the two can never
   * disagree. This is the timer's contribution to Part 7's open/closed determination — the
   * lowest-priority closed reason (out of time).
   */
  outOfTime?: InputMaybe<StudentDiagnosticFilterOutOfTime>;
  /**
   * Set when a teacher resets this student's timer (`:reset_timer`), which clears `started_at`
   * back to not-started while preserving progress. Distinguishes a reset student — who is told
   * their timer was reset and must explicitly `:resume` — from one who simply never started.
   * Cleared by `:resume` when the student re-engages, restarting the full countdown.
   */
  resetAt?: InputMaybe<StudentDiagnosticFilterResetAt>;
  startedAt?: InputMaybe<StudentDiagnosticFilterStartedAt>;
  status?: InputMaybe<StudentDiagnosticFilterStatus>;
  student?: InputMaybe<UserFilterInput>;
  studentId?: InputMaybe<StudentDiagnosticFilterStudentId>;
};

export type StudentDiagnosticFilterIsOpen = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudentDiagnosticFilterOutOfTime = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudentDiagnosticFilterResetAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StudentDiagnosticFilterStartedAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StudentDiagnosticFilterStatus = {
  eq?: InputMaybe<StudentDiagnosticStatus>;
  greaterThan?: InputMaybe<StudentDiagnosticStatus>;
  greaterThanOrEqual?: InputMaybe<StudentDiagnosticStatus>;
  in?: InputMaybe<Array<StudentDiagnosticStatus>>;
  isDistinctFrom?: InputMaybe<StudentDiagnosticStatus>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<StudentDiagnosticStatus>;
  lessThan?: InputMaybe<StudentDiagnosticStatus>;
  lessThanOrEqual?: InputMaybe<StudentDiagnosticStatus>;
  notEq?: InputMaybe<StudentDiagnosticStatus>;
};

export type StudentDiagnosticFilterStudentId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export enum StudentDiagnosticSortField {
  Archived = 'ARCHIVED',
  Availability = 'AVAILABILITY',
  CompletedAt = 'COMPLETED_AT',
  CurrentQuestionId = 'CURRENT_QUESTION_ID',
  CurrentSkillId = 'CURRENT_SKILL_ID',
  DiagnosticId = 'DIAGNOSTIC_ID',
  DiagnosticSettingsId = 'DIAGNOSTIC_SETTINGS_ID',
  EnrolledViaClassroomId = 'ENROLLED_VIA_CLASSROOM_ID',
  ExpiresAt = 'EXPIRES_AT',
  Id = 'ID',
  IsOpen = 'IS_OPEN',
  OutOfTime = 'OUT_OF_TIME',
  ResetAt = 'RESET_AT',
  StartedAt = 'STARTED_AT',
  Status = 'STATUS',
  StudentId = 'STUDENT_ID'
}

export type StudentDiagnosticSortInput = {
  field: StudentDiagnosticSortField;
  order?: InputMaybe<SortOrder>;
};

export enum StudentDiagnosticStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

export type StudentSkillPath = {
  __typename?: 'StudentSkillPath';
  /**
   * Whether the class this student was assigned through is archived — see
   * `Mandark.Learning.Calculations.ArchivedRecipient`. This is what makes a student added via an
   * archived class an archived recipient, whatever their other enrolments.
   */
  archived?: Maybe<Scalars['Boolean']['output']>;
  classroom: ClassroomsClassroom;
  classroomId: Scalars['ID']['output'];
  guideLevel?: Maybe<GuideLevel>;
  guideLevelId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  skillPathSettings: SkillPathSettings;
  skillPathSettingsId: Scalars['ID']['output'];
  student: User;
  studentId: Scalars['ID']['output'];
  unfilteredGuideLevel: GuideLevel;
};


export type StudentSkillPathSkillPathSettingsArgs = {
  asEducatorId?: InputMaybe<Scalars['ID']['input']>;
};

export type StudentSkillPathFilterArchived = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudentSkillPathFilterClassroomId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type StudentSkillPathFilterGuideLevelId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type StudentSkillPathFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type StudentSkillPathFilterInput = {
  and?: InputMaybe<Array<StudentSkillPathFilterInput>>;
  /**
   * Whether the class this student was assigned through is archived — see
   * `Mandark.Learning.Calculations.ArchivedRecipient`. This is what makes a student added via an
   * archived class an archived recipient, whatever their other enrolments.
   */
  archived?: InputMaybe<StudentSkillPathFilterArchived>;
  classroom?: InputMaybe<ClassroomsClassroomFilterInput>;
  classroomId?: InputMaybe<StudentSkillPathFilterClassroomId>;
  guideLevel?: InputMaybe<GuideLevelFilterInput>;
  guideLevelId?: InputMaybe<StudentSkillPathFilterGuideLevelId>;
  id?: InputMaybe<StudentSkillPathFilterId>;
  not?: InputMaybe<Array<StudentSkillPathFilterInput>>;
  or?: InputMaybe<Array<StudentSkillPathFilterInput>>;
  skillPathSettings?: InputMaybe<SkillPathSettingsFilterInput>;
  skillPathSettingsId?: InputMaybe<StudentSkillPathFilterSkillPathSettingsId>;
  student?: InputMaybe<UserFilterInput>;
  studentId?: InputMaybe<StudentSkillPathFilterStudentId>;
  unfilteredGuideLevel?: InputMaybe<GuideLevelFilterInput>;
};

export type StudentSkillPathFilterSkillPathSettingsId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type StudentSkillPathFilterStudentId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export enum StudentSkillPathSortField {
  Archived = 'ARCHIVED',
  ClassroomId = 'CLASSROOM_ID',
  GuideLevelId = 'GUIDE_LEVEL_ID',
  Id = 'ID',
  SkillPathSettingsId = 'SKILL_PATH_SETTINGS_ID',
  StudentId = 'STUDENT_ID'
}

export type StudentSkillPathSortInput = {
  field: StudentSkillPathSortField;
  order?: InputMaybe<SortOrder>;
};

export type Subject = {
  __typename?: 'Subject';
  abQuestionCount?: Maybe<Scalars['Int']['output']>;
  adaptive: Scalars['Boolean']['output'];
  /**
   * The adaptive advance threshold for every skill in this subject, if any. Resolved the same
   * way as `adaptive_range`.
   */
  adaptiveAdvanceThreshold?: Maybe<Scalars['Int']['output']>;
  /**
   * The adaptive fallback threshold for every skill in this subject, if any. Resolved the same
   * way as `adaptive_range`.
   */
  adaptiveFallbackThreshold?: Maybe<Scalars['Int']['output']>;
  /**
   * The diagnostic scoring engine's k-factor (learning rate) for every skill in this subject,
   * if any. Resolved the same way as `adaptive_range`.
   */
  adaptiveKFactor?: Maybe<Scalars['Float']['output']>;
  /**
   * The adaptive range setting for every skill in this subject, if any. Skills, their
   * ancestors, and their guide override it; the global default backs it up. Read the effective
   * value from a guide level's `effective_adaptive_range` calculation rather than here.
   */
  adaptiveRange?: Maybe<Scalars['Int']['output']>;
  alternateName?: Maybe<Scalars['String']['output']>;
  badge?: Maybe<Scalars['String']['output']>;
  banner?: Maybe<Scalars['String']['output']>;
  belongsToStandard?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  countOfDifficultQuestions?: Maybe<Scalars['Int']['output']>;
  countOfEasyQuestions?: Maybe<Scalars['Int']['output']>;
  countOfFreeResponseQuestions?: Maybe<Scalars['Int']['output']>;
  countOfMediumQuestions?: Maybe<Scalars['Int']['output']>;
  countOfQuestions?: Maybe<Scalars['Int']['output']>;
  curriculumArea?: Maybe<CurriculumArea>;
  curriculumAreaId?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  featuredAs?: Maybe<Scalars['String']['output']>;
  footerText?: Maybe<Scalars['String']['output']>;
  freeResponseQuestionsPublished: Scalars['Boolean']['output'];
  guides: Array<Guide>;
  hasAccessViaLicense?: Maybe<Scalars['Boolean']['output']>;
  hasAccessViaLicenseAsStudent?: Maybe<Scalars['Boolean']['output']>;
  hasAccessViaLicenseAsTeacher?: Maybe<Scalars['Boolean']['output']>;
  hasAccessViaSubscription?: Maybe<Scalars['Boolean']['output']>;
  hasFreeAccess?: Maybe<Scalars['Boolean']['output']>;
  hasFreeAccessAsStudent?: Maybe<Scalars['Boolean']['output']>;
  hasFreeAccessAsTeacher?: Maybe<Scalars['Boolean']['output']>;
  hasRestrictedFreePractice?: Maybe<Scalars['Boolean']['output']>;
  hidden: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  includedInPersonalizationSettings?: Maybe<Scalars['Boolean']['output']>;
  logoImageUrl?: Maybe<Scalars['String']['output']>;
  /** Whether the subject matches the given search term. searchFields may be any of name, description. Defaults to name. */
  matchesSearch?: Maybe<Scalars['Boolean']['output']>;
  matchingGuideLevelsSearchCount?: Maybe<Scalars['Int']['output']>;
  /** The subscriptions for this subject that belong to the current user. */
  mySubscriptions: Array<RetailSubscription>;
  name: Scalars['String']['output'];
  published: Scalars['Boolean']['output'];
  /**
   * The search relevance score for the subject given the search term. Use include_description to also match on description.
   * This should be used mostly for sorting. For filtering, use the `matches_search` calculation, which is more efficient.
   */
  searchRelevance?: Maybe<Scalars['Float']['output']>;
  shouldShowLabelTable: Scalars['Boolean']['output'];
  studentClassroomSubjects: Array<ClassroomSubject>;
  subjectFaqs: Array<SubjectFaq>;
  subscriptionsPrices?: Maybe<Array<Scalars['JsonString']['output']>>;
  tagCategories: Array<TagCategory>;
  translateQuestions: Scalars['Boolean']['output'];
  translateSupplements: Scalars['Boolean']['output'];
  type: SubjectType;
  unfilteredGuides: Array<Guide>;
  urlSlug: Scalars['String']['output'];
  userHasAccess?: Maybe<Scalars['Boolean']['output']>;
};


export type SubjectAbQuestionCountArgs = {
  guideLevels?: InputMaybe<Array<Scalars['ID']['input']>>;
  hideAssessmentQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  hidePreviouslyAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  questionDifficulties?: InputMaybe<Array<Scalars['Int']['input']>>;
  questionTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  standardSets?: InputMaybe<Array<Scalars['ID']['input']>>;
  standards?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type SubjectBelongsToStandardArgs = {
  standardId: Scalars['ID']['input'];
};


export type SubjectGuidesArgs = {
  filter?: InputMaybe<GuideFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GuideSortInput>>>;
};


export type SubjectMatchesSearchArgs = {
  search: Scalars['String']['input'];
  searchFields?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SubjectMatchingGuideLevelsSearchCountArgs = {
  search: Scalars['String']['input'];
};


export type SubjectMySubscriptionsArgs = {
  filter?: InputMaybe<RetailSubscriptionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<RetailSubscriptionSortInput>>>;
};


export type SubjectSearchRelevanceArgs = {
  includeDescription?: InputMaybe<Scalars['Boolean']['input']>;
  search: Scalars['String']['input'];
};


export type SubjectStudentClassroomSubjectsArgs = {
  filter?: InputMaybe<ClassroomSubjectFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ClassroomSubjectSortInput>>>;
};


export type SubjectSubjectFaqsArgs = {
  filter?: InputMaybe<SubjectFaqFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SubjectFaqSortInput>>>;
};


export type SubjectTagCategoriesArgs = {
  filter?: InputMaybe<TagCategoryFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TagCategorySortInput>>>;
};


export type SubjectUnfilteredGuidesArgs = {
  filter?: InputMaybe<GuideFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GuideSortInput>>>;
};

export type SubjectAbQuestionCountFieldInput = {
  guideLevels?: InputMaybe<Array<Scalars['ID']['input']>>;
  hideAssessmentQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  hidePreviouslyAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  questionDifficulties?: InputMaybe<Array<Scalars['Int']['input']>>;
  questionTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  standardSets?: InputMaybe<Array<Scalars['ID']['input']>>;
  standards?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SubjectAuthor = {
  __typename?: 'SubjectAuthor';
  author?: Maybe<User>;
  canEditGuideLevels?: Maybe<Scalars['Boolean']['output']>;
  canEditQuestions?: Maybe<Scalars['Boolean']['output']>;
  canEditSupplements?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  subject?: Maybe<Subject>;
  subjectId: Scalars['ID']['output'];
  unfilteredSubject: Subject;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type SubjectAuthorFilterCanEditGuideLevels = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubjectAuthorFilterCanEditQuestions = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubjectAuthorFilterCanEditSupplements = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubjectAuthorFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type SubjectAuthorFilterInput = {
  and?: InputMaybe<Array<SubjectAuthorFilterInput>>;
  author?: InputMaybe<UserFilterInput>;
  canEditGuideLevels?: InputMaybe<SubjectAuthorFilterCanEditGuideLevels>;
  canEditQuestions?: InputMaybe<SubjectAuthorFilterCanEditQuestions>;
  canEditSupplements?: InputMaybe<SubjectAuthorFilterCanEditSupplements>;
  id?: InputMaybe<SubjectAuthorFilterId>;
  not?: InputMaybe<Array<SubjectAuthorFilterInput>>;
  or?: InputMaybe<Array<SubjectAuthorFilterInput>>;
  subject?: InputMaybe<SubjectFilterInput>;
  subjectId?: InputMaybe<SubjectAuthorFilterSubjectId>;
  unfilteredSubject?: InputMaybe<SubjectFilterInput>;
  userId?: InputMaybe<SubjectAuthorFilterUserId>;
};

export type SubjectAuthorFilterSubjectId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type SubjectAuthorFilterUserId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export enum SubjectAuthorSortField {
  CanEditGuideLevels = 'CAN_EDIT_GUIDE_LEVELS',
  CanEditQuestions = 'CAN_EDIT_QUESTIONS',
  CanEditSupplements = 'CAN_EDIT_SUPPLEMENTS',
  Id = 'ID',
  SubjectId = 'SUBJECT_ID',
  UserId = 'USER_ID'
}

export type SubjectAuthorSortInput = {
  field: SubjectAuthorSortField;
  order?: InputMaybe<SortOrder>;
};

export type SubjectBelongsToStandardFieldInput = {
  standardId: Scalars['ID']['input'];
};

export type SubjectFaq = {
  __typename?: 'SubjectFaq';
  answer?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  orderPosition?: Maybe<Scalars['Int']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Subject>;
  subjectId: Scalars['ID']['output'];
  unfilteredSubject: Subject;
};

export type SubjectFaqFilterAnswer = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SubjectFaqFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type SubjectFaqFilterInput = {
  and?: InputMaybe<Array<SubjectFaqFilterInput>>;
  answer?: InputMaybe<SubjectFaqFilterAnswer>;
  id?: InputMaybe<SubjectFaqFilterId>;
  not?: InputMaybe<Array<SubjectFaqFilterInput>>;
  or?: InputMaybe<Array<SubjectFaqFilterInput>>;
  orderPosition?: InputMaybe<SubjectFaqFilterOrderPosition>;
  question?: InputMaybe<SubjectFaqFilterQuestion>;
  subject?: InputMaybe<SubjectFilterInput>;
  subjectId?: InputMaybe<SubjectFaqFilterSubjectId>;
  unfilteredSubject?: InputMaybe<SubjectFilterInput>;
};

export type SubjectFaqFilterOrderPosition = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type SubjectFaqFilterQuestion = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SubjectFaqFilterSubjectId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export enum SubjectFaqSortField {
  Answer = 'ANSWER',
  Id = 'ID',
  OrderPosition = 'ORDER_POSITION',
  Question = 'QUESTION',
  SubjectId = 'SUBJECT_ID'
}

export type SubjectFaqSortInput = {
  field: SubjectFaqSortField;
  order?: InputMaybe<SortOrder>;
};

export type SubjectFilterAdaptive = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubjectFilterAdaptiveAdvanceThreshold = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type SubjectFilterAdaptiveFallbackThreshold = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type SubjectFilterAdaptiveKFactor = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Float']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Float']['input']>;
  lessThan?: InputMaybe<Scalars['Float']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Float']['input']>;
  notEq?: InputMaybe<Scalars['Float']['input']>;
};

export type SubjectFilterAdaptiveRange = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type SubjectFilterAlternateName = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SubjectFilterBadge = {
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type SubjectFilterBanner = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SubjectFilterBelongsToStandard = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  input?: InputMaybe<SubjectBelongsToStandardFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubjectFilterCode = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SubjectFilterCountOfDifficultQuestions = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type SubjectFilterCountOfEasyQuestions = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type SubjectFilterCountOfFreeResponseQuestions = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type SubjectFilterCountOfMediumQuestions = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type SubjectFilterCountOfQuestions = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type SubjectFilterCurriculumAreaId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type SubjectFilterDescription = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SubjectFilterFeaturedAs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SubjectFilterFooterText = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SubjectFilterFreeResponseQuestionsPublished = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubjectFilterHasAccessViaLicense = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubjectFilterHasAccessViaLicenseAsStudent = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubjectFilterHasAccessViaLicenseAsTeacher = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubjectFilterHasAccessViaSubscription = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubjectFilterHasFreeAccess = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubjectFilterHasFreeAccessAsStudent = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubjectFilterHasFreeAccessAsTeacher = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubjectFilterHasRestrictedFreePractice = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubjectFilterHidden = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubjectFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type SubjectFilterIncludedInPersonalizationSettings = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubjectFilterInput = {
  adaptive?: InputMaybe<SubjectFilterAdaptive>;
  /**
   * The adaptive advance threshold for every skill in this subject, if any. Resolved the same
   * way as `adaptive_range`.
   */
  adaptiveAdvanceThreshold?: InputMaybe<SubjectFilterAdaptiveAdvanceThreshold>;
  /**
   * The adaptive fallback threshold for every skill in this subject, if any. Resolved the same
   * way as `adaptive_range`.
   */
  adaptiveFallbackThreshold?: InputMaybe<SubjectFilterAdaptiveFallbackThreshold>;
  /**
   * The diagnostic scoring engine's k-factor (learning rate) for every skill in this subject,
   * if any. Resolved the same way as `adaptive_range`.
   */
  adaptiveKFactor?: InputMaybe<SubjectFilterAdaptiveKFactor>;
  /**
   * The adaptive range setting for every skill in this subject, if any. Skills, their
   * ancestors, and their guide override it; the global default backs it up. Read the effective
   * value from a guide level's `effective_adaptive_range` calculation rather than here.
   */
  adaptiveRange?: InputMaybe<SubjectFilterAdaptiveRange>;
  alternateName?: InputMaybe<SubjectFilterAlternateName>;
  and?: InputMaybe<Array<SubjectFilterInput>>;
  badge?: InputMaybe<SubjectFilterBadge>;
  banner?: InputMaybe<SubjectFilterBanner>;
  belongsToStandard?: InputMaybe<SubjectFilterBelongsToStandard>;
  code?: InputMaybe<SubjectFilterCode>;
  countOfDifficultQuestions?: InputMaybe<SubjectFilterCountOfDifficultQuestions>;
  countOfEasyQuestions?: InputMaybe<SubjectFilterCountOfEasyQuestions>;
  countOfFreeResponseQuestions?: InputMaybe<SubjectFilterCountOfFreeResponseQuestions>;
  countOfMediumQuestions?: InputMaybe<SubjectFilterCountOfMediumQuestions>;
  countOfQuestions?: InputMaybe<SubjectFilterCountOfQuestions>;
  curriculumArea?: InputMaybe<CurriculumAreaFilterInput>;
  curriculumAreaId?: InputMaybe<SubjectFilterCurriculumAreaId>;
  description?: InputMaybe<SubjectFilterDescription>;
  featuredAs?: InputMaybe<SubjectFilterFeaturedAs>;
  footerText?: InputMaybe<SubjectFilterFooterText>;
  freeResponseQuestionsPublished?: InputMaybe<SubjectFilterFreeResponseQuestionsPublished>;
  guides?: InputMaybe<GuideFilterInput>;
  hasAccessViaLicense?: InputMaybe<SubjectFilterHasAccessViaLicense>;
  hasAccessViaLicenseAsStudent?: InputMaybe<SubjectFilterHasAccessViaLicenseAsStudent>;
  hasAccessViaLicenseAsTeacher?: InputMaybe<SubjectFilterHasAccessViaLicenseAsTeacher>;
  hasAccessViaSubscription?: InputMaybe<SubjectFilterHasAccessViaSubscription>;
  hasFreeAccess?: InputMaybe<SubjectFilterHasFreeAccess>;
  hasFreeAccessAsStudent?: InputMaybe<SubjectFilterHasFreeAccessAsStudent>;
  hasFreeAccessAsTeacher?: InputMaybe<SubjectFilterHasFreeAccessAsTeacher>;
  hasRestrictedFreePractice?: InputMaybe<SubjectFilterHasRestrictedFreePractice>;
  hidden?: InputMaybe<SubjectFilterHidden>;
  id?: InputMaybe<SubjectFilterId>;
  includedInPersonalizationSettings?: InputMaybe<SubjectFilterIncludedInPersonalizationSettings>;
  logoImageUrl?: InputMaybe<SubjectFilterLogoImageUrl>;
  /** Whether the subject matches the given search term. searchFields may be any of name, description. Defaults to name. */
  matchesSearch?: InputMaybe<SubjectFilterMatchesSearch>;
  matchingGuideLevelsSearchCount?: InputMaybe<SubjectFilterMatchingGuideLevelsSearchCount>;
  /** The subscriptions for this subject that belong to the current user. */
  mySubscriptions?: InputMaybe<RetailSubscriptionFilterInput>;
  name?: InputMaybe<SubjectFilterName>;
  not?: InputMaybe<Array<SubjectFilterInput>>;
  or?: InputMaybe<Array<SubjectFilterInput>>;
  published?: InputMaybe<SubjectFilterPublished>;
  /**
   * The search relevance score for the subject given the search term. Use include_description to also match on description.
   * This should be used mostly for sorting. For filtering, use the `matches_search` calculation, which is more efficient.
   */
  searchRelevance?: InputMaybe<SubjectFilterSearchRelevance>;
  shouldShowLabelTable?: InputMaybe<SubjectFilterShouldShowLabelTable>;
  studentClassroomSubjects?: InputMaybe<ClassroomSubjectFilterInput>;
  subjectFaqs?: InputMaybe<SubjectFaqFilterInput>;
  tagCategories?: InputMaybe<TagCategoryFilterInput>;
  translateQuestions?: InputMaybe<SubjectFilterTranslateQuestions>;
  translateSupplements?: InputMaybe<SubjectFilterTranslateSupplements>;
  type?: InputMaybe<SubjectFilterType>;
  unfilteredGuides?: InputMaybe<GuideFilterInput>;
  urlSlug?: InputMaybe<SubjectFilterUrlSlug>;
  userHasAccess?: InputMaybe<SubjectFilterUserHasAccess>;
};

export type SubjectFilterLogoImageUrl = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SubjectFilterMatchesSearch = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  input?: InputMaybe<SubjectMatchesSearchFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubjectFilterMatchingGuideLevelsSearchCount = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  input?: InputMaybe<SubjectMatchingGuideLevelsSearchCountFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type SubjectFilterName = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SubjectFilterPublished = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubjectFilterSearchRelevance = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  input?: InputMaybe<SubjectSearchRelevanceFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['Float']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Float']['input']>;
  lessThan?: InputMaybe<Scalars['Float']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Float']['input']>;
  notEq?: InputMaybe<Scalars['Float']['input']>;
};

export type SubjectFilterShouldShowLabelTable = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubjectFilterTranslateQuestions = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubjectFilterTranslateSupplements = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubjectFilterType = {
  eq?: InputMaybe<SubjectType>;
  greaterThan?: InputMaybe<SubjectType>;
  greaterThanOrEqual?: InputMaybe<SubjectType>;
  in?: InputMaybe<Array<SubjectType>>;
  isDistinctFrom?: InputMaybe<SubjectType>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<SubjectType>;
  lessThan?: InputMaybe<SubjectType>;
  lessThanOrEqual?: InputMaybe<SubjectType>;
  notEq?: InputMaybe<SubjectType>;
};

export type SubjectFilterUrlSlug = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SubjectFilterUserHasAccess = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubjectMatchesSearchFieldInput = {
  search: Scalars['String']['input'];
  searchFields?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SubjectMatchingGuideLevelsSearchCountFieldInput = {
  search: Scalars['String']['input'];
};

export type SubjectSearchRelevanceFieldInput = {
  includeDescription?: InputMaybe<Scalars['Boolean']['input']>;
  search: Scalars['String']['input'];
};

export enum SubjectSortField {
  Adaptive = 'ADAPTIVE',
  AdaptiveAdvanceThreshold = 'ADAPTIVE_ADVANCE_THRESHOLD',
  AdaptiveFallbackThreshold = 'ADAPTIVE_FALLBACK_THRESHOLD',
  AdaptiveKFactor = 'ADAPTIVE_K_FACTOR',
  AdaptiveRange = 'ADAPTIVE_RANGE',
  AlternateName = 'ALTERNATE_NAME',
  Badge = 'BADGE',
  Banner = 'BANNER',
  BelongsToStandard = 'BELONGS_TO_STANDARD',
  Code = 'CODE',
  CountOfDifficultQuestions = 'COUNT_OF_DIFFICULT_QUESTIONS',
  CountOfEasyQuestions = 'COUNT_OF_EASY_QUESTIONS',
  CountOfFreeResponseQuestions = 'COUNT_OF_FREE_RESPONSE_QUESTIONS',
  CountOfMediumQuestions = 'COUNT_OF_MEDIUM_QUESTIONS',
  CountOfQuestions = 'COUNT_OF_QUESTIONS',
  CurriculumAreaId = 'CURRICULUM_AREA_ID',
  Description = 'DESCRIPTION',
  FeaturedAs = 'FEATURED_AS',
  FooterText = 'FOOTER_TEXT',
  FreeResponseQuestionsPublished = 'FREE_RESPONSE_QUESTIONS_PUBLISHED',
  HasAccessViaLicense = 'HAS_ACCESS_VIA_LICENSE',
  HasAccessViaLicenseAsStudent = 'HAS_ACCESS_VIA_LICENSE_AS_STUDENT',
  HasAccessViaLicenseAsTeacher = 'HAS_ACCESS_VIA_LICENSE_AS_TEACHER',
  HasAccessViaSubscription = 'HAS_ACCESS_VIA_SUBSCRIPTION',
  HasFreeAccess = 'HAS_FREE_ACCESS',
  HasFreeAccessAsStudent = 'HAS_FREE_ACCESS_AS_STUDENT',
  HasFreeAccessAsTeacher = 'HAS_FREE_ACCESS_AS_TEACHER',
  HasRestrictedFreePractice = 'HAS_RESTRICTED_FREE_PRACTICE',
  Hidden = 'HIDDEN',
  Id = 'ID',
  IncludedInPersonalizationSettings = 'INCLUDED_IN_PERSONALIZATION_SETTINGS',
  LogoImageUrl = 'LOGO_IMAGE_URL',
  MatchesSearch = 'MATCHES_SEARCH',
  MatchingGuideLevelsSearchCount = 'MATCHING_GUIDE_LEVELS_SEARCH_COUNT',
  Name = 'NAME',
  Published = 'PUBLISHED',
  SearchRelevance = 'SEARCH_RELEVANCE',
  ShouldShowLabelTable = 'SHOULD_SHOW_LABEL_TABLE',
  TranslateQuestions = 'TRANSLATE_QUESTIONS',
  TranslateSupplements = 'TRANSLATE_SUPPLEMENTS',
  Type = 'TYPE',
  UrlSlug = 'URL_SLUG',
  UserHasAccess = 'USER_HAS_ACCESS'
}

export type SubjectSortInput = {
  abQuestionCountInput?: InputMaybe<SubjectAbQuestionCountFieldInput>;
  belongsToStandardInput?: InputMaybe<SubjectBelongsToStandardFieldInput>;
  field: SubjectSortField;
  matchesSearchInput?: InputMaybe<SubjectMatchesSearchFieldInput>;
  matchingGuideLevelsSearchCountInput?: InputMaybe<SubjectMatchingGuideLevelsSearchCountFieldInput>;
  order?: InputMaybe<SortOrder>;
  searchRelevanceInput?: InputMaybe<SubjectSearchRelevanceFieldInput>;
};

export enum SubjectType {
  ActSat = 'ACT_SAT',
  Adaptive = 'ADAPTIVE',
  AdvancedPlacement = 'ADVANCED_PLACEMENT',
  College = 'COLLEGE',
  Core = 'CORE',
  Literature = 'LITERATURE',
  Professional = 'PROFESSIONAL',
  StateExam = 'STATE_EXAM'
}

export type SuggestUsernamesInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type Supplement = {
  __typename?: 'Supplement';
  audioGenerationStatus?: Maybe<Scalars['String']['output']>;
  content?: Maybe<SupplementContent>;
  id: Scalars['ID']['output'];
  imageGenerationStatus?: Maybe<Scalars['String']['output']>;
  insertedAt: Scalars['DateTime']['output'];
  name?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<User>;
  ownerEmail?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['ID']['output']>;
  subject: Subject;
  subjectId: Scalars['ID']['output'];
  supplementType?: Maybe<Scalars['String']['output']>;
  translate?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type SupplementContent = AudioSupplementContent | FreeFormSupplementContent | ImageSupplementContent | PassageSupplementContent | SortableTableSupplementContent;

export type SupplementContentAudioInput = {
  audio?: InputMaybe<Scalars['String']['input']>;
  audioStatus?: InputMaybe<SupplementGenerationStatus>;
  audioText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  voiceId?: InputMaybe<Scalars['String']['input']>;
};

export type SupplementContentFreeFormInput = {
  text?: InputMaybe<Scalars['String']['input']>;
};

export type SupplementContentImageInput = {
  alttext?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  generationMode?: InputMaybe<SupplementImageGenerationMode>;
  height?: InputMaybe<Scalars['Int']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  imagePrompt?: InputMaybe<Scalars['String']['input']>;
  imageSize?: InputMaybe<Scalars['Int']['input']>;
  imageStatus?: InputMaybe<SupplementGenerationStatus>;
  width?: InputMaybe<Scalars['Int']['input']>;
  x?: InputMaybe<Scalars['Int']['input']>;
  y?: InputMaybe<Scalars['Int']['input']>;
};

export type SupplementContentInput = {
  audio?: InputMaybe<SupplementContentAudioInput>;
  freeForm?: InputMaybe<SupplementContentFreeFormInput>;
  image?: InputMaybe<SupplementContentImageInput>;
  passage?: InputMaybe<SupplementContentPassageInput>;
  sortableTable?: InputMaybe<SupplementContentSortableTableInput>;
};

export type SupplementContentPassageInput = {
  excludeHeaders?: InputMaybe<Scalars['Boolean']['input']>;
  excludeWhiteSpace?: InputMaybe<Scalars['Boolean']['input']>;
  hideLineNumbers?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreWhiteSpace?: InputMaybe<Scalars['Boolean']['input']>;
  lineNumberAlignment?: InputMaybe<Scalars['String']['input']>;
  lineNumberIncrement?: InputMaybe<Scalars['Int']['input']>;
  setMaxHeight?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SupplementContentSortableTableInput = {
  hasTotal?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type SupplementFilterAudioGenerationStatus = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SupplementFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type SupplementFilterImageGenerationStatus = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SupplementFilterInput = {
  and?: InputMaybe<Array<SupplementFilterInput>>;
  audioGenerationStatus?: InputMaybe<SupplementFilterAudioGenerationStatus>;
  id?: InputMaybe<SupplementFilterId>;
  imageGenerationStatus?: InputMaybe<SupplementFilterImageGenerationStatus>;
  insertedAt?: InputMaybe<SupplementFilterInsertedAt>;
  name?: InputMaybe<SupplementFilterName>;
  not?: InputMaybe<Array<SupplementFilterInput>>;
  or?: InputMaybe<Array<SupplementFilterInput>>;
  owner?: InputMaybe<UserFilterInput>;
  ownerEmail?: InputMaybe<SupplementFilterOwnerEmail>;
  ownerId?: InputMaybe<SupplementFilterOwnerId>;
  subject?: InputMaybe<SubjectFilterInput>;
  subjectId?: InputMaybe<SupplementFilterSubjectId>;
  supplementType?: InputMaybe<SupplementFilterSupplementType>;
  translate?: InputMaybe<SupplementFilterTranslate>;
  updatedAt?: InputMaybe<SupplementFilterUpdatedAt>;
};

export type SupplementFilterInsertedAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SupplementFilterName = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SupplementFilterOwnerEmail = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SupplementFilterOwnerId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type SupplementFilterSubjectId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type SupplementFilterSupplementType = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SupplementFilterTranslate = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SupplementFilterUpdatedAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum SupplementGenerationStatus {
  Complete = 'COMPLETE',
  Error = 'ERROR',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export enum SupplementImageGenerationMode {
  Graph = 'GRAPH',
  Image = 'IMAGE'
}

export enum SupplementSortField {
  AudioGenerationStatus = 'AUDIO_GENERATION_STATUS',
  Id = 'ID',
  ImageGenerationStatus = 'IMAGE_GENERATION_STATUS',
  InsertedAt = 'INSERTED_AT',
  Name = 'NAME',
  OwnerEmail = 'OWNER_EMAIL',
  OwnerId = 'OWNER_ID',
  SubjectId = 'SUBJECT_ID',
  SupplementType = 'SUPPLEMENT_TYPE',
  Translate = 'TRANSLATE',
  UpdatedAt = 'UPDATED_AT'
}

export type SupplementSortInput = {
  field: SupplementSortField;
  order?: InputMaybe<SortOrder>;
};

export enum SupplementType {
  Audio = 'AUDIO',
  FreeForm = 'FREE_FORM',
  Image = 'IMAGE',
  Passage = 'PASSAGE',
  SortableTable = 'SORTABLE_TABLE'
}

export type Tag = {
  __typename?: 'Tag';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** A human-readable version of the tag name, with each part capitalized */
  prettyName?: Maybe<Scalars['String']['output']>;
  questions: Array<Question>;
  tagCategories: Array<TagCategory>;
};


export type TagQuestionsArgs = {
  filter?: InputMaybe<QuestionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<QuestionSortInput>>>;
};


export type TagTagCategoriesArgs = {
  filter?: InputMaybe<TagCategoryFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TagCategorySortInput>>>;
};

export type TagCategory = {
  __typename?: 'TagCategory';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  tags: Array<Tag>;
};


export type TagCategoryTagsArgs = {
  filter?: InputMaybe<TagFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TagSortInput>>>;
};

export type TagCategoryFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type TagCategoryFilterInput = {
  and?: InputMaybe<Array<TagCategoryFilterInput>>;
  id?: InputMaybe<TagCategoryFilterId>;
  name?: InputMaybe<TagCategoryFilterName>;
  not?: InputMaybe<Array<TagCategoryFilterInput>>;
  or?: InputMaybe<Array<TagCategoryFilterInput>>;
  tags?: InputMaybe<TagFilterInput>;
};

export type TagCategoryFilterName = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export enum TagCategorySortField {
  Id = 'ID',
  Name = 'NAME'
}

export type TagCategorySortInput = {
  field: TagCategorySortField;
  order?: InputMaybe<SortOrder>;
};

export type TagFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type TagFilterInput = {
  and?: InputMaybe<Array<TagFilterInput>>;
  id?: InputMaybe<TagFilterId>;
  name?: InputMaybe<TagFilterName>;
  not?: InputMaybe<Array<TagFilterInput>>;
  or?: InputMaybe<Array<TagFilterInput>>;
  /** A human-readable version of the tag name, with each part capitalized */
  prettyName?: InputMaybe<TagFilterPrettyName>;
  questions?: InputMaybe<QuestionFilterInput>;
  tagCategories?: InputMaybe<TagCategoryFilterInput>;
};

export type TagFilterName = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type TagFilterPrettyName = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export enum TagSortField {
  Id = 'ID',
  Name = 'NAME',
  PrettyName = 'PRETTY_NAME'
}

export type TagSortInput = {
  field: TagSortField;
  order?: InputMaybe<SortOrder>;
};

export type TranslatedField = {
  __typename?: 'TranslatedField';
  field: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  language: Scalars['String']['output'];
  lastModifiedBy?: Maybe<Scalars['ID']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  resourceId: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  text?: Maybe<Scalars['String']['output']>;
};

export type TranslatedFieldFilterField = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type TranslatedFieldFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type TranslatedFieldFilterInput = {
  and?: InputMaybe<Array<TranslatedFieldFilterInput>>;
  field?: InputMaybe<TranslatedFieldFilterField>;
  id?: InputMaybe<TranslatedFieldFilterId>;
  language?: InputMaybe<TranslatedFieldFilterLanguage>;
  lastModifiedBy?: InputMaybe<TranslatedFieldFilterLastModifiedBy>;
  not?: InputMaybe<Array<TranslatedFieldFilterInput>>;
  notes?: InputMaybe<TranslatedFieldFilterNotes>;
  or?: InputMaybe<Array<TranslatedFieldFilterInput>>;
  resourceId?: InputMaybe<TranslatedFieldFilterResourceId>;
  status?: InputMaybe<TranslatedFieldFilterStatus>;
  text?: InputMaybe<TranslatedFieldFilterText>;
};

export type TranslatedFieldFilterLanguage = {
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type TranslatedFieldFilterLastModifiedBy = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type TranslatedFieldFilterNotes = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type TranslatedFieldFilterResourceId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type TranslatedFieldFilterStatus = {
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type TranslatedFieldFilterText = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export enum TranslatedFieldSortField {
  Field = 'FIELD',
  Id = 'ID',
  Language = 'LANGUAGE',
  LastModifiedBy = 'LAST_MODIFIED_BY',
  Notes = 'NOTES',
  ResourceId = 'RESOURCE_ID',
  Status = 'STATUS',
  Text = 'TEXT'
}

export type TranslatedFieldSortInput = {
  field: TranslatedFieldSortField;
  order?: InputMaybe<SortOrder>;
};

export type TranslatedQuestion = {
  __typename?: 'TranslatedQuestion';
  dropdownText?: Maybe<Scalars['String']['output']>;
  dropdowns?: Maybe<Array<Scalars['JsonString']['output']>>;
  headerLeft?: Maybe<Scalars['String']['output']>;
  headerRight?: Maybe<Scalars['String']['output']>;
  highlightPrompt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inputs?: Maybe<Array<Scalars['JsonString']['output']>>;
  language: Scalars['String']['output'];
  meetsTranslationRequirements: Scalars['Boolean']['output'];
  options?: Maybe<Array<Scalars['JsonString']['output']>>;
  prompt?: Maybe<Scalars['String']['output']>;
  questionType: Scalars['String']['output'];
  requiredFields?: Maybe<Array<Scalars['String']['output']>>;
  rows?: Maybe<Array<Scalars['JsonString']['output']>>;
  sample?: Maybe<Scalars['String']['output']>;
  snippetPrompt?: Maybe<Scalars['String']['output']>;
  solutionText?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  translate: Scalars['Boolean']['output'];
  translateSupplements: Scalars['Boolean']['output'];
  translatedFields: Array<TranslatedField>;
  uncorrectedText?: Maybe<Scalars['String']['output']>;
};


export type TranslatedQuestionTranslatedFieldsArgs = {
  filter?: InputMaybe<TranslatedFieldFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TranslatedFieldSortInput>>>;
};

export type TranslatedSupplement = {
  __typename?: 'TranslatedSupplement';
  content?: Maybe<Scalars['JsonString']['output']>;
  id: Scalars['ID']['output'];
  language?: Maybe<Scalars['String']['output']>;
  meetsTranslationRequirements: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  requiredFields?: Maybe<Array<Scalars['String']['output']>>;
  translate: Scalars['Boolean']['output'];
  translatedFields: Array<TranslatedField>;
  type?: Maybe<Scalars['String']['output']>;
};


export type TranslatedSupplementTranslatedFieldsArgs = {
  filter?: InputMaybe<TranslatedFieldFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TranslatedFieldSortInput>>>;
};

export type TranslationJob = {
  __typename?: 'TranslationJob';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  language: Scalars['String']['output'];
  status: Scalars['String']['output'];
  translationRequests: Array<Scalars['JsonString']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type UnlinkUserIdentityInput = {
  provider: Scalars['String']['input'];
};

/** The result of the :unlink_user_identity mutation */
export type UnlinkUserIdentityResult = {
  __typename?: 'UnlinkUserIdentityResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<User>;
};

/** The result of the :unlock_content mutation */
export type UnlockContentResult = {
  __typename?: 'UnlockContentResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The record that was successfully deleted */
  result?: Maybe<ContentLock>;
};

export type UpdateClassroomSubjectAccessInput = {
  partialCreditEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  restrictFreePractice?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of the :update_classroom_subject_access mutation */
export type UpdateClassroomSubjectAccessResult = {
  __typename?: 'UpdateClassroomSubjectAccessResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<ClassroomSubject>;
};

export type UpdateDiagnosticInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  recipientGroups?: InputMaybe<Array<DiagnosticRecipientGroupInput>>;
};

/** The result of the :update_diagnostic mutation */
export type UpdateDiagnosticResult = {
  __typename?: 'UpdateDiagnosticResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<Diagnostic>;
};

export type UpdateDistrictInput = {
  cleverId?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ncesId?: InputMaybe<Scalars['String']['input']>;
  ncesLocale?: InputMaybe<NcesLocale>;
  state?: InputMaybe<UsState>;
};

/** The result of the :update_district mutation */
export type UpdateDistrictResult = {
  __typename?: 'UpdateDistrictResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<District>;
};

export type UpdateGuideInput = {
  /**
   * The adaptive advance threshold for every skill in this guide, if any. Resolved the same
   * way as `adaptive_range`.
   */
  adaptiveAdvanceThreshold?: InputMaybe<Scalars['Int']['input']>;
  /**
   * The adaptive fallback threshold for every skill in this guide, if any. Resolved the same
   * way as `adaptive_range`.
   */
  adaptiveFallbackThreshold?: InputMaybe<Scalars['Int']['input']>;
  /**
   * The diagnostic scoring engine's k-factor (learning rate) for every skill in this guide,
   * if any. Resolved the same way as `adaptive_range`.
   */
  adaptiveKFactor?: InputMaybe<Scalars['Float']['input']>;
  /**
   * The adaptive range setting for every skill in this guide, if any. Skills and their
   * ancestors override it; the subject and the global default back it up. Read the effective
   * value from a guide level's `effective_adaptive_range` calculation rather than here.
   */
  adaptiveRange?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Content's display order for this guide within its subject. Guides without one sort after
   * those that have one; ties break alphabetically. Callers listing guides to users sort by
   * `position` ascending with nulls last, then `name`.
   */
  position?: InputMaybe<Scalars['Int']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  subjectId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** The result of the :update_guide mutation */
export type UpdateGuideResult = {
  __typename?: 'UpdateGuideResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<Guide>;
};

export type UpdateQuestionInput = {
  answerBreakdown?: InputMaybe<Scalars['JsonString']['input']>;
  /**
   * The highest calculator tier this question allows, if set. Tiers are additive: graphing also
   * permits scientific and basic. An explicit `none` withholds the calculator.
   * This is only the stored value. Unset means the question has no setting of its own; clients resolve
   * availability from its guide levels.
   */
  calculatorType?: InputMaybe<CalculatorType>;
  chainPath?: InputMaybe<Scalars['Json']['input']>;
  difficulty?: InputMaybe<Scalars['Int']['input']>;
  guideLevel?: InputMaybe<Scalars['ID']['input']>;
  prompt?: InputMaybe<Scalars['String']['input']>;
  rubric?: InputMaybe<RubricInput>;
  solutionText?: InputMaybe<Scalars['String']['input']>;
  /**
   * Replaces the question's standard alignment when given. Omitted or `null` leaves the
   * current alignment untouched — pass `[]` to remove it all.
   */
  standards?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<QuestionStatus>;
  /**
   * Replaces the question's tags when given. Omitted or `null` leaves the current tags
   * untouched — pass `[]` to remove them all.
   */
  tags?: InputMaybe<Array<Scalars['ID']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  translate?: InputMaybe<Scalars['Boolean']['input']>;
  translateSupplements?: InputMaybe<Scalars['Boolean']['input']>;
  typeAttributes?: InputMaybe<QuestionTypeAttributesInput>;
};

/** The result of the :update_question mutation */
export type UpdateQuestionResult = {
  __typename?: 'UpdateQuestionResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<Question>;
};

export type UpdateSchoolLicenseInput = {
  /** The last instant of the day the license lapses, inclusive. */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  licenseType?: InputMaybe<LicenseType>;
  /** The number of licensed students the school may enroll. */
  numberOfSeats?: InputMaybe<Scalars['Int']['input']>;
  /** Midnight CDT on the day the license takes effect, inclusive. */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  subjectGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  subjectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  upgradeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** The result of the :update_school_license mutation */
export type UpdateSchoolLicenseResult = {
  __typename?: 'UpdateSchoolLicenseResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<SchoolLicense>;
};

export type UpdateSchoolSettingsInput = {
  allowTranslations?: InputMaybe<Scalars['Boolean']['input']>;
  restrictClassroomEnrollment?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of the :update_school_settings mutation */
export type UpdateSchoolSettingsResult = {
  __typename?: 'UpdateSchoolSettingsResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<School>;
};

export type UpdateStandardInput = {
  caseId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  standardSetId?: InputMaybe<Scalars['ID']['input']>;
  statusEndDate?: InputMaybe<Scalars['Date']['input']>;
  statusStartDate?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};

/** The result of the :update_standard mutation */
export type UpdateStandardResult = {
  __typename?: 'UpdateStandardResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<Standard>;
};

export type UpdateStandardSetCreatorInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * What kind of body publishes this creator's standards. Nullable because the only UI that
   * creates publishers — the Dennis standard set editor — has never collected a type, so rows
   * created through it have none. Feeds the `standard_set_creator_type` analytics dimension.
   */
  type?: InputMaybe<StandardSetCreatorType>;
};

/** The result of the :update_standard_set_creator mutation */
export type UpdateStandardSetCreatorResult = {
  __typename?: 'UpdateStandardSetCreatorResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<StandardSetCreator>;
};

export type UpdateStandardSetInput = {
  adoptionStatus?: InputMaybe<Scalars['String']['input']>;
  caseId?: InputMaybe<Scalars['ID']['input']>;
  /** Replaces the standard set's curriculum areas when given. At least one is required. */
  curriculumAreaIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  officialSourceUrl?: InputMaybe<Scalars['String']['input']>;
  standardSetCreatorId?: InputMaybe<Scalars['ID']['input']>;
  statusEndDate?: InputMaybe<Scalars['Date']['input']>;
  statusStartDate?: InputMaybe<Scalars['Date']['input']>;
  /**
   * Replaces the standard set's subjects when given. Omitted or `null` leaves the current
   * subjects untouched — pass `[]` to remove them all.
   */
  subjectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};

/** The result of the :update_standard_set mutation */
export type UpdateStandardSetResult = {
  __typename?: 'UpdateStandardSetResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<StandardSet>;
};

export type UpdateStripeCardInput = {
  addressCountry?: InputMaybe<Scalars['String']['input']>;
  addressZip?: InputMaybe<Scalars['String']['input']>;
  cardId: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JsonString']['input']>;
};

export type UpdateSubjectFaqInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
};

/** The result of the :update_subject_faq mutation */
export type UpdateSubjectFaqResult = {
  __typename?: 'UpdateSubjectFaqResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<SubjectFaq>;
};

export type UpdateSubjectInput = {
  adaptive?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The adaptive advance threshold for every skill in this subject, if any. Resolved the same
   * way as `adaptive_range`.
   */
  adaptiveAdvanceThreshold?: InputMaybe<Scalars['Int']['input']>;
  /**
   * The adaptive fallback threshold for every skill in this subject, if any. Resolved the same
   * way as `adaptive_range`.
   */
  adaptiveFallbackThreshold?: InputMaybe<Scalars['Int']['input']>;
  /**
   * The diagnostic scoring engine's k-factor (learning rate) for every skill in this subject,
   * if any. Resolved the same way as `adaptive_range`.
   */
  adaptiveKFactor?: InputMaybe<Scalars['Float']['input']>;
  /**
   * The adaptive range setting for every skill in this subject, if any. Skills, their
   * ancestors, and their guide override it; the global default backs it up. Read the effective
   * value from a guide level's `effective_adaptive_range` calculation rather than here.
   */
  adaptiveRange?: InputMaybe<Scalars['Int']['input']>;
  alternateName?: InputMaybe<Scalars['String']['input']>;
  badge?: InputMaybe<Scalars['String']['input']>;
  banner?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  curriculumAreaId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  featuredAs?: InputMaybe<Scalars['String']['input']>;
  footerText?: InputMaybe<Scalars['String']['input']>;
  freeResponseQuestionsPublished?: InputMaybe<Scalars['Boolean']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  logoImageUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  shouldShowLabelTable?: InputMaybe<Scalars['Boolean']['input']>;
  subscriptionsPrices?: InputMaybe<Array<Scalars['JsonString']['input']>>;
  translateQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  translateSupplements?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<SubjectType>;
};

/** The result of the :update_subject mutation */
export type UpdateSubjectResult = {
  __typename?: 'UpdateSubjectResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<Subject>;
};

export type UpdateSubscriptionInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** The result of the :update_subscription mutation */
export type UpdateSubscriptionResult = {
  __typename?: 'UpdateSubscriptionResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<RetailSubscription>;
};

export type UpdateSupplementInput = {
  content?: InputMaybe<SupplementContentInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  translate?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of the :update_supplement mutation */
export type UpdateSupplementResult = {
  __typename?: 'UpdateSupplementResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<Supplement>;
};

export type UpdateTagCategoryInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Ordered list of tag ids; replaces the category's current tags when given.
   * Omitted or `null` leaves the current tags untouched — pass `[]` to remove them all.
   */
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** The result of the :update_tag_category mutation */
export type UpdateTagCategoryResult = {
  __typename?: 'UpdateTagCategoryResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<TagCategory>;
};

export type UpdateUpgradeInput = {
  upgradeType?: InputMaybe<UpgradeType>;
};

/** The result of the :update_upgrade mutation */
export type UpdateUpgradeResult = {
  __typename?: 'UpdateUpgradeResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<Upgrade>;
};

export type UpdateUserInput = {
  cleverId?: InputMaybe<Scalars['String']['input']>;
  /** The user's preferred color mode: light, dark, or system */
  colorModePreference?: InputMaybe<Scalars['String']['input']>;
  /** The user's content preferences for suggested content */
  contentPreferences?: InputMaybe<Scalars['JsonString']['input']>;
  coppaConsentEmail?: InputMaybe<Scalars['String']['input']>;
  customerFeedbackReminderDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The user's email address */
  email?: InputMaybe<Scalars['String']['input']>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  isAuthor?: InputMaybe<Scalars['Boolean']['input']>;
  isSchoolAdministrator?: InputMaybe<Scalars['Boolean']['input']>;
  isTeacher?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  ltiId?: InputMaybe<Scalars['String']['input']>;
  /** Issuer of the LTI platform `lti_id` belongs to; identity is the (lti_iss, lti_id) pair. */
  ltiIss?: InputMaybe<Scalars['String']['input']>;
  needsCoppa?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of completed onboarding steps for the user */
  onboardingSteps?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The user's password hash */
  password?: InputMaybe<Scalars['String']['input']>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  schoolId?: InputMaybe<Scalars['ID']['input']>;
  signUpMethod?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subjectAuthors?: InputMaybe<Array<UserUpdateSubjectAuthorsInput>>;
  /** The user's username */
  username?: InputMaybe<Scalars['String']['input']>;
};

/** The result of the :update_user mutation */
export type UpdateUserResult = {
  __typename?: 'UpdateUserResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<User>;
};

export type Upgrade = {
  __typename?: 'Upgrade';
  id: Scalars['ID']['output'];
  upgradeType: UpgradeType;
};

export type UpgradeFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type UpgradeFilterInput = {
  and?: InputMaybe<Array<UpgradeFilterInput>>;
  id?: InputMaybe<UpgradeFilterId>;
  not?: InputMaybe<Array<UpgradeFilterInput>>;
  or?: InputMaybe<Array<UpgradeFilterInput>>;
  upgradeType?: InputMaybe<UpgradeFilterUpgradeType>;
};

export type UpgradeFilterUpgradeType = {
  eq?: InputMaybe<UpgradeType>;
  greaterThan?: InputMaybe<UpgradeType>;
  greaterThanOrEqual?: InputMaybe<UpgradeType>;
  in?: InputMaybe<Array<UpgradeType>>;
  isDistinctFrom?: InputMaybe<UpgradeType>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<UpgradeType>;
  lessThan?: InputMaybe<UpgradeType>;
  lessThanOrEqual?: InputMaybe<UpgradeType>;
  notEq?: InputMaybe<UpgradeType>;
};

export enum UpgradeSortField {
  Id = 'ID',
  UpgradeType = 'UPGRADE_TYPE'
}

export type UpgradeSortInput = {
  field: UpgradeSortField;
  order?: InputMaybe<SortOrder>;
};

export enum UpgradeType {
  Onboarding = 'ONBOARDING',
  Pro = 'PRO'
}

export type UpsertReportInput = {
  dimensions: Array<Scalars['String']['input']>;
  filters?: InputMaybe<Array<AnalyticsReportFiltersInput>>;
  metricInputs?: InputMaybe<Array<MetricInputInput>>;
  metrics?: InputMaybe<Array<Scalars['String']['input']>>;
  persist?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of the :upsert_report mutation */
export type UpsertReportResult = {
  __typename?: 'UpsertReportResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<AnalyticsReport>;
};

export type UpsertTranslatedQuestionFieldInput = {
  field: Scalars['String']['input'];
  language: Scalars['String']['input'];
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  resourceId: Scalars['ID']['input'];
  status: Scalars['String']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

/** The result of the :upsert_translated_question_field mutation */
export type UpsertTranslatedQuestionFieldResult = {
  __typename?: 'UpsertTranslatedQuestionFieldResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<TranslatedField>;
};

export type UpsertTranslatedSupplementFieldInput = {
  field: Scalars['String']['input'];
  language: Scalars['String']['input'];
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  resourceId: Scalars['ID']['input'];
  status: Scalars['String']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

/** The result of the :upsert_translated_supplement_field mutation */
export type UpsertTranslatedSupplementFieldResult = {
  __typename?: 'UpsertTranslatedSupplementFieldResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<TranslatedField>;
};

export enum UsState {
  Ak = 'AK',
  Al = 'AL',
  Ar = 'AR',
  Az = 'AZ',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  Dc = 'DC',
  De = 'DE',
  Fl = 'FL',
  Ga = 'GA',
  Hi = 'HI',
  Ia = 'IA',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Ma = 'MA',
  Md = 'MD',
  Me = 'ME',
  Mi = 'MI',
  Mn = 'MN',
  Mo = 'MO',
  Ms = 'MS',
  Mt = 'MT',
  Nc = 'NC',
  Nd = 'ND',
  Ne = 'NE',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Nv = 'NV',
  Ny = 'NY',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pa = 'PA',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Tn = 'TN',
  Tx = 'TX',
  Ut = 'UT',
  Va = 'VA',
  Vt = 'VT',
  Wa = 'WA',
  Wi = 'WI',
  Wv = 'WV',
  Wy = 'WY'
}

export type User = {
  __typename?: 'User';
  cleverId?: Maybe<Scalars['String']['output']>;
  /** The user's preferred color mode: light, dark, or system */
  colorModePreference: Scalars['String']['output'];
  /** The user's content preferences for suggested content */
  contentPreferences?: Maybe<Scalars['JsonString']['output']>;
  coppaApprovedAt?: Maybe<Scalars['DateTime']['output']>;
  coppaConsentGrants: Array<CoppaConsentGrant>;
  customerFeedbackReminderDate?: Maybe<Scalars['DateTime']['output']>;
  /** The Clever ID of the district this user's Clever user belongs to */
  districtCleverId?: Maybe<Scalars['String']['output']>;
  /** The user's email address */
  email: Scalars['String']['output'];
  facebookId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  /**
   * Whether this user has connected Google Classroom: Albert holds a refresh
   * token granted with the Classroom scopes roster and grade sync need. False
   * once the connection is cancelled, revoked, or granted without those scopes.
   * Visible to the user themselves and to supers.
   */
  googleClassroomConnected?: Maybe<Scalars['Boolean']['output']>;
  googleId?: Maybe<Scalars['String']['output']>;
  /**
   * Whether a Google account is linked to this user. Google Classroom grade sync
   * only reaches linked students; a roster sync links a student by matching the
   * course's email, and skips them when that Google account already belongs to
   * another Albert user. Visible to the user, their teachers, and their school admins.
   */
  hasLinkedGoogleAccount?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  /**
   * Whether the user is an active managed user. Active managed users are students that either:
   *
   * 1. are enrolled in at least one active classroom at a school that manages their email domain.
   * 2. have an explicit school_managed_user record at a school that manages their email domain.
   *
   * If school_id is provided, checks if the user is actively managed by that school,
   * otherwise checks if the user is actively managed by any school.
   */
  isActiveManagedUser?: Maybe<Scalars['Boolean']['output']>;
  isAuthor?: Maybe<Scalars['Boolean']['output']>;
  isBetaTesting?: Maybe<Scalars['Boolean']['output']>;
  isCompleteProfile?: Maybe<Scalars['Boolean']['output']>;
  isContentManager: Scalars['Boolean']['output'];
  isCoppaApproved?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether the user is a managed user (less strict than is_active_managed_user).
   * True if sign_up_method is "admin-create" OR has any school_managed_user record.
   * Does not require email domain match or active classroom enrollment.
   *
   * As of writing, this is mainly used to determine whether the student can self-serve reset their password
   * without supplying their old password
   */
  isManagedUser?: Maybe<Scalars['Boolean']['output']>;
  isPlatformAdministrator?: Maybe<Scalars['Boolean']['output']>;
  isPointOfContact?: Maybe<Scalars['Boolean']['output']>;
  isSchoolAdministrator: Scalars['Boolean']['output'];
  isTeacher?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  licenseStatus?: Maybe<UserLicenseStatus>;
  ltiId?: Maybe<Scalars['String']['output']>;
  needsCoppa: Scalars['Boolean']['output'];
  /** List of completed onboarding steps for the user */
  onboardingSteps: Array<Scalars['String']['output']>;
  pointsEarned: Scalars['Int']['output'];
  salutation?: Maybe<Scalars['String']['output']>;
  /** The school this user signed up under, if any */
  school?: Maybe<School>;
  schoolId?: Maybe<Scalars['ID']['output']>;
  /** Set to null to resend if user has not already been confirmed */
  sentConfirmationEmailAt?: Maybe<Scalars['DateTime']['output']>;
  /** Set to null to resend */
  sentCreatedUserEmailAt?: Maybe<Scalars['DateTime']['output']>;
  /** Set to null to resend */
  sentPasswordResetEmailAt?: Maybe<Scalars['DateTime']['output']>;
  signUpMethod?: Maybe<Scalars['String']['output']>;
  signupComplete?: Maybe<Scalars['Boolean']['output']>;
  signupPending?: Maybe<Array<Scalars['String']['output']>>;
  signupWorkflow?: Maybe<SignupWorkflow>;
  status: Scalars['String']['output'];
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  studentAssignments: PageOfStudentAssignment;
  subjectAuthors: Array<SubjectAuthor>;
  subjects: Array<Subject>;
  subscriptions: Array<RetailSubscription>;
  super?: Maybe<Scalars['Boolean']['output']>;
  unfilteredSubjects: Array<Subject>;
  unfilteredSubscriptions: Array<RetailSubscription>;
  userWorkflowSteps: Array<UserWorkflowStep>;
  /** The user's username */
  username: Scalars['String']['output'];
};


export type UserCoppaConsentGrantsArgs = {
  filter?: InputMaybe<CoppaConsentGrantFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CoppaConsentGrantSortInput>>>;
};


export type UserIsActiveManagedUserArgs = {
  schoolId?: InputMaybe<Scalars['ID']['input']>;
};


export type UserStudentAssignmentsArgs = {
  filter?: InputMaybe<StudentAssignmentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<StudentAssignmentSortInput>>>;
};


export type UserSubjectAuthorsArgs = {
  filter?: InputMaybe<SubjectAuthorFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SubjectAuthorSortInput>>>;
};


export type UserSubjectsArgs = {
  filter?: InputMaybe<SubjectFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SubjectSortInput>>>;
};


export type UserSubscriptionsArgs = {
  filter?: InputMaybe<RetailSubscriptionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<RetailSubscriptionSortInput>>>;
};


export type UserUnfilteredSubjectsArgs = {
  filter?: InputMaybe<SubjectFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SubjectSortInput>>>;
};


export type UserUnfilteredSubscriptionsArgs = {
  filter?: InputMaybe<RetailSubscriptionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<RetailSubscriptionSortInput>>>;
};


export type UserUserWorkflowStepsArgs = {
  filter?: InputMaybe<UserWorkflowStepFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<UserWorkflowStepSortInput>>>;
};

export type UserCreateSubjectAuthorsInput = {
  canEditGuideLevels?: InputMaybe<Scalars['Boolean']['input']>;
  canEditQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  canEditSupplements?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  subjectId?: InputMaybe<Scalars['ID']['input']>;
};

export type UserFeedback = {
  __typename?: 'UserFeedback';
  comment: Scalars['String']['output'];
  feedbackType: UserFeedbackType;
  id: Scalars['ID']['output'];
  question: Question;
  questionId: Scalars['ID']['output'];
  reportedDevice?: Maybe<UserFeedbackReportedDevice>;
  user: User;
  userAgent?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

export type UserFeedbackFilterComment = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type UserFeedbackFilterFeedbackType = {
  eq?: InputMaybe<UserFeedbackType>;
  greaterThan?: InputMaybe<UserFeedbackType>;
  greaterThanOrEqual?: InputMaybe<UserFeedbackType>;
  in?: InputMaybe<Array<UserFeedbackType>>;
  isDistinctFrom?: InputMaybe<UserFeedbackType>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<UserFeedbackType>;
  lessThan?: InputMaybe<UserFeedbackType>;
  lessThanOrEqual?: InputMaybe<UserFeedbackType>;
  notEq?: InputMaybe<UserFeedbackType>;
};

export type UserFeedbackFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type UserFeedbackFilterInput = {
  and?: InputMaybe<Array<UserFeedbackFilterInput>>;
  comment?: InputMaybe<UserFeedbackFilterComment>;
  feedbackType?: InputMaybe<UserFeedbackFilterFeedbackType>;
  id?: InputMaybe<UserFeedbackFilterId>;
  not?: InputMaybe<Array<UserFeedbackFilterInput>>;
  or?: InputMaybe<Array<UserFeedbackFilterInput>>;
  question?: InputMaybe<QuestionFilterInput>;
  questionId?: InputMaybe<UserFeedbackFilterQuestionId>;
  reportedDevice?: InputMaybe<UserFeedbackFilterReportedDevice>;
  user?: InputMaybe<UserFilterInput>;
  userAgent?: InputMaybe<UserFeedbackFilterUserAgent>;
  userId?: InputMaybe<UserFeedbackFilterUserId>;
};

export type UserFeedbackFilterQuestionId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type UserFeedbackFilterReportedDevice = {
  eq?: InputMaybe<UserFeedbackReportedDevice>;
  greaterThan?: InputMaybe<UserFeedbackReportedDevice>;
  greaterThanOrEqual?: InputMaybe<UserFeedbackReportedDevice>;
  in?: InputMaybe<Array<InputMaybe<UserFeedbackReportedDevice>>>;
  isDistinctFrom?: InputMaybe<UserFeedbackReportedDevice>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<UserFeedbackReportedDevice>;
  lessThan?: InputMaybe<UserFeedbackReportedDevice>;
  lessThanOrEqual?: InputMaybe<UserFeedbackReportedDevice>;
  notEq?: InputMaybe<UserFeedbackReportedDevice>;
};

export type UserFeedbackFilterUserAgent = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type UserFeedbackFilterUserId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export enum UserFeedbackReportedDevice {
  Desktop = 'DESKTOP',
  Mobile = 'MOBILE'
}

export enum UserFeedbackSortField {
  Comment = 'COMMENT',
  FeedbackType = 'FEEDBACK_TYPE',
  Id = 'ID',
  QuestionId = 'QUESTION_ID',
  ReportedDevice = 'REPORTED_DEVICE',
  UserAgent = 'USER_AGENT',
  UserId = 'USER_ID'
}

export type UserFeedbackSortInput = {
  field: UserFeedbackSortField;
  order?: InputMaybe<SortOrder>;
};

export enum UserFeedbackType {
  Formatting = 'FORMATTING',
  Image = 'IMAGE',
  Inaccuracy = 'INACCURACY',
  Suggestion = 'SUGGESTION',
  TranslationError = 'TRANSLATION_ERROR',
  Typo = 'TYPO'
}

export type UserFilterCleverId = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type UserFilterColorModePreference = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type UserFilterContentPreferences = {
  eq?: InputMaybe<Scalars['JsonString']['input']>;
  greaterThan?: InputMaybe<Scalars['JsonString']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['JsonString']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JsonString']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['JsonString']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['JsonString']['input']>;
  lessThan?: InputMaybe<Scalars['JsonString']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['JsonString']['input']>;
  notEq?: InputMaybe<Scalars['JsonString']['input']>;
};

export type UserFilterCoppaApprovedAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserFilterCustomerFeedbackReminderDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserFilterDistrictCleverId = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type UserFilterEmail = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type UserFilterFacebookId = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type UserFilterFirstName = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type UserFilterFullName = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type UserFilterGoogleId = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type UserFilterHasLinkedGoogleAccount = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type UserFilterInput = {
  and?: InputMaybe<Array<UserFilterInput>>;
  cleverId?: InputMaybe<UserFilterCleverId>;
  /** The user's preferred color mode: light, dark, or system */
  colorModePreference?: InputMaybe<UserFilterColorModePreference>;
  /** The user's content preferences for suggested content */
  contentPreferences?: InputMaybe<UserFilterContentPreferences>;
  coppaApprovedAt?: InputMaybe<UserFilterCoppaApprovedAt>;
  coppaConsentGrants?: InputMaybe<CoppaConsentGrantFilterInput>;
  customerFeedbackReminderDate?: InputMaybe<UserFilterCustomerFeedbackReminderDate>;
  /** The Clever ID of the district this user's Clever user belongs to */
  districtCleverId?: InputMaybe<UserFilterDistrictCleverId>;
  /** The user's email address */
  email?: InputMaybe<UserFilterEmail>;
  facebookId?: InputMaybe<UserFilterFacebookId>;
  firstName?: InputMaybe<UserFilterFirstName>;
  fullName?: InputMaybe<UserFilterFullName>;
  googleId?: InputMaybe<UserFilterGoogleId>;
  /**
   * Whether a Google account is linked to this user. Google Classroom grade sync
   * only reaches linked students; a roster sync links a student by matching the
   * course's email, and skips them when that Google account already belongs to
   * another Albert user. Visible to the user, their teachers, and their school admins.
   */
  hasLinkedGoogleAccount?: InputMaybe<UserFilterHasLinkedGoogleAccount>;
  id?: InputMaybe<UserFilterId>;
  insertedAt?: InputMaybe<UserFilterInsertedAt>;
  /**
   * Whether the user is an active managed user. Active managed users are students that either:
   *
   * 1. are enrolled in at least one active classroom at a school that manages their email domain.
   * 2. have an explicit school_managed_user record at a school that manages their email domain.
   *
   * If school_id is provided, checks if the user is actively managed by that school,
   * otherwise checks if the user is actively managed by any school.
   */
  isActiveManagedUser?: InputMaybe<UserFilterIsActiveManagedUser>;
  isAuthor?: InputMaybe<UserFilterIsAuthor>;
  isBetaTesting?: InputMaybe<UserFilterIsBetaTesting>;
  isCompleteProfile?: InputMaybe<UserFilterIsCompleteProfile>;
  isContentManager?: InputMaybe<UserFilterIsContentManager>;
  isCoppaApproved?: InputMaybe<UserFilterIsCoppaApproved>;
  /**
   * Whether the user is a managed user (less strict than is_active_managed_user).
   * True if sign_up_method is "admin-create" OR has any school_managed_user record.
   * Does not require email domain match or active classroom enrollment.
   *
   * As of writing, this is mainly used to determine whether the student can self-serve reset their password
   * without supplying their old password
   */
  isManagedUser?: InputMaybe<UserFilterIsManagedUser>;
  isPlatformAdministrator?: InputMaybe<UserFilterIsPlatformAdministrator>;
  isPointOfContact?: InputMaybe<UserFilterIsPointOfContact>;
  isSchoolAdministrator?: InputMaybe<UserFilterIsSchoolAdministrator>;
  isTeacher?: InputMaybe<UserFilterIsTeacher>;
  lastName?: InputMaybe<UserFilterLastName>;
  licenseStatus?: InputMaybe<UserFilterLicenseStatus>;
  ltiId?: InputMaybe<UserFilterLtiId>;
  needsCoppa?: InputMaybe<UserFilterNeedsCoppa>;
  not?: InputMaybe<Array<UserFilterInput>>;
  or?: InputMaybe<Array<UserFilterInput>>;
  pointsEarned?: InputMaybe<UserFilterPointsEarned>;
  salutation?: InputMaybe<UserFilterSalutation>;
  /** The school this user signed up under, if any */
  school?: InputMaybe<SchoolFilterInput>;
  schoolId?: InputMaybe<UserFilterSchoolId>;
  /** Set to null to resend if user has not already been confirmed */
  sentConfirmationEmailAt?: InputMaybe<UserFilterSentConfirmationEmailAt>;
  /** Set to null to resend */
  sentCreatedUserEmailAt?: InputMaybe<UserFilterSentCreatedUserEmailAt>;
  /** Set to null to resend */
  sentPasswordResetEmailAt?: InputMaybe<UserFilterSentPasswordResetEmailAt>;
  signUpMethod?: InputMaybe<UserFilterSignUpMethod>;
  status?: InputMaybe<UserFilterStatus>;
  stripeCustomerId?: InputMaybe<UserFilterStripeCustomerId>;
  studentAssignments?: InputMaybe<StudentAssignmentFilterInput>;
  subjectAuthors?: InputMaybe<SubjectAuthorFilterInput>;
  subjects?: InputMaybe<SubjectFilterInput>;
  subscriptions?: InputMaybe<RetailSubscriptionFilterInput>;
  super?: InputMaybe<UserFilterSuper>;
  unfilteredSubjects?: InputMaybe<SubjectFilterInput>;
  unfilteredSubscriptions?: InputMaybe<RetailSubscriptionFilterInput>;
  userWorkflowSteps?: InputMaybe<UserWorkflowStepFilterInput>;
  /** The user's username */
  username?: InputMaybe<UserFilterUsername>;
};

export type UserFilterInsertedAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserFilterIsActiveManagedUser = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  input?: InputMaybe<UserIsActiveManagedUserFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserFilterIsAuthor = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserFilterIsBetaTesting = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserFilterIsCompleteProfile = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserFilterIsContentManager = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserFilterIsCoppaApproved = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserFilterIsManagedUser = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserFilterIsPlatformAdministrator = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserFilterIsPointOfContact = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserFilterIsSchoolAdministrator = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserFilterIsTeacher = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserFilterLastName = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type UserFilterLicenseStatus = {
  eq?: InputMaybe<UserLicenseStatus>;
  greaterThan?: InputMaybe<UserLicenseStatus>;
  greaterThanOrEqual?: InputMaybe<UserLicenseStatus>;
  in?: InputMaybe<Array<UserLicenseStatus>>;
  isDistinctFrom?: InputMaybe<UserLicenseStatus>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<UserLicenseStatus>;
  lessThan?: InputMaybe<UserLicenseStatus>;
  lessThanOrEqual?: InputMaybe<UserLicenseStatus>;
  notEq?: InputMaybe<UserLicenseStatus>;
};

export type UserFilterLtiId = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type UserFilterNeedsCoppa = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserFilterPointsEarned = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type UserFilterSalutation = {
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type UserFilterSchoolId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type UserFilterSentConfirmationEmailAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserFilterSentCreatedUserEmailAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserFilterSentPasswordResetEmailAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserFilterSignUpMethod = {
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type UserFilterStatus = {
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type UserFilterStripeCustomerId = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type UserFilterSuper = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserFilterUsername = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type UserInputAccountCompletionInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  schoolId?: InputMaybe<Scalars['ID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UserInputAccountTypeSelectionInput = {
  accountType?: InputMaybe<Scalars['String']['input']>;
};

export type UserInputContentPersonalizationInput = {
  contentPreferences?: InputMaybe<Scalars['JsonString']['input']>;
};

export type UserInputCoppaAgeScreeningInput = {
  age?: InputMaybe<Scalars['Int']['input']>;
};

export type UserInputHomeschoolSchoolSetupInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  schoolId?: InputMaybe<Scalars['ID']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type UserInputParentalConsentInput = {
  classroomInvitationId?: InputMaybe<Scalars['ID']['input']>;
  consentMethod?: InputMaybe<Scalars['String']['input']>;
  coppaConsentEmail?: InputMaybe<Scalars['String']['input']>;
  enrollCode?: InputMaybe<Scalars['String']['input']>;
};

export type UserIsActiveManagedUserFieldInput = {
  schoolId?: InputMaybe<Scalars['ID']['input']>;
};

export enum UserLicenseStatus {
  Guest = 'GUEST',
  Licensed = 'LICENSED',
  Retail = 'RETAIL'
}

export enum UserSortField {
  CleverId = 'CLEVER_ID',
  ColorModePreference = 'COLOR_MODE_PREFERENCE',
  ContentPreferences = 'CONTENT_PREFERENCES',
  CoppaApprovedAt = 'COPPA_APPROVED_AT',
  CustomerFeedbackReminderDate = 'CUSTOMER_FEEDBACK_REMINDER_DATE',
  DistrictCleverId = 'DISTRICT_CLEVER_ID',
  Email = 'EMAIL',
  FacebookId = 'FACEBOOK_ID',
  FirstName = 'FIRST_NAME',
  FullName = 'FULL_NAME',
  GoogleId = 'GOOGLE_ID',
  HasLinkedGoogleAccount = 'HAS_LINKED_GOOGLE_ACCOUNT',
  Id = 'ID',
  InsertedAt = 'INSERTED_AT',
  IsActiveManagedUser = 'IS_ACTIVE_MANAGED_USER',
  IsAuthor = 'IS_AUTHOR',
  IsBetaTesting = 'IS_BETA_TESTING',
  IsCompleteProfile = 'IS_COMPLETE_PROFILE',
  IsContentManager = 'IS_CONTENT_MANAGER',
  IsCoppaApproved = 'IS_COPPA_APPROVED',
  IsManagedUser = 'IS_MANAGED_USER',
  IsPlatformAdministrator = 'IS_PLATFORM_ADMINISTRATOR',
  IsPointOfContact = 'IS_POINT_OF_CONTACT',
  IsSchoolAdministrator = 'IS_SCHOOL_ADMINISTRATOR',
  IsTeacher = 'IS_TEACHER',
  LastName = 'LAST_NAME',
  LicenseStatus = 'LICENSE_STATUS',
  LtiId = 'LTI_ID',
  NeedsCoppa = 'NEEDS_COPPA',
  PointsEarned = 'POINTS_EARNED',
  Salutation = 'SALUTATION',
  SchoolId = 'SCHOOL_ID',
  SentConfirmationEmailAt = 'SENT_CONFIRMATION_EMAIL_AT',
  SentCreatedUserEmailAt = 'SENT_CREATED_USER_EMAIL_AT',
  SentPasswordResetEmailAt = 'SENT_PASSWORD_RESET_EMAIL_AT',
  SignUpMethod = 'SIGN_UP_METHOD',
  Status = 'STATUS',
  StripeCustomerId = 'STRIPE_CUSTOMER_ID',
  Super = 'SUPER',
  Username = 'USERNAME'
}

export type UserSortInput = {
  field: UserSortField;
  isActiveManagedUserInput?: InputMaybe<UserIsActiveManagedUserFieldInput>;
  order?: InputMaybe<SortOrder>;
};

export type UserSubjectTagPreference = {
  __typename?: 'UserSubjectTagPreference';
  id: Scalars['ID']['output'];
  subject: Subject;
  subjectId: Scalars['ID']['output'];
  tags: Array<Tag>;
};


export type UserSubjectTagPreferenceTagsArgs = {
  filter?: InputMaybe<TagFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TagSortInput>>>;
};

export type UserUpdateSubjectAuthorsInput = {
  canEditGuideLevels?: InputMaybe<Scalars['Boolean']['input']>;
  canEditQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  canEditSupplements?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  subjectId?: InputMaybe<Scalars['ID']['input']>;
};

export type UserWorkflowStep = {
  __typename?: 'UserWorkflowStep';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  skippedAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  step: Scalars['String']['output'];
  workflow: Scalars['String']['output'];
};

export type UserWorkflowStepFilterCompletedAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserWorkflowStepFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type UserWorkflowStepFilterInput = {
  and?: InputMaybe<Array<UserWorkflowStepFilterInput>>;
  completedAt?: InputMaybe<UserWorkflowStepFilterCompletedAt>;
  id?: InputMaybe<UserWorkflowStepFilterId>;
  not?: InputMaybe<Array<UserWorkflowStepFilterInput>>;
  or?: InputMaybe<Array<UserWorkflowStepFilterInput>>;
  skippedAt?: InputMaybe<UserWorkflowStepFilterSkippedAt>;
  status?: InputMaybe<UserWorkflowStepFilterStatus>;
  step?: InputMaybe<UserWorkflowStepFilterStep>;
  workflow?: InputMaybe<UserWorkflowStepFilterWorkflow>;
};

export type UserWorkflowStepFilterSkippedAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserWorkflowStepFilterStatus = {
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type UserWorkflowStepFilterStep = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type UserWorkflowStepFilterWorkflow = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  stringEndsWith?: InputMaybe<Scalars['String']['input']>;
  stringStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export enum UserWorkflowStepSortField {
  CompletedAt = 'COMPLETED_AT',
  Id = 'ID',
  SkippedAt = 'SKIPPED_AT',
  Status = 'STATUS',
  Step = 'STEP',
  Workflow = 'WORKFLOW'
}

export type UserWorkflowStepSortInput = {
  field: UserWorkflowStepSortField;
  order?: InputMaybe<SortOrder>;
};

export type UsernameAvailability = {
  __typename?: 'UsernameAvailability';
  available: Scalars['Boolean']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};
